{
 " ao(à) paciente {nome}{cpf}": " kepada pasien {nome}{cpf}",
 " junto ao plano de saúde {c}": " pada asuransi kesehatan {c}",
 " às {h}": " pukul {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" atau \"Halaman 1 dari 10\", di sudut mana pun yang Anda mau.",
 "\"{nome}\" está no {provedor}.": "\"{nome}\" ada di {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" bukan JPG atau PNG. Ubah ke JPG lalu coba lagi.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" bukan PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "\"{nova}\" pukul {hora} bentrok dengan: {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\" sekarang milik grup. Dalam 1 menit anggota lain akan melihat semuanya.",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" telah dibuat dengan data yang sama.",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" sudah ditambahkan pada {data}.",
 "% ao mês": "% per bulan",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(Di komputer admin: 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(salinan)",
 "(sem título)": "(tanpa judul)",
 "+ Adicionar alerta": "+ Tambah peringatan",
 "+ Adicionar outra OAB": "+ Tambah OAB lain",
 "+ Adicionar pausa": "+ Tambah jeda",
 "+ Adicionar subtarefa": "+ Tambah subtugas",
 "+ Matéria em {nome}": "+ Mata pelajaran di {nome}",
 "+ Perfil": "+ Profil",
 "+ Subtarefa": "+ Subtugas",
 "+5 min": "+5 mnt",
 "+{n} acompanhante(s)": "+{n} pendamping",
 "+{n} páginas acima da meta": "+{n} halaman di atas target",
 ", carteirinha nº {n},": ", no. kartu {n},",
 ", pago em {d}{f}": ", dibayar pada {d}{f}",
 "1 cápsula": "1 kapsul",
 "1 dose": "1 takar",
 "1 dose (30 g)": "1 takar (30 g)",
 "1 pessoa": "1 orang",
 "1 publicação nova": "1 publikasi baru",
 "1 página": "1 halaman",
 "1 tarja no documento": "1 blok hitam di dokumen",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Pasang My Planner dan buat akun Anda.  2. Buka tautan ini lagi (atau masukkan kode di Pengaturan › Grup & undangan).",
 "1. Quais dados tratamos": "1. Data yang kami proses",
 "1. Sobre o app": "1. Tentang aplikasi",
 "1ª dose": "Dosis ke-1",
 "2 por folha": "2 per lembar",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 cangkir tepung\n3 butir telur\n1 sendok baking powder",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 atau 9 halaman di setiap lembar (untuk dicetak).",
 "2. Para que usamos": "2. Untuk apa kami menggunakannya",
 "2. Sua conta": "2. Akun Anda",
 "2ª dose": "Dosis ke-2",
 "3 a 5 g": "3–5 g",
 "3. Bases legais (LGPD)": "3. Dasar hukum (LGPD)",
 "3. Uso correto": "3. Penggunaan yang benar",
 "3ª dose": "Dosis ke-3",
 "4 por folha": "4 per lembar",
 "4. Com quem compartilhamos": "4. Dengan siapa kami berbagi",
 "4. Planos e testes": "4. Paket dan uji coba",
 "5. Limites": "5. Batasan",
 "5. Segurança": "5. Keamanan",
 "6 por folha": "6 per lembar",
 "6. Por quanto tempo": "6. Berapa lama",
 "7. Seus direitos (art. 18 da LGPD)": "7. Hak Anda (art. 18 LGPD)",
 "8. Crianças e adolescentes": "8. Anak-anak dan remaja",
 "9 por folha": "9 per lembar",
 "9. Mudanças": "9. Perubahan",
 "@letra-dom": "M",
 "@letra-qua": "R",
 "@letra-qui": "K",
 "@letra-sab": "S",
 "@letra-seg": "S",
 "@letra-sex": "J",
 "@letra-ter": "S",
 "A IA está classificando...": "AI sedang mengelompokkan...",
 "A IA está lendo a caixa...": "AI sedang membaca kotak...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI membaca halaman dan PDF jadi bisa dicari dan disalin.",
 "A IA lê o PDF e sugere um nome claro.": "AI membaca PDF dan menyarankan nama yang jelas.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "AI tidak memberikan jawaban dalam format yang diharapkan. Coba lagi.",
 "A IA não encontrou dados para esta ficha no arquivo.": "AI tidak menemukan data untuk catatan ini di dalam file.",
 "A IA não encontrou tarefas nesta caixa.": "AI tidak menemukan tugas di kotak ini.",
 "A IA resume o PDF e responde perguntas.": "AI meringkas PDF dan menjawab pertanyaan.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ mencatat bahwa Anda sudah mengetahui faktur tersebut (tidak mengonfirmasi atau menolak pembelian) dan membuka XML lengkap pada pencarian berikutnya, dalam 1 jam.",
 "A VENCER (7 DIAS)": "JATUH TEMPO (7 HARI)",
 "A aba inteira": "Seluruh tab",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "Tab {aba} hampir penuh. Arsipkan atau hapus item lama di dalamnya.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "Tab {aba} belum dilanggan. Tautan tetap disimpan dan kembali saat berlangganan.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "Pencarian \"{nome}\" terlalu luas. Gunakan nama lengkap.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "Pencarian GIF belum diaktifkan di aplikasi ini. Sementara itu, gunakan stiker animasi (🎉).",
 "A cada": "Setiap",
 "A cada N páginas": "Setiap N halaman",
 "A cada quantos dias": "Setiap berapa hari",
 "A cada {n} dia(s)": "Setiap {n} hari",
 "A cada {n} mês(es)": "Setiap {n} bulan",
 "A cada {n} mês(es) · dia {d}": "Setiap {n} bulan · tanggal {d}",
 "A cada {n} semana(s)": "Setiap {n} minggu",
 "A cada {n} semana(s) · {dia}": "Setiap {n} minggu · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "Kotak ada di {aba}, di \"Catatan diterima\".",
 "A caixa foi para {destino}.": "Kotak dikirim ke {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "Kunci hanya disimpan di perangkat ini, di brankas sistem. Di perangkat lain, daftarkan lagi.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "Kunci hanya disimpan di browser ini. Gunakan di komputer pribadi.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "Koneksi dienkripsi. Brankas menggunakan enkripsi ujung ke ujung (AES-256): bahkan tim dukungan tidak bisa membacanya. Aplikasi bisa dikunci dengan kata sandi, pola, atau biometrik.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "Konfirmasi lewat WhatsApp belum diaktifkan di server.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "Akun dan semua data yang tersimpan di cloud: tugas, catatan, tab, data, pesan, file yang dikirim ke aplikasi, dan pengaturan. Data di perangkat ini juga dihapus. Tidak bisa dibatalkan.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "Warna ini muncul di bilah, judul, dan tugas yang terkait dengan tab ini.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "Warna My Planner adalah warna aksen aplikasi. Setiap tugas bisa punya warna sendiri di detailnya.",
 "A data de fim é anterior à de início.": "Tanggal akhir lebih awal dari tanggal mulai.",
 "A data inicial precisa ser antes da final.": "Tanggal mulai harus sebelum tanggal akhir.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "Tim akan memeriksa galat ini dan memperbaikinya di pembaruan berikutnya.",
 "A equipe vê e altera conforme o papel de cada um": "Tim melihat dan mengubah sesuai peran masing-masing",
 "A fazer": "Akan dikerjakan",
 "A foto passa de 8 MB.": "Foto lebih dari 8 MB.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "Foto terlalu besar. Instal versi baru aplikasi untuk memotong foto.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "Fungsi \"nuvem\" belum dipublikasikan di server. Jalankan 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "Fungsi \"nuvem\" belum dipublikasikan di server. Jalankan 9-LIGAR-DRIVE-ONEDRIVE.bat (lihat COMO RODAR, versi 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "Rekaman masih disiapkan. Coba lagi dalam beberapa menit.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "Jam dicatat dalam zona waktu ini. Di zona waktu lain, aplikasi menampilkan dan mengingatkan pada jam yang sudah dikonversi.",
 "A imagem original não está neste dispositivo.": "Gambar asli tidak ada di perangkat ini.",
 "A pagar": "Harus dibayar",
 "A pagar: {v}": "Harus dibayar: {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "Izin kalender telah dicabut. Izinkan lagi di pengaturan ponsel.",
 "A pessoa sai do grupo e deixa de receber os envios.": "Orang tersebut keluar dari grup dan tidak lagi menerima kiriman.",
 "A receber": "Belum diterima",
 "A receber: {v}": "Akan diterima: {v}",
 "A reunião ainda está sendo gravada.": "Rapat masih direkam.",
 "A senha atual não confere.": "Kata sandi saat ini salah.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "Kata sandi brankas harus minimal 6 karakter.",
 "A senha precisa ter 8 caracteres ou mais.": "Kata sandi harus 8 karakter atau lebih.",
 "A senha precisa ter pelo menos 8 caracteres.": "Kata sandi harus minimal 8 karakter.",
 "A senha é a mesma no celular e no My Planner Web.": "Kata sandinya sama di ponsel dan di My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "Sinkronisasi berjalan saat aplikasi dibuka dan setelah setiap perubahan. Tugas yang terhubung ke kalender menampilkan 📆.",
 "A sua equipe num lugar só": "Tim Anda dalam satu tempat",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Tugas rumah tidak masuk ke My Planner dengan sendirinya. \"Kirim ke My Planner\" membuka formulir lengkap untuk memilih hari, jam, frekuensi, jeda, dan pengingat.",
 "A validade não pode ser antes da emissão.": "Masa berlaku tidak boleh sebelum tanggal terbit.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "Versi iPhone segera hadir di App Store. Sementara itu, gunakan My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "Versi iPhone segera hadir di App Store. Sementara itu, gunakan My Planner Web: di Safari, ketuk Bagikan > Tambah ke Layar Utama agar menjadi ikon di ponsel.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Letter, A5 atau Legal, tanpa memotong apa pun.",
 "ADICIONAR AMIGO": "TAMBAH TEMAN",
 "AGUARDANDO RESPOSTA": "MENUNGGU BALASAN",
 "AMIGOS": "TEMAN",
 "ANOTAÇÕES": "CATATAN",
 "ANOTAÇÕES RECEBIDAS · {aba}": "CATATAN DITERIMA · {aba}",
 "ATIVIDADE": "AKTIVITAS",
 "ATIVIDADE FÍSICA": "AKTIVITAS FISIK",
 "ATRASADAS": "TERLAMBAT",
 "Aba": "Tab",
 "Aba bloqueada": "Tab terkunci",
 "Aba {nome}": "Tab {nome}",
 "Abas": "Tab",
 "Abas liberadas pelo suporte": "Tab yang dibuka oleh dukungan",
 "Abas para comprar": "Tab untuk dibeli",
 "Abas que você já tem": "Tab yang sudah Anda miliki",
 "Abastecimento": "Pengisian BBM",
 "Abastecimentos": "Pengisian BBM",
 "Abdominal": "Crunch",
 "Abertura do prazo da declaração do IR": "Pembukaan masa lapor SPT IR (pajak penghasilan)",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Buka perusahaan dan ketuk \"Cari faktur\" untuk memasukkan kata sandi brankas.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Buka My Planner Anne dan masuk dengan nomor identitas dan kata sandi.",
 "Abra o My Planner no celular.": "Buka My Planner di ponsel.",
 "Abra o cofre": "Buka brankas",
 "Abra um PDF para começar.": "Buka PDF untuk mulai.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Buka mata pelajaran dan ketuk \"Belajar sekarang\" untuk menghitung waktu. Atur target mingguan di setiap mata pelajaran.",
 "Abraço": "Peluk",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Membuka menu bagikan di ponsel: WhatsApp, email, Google Drive, OneDrive, Simpan ke File, dan lainnya.",
 "Abre o PDF para ler aqui mesmo.": "Membuka PDF untuk dibaca di sini.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Membuka Pemindai PDF (tepi dan bayangan diperbaiki).",
 "Abrir": "Buka",
 "Abrir Ajustes": "Buka Pengaturan",
 "Abrir PDF": "Buka PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Buka PDF dari ponsel, Drive atau OneDrive",
 "Abrir a aba": "Buka tab",
 "Abrir a cópia guardada": "Buka salinan tersimpan",
 "Abrir a pasta no Drive": "Buka folder di Drive",
 "Abrir com outro app": "Buka dengan aplikasi lain",
 "Abrir configurações": "Buka pengaturan",
 "Abrir em outro app": "Buka di aplikasi lain",
 "Abrir no DJEN": "Buka di DJEN",
 "Abrir no modo seguro": "Buka dalam mode aman",
 "Abrir normalmente": "Buka seperti biasa",
 "Abrir nota fiscal": "Buka faktur",
 "Abrir o PDF": "Buka PDF",
 "Abrir o PDF no {nome}": "Buka PDF di {nome}",
 "Abrir o XML": "Buka XML",
 "Abrir o app": "Buka aplikasi",
 "Abrir o app My Planner": "Buka aplikasi My Planner",
 "Abrir o cartão": "Buka kartu",
 "Abrir o cofre": "Buka brankas",
 "Abrir o cofre para ver": "Buka brankas untuk melihat",
 "Abrir o diário oficial": "Buka lembaran resmi",
 "Abrir ou baixar": "Buka atau unduh",
 "Abrir página": "Buka halaman",
 "Abrir site": "Buka situs",
 "Abrir {nome}": "Buka {nome}",
 "Acabamento": "Finishing",
 "Acabou": "Habis",
 "Academia": "Gym",
 "Aceitar": "Terima",
 "Aceitar, editar ou recusar": "Terima, edit, atau tolak",
 "Aceite os termos para continuar.": "Setujui ketentuan untuk melanjutkan.",
 "Aceito": "Diterima",
 "Aceito com alterações": "Diterima dengan perubahan",
 "Acerto de contas": "Penyelesaian tagihan",
 "Acerto de contas: {v}": "Penyelesaian tagihan: {v}",
 "Acessibilidade": "Aksesibilitas",
 "Acesso ilimitado": "Akses tanpa batas",
 "Acesso ilimitado a todas as funções, sem prazo": "Akses tanpa batas ke semua fitur, tanpa batas waktu",
 "Achatar": "Ratakan",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Memantau semuanya, termasuk pengeluaran, dan menulis di catatan harian.",
 "Acompanhamento": "Lauk pendamping",
 "Acompanhantes": "Pendamping",
 "Acrescentar no fim da página": "Tambahkan di akhir halaman",
 "Adaptador de tomada": "Adaptor colokan",
 "Adestramento": "Pelatihan",
 "Adicionar": "Tambah",
 "Adicionar amigo": "Tambah teman",
 "Adicionar amigos do app": "Tambahkan teman aplikasi",
 "Adicionar ao Planner?": "Tambahkan ke Planner?",
 "Adicionar arquivo": "Tambah file",
 "Adicionar cômodo": "Tambah ruangan",
 "Adicionar fotos e vídeos": "Tambah foto dan video",
 "Adicionar imagem": "Tambah gambar",
 "Adicionar item (ex.: 2 ovos mexidos)": "Tambah item (mis.: 2 telur orak-arik)",
 "Adicionar na página": "Tambahkan ke halaman",
 "Adicionar passo": "Tambah langkah",
 "Adicionar país": "Tambah negara",
 "Adicionar página": "Tambah halaman",
 "Adicionar texto": "Tambah teks",
 "Adicionar {nome}": "Tambah {nome}",
 "Adicionar à equipe": "Tambahkan ke tim",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Tambahkan teman lewat kodenya atau kirim kode Anda ke orang yang Anda inginkan.",
 "Admin": "Admin",
 "Administração": "Administrasi",
 "Adubar a cada quantos dias": "Pupuk setiap berapa hari",
 "Adubar: {p}": "Pupuk: {p}",
 "Adubei hoje": "Sudah dipupuk hari ini",
 "Advogado": "Pengacara",
 "Advogados": "Pengacara",
 "Afundo": "Lunge",
 "Agachamento": "Squat",
 "Agenda do Google": "Google Kalender",
 "Agenda limpa": "Agenda bersih",
 "Agenda não liberada": "Kalender belum diizinkan",
 "Agenda sincronizada ✓": "Kalender tersinkron ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Agenda, catatan, keuangan, belajar, pesan, dan banyak lagi dalam satu aplikasi.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Jadwal, data pasien, dan pembayaran, tanpa rekam medis.",
 "Agendado": "Dijadwalkan",
 "Agendado no My Planner": "Dijadwalkan di My Planner",
 "Agendamento no pet shop": "Janji di pet shop",
 "Agendar": "Jadwalkan",
 "Agendar no My Planner": "Jadwalkan di My Planner",
 "Agendar no My Planner (dias e horários)": "Jadwalkan di My Planner (hari dan jam)",
 "Agora não": "Nanti saja",
 "Agora o verso do documento.": "Sekarang bagian belakang dokumen.",
 "Agora, {hora}": "Sekarang, {hora}",
 "Agora: {ml}": "Sekarang: {ml}",
 "Aguardando o celular · {s}s": "Menunggu ponsel · {s} dtk",
 "Aguarde": "Tunggu",
 "Aguarde um pouco": "Tunggu sebentar",
 "Aguarde...": "Harap tunggu...",
 "Ainda a pagar no mês": "Masih harus dibayar bulan ini",
 "Ainda a receber no mês": "Masih akan diterima bulan ini",
 "Ainda não confirmado": "Belum dikonfirmasi",
 "Ainda não disponível: falta configurar no servidor.": "Belum tersedia: belum dikonfigurasi di server.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Bulan ini Anda belum menabung apa pun. Bagaimana kalau sisihkan {v} (10% dari pemasukan) begitu uangnya masuk?",
 "Ainda não há feriados deste país para este ano.": "Belum ada hari libur negara ini untuk tahun ini.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "Belum ada apa pun di tab ini untuk dibagikan. Buat dulu (mis.: perjalanannya) lalu kembali ke sini.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Belum ada orang lain di grup (atau Anda tidak dapat melihat daftar anggota).",
 "Ainda não marcado como feito. Toque para abrir.": "Belum ditandai selesai. Ketuk untuk membuka.",
 "Ainda não sincronizado": "Belum disinkronkan",
 "Ainda sem chave neste dispositivo.": "Belum ada kunci di perangkat ini.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking, atau langsung: reservasi, bersih-bersih saat check-out, pemasukan, pengeluaran, dan laba bulan ini",
 "Ajuda na organização": "Membantu penyelenggaraan",
 "Ajudante": "Asisten",
 "Ajustar": "Sesuaikan",
 "Ajustar a data final": "Sesuaikan tanggal akhir",
 "Ajustar a folha": "Sesuaikan kertas",
 "Ajustar tamanho da página": "Sesuaikan ukuran halaman",
 "Ajuste visual": "Penyesuaian visual",
 "Ajustes": "Pengaturan",
 "Alarme dos remédios": "Alarm obat",
 "Alarme que insiste até marcar como tomado": "Alarm yang terus berbunyi sampai ditandai sudah diminum",
 "Alemão": "Bahasa Jerman",
 "Alergia": "Alergi",
 "Alergias": "Alergi",
 "Alergias e alertas": "Alergi dan peringatan",
 "Alertas": "Peringatan",
 "Alertas das tarefas": "Peringatan tugas",
 "Alertas dos compromissos": "Peringatan janji",
 "Algo deu errado, mas o app continua aberto": "Terjadi masalah, tapi aplikasi tetap terbuka",
 "Alguns arquivos foram guardados em outro dispositivo.": "Beberapa file disimpan di perangkat lain.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Beberapa jam tangan (seperti Huawei) mungkin tidak mengirim data ke Health Connect. Jika begitu, masukkan secara manual.",
 "Alguém": "Seseorang",
 "Alguém indicou o app para você?": "Ada yang merekomendasikan aplikasi ini kepada Anda?",
 "Alimentação": "Makanan",
 "Alimentação & Despensa": "Makanan & Dapur",
 "Alimentação {semana}": "Makanan {semana}",
 "Alimento": "Makanan",
 "Alinhamento e balanceamento": "Spooring dan balancing",
 "Almoço": "Makan siang",
 "Alongamento": "Peregangan",
 "Alta": "Tinggi",
 "Alterado por último por {nome}": "Terakhir diubah oleh {nome}",
 "Alterar metadados": "Ubah metadata",
 "Alterar o valor pago": "Ubah jumlah dibayar",
 "Alterações": "Perubahan",
 "Alto-falante": "Speaker",
 "Aluga como": "Disewakan sebagai",
 "Alugar a casa ou um cômodo": "Sewakan rumah atau satu kamar",
 "Aluguel": "Sewa",
 "Aluguel & Hospedagem": "Sewa & Penginapan",
 "Aluguel de carro": "Sewa mobil",
 "Aluno": "Siswa",
 "Alunos": "Siswa",
 "Alvará ou licença": "Izin atau lisensi",
 "Alvenaria": "Pasangan bata",
 "Alvo": "Jumlah target",
 "Alíquota do ISS (%)": "Tarif ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Tarif ISS layanan ini (%)",
 "Amanhã": "Besok",
 "Ambiente": "Lingkungan",
 "Ameno": "Sejuk",
 "Amigos": "Teman",
 "Amor": "Cinta",
 "Amortização": "Pelunasan pokok",
 "Ampliar a foto": "Perbesar foto",
 "Amém": "Amin",
 "Analisar com IA": "Analisis dengan AI",
 "Anamnese e histórico (no cofre)": "Anamnesis dan riwayat (di brankas)",
 "Anexar arquivos": "Lampirkan file",
 "Anexar comprovante": "Lampirkan bukti",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Melampirkan dokumen, mengimpor mutasi rekening, serta menyimpan laporan, PDF, dan cadangan.",
 "Anexos": "Lampiran",
 "Anexos guardados aqui no dispositivo: {n}": "Lampiran yang disimpan di perangkat ini: {n}",
 "Animais e natureza": "Hewan dan alam",
 "Animação": "Animasi",
 "Anime": "Anime",
 "Aniversário": "Ulang tahun",
 "Aniversário de Campo Grande": "Ulang Tahun Campo Grande",
 "Aniversário de São Paulo": "Ulang Tahun São Paulo",
 "Ano": "Tahun",
 "Ano anterior": "Tahun sebelumnya",
 "Ano de lançamento": "Tahun rilis",
 "Ano de {ano}": "Tahun {ano}",
 "Ano passado": "Tahun lalu",
 "Anotar pela foto da página": "Catat dari foto halaman",
 "Anotação": "Catatan",
 "Anotação de {data}": "Catatan {data}",
 "Anotação do professor": "Catatan guru",
 "Anotação à mão": "Catatan tulisan tangan",
 "Anotações": "Catatan",
 "Anotações Rápidas": "Catatan Cepat",
 "Anotações arquivadas": "Catatan yang diarsipkan",
 "Anotações arquivadas ({n})": "Catatan yang diarsipkan ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Catat setiap reservasi dengan tanggal, sumber, dan nilainya. Bersih-bersih saat check-out otomatis masuk ke daftar bersih-bersih.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Catat kegiatan harian proyek dengan foto. Tandai foto sebagai Sebelum atau Sesudah untuk melihat perkembangannya.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Catat barang yang Anda pinjamkan atau pinjam, dengan foto dan tenggat. Aplikasi mengingatkan pada hari pengembalian.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Catat tempat yang ingin Anda kunjungi. Cari di Google Maps atau Waze, buat rute melewati semuanya, lalu masukkan ke rencana perjalanan hari itu.",
 "Anteriores ({n})": "Sebelumnya ({n})",
 "Antes": "Sebelum",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Sebelum mulai, lihat apa saja yang digunakan aplikasi dan alasannya. Anda bisa mengubah semuanya nanti di Pengaturan > Privasi dan ketentuan.",
 "Antes de uma data": "Sebelum tanggal",
 "Antes do início": "Sebelum mulai",
 "Antes e depois": "Sebelum dan sesudah",
 "Antes: {lista}": "Sebelum: {lista}",
 "Antipulgas": "Antikutu",
 "Anual": "Tahunan",
 "Ao ar livre": "Di luar ruangan",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "Jika dibatalkan, tab menjadi hitam putih dan tautan hilang dari tugas, tetapi tidak ada yang dihapus.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "Dengan membuat akun atau terus menggunakan aplikasi, Anda menyetujui ketentuan ini dan kebijakan privasi di bawah.",
 "Ao fechar, a página é salva.": "Saat ditutup, halaman disimpan.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "Saat menyimpan, Anda membuat kata sandi brankas. Kolom ini dienkripsi di perangkat.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Saat Anda mengetuk \"File\" atau \"Foto\" di Studi dan Dokumen, pemilih di ponsel menampilkan Google Drive, OneDrive, dan Dropbox (jika aplikasinya terpasang). Pilih file langsung dari sana.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Ketuk file lampiran untuk membukanya di aplikasi ponsel pilihanmu (di Android, \"Sekali saja\" atau \"Selalu\"). Yang kamu ubah di sana tersimpan di file itu sendiri.",
 "Apaga a conta e todos os vencimentos dela.": "Menghapus tagihan dan semua jatuh temponya.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Menghapus mata pelajaran dan halaman di map ini. Tugas di planner tetap ada.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Menghapus halaman mata pelajaran ini. Waktu belajar tetap ada di riwayat.",
 "Apaga o cartão e as compras dele.": "Menghapus kartu dan pembeliannya.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Menghapus akun dan semua data di cloud serta di perangkat ini secara permanen. Tidak dapat dibatalkan.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Menghapus semua tugas di agenda, yang lalu maupun yang akan datang.",
 "Apaga todas as {n} parcelas.": "Menghapus semua {n} cicilan.",
 "Apaga todos os meses desta conta.": "Menghapus semua bulan dari tagihan ini.",
 "Apagar": "Hapus",
 "Apagar \"{nome}\"?": "Hapus \"{nome}\"?",
 "Apagar a caixa?": "Hapus kotak?",
 "Apagar a chave": "Hapus kunci",
 "Apagar a chave deste dispositivo?": "Hapus kunci dari perangkat ini?",
 "Apagar a conta?": "Hapus akun?",
 "Apagar a lista de erros?": "Hapus daftar galat?",
 "Apagar a pasta (os documentos continuam)": "Hapus folder (dokumen tetap ada)",
 "Apagar as da agenda": "Hapus yang dari kalender",
 "Apagar caixa": "Hapus kotak",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Hapus sungguhan (halaman dengan blok hitam jadi gambar)",
 "Apagar de vez": "Hapus permanen",
 "Apagar desenho": "Hapus gambar",
 "Apagar envio": "Hapus kiriman",
 "Apagar lista": "Hapus daftar",
 "Apagar minha conta": "Hapus akun saya",
 "Apagar minha conta e todos os dados": "Hapus akun saya dan semua data",
 "Apagar o escritório": "Hapus kantor",
 "Apagar o escritório?": "Hapus kantor?",
 "Apagar o grupo": "Hapus grup",
 "Apagar o grupo?": "Hapus grup?",
 "Apagar o lançamento?": "Hapus transaksi ini?",
 "Apagar para todos": "Hapus untuk semua",
 "Apagar tudo": "Hapus semua",
 "Apagar tudo antes de": "Hapus semua sebelum",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Hapus sekaligus tugas hari ini, bulan ini, dalam satu periode, atau berdasarkan nama. Sebelum menghapus, aplikasi menampilkan apa yang akan dihapus dan meminta kata sandi Anda.",
 "Aparece na barra quando estiver liberada": "Muncul di bilah setelah tersedia",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Muncul di Planner, bersama hari libur opsional (Karnaval, Rabu Abu, dan Corpus Christi).",
 "Aplicar": "Terapkan",
 "Aponte a câmera do celular para este QR Code.": "Arahkan kamera ponsel ke Kode QR ini.",
 "Aponte para o QR Code na tela do computador": "Arahkan ke Kode QR di layar komputer",
 "Apostila": "Modul",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Modul, latihan soal, slide, video, tautan, dan pengumuman. Lewat ⋮ › Kirim ke sebuah grup, setiap siswa menerimanya di aplikasinya.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "Aplikasi untuk tombol \"Rute\" pada alamat (tugas, janji temu, rencana perjalanan, renovasi, sekolah...).",
 "Apple Saúde": "Apple Kesehatan",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch: sudah menyimpan semuanya di app Kesehatan iPhone. Anda tidak perlu melakukan apa pun.",
 "Apresentação": "Presentasi",
 "Aprovação": "Persetujuan",
 "Aqui": "Di sini",
 "Ar-condicionado": "AC",
 "Arco-íris": "Pelangi",
 "Arenoso": "Berpasir",
 "Armazenamento": "Penyimpanan",
 "Armário": "Lemari",
 "Arquivadas ({n})": "Diarsipkan ({n})",
 "Arquivados ({n})": "Diarsipkan ({n})",
 "Arquivar": "Arsipkan",
 "Arquivar a caixa de anotações?": "Arsipkan kotak catatan?",
 "Arquivar conversa": "Arsipkan chat",
 "Arquivo": "File",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "File (Drive, OneDrive, Dropbox, atau dari perangkat)",
 "Arquivo OFX ou CSV do banco": "File OFX atau CSV dari bank",
 "Arquivo adicionado": "File ditambahkan",
 "Arquivo menor (para WhatsApp e e-mail)": "File lebih kecil (untuk WhatsApp dan email)",
 "Arquivo menor para WhatsApp e e-mail.": "File lebih kecil untuk WhatsApp dan email.",
 "Arquivo não encontrado.": "File tidak ditemukan.",
 "Arquivo ou PDF": "File atau PDF",
 "Arquivo ou documento": "File atau dokumen",
 "Arquivos": "File",
 "Arquivos (frente, verso, PDF)": "File (depan, belakang, PDF)",
 "Arquivos (importar e exportar)": "File (impor dan ekspor)",
 "Arquivos de {nome}": "File dari {nome}",
 "Arquivos na nuvem e cópias de segurança": "File di cloud dan cadangan",
 "Arrasou!": "Keren banget!",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Seret titik-titik ke 4 sudut kertas. Aplikasi akan memotong dan meluruskan halaman.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Seret jari di atas bagian yang ingin disembunyikan. Ketuk blok untuk menghapusnya.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Geser ke kanan untuk menghapus, atau ke kiri untuk mengirim ke tab lain.",
 "Arraste para a direita para excluir.": "Geser ke kanan untuk menghapus.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Seret untuk mengubah urutan, putar, gandakan, hapus, dan tambah halaman kosong.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Seret untuk melihat sisa papan. Papan bertambah ke bawah dan ke kanan.",
 "Arraste um documento para a direita para excluir.": "Geser dokumen ke kanan untuk menghapus.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Geser kotak ke kiri untuk mengarsipkan atau ke kanan untuk menghapus.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Geser kotak ke kiri untuk mengarsipkan atau ke kanan untuk menghapus. Tahan ⋮⋮ untuk mengubah urutan.",
 "Arroz": "Nasi",
 "Artes": "Seni",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Langganan Claude Pro, ChatGPT Plus, dan Gemini Advanced tidak bisa dipakai oleh aplikasi lain. Untuk mengaktifkan AI di sini, buat kunci API di akun Anda (Gemini punya penggunaan gratis; Claude dan ChatGPT menagih per penggunaan, beberapa sen per analisis).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Panggilan belum diaktifkan di server (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Pembelian di kartu ini juga dihapus dari Keuangan.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Pembelian cicilan dicatat dengan semua cicilannya: cicilan berikutnya langsung muncul di tagihan bulan-bulan selanjutnya.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Foto dokumen ini ada di perangkat tempat dokumen dipindai. Di sana Anda bisa mengedit, membagikan, dan membaca teksnya.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Gambar hanya dikirim ke AI pilihan Anda, dengan kunci Anda sendiri.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Bersih-bersih setelah check-out muncul otomatis di sini, dengan daftar periksa dan foto sebelum dan sesudah.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Faktur yang diterbitkan di sini, yang ditemukan dalam pencarian, dan XML yang diimpor muncul di daftar ini.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Cicilan muncul di sini. Lampirkan bukti bayar (foto, PDF, atau tangkapan layar PIX) di setiap cicilan.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Cicilan 12 bulan ke depan sudah ada di My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Cicilan yang belum dibayar dihitung ulang dengan nilai, bunga, dan jangka waktu kontrak saat ini. Yang sudah dibayar tidak berubah.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Halaman dokumen ini ada di perangkat tempat dokumen dipindai. Buka di sana atau gunakan salinan yang tersimpan di Drive atau OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Halaman jadi gambar yang lebih ringan: bagus untuk PDF hasil pindai. Teks tidak bisa dicari lagi (pakai OCR sesudahnya jika perlu).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Halaman hanya dikirim ke AI pilihan Anda, dengan kunci Anda.",
 "As receitas do cardápio já têm tudo na despensa.": "Semua bahan resep di menu sudah ada di dapur.",
 "As senhas novas não conferem.": "Kata sandi baru tidak cocok.",
 "As senhas não conferem.": "Kata sandi tidak cocok.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Tugas tetap ada di My Planner. Hapus juga tugas yang berasal dari Google Kalender?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Tugas ruangan tetap ada di Rumahku, tanpa ruangan.",
 "As tarefas vinculadas continuam no My Planner.": "Tugas yang tertaut tetap ada di My Planner.",
 "Aspirar e passar pano": "Menyedot debu dan mengepel",
 "Assinada": "Berlangganan",
 "Assinar": "Tanda tangan",
 "Assinar (simulação de teste)": "Berlangganan (simulasi uji)",
 "Assinar o documento": "Tanda tangani dokumen",
 "Assinatura": "Tanda tangan",
 "Assinatura do profissional": "Tanda tangan tenaga profesional",
 "Assinatura e segurança": "Tanda tangan dan keamanan",
 "Assinaturas (simulação de teste)": "Langganan (simulasi uji)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Berlangganan tab ini di Pengaturan untuk mengirim catatan ke sana.",
 "Assine a aba em Ajustes para vincular.": "Berlangganan tab ini di Pengaturan untuk menautkan.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Berlangganan tab ini di Pengaturan › Pembelian untuk mengirim catatan ke sana.",
 "Assine a aba em Ajustes › Compras para vincular.": "Berlangganan tab ini di Pengaturan › Pembelian untuk menautkan.",
 "Assine a aba para abrir o vínculo.": "Berlangganan tab ini untuk membuka tautan.",
 "Assisti mais uma aula": "Sudah menonton satu pelajaran lagi",
 "Assistido": "Sudah ditonton",
 "Assistindo": "Sedang ditonton",
 "Assistência técnica (nome)": "Servis (nama)",
 "Assistência: {nome}": "Servis: {nome}",
 "Assunto": "Perihal",
 "Assunto (ex.: Reunião semanal)": "Topik (mis.: Rapat mingguan)",
 "Atender": "Jawab",
 "Atendimento": "Kunjungan",
 "Atendimentos": "Kunjungan",
 "Ativar avisos": "Aktifkan notifikasi",
 "Ativar monitor": "Aktifkan monitor",
 "Ativas": "Aktif",
 "Atividade": "Kegiatan",
 "Atividade do roteiro": "Kegiatan rencana perjalanan",
 "Atividade hoje": "Aktivitas hari ini",
 "Atividade: {blocos}": "Aktivitas: {blocos}",
 "Atividades": "Aktivitas",
 "Atividades de hoje": "Aktivitas hari ini",
 "Atividades e materiais": "Kegiatan dan bahan",
 "Atividades físicas e saúde": "Olahraga dan kesehatan",
 "Atrasada": "Terlambat",
 "Atrasada há {n} dia(s)": "Terlambat {n} hari",
 "Atrasadas": "Terlambat",
 "Atrasados": "Terlambat",
 "Atuais": "Saat ini",
 "Atualidades": "Isu Terkini",
 "Atualizar": "Perbarui",
 "Atualizar agora": "Perbarui sekarang",
 "Atualizar alarmes no My Planner": "Perbarui alarm di My Planner",
 "Atualizar rega e adubo na agenda": "Perbarui penyiraman dan pemupukan di jadwal",
 "Atualização automática disponível no app instalado (APK).": "Pembaruan otomatis tersedia di aplikasi terpasang (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Pembaruan telah diunduh. Berlaku saat aplikasi dibuka ulang atau saat notifikasi diketuk.",
 "Atualização pronta": "Pembaruan siap",
 "Atualizações": "Pembaruan",
 "Até": "Sampai",
 "Audiência": "Sidang",
 "Aula dada": "Pelajaran sudah diberikan",
 "Aula {a} de {n} ({p}%)": "Pelajaran {a} dari {n} ({p}%)",
 "Aulas assistidas": "Pelajaran ditonton",
 "Autoajuda": "Pengembangan diri",
 "Autor": "Penulis",
 "Avaliação": "Penilaian",
 "Avaliações e notas": "Penilaian dan nilai",
 "Avançado": "Lanjutan",
 "Aveia": "Oat",
 "Avisar a hora de sair": "Ingatkan waktu berangkat",
 "Avisar antes de vencer": "Ingatkan sebelum kedaluwarsa",
 "Avisar no celular quando alguém incluir algo": "Beri tahu di ponsel saat seseorang menambahkan sesuatu",
 "Aviso": "Pengumuman",
 "Aviso com as tarefas do dia": "Notifikasi berisi tugas hari ini",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Notifikasi uji dikirim oleh server. Akan tiba dalam beberapa detik; keluar dari aplikasi untuk melihatnya di bilah notifikasi ponsel.",
 "Aviso enviado": "Notifikasi terkirim",
 "Aviso {dias} dia(s) antes e no dia": "Pengingat {dias} hari sebelumnya dan pada harinya",
 "Avisos no celular": "Notifikasi di ponsel",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Notifikasi di ponsel melewati layanan Expo, Google, dan Apple.",
 "Ação": "Aksi",
 "Ações": "Saham",
 "BOLETO E DOCUMENTOS": "BOLETO DAN DOKUMEN",
 "Backup importado.": "Cadangan diimpor.",
 "Bairro": "Kelurahan",
 "Baixa": "Rendah",
 "Baixando atualização...": "Mengunduh pembaruan...",
 "Baixar": "Unduh",
 "Baixar a versão {v}": "Unduh versi {v}",
 "Baixar agora": "Unduh sekarang",
 "Baixar o My Planner para Android": "Unduh My Planner untuk Android",
 "Baixar o My Planner para Android (versão {v})": "Unduh My Planner untuk Android (versi {v})",
 "Baixar o My Planner para iPhone": "Unduh My Planner untuk iPhone",
 "Baixar o PDF da nota (DANFSe)": "Unduh PDF faktur (DANFSe)",
 "Baixar o PDF?": "Unduh PDF?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Unduh XML lengkap (memberi konfirmasi ke SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Unduh versi Android terbaru: {apk}",
 "Baixe aqui a versão mais recente: {link}": "Unduh versi terbaru di sini: {link}",
 "Balança": "Bergoyang",
 "Balanço e relatórios": "Neraca dan laporan",
 "Banana": "Pisang",
 "Banco": "Bank",
 "Banco, financeira ou pessoa": "Bank, lembaga pembiayaan, atau perorangan",
 "Bandeiras": "Bendera",
 "Banheiro": "Kamar mandi",
 "Banho": "Mandi",
 "Banho e tosa": "Mandi dan grooming",
 "Barra": "Bilah",
 "Bateria": "Aki",
 "Batimentos (média)": "Detak jantung (rata-rata)",
 "Batizado": "Pembaptisan",
 "Bebida": "Minuman",
 "Bebê": "Bayi",
 "Beijo": "Cium",
 "Bem": "Aset",
 "Bem clara": "Sangat tipis",
 "Bem-Estar": "Kesehatan",
 "Bem-Estar · Cronograma alimentar": "Kesehatan · Rencana makan",
 "Bens": "Aset",
 "Bichos e diversão": "Hewan dan hiburan",
 "Bicicleta": "Sepeda",
 "Bicicleta ergométrica": "Sepeda statis",
 "Biografia": "Biografi",
 "Biologia": "Biologi",
 "Biometria (digital ou rosto)": "Biometrik (sidik jari atau wajah)",
 "Biometria ({tipos})": "Biometrik ({tipos})",
 "Biometria não confirmada.": "Biometrik tidak terkonfirmasi.",
 "Bloqueado": "Diblokir",
 "Bloquear": "Blokir",
 "Bloquear agora": "Kunci sekarang",
 "Bloqueio": "Blokir",
 "Blusas de frio": "Baju hangat",
 "Boa noite": "Selamat malam",
 "Boa sorte!": "Semoga berhasil!",
 "Boas-vindas ao My Planner": "Selamat datang di My Planner",
 "Boas-vindas pelo WhatsApp": "Sambutan lewat WhatsApp",
 "Boleto": "Boleto",
 "Boleto anexado": "Boleto terlampir",
 "Boleto do banco {b}": "Boleto dari bank {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto dan dokumen (foto, PDF, atau file)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto atau tagihan (foto, PDF, atau file)",
 "Boleto por foto": "Boleto dari foto",
 "Bolinha": "Bulatan",
 "Bom dia": "Selamat pagi",
 "Bom dia!": "Selamat pagi!",
 "Bom dia! Seu dia no My Planner": "Selamat pagi! Hari Anda di My Planner",
 "Booking": "Booking",
 "Bora!": "Gas!",
 "Borboleta": "Kupu-kupu",
 "Borracha": "Penghapus",
 "Botas para neve": "Sepatu bot salju",
 "Brasil": "Brasil",
 "Braços acima da cabeça": "Lengan di atas kepala",
 "Brilho": "Kilau",
 "Brinquedo ou livro para a viagem": "Mainan atau buku untuk perjalanan",
 "Busca de notas": "Pencarian faktur",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Mencari nama di lembaran daerah kota yang dikumpulkan oleh Querido Diário (Open Knowledge Brasil). Tidak semua kota tercakup, dan lembaran resmi bukan bagian dari DJEN.",
 "Buscando...": "Mencari...",
 "Buscar": "Cari",
 "Buscar GIF (ex.: parabéns, bom dia)": "Cari GIF (mis.: selamat, selamat pagi)",
 "Buscar cidade, país ou GMT": "Cari kota, negara, atau GMT",
 "Buscar conversa": "Cari obrolan",
 "Buscar documento, titular ou órgão": "Cari dokumen, pemilik, atau instansi",
 "Buscar em {nome}": "Cari di {nome}",
 "Buscar emoji (ex.: coração, risada)": "Cari emoji (mis.: hati, tawa)",
 "Buscar figurinha": "Cari stiker",
 "Buscar notas": "Cari faktur",
 "Buscar ou digitar um alimento": "Cari atau ketik makanan",
 "Buscar país": "Cari negara",
 "Buscar pelo nome ou pelo texto": "Cari berdasarkan nama atau teks",
 "Buscar produto, loja ou observação": "Cari produk, toko, atau catatan",
 "Buscar tarefas": "Cari tugas",
 "Buscar: processo, parte, tribunal, palavra...": "Cari: perkara, pihak, pengadilan, kata...",
 "CAIXA {n}": "KARDUS {n}",
 "CARDS DE ANOTAÇÕES": "KARTU CATATAN",
 "CARTÕES": "KARTU",
 "CEP": "CEP (kode pos)",
 "CID (se o paciente pedir na declaração)": "CID (jika pasien memintanya di surat keterangan)",
 "CID: {c}": "CID: {c}",
 "CNH": "SIM (CNH)",
 "CNPJ (se tiver)": "CNPJ (jika ada)",
 "CNPJ ou CPF": "CNPJ atau CPF",
 "COMPROVANTE DE PAGAMENTO": "BUKTI PEMBAYARAN",
 "COMPROVANTE DE RECEBIMENTO": "BUKTI PENERIMAAN",
 "COMPROVANTES ANTERIORES": "BUKTI SEBELUMNYA",
 "CONTAS DO MÊS": "TAGIHAN BULAN INI",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brasil)",
 "CPF de quem paga": "CPF pembayar",
 "CPF do paciente": "CPF pasien",
 "CPF do pagador": "CPF pembayar",
 "CPF inválido": "CPF tidak valid",
 "CPF ou CNPJ de quem recebeu": "CPF atau CNPJ penerima",
 "CPF ou senha incorretos.": "CPF atau kata sandi salah.",
 "CRIAR CÔMODO": "BUAT RUANGAN",
 "CRIAR UM GRUPO": "BUAT GRUP",
 "CRONOGRAMA ALIMENTAR": "JADWAL MAKAN",
 "CUIDADOS PESSOAIS": "PERAWATAN DIRI",
 "Cabeleireiro": "Penata rambut",
 "Cabelo": "Rambut",
 "Cachorro": "Anjing",
 "Cactos e suculentas": "Kaktus dan sukulen",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Setiap tab tambahan: gratis {n} hari; setelah itu {preco} per tahun.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Setiap file yang selesai masuk ke {nome}. PDF yang dibuka juga tetap ada di perangkat ini, di daftar bawah.",
 "Cada dia da semana": "Setiap hari dalam seminggu",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Setiap dokumen baru dikirim ke {nome} saat Anda keluar darinya. Foto halaman hanya tersimpan di perangkat ini.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Setiap anggota tim menerima rapat di Diterima dan memasukkannya ke Planner dengan satu ketukan, beserta pengingatnya.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Setiap orang di grup menerimanya dan memutuskan apakah menerima.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Setiap halaman menyimpan ringkasan, kuliah, atau bab. Tandai sudah diulas setelah selesai.",
 "Cada página vira uma imagem JPG.": "Setiap halaman jadi gambar JPG.",
 "Cada refeição se repete nos dias dela": "Setiap waktu makan diulang pada harinya masing-masing",
 "Cadastrar": "Daftarkan",
 "Cadastrar cartão de crédito": "Daftarkan kartu kredit",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Daftarkan dari foto (halaman kursus, sertifikat, brosur)",
 "Cadastrar pela foto da capa": "Daftarkan dari foto sampul",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Isi \"Data saya\" agar kuitansi memuat nama, dewan profesi, dan nomor Anda.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Simpan KTP, SIM, paspor, kontrak, dan akta. Aplikasi mengingatkan sebelum kedaluwarsa dan mengirim dokumen dengan satu ketukan.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Daftarkan perusahaan (atau Anda sendiri sebagai profesional) dengan CNPJ atau CPF, kota, dan rezim pajak. Lalu hubungkan sertifikat A1 untuk menerbitkan NFS-e sesuai Padrão Nacional dan mencari faktur yang diterbitkan dan diterima.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Daftarkan proyek, lalu di dalamnya tahapan dengan anggaran, catatan harian dengan foto, tukang, dan pengiriman material.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Daftarkan perjalanan, lalu di dalamnya rencana tiap hari, reservasi, dan koper. Selama perjalanan, rencananya muncul di My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Daftarkan hanya nama Anda sendiri dan OAB Anda.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Daftarkan anak-anak: ujian, rapat, konsultasi, dan vaksin tersimpan di masing-masing.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Daftarkan setiap hewan: buku vaksin, obat cacing, obat, dan pet shop tersimpan di dalamnya.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Daftarkan setiap tanaman dengan cahaya, tanah, dan setiap berapa hari disiram dan dipupuk. Aplikasi menyusun kalendernya di jadwal.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Daftarkan setiap kendaraan. Di dalamnya ada perawatan (dengan pengingat per km dan per tanggal) serta jatuh tempo IPVA, registrasi, dan asuransi.",
 "Cadastre digital ou rosto no aparelho para usar.": "Daftarkan sidik jari atau wajah di perangkat untuk menggunakannya.",
 "Cadastre o cartão primeiro": "Daftarkan kartu dulu",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Daftarkan pembiayaan atau pinjaman dengan nilai, bunga, dan jumlah cicilan. Aplikasi menghitung cicilan, sisa utang, dan mengingatkan jatuh tempo.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Daftarkan seluruh properti atau setiap kamar yang Anda sewakan. Di dalamnya ada reservasi, bersih-bersih, dan pengeluaran.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Daftarkan buku dengan jumlah halaman dan target per hari. Ketuk ⋮ untuk menambah halaman yang dibaca.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Daftarkan obat dengan jam minumnya, lalu ketuk ⋮ untuk memasukkannya ke lini masa dengan alarm.",
 "Cadastre os alunos da turma na aba Alunos.": "Daftarkan siswa kelas di tab Siswa.",
 "Cadastre os clientes para separar as horas.": "Daftarkan klien untuk memisahkan jam kerja.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Daftarkan klien yang menerima faktur Anda. Alamat opsional (jika diisi, masukkan CEP, kode IBGE, jalan, nomor, dan kelurahan).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Daftarkan layanan yang paling sering Anda tagihkan, dengan kode pajak nasional. Saat menerbitkan, cukup ketuk.",
 "Cadastre primeiro em {nome}.": "Daftarkan dulu di {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Isi nama, dewan profesi, dan nomor registrasi Anda. Data ini muncul di kuitansi dan surat keterangan.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Daftarkan klien Anda di tab \"Penerima jasa\" perusahaan untuk memilihnya di sini.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Isi data profesional Anda (nama, dewan profesi, dan nomor) di \"Data saya\" agar muncul di dokumen.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Isi data profesional Anda (nama, dewan profesi, dan nomor) di \"Data saya\" agar muncul di kuitansi.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Daftarkan pasien Anda. Di dalam setiap pasien ada kunjungan dengan perkembangan, resep, pembayaran, kuitansi, dan surat keterangan untuk asuransi kesehatan.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Daftarkan diri Anda dan setiap anggota keluarga. Konsultasi, pemeriksaan, vaksin, dan obat tersimpan di masing-masing. Data sensitif masuk ke brankas terenkripsi.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Pendaftaran menunggu persetujuan: matikan \"Confirm email\" di Supabase (lihat COMO RODAR).",
 "Cadastro recebido": "Pendaftaran diterima",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Pendaftaran: nama, CPF atau email, kata sandi (disimpan hanya dalam bentuk terlindungi), dan email kontak.",
 "Cadastros": "Data",
 "Cadastros e comprovantes": "Data dan bukti",
 "Cadeira extensora": "Leg extension",
 "Café": "Kopi",
 "Café da manhã": "Sarapan",
 "Café ou bar": "Kafe atau bar",
 "Café?": "Ngopi?",
 "Cafés": "Kafe",
 "Caixa": "Kardus",
 "Caixa arquivada": "Kotak diarsipkan",
 "Caixa com checklist, lista ou texto livre": "Kotak berisi checklist, daftar, atau teks bebas",
 "Caixa {n}": "Kardus {n}",
 "Caixas": "Kardus",
 "Caixas e cronograma da mudança.": "Kardus dan jadwal pindahan.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Kardus per ruangan dengan label, pindah layanan air, listrik, dan internet, inspeksi, serta jadwal harian.",
 "Calculadora": "Kalkulator",
 "Calculando...": "Menghitung...",
 "Calendário": "Kalender",
 "Calendário da planta": "Kalender tanaman",
 "Calendário do imposto": "Kalender pajak",
 "Calendários": "Kalender",
 "Calorias em atividade": "Kalori aktivitas",
 "Calorias gastas em atividade (kcal)": "Kalori terbakar saat aktivitas (kcal)",
 "Calça térmica (segunda pele)": "Celana termal (lapisan dalam)",
 "Calças ou bermudas": "Celana panjang atau pendek",
 "Cama": "Tempat tidur",
 "Caminhada": "Jalan kaki",
 "Caminhão": "Truk",
 "Camisetas": "Kaus",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Kolom formulir",
 "Cancelada": "Dibatalkan",
 "Canceladas": "Dibatalkan",
 "Cancelar": "Batal",
 "Cancelar a NFS-e": "Batalkan NFS-e",
 "Cancelar a NFS-e {n}?": "Batalkan NFS-e {n}?",
 "Cancelar a nota": "Batalkan faktur",
 "Cancelar a reunião \"{nome}\"?": "Batalkan rapat \"{nome}\"?",
 "Cancelar reunião": "Batalkan rapat",
 "Caneta": "Pena",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Pengambilan otomatis oleh server: setiap 2 jam, pukul 08.00 sampai 20.00",
 "Captura automática: todos os dias às 08h e 12h": "Pengambilan otomatis: setiap hari pukul 08.00 dan 12.00",
 "Card": "Kartu",
 "Cardápio": "Menu",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Menu mingguan, resep, daftar belanja otomatis, dan tanggal kedaluwarsa di dapur.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Menu hanya untuk hari ini. Hari lain tetap memakai menu mingguan.",
 "Carga (kg)": "Beban (kg)",
 "Carimbo": "Stempel",
 "Carnaval": "Karnaval",
 "Carne magra": "Daging tanpa lemak",
 "Carregando feriados...": "Memuat hari libur...",
 "Carregando...": "Memuat...",
 "Carro": "Mobil",
 "Carta": "Letter",
 "Carteira": "Dompet",
 "Carteira de trabalho": "Buku kerja",
 "Carteira profissional (OAB, CRC, CREA...)": "Kartu profesi (OAB, CRC, CREA...)",
 "Cartão": "Kartu",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Kartu kontak Pesan: foto, telepon, email, dan status yang Anda sendiri pilih untuk ditampilkan. Hanya orang yang mengobrol dengan Anda, teman Anda, dan orang yang satu grup aplikasi dengan Anda yang dapat melihatnya.",
 "Cartão de crédito": "Kartu kredit",
 "Cartão de débito": "Kartu debit",
 "Cartão parcelado": "Kartu kredit cicilan",
 "Cartões": "Kartu",
 "Cartões de visita": "Kartu nama",
 "Cartões e dinheiro": "Kartu dan uang tunai",
 "Casa": "Rumah",
 "Casa e rotina": "Rumah dan rutinitas",
 "Casa, família e veículos": "Rumah, keluarga, dan kendaraan",
 "Casaco leve": "Jaket tipis",
 "Casaco pesado": "Jaket tebal",
 "Casamento": "Pernikahan",
 "Castanhas": "Kacang-kacangan",
 "Categoria": "Kategori",
 "Categoria de \"{d}\"": "Kategori \"{d}\"",
 "Categorias": "Kategori",
 "Caução": "Deposit jaminan",
 "Ceia": "Makan malam ringan",
 "Celular": "Ponsel",
 "Celular confirmado": "Ponsel terkonfirmasi",
 "Celular e carregador": "Ponsel dan pengisi daya",
 "Certidão": "Akta / surat keterangan",
 "Certificado digital": "Sertifikat digital",
 "Certificado digital A1": "Sertifikat digital A1",
 "Certificado ligado": "Sertifikat terhubung",
 "Chamada": "Absensi",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Absensi hari ini belum diisi. Ketuk siswa yang tidak hadir atau konfirmasi semua hadir.",
 "Chamada, notas, planos de aula e materiais.": "Absensi, nilai, rencana pelajaran, dan materi.",
 "Chamadas": "Panggilan",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Panggilan suara dan video melewati server LiveKit, hanya selama panggilan dan tanpa rekaman.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Panggilan audio dan video melewati server LiveKit, hanya selama panggilan berlangsung. Perekaman hanya terjadi di rapat Kantor, saat administrator merekam, dan file langsung masuk ke penyimpanan aplikasi.",
 "Chamando...": "Memanggil...",
 "Chapéu ou boné": "Topi",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Kunci AI belum didaftarkan di perangkat ini (Pengaturan › Kecerdasan buatan).",
 "Chave de acesso": "Kunci akses",
 "Check-in": "Check-in",
 "Check-in: {d} a partir das {h}": "Check-in: {d} mulai pukul {h}",
 "Check-in: {h} · {e}": "Check-in: {h} · {e}",
 "Check-out": "Check-out",
 "Check-out: {d} até as {h}": "Check-out: {d} paling lambat pukul {h}",
 "Check-out: {h} · {e}": "Check-out: {h} · {e}",
 "Checklist": "Daftar centang",
 "Chinelo": "Sandal jepit",
 "Chá de bebê": "Baby shower",
 "Cidade": "Kota",
 "Cidade (para a data dos recibos)": "Kota (untuk tanggal kuitansi)",
 "Cidade de {nome}": "Kota {nome}",
 "Cidades": "Kota",
 "Cifrão": "Tanda dolar",
 "Cinza": "Abu-abu",
 "Cirurgia": "Operasi",
 "Ciências": "IPA",
 "Clara": "Tipis",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Mencerahkan PDF hasil pindai: latar putih, abu-abu, atau hitam putih.",
 "Claro": "Terang",
 "Classificar categorias com IA": "Kelompokkan kategori dengan AI",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT, atau Gemini",
 "Cliente": "Klien",
 "Clientes": "Klien",
 "Clima esperado": "Perkiraan cuaca",
 "Co-anfitrião": "Co-host",
 "Cobrança": "Tagihan",
 "Cobranças": "Tagihan",
 "Coelho": "Kelinci",
 "Cofre (criptografia de ponta a ponta)": "Brankas (enkripsi end-to-end)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Brankas terbuka (tertutup sendiri setelah 5 menit tidak dipakai)",
 "Cofre ainda não criado": "Brankas belum dibuat",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Brankas terenkripsi untuk KTP, SIM, paspor, kontrak, dan akta, dengan hitung mundur masa berlaku dan kirim sekali ketuk.",
 "Cofre fechado": "Brankas tertutup",
 "Cofrinho": "Celengan",
 "Cole aqui a chave ({ini}...)": "Tempel kunci di sini ({ini}...)",
 "Cole o link (https://...)": "Tempel tautan (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Tempel atau ketik barcode (atau kode Pix salin-tempel) di kolom kode: aplikasi menghitung sendiri jumlah dan jatuh temponya. Jika AI Anda aktif, aplikasi membaca semuanya dari foto.",
 "Coloca arquivos dentro do PDF.": "Menaruh file di dalam PDF.",
 "Colocar na agenda": "Masukkan ke jadwal",
 "Colocar na linha do tempo com alarme": "Masukkan ke lini masa dengan alarm",
 "Colocar no My Planner": "Masukkan ke My Planner",
 "Colocar rega e adubo na agenda": "Masukkan penyiraman dan pemupukan ke jadwal",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Isi nilai iuran bulanan di kelas (Edit) atau di siswa. Tagihan bulan ini yang sudah ada tidak dibuat ulang.",
 "Coluna": "Kolom",
 "Colágeno": "Kolagen",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Jika biometrik aktif, biometrik muncul lebih dulu. Jika gagal, gunakan pola atau kata sandi.",
 "Com convênio": "Dengan asuransi",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Dengan kode negara dan kode area. Contoh: +55 41 99999-0000",
 "Com outras pessoas": "Dipinjam orang lain",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Dengan tenggat, aplikasi menghitung berapa yang perlu ditabung per bulan. Uang yang ditabung dihitung sebagai \"Ditabung\" di bulan itu.",
 "Com quem": "Dengan siapa",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Siapa yang membayar, pasien, tanggal, dan nilai setiap kunjungan yang dibayar. Sebagai perorangan, masukkan masing-masing di aplikasi Receita Federal › Receita Saúde; dengan CNPJ, terbitkan faktur jasa.",
 "Com valor a receber": "Ada nilai yang akan diterima",
 "Com vencimento": "Dengan jatuh tempo",
 "Combinado": "Sepakat",
 "Combinado 👍": "Oke 👍",
 "Combustível": "Bahan bakar",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Mulailah dengan mendaftarkan biaya tetap bulanan (sewa, listrik, internet) dan kartu Anda. Saya akan mengingatkan sebelum setiap jatuh tempo.",
 "Comecei em": "Mulai tanggal",
 "Comentários": "Komentar",
 "Começa amanhã": "Mulai besok",
 "Começa às {hora} (em {m} min)": "Mulai pukul {hora} (dalam {m} mnt)",
 "Começar": "Mulai",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Mulai dengan templat: sarapan, camilan, makan siang, camilan, dan makan malam",
 "Começar em": "Mulai dari",
 "Começar o teste grátis": "Mulai uji coba gratis",
 "Comi outros alimentos ou quantidades": "Saya makan makanan atau porsi lain",
 "Comida": "Makanan",
 "Comidas e bebidas": "Makanan dan minuman",
 "Comido": "Dimakan",
 "Comido / alterações": "Dimakan / perubahan",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "\"Dimakan\" menghitung waktu makan yang ditandai selesai (atau ada perubahan) sampai hari ini.",
 "Comigo": "Ada pada saya",
 "Comissão da plataforma": "Komisi platform",
 "Como apagar a sua conta e os seus dados": "Cara menghapus akun dan data kamu",
 "Como chegar": "Petunjuk arah",
 "Como ela está": "Kondisinya",
 "Como estou comparado ao mês passado?": "Bagaimana posisi saya dibanding bulan lalu?",
 "Como funciona": "Cara kerjanya",
 "Como planejado": "Sesuai rencana",
 "Compartilhado no grupo": "Dibagikan di grup",
 "Compartilhado no grupo · só leitura": "Dibagikan di grup · hanya baca",
 "Compartilhamento indisponível neste dispositivo.": "Berbagi tidak tersedia di perangkat ini.",
 "Compartilhar": "Bagikan",
 "Compartilhar PDF": "Bagikan PDF",
 "Compartilhar a limpeza": "Bagikan bersih-bersih",
 "Compartilhar os dados": "Bagikan data",
 "Compartilhar os dados com a equipe": "Bagikan data dengan tim",
 "Compartilhar os dados com o grupo?": "Bagikan data dengan grup?",
 "Compartilhar texto": "Bagikan teks",
 "Competência (mês de referência)": "Periode (bulan referensi)",
 "Competência {d}": "Periode {d}",
 "Complemento": "Keterangan tambahan",
 "Complete seus dados": "Lengkapi data Anda",
 "Compra": "Pembelian",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Jual beli properti, kendaraan, dan saham, kuitansi yang dapat dikurangkan, dan kalender pajak.",
 "Compra feita": "Sudah dibeli",
 "Compra no cartão": "Pembelian dengan kartu",
 "Compras": "Pembelian",
 "Compras da semana": "Belanja mingguan",
 "Comprimir": "Kompres",
 "Compromisso": "Janji temu",
 "Compromisso da escola": "Agenda sekolah",
 "Comprovante": "Bukti",
 "Comprovante guardado": "Bukti tersimpan",
 "Comprovantes": "Bukti",
 "Computador": "Komputer",
 "Comédia": "Komedi",
 "Concedi": "Saya meminjamkan",
 "Concluir": "Selesaikan",
 "Concluir (esquerda)": "Selesaikan (kiri)",
 "Concluída": "Selesai",
 "Concluído": "Selesai",
 "Concluído (%)": "Selesai (%)",
 "Concluído!": "Selesai!",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Saya setuju nama, CPF, dan email saya hanya digunakan untuk mengidentifikasi akun saya, dan tugas serta catatan saya disimpan di dalamnya. Saya dapat menghapus akun dan semua data kapan saja di Pengaturan › Keamanan.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "Saya setuju nama, CPF, dan email saya hanya digunakan untuk mengidentifikasi akun saya, dan tugas serta catatan saya disimpan di dalamnya. Saya dapat menghapus akun dan semua data kapan saja di Pengaturan.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "Saya setuju nama, dokumen, dan email saya hanya digunakan untuk mengidentifikasi akun saya, dan tugas serta catatan saya disimpan di dalamnya. Saya dapat menghapus akun dan semua data kapan saja di Pengaturan › Keamanan.",
 "Concursos": "Seleksi Pegawai Negeri",
 "Condicionador": "Kondisioner",
 "Condomínio": "Iuran kondominium",
 "Condomínio e IPTU": "Iuran gedung dan IPTU",
 "Conectado": "Terhubung",
 "Conectando...": "Menghubungkan...",
 "Conectar": "Hubungkan",
 "Conectar navegador": "Hubungkan peramban",
 "Conectar o {nome}": "Hubungkan {nome}",
 "Conectar relógio ou app de saúde": "Hubungkan jam tangan atau app kesehatan",
 "Conectar {nome}": "Hubungkan {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Hubungkan {nome} di Pengaturan › Google Drive dan OneDrive.",
 "Conferindo...": "Memeriksa...",
 "Conferir controles, chaves e Wi-Fi": "Periksa remote, kunci, dan Wi-Fi",
 "Conferir o prazo no sistema oficial": "Periksa tenggat di sistem resmi",
 "Confete": "Konfeti",
 "Configuração geral": "Pengaturan umum",
 "Confira a senha da sua conta e tente de novo.": "Periksa kata sandi akun Anda dan coba lagi.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Periksa tanggal resmi di situs Receita Federal dan sesuaikan bila perlu.",
 "Confira o código. Ele tem 6 letras e números.": "Periksa kodenya. Kode terdiri dari 6 huruf dan angka.",
 "Confira o e-mail ou deixe em branco.": "Periksa email atau biarkan kosong.",
 "Confira o e-mail.": "Periksa email.",
 "Confira o prazo no sistema oficial.": "Periksa tenggat di sistem resmi.",
 "Confira os 11 números.": "Periksa 11 angkanya.",
 "Confira os campos antes de salvar.": "Periksa kolom sebelum menyimpan.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Pastikan akun Google Anda sudah ditambahkan di ponsel dan kalendernya sedang disinkronkan.",
 "Confirmada": "Dikonfirmasi",
 "Confirmado": "Hadir",
 "Confirmar": "Konfirmasi",
 "Confirme a declaração sobre a empresa.": "Konfirmasi pernyataan tentang perusahaan.",
 "Confirme o seu celular": "Konfirmasi ponsel Anda",
 "Confirme para ativar a biometria": "Konfirmasi untuk mengaktifkan biometrik",
 "Confirme para excluir": "Konfirmasi untuk menghapus",
 "Confirme sua senha para sincronizar": "Konfirmasi kata sandi Anda untuk menyinkronkan",
 "Confraternização": "Perayaan bersama",
 "Confraternização Universal": "Tahun Baru",
 "Conselho": "Dewan profesi",
 "Consignado": "Pinjaman potong gaji",
 "Consulta": "Konsultasi",
 "Consulta ou vacina": "Konsultasi atau vaksin",
 "Consultas": "Konsultasi",
 "Consultório": "Praktik",
 "Consumo médio: {v} km/L": "Rata-rata konsumsi: {v} km/L",
 "Conta": "Akun",
 "Conta a pagar": "Tagihan yang harus dibayar",
 "Conta a receber": "Piutang",
 "Conta de consumo ou tributo": "Tagihan utilitas atau pajak",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Menghitung hari saat setiap item dijadwalkan (menurut hari dalam minggunya) dan hari saat item ditandai selesai.",
 "Conta paga": "Tagihan dibayar",
 "Conta recebida": "Piutang diterima",
 "Conta vence hoje": "Tagihan jatuh tempo hari ini",
 "Conta vencendo": "Tagihan segera jatuh tempo",
 "Contabilidade": "Akuntansi",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Termasuk pendamping. Ketuk status tamu untuk mengubahnya.",
 "Contando: {cliente}": "Menghitung: {cliente}",
 "Contas": "Pembayaran",
 "Contas a pagar": "Tagihan",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Tagihan dan piutang, pengeluaran bulanan, pengingat jatuh tempo, dan kontrol MEI (Mestre Achado).",
 "Contas a receber": "Piutang",
 "Contas fixas": "Biaya tetap",
 "Contato": "Kontak",
 "Contato de emergência": "Kontak darurat",
 "Contato do encarregado de dados:": "Kontak petugas pelindungan data:",
 "Conte a sua ideia para o app ficar melhor.": "Ceritakan ide Anda agar aplikasi jadi lebih baik.",
 "Conte o que está difícil ou não funciona como deveria.": "Ceritakan apa yang sulit atau tidak berfungsi sebagaimana mestinya.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Ceritakan apa yang Anda lakukan, apa yang Anda harapkan, dan apa yang muncul. Jika ada pesan kesalahan, salin di sini.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Beri tahu kami masalah, error, dan ide perbaikan. Pesan Anda langsung sampai ke tim My Planner.",
 "Conteúdo": "Isi",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Konten yang Anda buat: tugas, catatan, keuangan, dokumen, foto, lampiran, dan data tab.",
 "Conteúdo, matéria, tarefa de casa...": "Isi, mata pelajaran, PR...",
 "Continuar": "Lanjutkan",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Terus gunakan My Planner dan Catatan seharga {preco} per tahun. Data Anda tetap tersimpan.",
 "Contratado": "Dikontrak",
 "Contratado: {v}": "Dikontrak: {v}",
 "Contrato": "Kontrak",
 "Conversa": "Obrolan",
 "Conversa do grupo": "Obrolan grup",
 "Conversar": "Chat",
 "Conversar com o Mestre (precisa da sua IA)": "Ngobrol dengan Mestre (perlu AI Anda)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Mengobrol dengan teman dan grup, serta melakukan panggilan suara dan video.",
 "Converter de PDF": "Konversi dari PDF",
 "Converter para PDF": "Konversi ke PDF",
 "Convidado": "Tamu",
 "Convidados": "Tamu",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Tamu dengan konfirmasi kehadiran, vendor, dan susunan acara hari besar.",
 "Convidados e cronograma do dia, sem os valores.": "Tamu dan jadwal hari H, tanpa nominal.",
 "Convidar": "Undang",
 "Convidar pelo WhatsApp": "Undang lewat WhatsApp",
 "Convite": "Undangan",
 "Convite copiado. Cole onde quiser enviar.": "Undangan disalin. Tempel di mana saja untuk mengirim.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Undangan tidak valid atau sudah diganti admin. Minta tautan baru.",
 "Convite para o My Planner": "Undangan ke My Planner",
 "Convênio": "Asuransi",
 "Copiar": "Salin",
 "Copiar a lista para uma tarefa": "Salin daftar ke tugas",
 "Copiar o código": "Salin kode",
 "Copiar para hoje": "Salin ke hari ini",
 "Copo de outro tamanho": "Gelas ukuran lain",
 "Copo {n}": "Gelas {n}",
 "Cor": "Warna",
 "Cor do fichário": "Warna map",
 "Cor do tema": "Warna tema",
 "Cor do tema de cada aba": "Warna tema setiap tab",
 "Coração": "Hati",
 "Corações": "Hati",
 "Cores das abas": "Warna tab",
 "Cores das conversas": "Warna chat",
 "Cores e opções desta aba": "Warna dan opsi tab ini",
 "Corpo": "Tubuh",
 "Corporativo": "Acara kantor",
 "Corpus Christi": "Corpus Christi",
 "Corredor": "Lorong",
 "Correia dentada": "Timing belt",
 "Corrida": "Lari",
 "Corta as bordas em branco ou partes da página.": "Memotong tepi kosong atau bagian halaman.",
 "Cortesia": "Gratis",
 "Coxa e sobrecoxa": "Paha ayam (atas dan bawah)",
 "Cozinha": "Dapur",
 "Creatina": "Kreatin",
 "Criada em {data}": "Dibuat pada {data}",
 "Criado com": "Dibuat dengan",
 "Criado em": "Dibuat pada",
 "Criança": "Anak",
 "Crianças": "Anak-anak",
 "Criar": "Buat",
 "Criar animada": "Buat animasi",
 "Criar conta": "Buat akun",
 "Criar do zero": "Buat dari awal",
 "Criar documento, planilha ou apresentação": "Buat dokumen, spreadsheet, atau presentasi",
 "Criar em outro app": "Buat di aplikasi lain",
 "Criar escritório": "Buat kantor",
 "Criar fichário": "Buat map",
 "Criar figurinha": "Buat stiker",
 "Criar grupo": "Buat grup",
 "Criar grupo e convidar pessoas": "Buat grup dan undang orang",
 "Criar minha chave de API": "Buat kunci API saya",
 "Criar o cofre": "Buat brankas",
 "Criar o grupo e convidar": "Buat grup dan undang",
 "Criar os prazos do IR de {ano}": "Buat tenggat IR {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Buat target (liburan, dana cadangan, mobil...)",
 "Criar uma senha nova": "Buat kata sandi baru",
 "Criar {n} tarefa(s)": "Buat {n} tugas",
 "Criação do Estado de MS": "Hari Pembentukan Negara Bagian MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Buat kepindahan dan aplikasi langsung menyusun daftar pemindahan (listrik, air, internet...). Lalu daftarkan kardus per ruangan, inspeksi, dan jadwal harian.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Buat folder untuk setiap klien, undang klien lewat tautan (ia hanya melihat foldernya sendiri), dan bertukar dokumen dua arah: faktur, slip pembayaran, slip gaji, rekening koran, kontrak.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Buat kelas (atau grup mentoring, latihan, kursus) dan, di dalamnya, siswa, absensi, nilai, rencana pelajaran, materi, dan tagihan.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Buat kelas, lalu di dalamnya siswa, absensi, penilaian dengan nilai, dan rencana pelajaran.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Buat tugas rumah (membersihkan kamar mandi, mengganti sprei...) beserta frekuensinya. Aplikasi akan memberi tahu saat terlambat, tanpa memenuhi My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Buat kartu berisi checklist, daftar, teks bebas, atau gambar untuk materi ini. Geser ke kanan untuk menghapus dan ke kiri untuk mengarsipkan.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Buat kantor, ajak tim (teman aplikasi atau undangan lewat tautan), lalu saling bertukar pesan dan dokumen, jadwalkan rapat, dan adakan rapat video. Sebagai admin, Anda bisa merekam rapat.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Buat acara, lalu di dalamnya daftar tamu dengan konfirmasi kehadiran, vendor, dan susunan acara.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Buat grup dan kirim tautannya: siapa pun yang bergabung menerima tanggal, lokasi, pemberitahuan, dan semua yang Anda kirim, lalu bisa menerima, mengedit, atau menolak.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: siapa pun yang bergabung dapat melihat dan ikut serta sesuai peran yang Anda pilih. Hanya admin yang dapat menambah atau mengeluarkan orang.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: siapa pun yang bergabung melihat semua yang ada di sini dan ikut serta (menambah, mengedit, mengunggah foto). Hanya admin yang dapat menambah atau mengeluarkan orang.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Buat akun Anda. Data Anda disimpan di cloud dan di perangkat ini.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Buat map (mis.: Doktoral, Bahasa Inggris, Ujian) dan di dalamnya mata pelajaran dan halaman.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Buat grup (kelas, pasien, tim, tamu, klien), bagikan tautan undangan, lalu kirim janji temu, materi, dan pengumuman. Setiap orang menerima, mengedit, atau menolak yang mereka terima.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Buat profil dengan nama dan, jika Anda pengacara, nomor OAB.",
 "Criptografado no cofre, só neste dispositivo": "Terenkripsi di brankas, hanya di perangkat ini",
 "Criptomoedas": "Kripto",
 "Cronograma": "Jadwal",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Jadwal makan, perawatan diri langkah demi langkah, dan air minum hari ini.",
 "Cronograma do dia": "Susunan acara",
 "Cronograma físico-financeiro": "Jadwal fisik-keuangan",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Jadwal fisik-keuangan per tahap, catatan harian proyek dengan sebelum dan sesudah, tukang, dan pengiriman.",
 "Cronômetro de horas": "Pencatat jam",
 "Crédito empresarial": "Kredit usaha",
 "Créditos": "Kredit",
 "Cuida das reservas, da limpeza e das despesas.": "Mengurus pemesanan, kebersihan, dan pengeluaran.",
 "Cuidado": "Perawatan",
 "Cuidado pessoal": "Perawatan diri",
 "Cuidados": "Perawatan",
 "Cupom do mercado": "Struk belanja",
 "Cupom do mercado (foto)": "Struk belanja (foto)",
 "Cupom lançado": "Struk dicatat",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Kursus",
 "Cursos": "Kursus",
 "Cursos livres e certificações": "Kursus dan sertifikasi",
 "Cuscuz": "Kuskus jagung",
 "CÓDIGO PARA PAGAR": "KODE PEMBAYARAN",
 "CÔMODOS": "RUANGAN",
 "Câmera": "Kamera",
 "Câmera e galeria": "Kamera dan galeri",
 "Câmera não liberada": "Kamera tidak diizinkan",
 "Código IBGE do município": "Kode IBGE kota",
 "Código IBGE do município (7 números)": "Kode IBGE kota (7 angka)",
 "Código NBS (9 números, opcional)": "Kode NBS (9 angka, opsional)",
 "Código copiado": "Kode disalin",
 "Código da reserva (localizador)": "Kode pemesanan",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Barcode, kode angka, atau Pix salin-tempel (opsional)",
 "Código de indicação": "Kode referral",
 "Código de indicação (opcional)": "Kode referral (opsional)",
 "Código de quem convidou você": "Kode dari orang yang mengundang Anda",
 "Código de tributação nacional (6 números)": "Kode pajak nasional (6 angka)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Kode pajak nasional (6 angka, mis.: 171901)",
 "Código do amigo": "Kode teman",
 "Código do convite": "Kode undangan",
 "Código do procedimento (TUSS ou do plano)": "Kode tindakan (TUSS atau dari asuransi)",
 "Código errado. Confira e tente de novo.": "Kode salah. Periksa dan coba lagi.",
 "Código não encontrado. Confira as letras e os números.": "Kode tidak ditemukan. Periksa huruf dan angkanya.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Kode tidak dikenali. Periksa angkanya (boleto: 47 atau 48 digit).",
 "Código: {c}": "Kode: {c}",
 "Cópia automática toda semana": "Cadangan otomatis setiap minggu",
 "Cópia criada.": "Salinan dibuat.",
 "Cópia de segurança": "Cadangan",
 "Cópia feita": "Cadangan dibuat",
 "Cópia restaurada.": "Cadangan dipulihkan.",
 "Cômodo": "Ruangan",
 "Cômodo ou quarto": "Kamar atau ruangan",
 "Cômodos da casa e as tarefas de cada um.": "Ruangan di rumah dan tugas masing-masing.",
 "DAS de {mes} pago": "DAS {mes} sudah dibayar",
 "DAS de {mes}: vence dia {dia}": "DAS {mes}: jatuh tempo tanggal {dia}",
 "DAS do MEI": "DAS MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "SURAT KETERANGAN KUNJUNGAN",
 "DICA DO MESTRE ACHADO": "TIPS DARI MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS no. {n}, seri {s}",
 "Da galeria ou dos arquivos": "Dari galeri atau file",
 "Da meta de passos": "Dari target langkah",
 "Dados compartilhados": "Data bersama",
 "Dados compartilhados com o grupo": "Data yang dibagikan dengan grup",
 "Dados compartilhados · seu papel: {p}": "Data bersama · peran Anda: {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Data kesehatan yang Anda catat sendiri diproses hanya untuk Anda dan orang yang Anda ajak berbagi, dengan persetujuan Anda (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Data perangkat: bahasa, negara, dan zona waktu (untuk tanggal, hari libur, dan mata uang), model perangkat, serta kode untuk notifikasi di ponsel.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Data jam tangan dan kesehatan tidak digunakan untuk iklan dan tidak dibagikan kepada siapa pun. Anda dapat memutuskan koneksi dan mencabut izin kapan saja.",
 "Dança": "Dansa",
 "Dar ciência": "Konfirmasi",
 "Dar ciência da operação?": "Konfirmasi mengetahui transaksi?",
 "Data": "Tanggal",
 "Data (embarque ou check-in)": "Tanggal (keberangkatan atau check-in)",
 "Data agendada": "Tanggal dijadwalkan",
 "Data da aplicação": "Tanggal pemberian",
 "Data da compra": "Tanggal pembelian",
 "Data da entrega": "Tanggal pengiriman",
 "Data da venda": "Tanggal penjualan",
 "Data de nascimento": "Tanggal lahir",
 "Data do empréstimo": "Tanggal pinjam",
 "Data do pagamento": "Tanggal pembayaran",
 "Data em que foi feita": "Tanggal dilakukan",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Tanggal yang disarankan dengan cadangan 2 hari kerja. Periksa di sistem resmi.",
 "De": "Dari",
 "De uma foto": "Dari foto",
 "De {de} para {para} ({p}% menor).": "Dari {de} jadi {para} ({p}% lebih kecil).",
 "Declaração": "Pernyataan",
 "Declaração de atendimento": "Surat keterangan kunjungan",
 "Declaração para reembolso (PDF)": "Surat keterangan untuk klaim (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Saya menyatakan bahwa perusahaan ini milik saya atau milik klien yang mengizinkan pemantauan.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "Dengan ini saya menyatakan, untuk keperluan klaim penggantian{conv}, bahwa pasien {nome}{cpf}{cart} telah saya tangani pada {data}{hora}, berupa {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Atur target pelajaran per hari atau per minggu di Edit.",
 "Defina a meta de páginas por dia em Editar.": "Atur target halaman per hari di Edit.",
 "Defina um horário": "Atur jam",
 "Defina um horário para usar pausas.": "Atur jam untuk menggunakan jeda.",
 "Demaquilante ou água micelar": "Pembersih riasan atau air misel",
 "Demolição": "Pembongkaran",
 "Demonstração": "Demo",
 "Dentista": "Dokter gigi",
 "Dependentes": "Tanggungan",
 "Depois": "Sesudah",
 "Depois da aula": "Setelah kelas",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Tugas yang sudah dihapus tidak bisa dikembalikan. Masukkan kata sandi akun Anda untuk konfirmasi.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Setelah diunduh, buka file dan ketuk Instal. Jika ponsel meminta, izinkan instalasi aplikasi dari sumber ini.",
 "Depois de criar": "Setelah membuat",
 "Depois de {nome}. Toque para pular.": "Setelah {nome}. Ketuk untuk melewati.",
 "Depois é só ajustar horários e o que comer em cada um.": "Setelah itu tinggal sesuaikan jam dan menu setiap waktu makan.",
 "Desarquivar": "Batalkan arsip",
 "Desbloquear": "Buka kunci",
 "Desbloquear com": "Buka kunci dengan",
 "Desbloquear com biometria": "Buka kunci dengan biometrik",
 "Desbloquear o My Planner": "Buka kunci My Planner",
 "Desbloqueio do app": "Buka kunci aplikasi",
 "Descanso": "Istirahat",
 "Descartadas": "Diabaikan",
 "Descartar": "Abaikan",
 "Descartar este tempo?": "Buang waktu ini?",
 "Descobrir lugares em {d}": "Temukan tempat di {d}",
 "Desconectar": "Putuskan",
 "Desconectar o {nome}?": "Putuskan {nome}?",
 "Desconto": "Diskon",
 "Desconto de {v}": "Diskon {v}",
 "Descontos obtidos": "Diskon yang didapat",
 "Descrição": "Deskripsi",
 "Descrição (cliente, nota fiscal...)": "Deskripsi (klien, faktur...)",
 "Descrição do serviço (sai na nota)": "Deskripsi layanan (tercantum di faktur)",
 "Descrição que sai na nota": "Deskripsi yang tercantum di faktur",
 "Desenhar a assinatura": "Gambar tanda tangan",
 "Desenhar com caneta ou dedo": "Gambar dengan pena atau jari",
 "Desenhe a assinatura e escolha a página e o lugar.": "Gambar tanda tangan lalu pilih halaman dan posisinya.",
 "Desenhe a assinatura primeiro.": "Gambar tanda tangan dulu.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Gambarlah dengan jari atau pena (S Pen, Apple Pencil, atau pena tablet).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Gambar dengan jari atau pena. Untuk menggulir papan, ketuk Pindahkan.",
 "Desenhe de novo para confirmar.": "Gambar lagi untuk konfirmasi.",
 "Desenhe o seu padrão": "Gambar pola Anda",
 "Desenhe pelo menos uma tarja.": "Gambar setidaknya satu blok hitam.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Gambar pola yang menghubungkan minimal 4 titik.",
 "Desenho": "Sketsa",
 "Desenho com caneta ou dedo": "Sketsa dengan pena atau jari",
 "Desenho incorreto": "Pola salah",
 "Desenho padrão": "Pola kunci",
 "Desenho padrão salvo.": "Pola kunci disimpan.",
 "Desenvolvimento": "Shoulder press",
 "Desfazer": "Urungkan",
 "Desfazer amizade": "Hapus pertemanan",
 "Desligar": "Matikan",
 "Desligar a sincronização?": "Matikan sinkronisasi?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Geser ke samping untuk melihat hari lain (hingga 60 hari ke depan). Ketuk waktu makan untuk merencanakan menu khusus hari itu. Seret ke kanan untuk menghapus.",
 "Desmarcado": "Dibatalkan",
 "Desmarcar como recebida": "Tandai belum diterima",
 "Desmarcar feita hoje": "Batalkan tanda selesai hari ini",
 "Desmarcar grupo": "Batalkan pilihan grup",
 "Desmarcar pagamento": "Batalkan tanda bayar",
 "Desodorante": "Deodoran",
 "Despensa": "Gudang makanan",
 "Despesa": "Pengeluaran",
 "Despesas": "Pengeluaran",
 "Destino": "Tujuan",
 "Detalhes": "Detail",
 "Devolver até": "Kembalikan paling lambat",
 "Devolver: {i} ({p})": "Kembalikan: {i} ({p})",
 "Devolvido": "Sudah dikembalikan",
 "Devolvidos": "Dikembalikan",
 "Dia": "Hari",
 "Dia a dia": "Sehari-hari",
 "Dia da mudança": "Hari pindahan",
 "Dia de vencimento do DAS": "Tanggal jatuh tempo DAS",
 "Dia do Trabalho": "Hari Buruh",
 "Dia do vencimento": "Tanggal jatuh tempo",
 "Dia em que a fatura fecha": "Tanggal tutup tagihan",
 "Dia planejado": "Hari yang direncanakan",
 "Dia {d} de {total}": "Hari {d} dari {total}",
 "Diagnóstico": "Diagnosis",
 "Dias e horários": "Hari dan jam",
 "Dias específicos": "Hari tertentu",
 "Dias úteis": "Hari kerja",
 "Dias: {dias}": "Hari: {dias}",
 "Dicas e observações": "Tips dan catatan",
 "Diesel": "Solar",
 "Diferença": "Selisih",
 "Digitado": "Manual",
 "Digitar": "Ketik",
 "Digitar à mão": "Masukkan manual",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Masukkan kata sandi brankas. Brankas tertutup sendiri setelah 5 menit tidak dipakai.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Ketik dalam menit (90) atau jam dan menit (1:30 atau 01:30) lalu ketuk OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Ketik dengan format HH:MM, misalnya 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Masukkan kode dan dapatkan 10 hari dengan semua tab terbuka. Jika tidak punya, biarkan kosong.",
 "Digite o nome da tarefa.": "Masukkan nama tugas.",
 "Dinheiro": "Uang",
 "Dinheiro e documentos": "Uang dan dokumen",
 "Direita": "Kanan",
 "Direito": "Hukum",
 "Direito Administrativo": "Hukum Administrasi Negara",
 "Direito Civil": "Hukum Perdata",
 "Direito Constitucional": "Hukum Tata Negara",
 "Direito Empresarial": "Hukum Bisnis",
 "Direito Penal": "Hukum Pidana",
 "Direito Tributário": "Hukum Pajak",
 "Direito do Trabalho": "Hukum Ketenagakerjaan",
 "Direto": "Langsung",
 "Disciplina": "Mata pelajaran",
 "Dispensar": "Tutup",
 "Dispensar o aviso": "Tutup pemberitahuan",
 "Dispensar todas": "Tutup semua",
 "Disponibilizada em": "Tersedia pada",
 "Disponível no app novo": "Tersedia di aplikasi baru",
 "Distância": "Jarak",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Bagi kursus menjadi materi atau modul. Di setiap materi, tandai pelajaran terakhir dan buat kartu catatan.",
 "Dividir": "Pisahkan",
 "Dividir entre (nenhum marcado = todos)": "Bagi ke (tidak ada yang dipilih = semua)",
 "Divisão das despesas": "Pembagian pengeluaran",
 "Diária": "Tarif per malam",
 "Diária padrão": "Tarif standar per malam",
 "Diário": "Catatan harian",
 "Diários municipais": "Lembaran daerah kota",
 "Do celular, do Google Drive ou do OneDrive": "Dari ponsel, Google Drive atau OneDrive",
 "Do cliente": "Dari klien",
 "Do escritório": "Dari kantor",
 "Doações": "Donasi",
 "Docs": "Dok",
 "Documento": "Dokumen",
 "Documento (fundo branco)": "Dokumen (latar putih)",
 "Documento do veículo (CRLV)": "Dokumen kendaraan (CRLV)",
 "Documento pessoal": "Dokumen pribadi",
 "Documento vence hoje": "Dokumen kedaluwarsa hari ini",
 "Documento vencendo": "Dokumen segera kedaluwarsa",
 "Documento: {o}": "Dokumen: {o}",
 "Documentos": "Dokumen",
 "Documentos (contrato, nota, recibo...)": "Dokumen (kontrak, faktur, kuitansi...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Dokumen (paspor, KTP, SIM)",
 "Documentos e autorização das crianças": "Dokumen dan izin anak",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Dokumen terlindungi, hasil pemeriksaan, riwayat kesehatan, dan kolom lain bertanda 🔒 dienkripsi di perangkat ini (AES-256) dengan kata sandi brankas. Tim dukungan pun tidak bisa membacanya. Tanpa kata sandi, data ini tidak dapat dipulihkan.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Dokumen, struk, buku catatan, dan papan tulis, banyak halaman",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Dokumen, rapat, dan rekaman dihapus untuk semua orang. Obrolan tetap ada di Pesan.",
 "Documentário": "Dokumenter",
 "Doenças, cirurgias e observações": "Penyakit, operasi, dan catatan",
 "Dois dedos ou toque duplo para ampliar": "Cubit atau ketuk dua kali untuk memperbesar",
 "Domingo": "Minggu",
 "Dono da obra": "Pemilik proyek",
 "Dose": "Dosis",
 "Dose (ex.: 1 cápsula, 5 g)": "Takaran (mis.: 1 kapsul, 5 g)",
 "Dose única": "Dosis tunggal",
 "Drama": "Drama",
 "Duplicar": "Duplikat",
 "Duplicar tarefa": "Duplikat tugas",
 "Duração": "Durasi",
 "Duração de cada sessão": "Durasi setiap sesi",
 "Duração {dur}": "Durasi {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Bisakah saya membeli barang seharga 3 ribu dengan 10 kali cicilan?",
 "Débito automático": "Debit otomatis",
 "Débito, Pix ou dinheiro": "Debit, Pix, atau tunai",
 "Dê um nome ao cartão.": "Beri nama kartu.",
 "Dê um nome ao cuidado.": "Beri nama perawatan.",
 "Dê um nome ao cômodo.": "Beri nama ruangan.",
 "Dê um nome ao fichário.": "Beri nama map.",
 "Dê um nome ao grupo.": "Beri nama grup.",
 "Dê um nome ao suplemento.": "Beri nama suplemen.",
 "Dê um nome ao treino.": "Beri nama latihan.",
 "Dê um nome à conta.": "Beri nama tagihan.",
 "Dê um nome à matéria.": "Beri nama mata pelajaran.",
 "Dê um nome à meta.": "Beri nama target.",
 "Dê um nome à refeição.": "Beri nama waktu makan.",
 "Dê um nome à tarefa.": "Beri nama tugas.",
 "E-MAIL (OPCIONAL)": "EMAIL (OPSIONAL)",
 "E-mail": "Email",
 "E-mail (recebe a nota)": "Email (menerima faktur)",
 "E-mail de contato": "Email kontak",
 "E-mail do responsável": "Email wali murid",
 "E-mail inválido": "Email tidak valid",
 "E-mail inválido.": "Email tidak valid.",
 "E-mail ou WhatsApp para resposta (opcional)": "Email atau WhatsApp untuk balasan (opsional)",
 "E-mail para contato (opcional)": "Email kontak (opsional)",
 "E-mail salvo.": "Email disimpan.",
 "EM ATRASO": "TERLAMBAT",
 "ENTRAR COM UM CÓDIGO": "GABUNG DENGAN KODE",
 "ENVIADOS": "TERKIRIM",
 "ESCOLHA AS ATIVIDADES": "PILIH AKTIVITAS",
 "ESTA SEMANA": "MINGGU INI",
 "EXERCÍCIO FÍSICO": "OLAHRAGA",
 "Economia": "Ekonomi",
 "Edita tudo": "Mengedit semua",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Mengedit semua: tahapan, anggaran, catatan harian, dan pengiriman.",
 "Editar": "Edit",
 "Editar cartão": "Edit kartu",
 "Editar compra": "Edit pembelian",
 "Editar cômodo": "Edit ruangan",
 "Editar desenho": "Edit gambar",
 "Editar documento": "Edit dokumen",
 "Editar fichário": "Edit map",
 "Editar garantia": "Edit garansi",
 "Editar matéria": "Edit mata pelajaran",
 "Editar meta": "Edit target",
 "Editar perfil": "Edit profil",
 "Editar tarefa": "Edit tugas",
 "Editar {nome}": "Edit {nome}",
 "Educação": "Pendidikan",
 "Educação Física": "Pendidikan Jasmani",
 "Efeito de scanner": "Efek pemindai",
 "Ela sai da lista e dos Recebidos da equipe.": "Rapat akan hilang dari daftar dan dari Diterima milik tim.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Stiker juga tersimpan di \"Stiker saya\" agar bisa dikirim lagi.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Ini berasal dari tab Pinjaman & Pembiayaan. Tandai lunas di sini atau buka tab tersebut untuk melihat kontraknya.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Ini berasal dari tab Faktur Pajak. Tandai diterima saat uangnya masuk.",
 "Eleitorais": "Pemilu",
 "Eletrodoméstico": "Peralatan rumah tangga",
 "Eletrodomésticos": "Peralatan rumah tangga",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Peralatan rumah tangga, elektronik, dan perabot: nota, servis resmi, dan pengingat 15 hari sebelum garansi habis.",
 "Eletrônico": "Elektronik",
 "Elétrica": "Listrik",
 "Elétrico": "Listrik",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "Di Edit, tempel tautan kalender (iCal) iklan Anda. Di Airbnb: Kalender › Ketersediaan › Hubungkan kalender › Ekspor kalender. Di Booking: Harga & ketersediaan › Sinkronisasi kalender.",
 "Em aberto": "Belum lunas",
 "Em alta": "Trending",
 "Em andamento": "Sedang dikerjakan",
 "Em atraso": "Terlambat",
 "Em branco": "Kosong",
 "Em casa": "Di rumah",
 "Em cima": "Atas",
 "Em construção": "Dalam pengembangan",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "Terbaru. Perbaikan datang otomatis saat aplikasi dibuka.",
 "Em limpeza": "Sedang dibersihkan",
 "Em quais páginas": "Di halaman mana",
 "Em qual agenda criar os eventos:": "Kalender untuk membuat acara:",
 "Em qual página e onde": "Di halaman mana dan di mana",
 "Em tratamento": "Dalam perawatan",
 "Em um horário específico": "Pada waktu tertentu",
 "Em uso: {ia}": "Digunakan: {ia}",
 "Em {n} dia(s)": "Dalam {n} hari",
 "Embaixo": "Bawah",
 "Embaixo à esquerda": "Kiri bawah",
 "Emissão": "Tanggal terbit",
 "Emissão +": "Terbit +",
 "Emissão: {data}": "Terbit: {data}",
 "Emitida": "Diterbitkan",
 "Emitida em {data}": "Diterbitkan pada {data}",
 "Emitida ou recebida": "Diterbitkan atau diterima",
 "Emitidas": "Diterbitkan",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Diterbitkan: {v} · Diterima: {r} · {n} faktur",
 "Emitir": "Terbitkan",
 "Emitir NFS-e": "Terbitkan NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Terbitkan NFS-e sesuai Padrão Nacional dengan sertifikat A1, cari faktur yang diterbitkan dan diterima, serta ekspor XML, spreadsheet, dan PDF.",
 "Emitir a nota de verdade?": "Terbitkan faktur sungguhan?",
 "Emitir no ambiente de teste?": "Terbitkan di lingkungan uji?",
 "Emojis": "Emoji",
 "Emojis animados": "Emoji animasi",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Emoji animasi: Noto, dari Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emoji, GIF, dan stiker",
 "Empresa": "Perusahaan",
 "Empresa de mudança": "Jasa pindahan",
 "Empresa ou pessoa": "Perusahaan atau orang",
 "Empresa, hotel ou voo": "Perusahaan, hotel, atau penerbangan",
 "Empresas": "Perusahaan",
 "Emprestei": "Saya pinjamkan",
 "Empréstimo": "Pinjaman",
 "Empréstimo entre pessoas": "Pinjaman antarperorangan",
 "Empréstimo pessoal": "Pinjaman pribadi",
 "Empréstimos": "Pinjaman",
 "Empréstimos & Financiamentos": "Pinjaman & Pembiayaan",
 "Encaminhada para {nome}.": "Diteruskan ke {nome}.",
 "Encaminhar": "Teruskan",
 "Encaminhar para": "Teruskan ke",
 "Encerrar e salvar": "Akhiri dan simpan",
 "Encontrada para {perfil}": "Ditemukan untuk {perfil}",
 "Endereço": "Alamat",
 "Endereço (opcional)": "Alamat (opsional)",
 "Endereço (se for presencial)": "Alamat (jika tatap muka)",
 "Endereço atual": "Alamat saat ini",
 "Endereço da escola": "Alamat sekolah",
 "Endereço da oficina": "Alamat bengkel",
 "Endereço de quem está com o item": "Alamat orang yang memegang barang",
 "Endereço do consultório": "Alamat tempat praktik",
 "Endereço do imóvel": "Alamat properti",
 "Endereço do laboratório": "Alamat laboratorium",
 "Endereço do veterinário": "Alamat dokter hewan",
 "Endereço no trabalho e na escola": "Alamat di kantor dan sekolah",
 "Endereço nos Correios e entregas": "Alamat di kantor pos dan pengiriman",
 "Endereço nos bancos e cartões": "Alamat di bank dan kartu",
 "Endereço novo": "Alamat baru",
 "Endereço ou nome do lugar": "Alamat atau nama tempat",
 "Endereço ou terminal": "Alamat atau terminal",
 "Energia": "Energi",
 "Enfermeiro": "Perawat",
 "Engenharia": "Teknik",
 "Engenheiro ou arquiteto": "Insinyur atau arsitek",
 "Enquadre o documento e toque no botão": "Posisikan dokumen dalam bingkai lalu ketuk tombol",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Posisikan wajah Anda dan ketuk tombol. 🔄 membalik kamera.",
 "Ensino Fundamental": "Pendidikan Dasar",
 "Ensino Médio e ENEM": "SMA dan ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "Saya mengerti dan setuju menggunakan monitor dengan ketentuan ini.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Langsung masuk ke Planner, dengan jam, hari, dan daftar item. Jika jam itu sudah terisi, Anda bisa memilih: ganti, simpan keduanya, atau batal.",
 "Entrada": "Pemasukan",
 "Entrada (imóvel novo)": "Masuk (rumah baru)",
 "Entrada de dinheiro": "Uang masuk",
 "Entrando...": "Masuk...",
 "Entrar": "Masuk",
 "Entrar com CPF e senha": "Masuk dengan CPF dan kata sandi",
 "Entrar com outra conta": "Masuk dengan akun lain",
 "Entrar de novo": "Masuk lagi",
 "Entrar na chamada": "Gabung panggilan",
 "Entrar na reunião": "Gabung rapat",
 "Entrar na sala online": "Masuk ke ruang online",
 "Entrar no grupo": "Gabung grup",
 "Entrar no navegador?": "Masuk di peramban?",
 "Entre com seu CPF e sua senha.": "Masuk dengan CPF dan kata sandi Anda.",
 "Entre com seu e-mail e sua senha.": "Masuk dengan email dan kata sandi Anda.",
 "Entre na sua conta de novo.": "Silakan masuk lagi.",
 "Entre na sua conta para usar as notas fiscais.": "Masuk ke akun Anda untuk menggunakan faktur.",
 "Entre no app com o seu e-mail e a senha nova.": "Masuk ke aplikasi dengan email dan kata sandi baru Anda.",
 "Entrega de material": "Pengiriman material",
 "Entrega prevista": "Perkiraan pengiriman",
 "Entregas": "Pengiriman",
 "Entregue": "Diserahkan",
 "Entrou": "Masuk",
 "Entrou no total da semana.": "Ditambahkan ke total minggu ini.",
 "Enviada": "Terkirim",
 "Enviado": "Terkirim",
 "Enviado para o Planner": "Terkirim ke Planner",
 "Enviado pelo cliente": "Dikirim oleh klien",
 "Enviado pelo escritório": "Dikirim oleh kantor",
 "Enviado por {quem} no grupo {g}": "Dikirim oleh {quem} di grup {g}",
 "Enviando {f} de {n}...": "Mengirim {f} dari {n}...",
 "Enviando...": "Mengirim...",
 "Enviar": "Kirim",
 "Enviar \"{nome}\"": "Kirim \"{nome}\"",
 "Enviar \"{nome}\" para…": "Kirim \"{nome}\" ke…",
 "Enviar \"{titulo}\" para": "Kirim \"{titulo}\" ke",
 "Enviar ao grupo": "Kirim ke grup",
 "Enviar convite": "Kirim undangan",
 "Enviar convite para {nome}": "Kirim undangan ke {nome}",
 "Enviar convite pelo WhatsApp": "Kirim undangan lewat WhatsApp",
 "Enviar documento": "Kirim dokumen",
 "Enviar instruções ao hóspede": "Kirim petunjuk ke tamu",
 "Enviar o convite": "Kirim undangan",
 "Enviar ou copiar o código": "Kirim atau salin kode",
 "Enviar ou imprimir a etiqueta": "Kirim atau cetak label",
 "Enviar para Estudos": "Kirim ke Studi",
 "Enviar para My Planner": "Kirim ke My Planner",
 "Enviar para a equipe": "Kirim ke tim",
 "Enviar para o My Planner": "Kirim ke My Planner",
 "Enviar para o Planner": "Kirim ke Planner",
 "Enviar para o grupo": "Kirim ke grup",
 "Enviar para o grupo de estudos": "Kirim ke grup belajar",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Kirim {n} file dari perangkat ini ke {nome}",
 "Enviar para um grupo": "Kirim ke sebuah grup",
 "Enviar para {g}": "Kirim ke {g}",
 "Enviar para…": "Kirim ke…",
 "Enviar por e-mail": "Kirim lewat email",
 "Enviar relatório": "Kirim laporan",
 "Enviar relatório para a equipe": "Kirim laporan ke tim",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Kirim juga tugas yang sudah ada (mulai hari ini)",
 "Enviar tarefas do My Planner para a agenda": "Kirim tugas My Planner ke kalender",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Kirim slip pembayaran, faktur, dan laporan ke klien, atau lihat apa yang ia kirim. Setiap dokumen bisa berisi foto, PDF, dan tautan.",
 "Enxaguante": "Obat kumur",
 "Episódio": "Episode",
 "Equipe": "Tim",
 "Equipe ({n})": "Tim ({n})",
 "Equipe de limpeza": "Tim kebersihan",
 "Equipe do consultório": "Tim tempat praktik",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Tim properti (kebersihan dan co-host)",
 "Erro": "Error",
 "Erro na emissão": "Gagal menerbitkan",
 "Erro: {erro}": "Kesalahan: {erro}",
 "Erros registrados neste dispositivo ({n})": "Galat yang tercatat di perangkat ini ({n})",
 "Escanear documento": "Pindai dokumen",
 "Escanear o verso": "Pindai bagian belakang",
 "Escanear para PDF": "Pindai ke PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Pindai dokumen, struk, buku catatan, dan papan tulis: tepi dan bayangan diperbaiki, banyak halaman, kartu identitas depan dan belakang, tanda tangan, dan PDF tersimpan di ponsel, Google Drive, atau OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Pindai, perjelas gambar, atur dalam folder, dan kirim PDF lewat WhatsApp, email, atau Drive. Saat AI Anda aktif, aplikasi membaca teks, merangkum, dan menjawab pertanyaan tentang dokumen.",
 "Escola": "Sekolah",
 "Escolha a aba:": "Pilih tab:",
 "Escolha a data do compromisso.": "Pilih tanggal janji temu.",
 "Escolha a imagem.": "Pilih gambar.",
 "Escolha a matéria": "Pilih mata pelajaran",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Pilih folder di ponsel (mis.: Documents). Aplikasi akan menyimpan di sana secara otomatis.",
 "Escolha a página": "Pilih halaman",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Pilih setidaknya satu pengadilan atau centang \"Semua pengadilan\".",
 "Escolha ao menos uma agenda.": "Pilih setidaknya satu kalender.",
 "Escolha o PDF": "Pilih PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Pilih file .pfx (atau .p12) sertifikat A1 perusahaan dan masukkan kata sandinya. Sertifikat disimpan terenkripsi di brankas Anda.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Pilih file .xml NFS-e, NF-e, atau CT-e.",
 "Escolha o fichário": "Pilih map",
 "Escolha o grupo para enviar: {t}": "Pilih grup tujuan: {t}",
 "Escolha os PDFs": "Pilih PDF-PDF",
 "Escolha os arquivos.": "Pilih file.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Pilih hari libur yang muncul di Planner dan di tombol 🎉 Hari libur.",
 "Escolha para quem enviar.": "Pilih penerima.",
 "Escolha pelo menos um dia.": "Pilih setidaknya satu hari.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Pilih setidaknya satu halaman yang ada di PDF (mis.: 1-3, 5).",
 "Escolha quem participa:": "Pilih peserta:",
 "Escolher": "Pilih",
 "Escolher a imagem": "Pilih gambar",
 "Escolher a pasta": "Pilih folder",
 "Escolher agendas": "Pilih kalender",
 "Escolher alimento": "Pilih makanan",
 "Escolher arquivo": "Pilih file",
 "Escolher arquivos": "Pilih file",
 "Escolher arquivos do Drive ou do OneDrive": "Pilih file dari Drive atau OneDrive",
 "Escolher as imagens e criar o PDF": "Pilih gambar dan buat PDF",
 "Escolher da galeria": "Pilih dari galeri",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Pilih dari galeri atau file (foto atau PDF)",
 "Escolher data": "Pilih tanggal",
 "Escolher fuso": "Pilih zona waktu",
 "Escolher hora": "Pilih jam",
 "Escolher horário": "Pilih jam",
 "Escolher o certificado": "Pilih sertifikat",
 "Escolher outro": "Pilih yang lain",
 "Escolher pessoas": "Pilih orang",
 "Escolher tribunais": "Pilih pengadilan",
 "Escolher ícone": "Pilih ikon",
 "Esconder da equipe (só administradores)": "Sembunyikan dari tim (hanya admin)",
 "Esconder detalhes": "Sembunyikan detail",
 "Esconder o texto completo": "Sembunyikan teks lengkap",
 "Escondido de {n} pessoa(s)": "Disembunyikan dari {n} orang",
 "Escondido de: {n}": "Disembunyikan dari: {n}",
 "Escondidos no Planner.": "Disembunyikan di Planner.",
 "Escova e pasta de dente": "Sikat dan pasta gigi",
 "Escovar os dentes": "Sikat gigi",
 "Escreva aqui": "Tulis di sini",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Ketik lalu tekan Enter (mis.: cuci mesin)",
 "Escreva em uma ou em todas as páginas.": "Tulis di satu atau semua halaman.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Tulis alasannya di \"Alasan pembatalan\" pada data faktur (minimal 15 huruf) lalu ketuk di sini lagi.",
 "Escreva o resumo, tópicos, dúvidas...": "Tulis ringkasan, topik, pertanyaan...",
 "Escreva o texto da marca d'água.": "Tulis teks tanda air.",
 "Escreva o texto.": "Tulis teksnya.",
 "Escreva o título.": "Tulis judulnya.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Tulis atau tempel teks. Baris yang diawali \"# \" jadi judul.",
 "Escreva ou cole um texto e gere o PDF.": "Tulis atau tempel teks lalu buat PDF.",
 "Escritório": "Kantor",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Kantor: dokumen dan rapat tim. Hanya administrator kantor yang dapat merekam rapat, dan semua peserta rapat melihat pemberitahuan \"Merekam\" selama rapat direkam. Rekaman disimpan di dokumen kantor dan hanya dapat dilihat oleh administrator sampai ia membagikannya kepada tim.",
 "Escuro": "Gelap",
 "Espanhol": "Bahasa Spanyol",
 "Espaço": "Properti",
 "Espaço livre, dados de cada aba e anexos": "Ruang kosong, data setiap tab, dan lampiran",
 "Especialidade": "Spesialisasi",
 "Espécie": "Spesies",
 "Esquadro": "Penggaris siku",
 "Esqueci a senha": "Lupa kata sandi",
 "Esquerda": "Kiri",
 "Esse código é o seu.": "Kode ini milik Anda sendiri.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "Itu kode Anda sendiri. Gunakan kode milik orang yang merekomendasikan aplikasi kepada Anda.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Alamat ini tidak merespons sebagai server faktur. Periksa dan coba lagi.",
 "Esta aba ainda não está no seu plano.": "Tab ini belum ada di paket Anda.",
 "Esta e todas as futuras": "Ini dan semua yang akan datang",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Alat ini perlu melihat halaman PDF, yang tersedia di aplikasi baru (versi 0.50). Gunakan browser atau pasang APK baru.",
 "Esta imagem foi guardada em outro dispositivo.": "Gambar ini disimpan di perangkat lain.",
 "Esta janela pode ser fechada.": "Jendela ini boleh ditutup.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Orang ini belum mengisi kartu kontaknya.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Minggu ini: {a} dari {m} pelajaran ({p}%)",
 "Esta senha é de outra conta.": "Kata sandi ini milik akun lain.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Tugas ini tidak punya waktu: \"Saat mulai\" dan \"Sebelum mulai\" tidak berlaku. Gunakan \"Pada waktu tertentu\".",
 "Esta tarefa se repete. O que excluir?": "Tugas ini berulang. Apa yang ingin dihapus?",
 "Esta tela teve um problema": "Layar ini mengalami masalah",
 "Estado (UF) do registro": "Provinsi (UF) registrasi",
 "Estado de Mato Grosso do Sul": "Negara Bagian Mato Grosso do Sul",
 "Estado de São Paulo": "Negara Bagian São Paulo",
 "Estado do Paraná": "Negara Bagian Paraná",
 "Estados": "Negara bagian",
 "Estaduais": "Negara bagian",
 "Estadual": "Negara bagian",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Tab ini muncul di bilah bawah sesuai urutan ini. My Planner, Tab, dan Pengaturan selalu ada. Tab lainnya tetap di layar Tab ini.",
 "Estatística": "Statistika",
 "Este CPF já tem cadastro. Use \"Entrar\".": "CPF ini sudah terdaftar. Gunakan \"Masuk\".",
 "Este PDF está no dispositivo onde foi aberto.": "PDF ini ada di perangkat tempat dibuka.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "PDF ini ada di perangkat tempat dibuka. Buka di sana, atau buka lagi salinan yang tersimpan di Drive atau OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "PDF ini dilindungi kata sandi. Hapus kata sandinya di program tempat PDF dibuat, lalu coba lagi.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "PDF ini tidak punya kolom formulir. Gunakan \"Tambah teks\" untuk menulis di atasnya.",
 "Este ano": "Tahun ini",
 "Este dispositivo": "Perangkat ini",
 "Este dispositivo não consegue abrir o arquivo.": "Perangkat ini tidak dapat membuka file.",
 "Este dispositivo não consegue compartilhar arquivos.": "Perangkat ini tidak dapat membagikan file.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Perangkat ini tidak memiliki data kesehatan. Anda dapat memasukkannya secara manual.",
 "Este arquivo foi guardado em outro dispositivo.": "File ini disimpan di perangkat lain.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "File ini disimpan di ponsel. Buka melalui aplikasi di ponsel.",
 "Este arquivo não é um backup do My Planner.": "File ini bukan cadangan My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Ponsel ini belum menerima notifikasi saat aplikasi ditutup. Instal aplikasi {v} atau yang lebih baru (APK dengan notifikasi server). Saat aplikasi terbuka, notifikasi sudah berfungsi.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Sertifikat ini milik {doc}, berbeda dari CNPJ/CPF perusahaan ({emp}).",
 "Este fichário ainda não tem matérias.": "Map ini belum memiliki mata pelajaran.",
 "Este grupo já está cheio.": "Grup ini sudah penuh.",
 "Este mês": "Bulan ini",
 "Este mês: emitidas {e} · recebidas {r}": "Bulan ini: diterbitkan {e} · diterima {r}",
 "Este mês: {h}": "Bulan ini: {h}",
 "Este navegador": "Browser ini",
 "Este país só tem feriados nacionais.": "Negara ini hanya memiliki hari libur nasional.",
 "Esteira": "Treadmill",
 "Esteticista": "Ahli kecantikan",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "Saya pakai My Planner untuk mengatur agenda, keuangan, dan banyak lagi. Unduh aplikasinya dan saat membuat akun, gunakan kode saya {codigo} untuk mendapatkan 10 hari dengan semua tab terbuka.",
 "Estratégia": "Strategi",
 "Estrela": "Bintang",
 "Estudando": "Belajar",
 "Estudar agora": "Belajar sekarang",
 "Estudar {nome}": "Belajar {nome}",
 "Estudar: {c}": "Belajar: {c}",
 "Estudo": "Kajian",
 "Estudos": "Studi",
 "Estudos e exatas": "Belajar dan sains",
 "Estudos, lazer e viagens": "Studi, hiburan, dan perjalanan",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "Ada di Harta & Pajak Penghasilan › Kuitansi yang dapat dikurangkan. Buka di sana untuk melampirkan foto kuitansi dan CPF atau CNPJ penerimanya.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Ada di halaman \"{titulo}\" dan di \"Lihat file\".",
 "Etanol": "Etanol",
 "Etapa": "Tahap",
 "Etapa do cronograma": "Tahap jadwal",
 "Etapas": "Tahapan",
 "Evento": "Acara",
 "Eventos": "Acara",
 "Eventos & Celebrações": "Acara & Perayaan",
 "Evolução (no cofre)": "Perkembangan (di brankas)",
 "Ex.: 08:00 e 20:00": "Mis.: 08:00 dan 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Mis.: 08:00, 14:00, dan 20:00",
 "Ex.: 09/2026": "Mis.: 09/2026",
 "Ex.: 1 comprimido": "Mis.: 1 tablet",
 "Ex.: 1-3, 4-10, 11-": "Mis.: 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Mis.: 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Mis.: 171901 (konsultasi), 010101 (pemrograman)",
 "Ex.: 40 sacos de cimento": "Mis.: 40 sak semen",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Mis.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Mis.: Kelas 8B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Contoh: Peregangan punggung bawah, Diet 1.800 kkal",
 "Ex.: Aniversário de 30 anos da Ana": "Mis.: Ulang tahun ke-30 Ana",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Contoh: Apartemen pantai, Suite 1, Paviliun",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Mis.: Apartemen di Jalan X, 100 saham PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Mis.: Kelas ulangan, Kontrol ulang",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Mis.: Katering, DJ, dekorasi, fotografer",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Mis.: RAHASIA, SALINAN, DRAF",
 "Ex.: Cardiologista": "Mis.: Kardiolog",
 "Ex.: Consultoria mensal": "Mis.: Konsultasi bulanan",
 "Ex.: Costela-de-adão da sala": "Mis.: Monstera di ruang tamu",
 "Ex.: DAS de setembro, Extrato do Itaú": "Mis.: DAS September, Rekening koran Itaú",
 "Ex.: Desmontar os móveis do quarto": "Mis.: Bongkar perabot kamar tidur",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Contoh: Tersedia · Di kelas sampai 18.00 · Ayo jalan-jalan!",
 "Ex.: Eletricista, loja de material": "Mis.: Tukang listrik, toko bangunan",
 "Ex.: Entrada dos noivos": "Mis.: Masuknya pengantin",
 "Ex.: Financiamento do carro": "Contoh: Kredit mobil",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Contoh: Fisioterapis, Ahli gizi, Dokter jantung",
 "Ex.: Furadeira, livro, R$ 200": "Mis.: Bor, buku, R$ 200",
 "Ex.: Hemograma": "Mis.: Hitung darah lengkap",
 "Ex.: IPVA 2027, parcela 1": "Mis.: IPVA 2027, cicilan 1",
 "Ex.: Lisboa, Portugal": "Mis.: Lisbon, Portugal",
 "Ex.: Mala da Ana": "Mis.: Koper Ana",
 "Ex.: Mensalidade de outubro, material": "Contoh: Iuran Oktober, materi",
 "Ex.: Netflix, cinema": "Mis.: Netflix, bioskop",
 "Ex.: Notas de compra de setembro": "Mis.: Faktur pembelian September",
 "Ex.: Onix 2022": "Mis.: Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Mis.: Ujian 1, tugas kelompok",
 "Ex.: Prova de matemática": "Mis.: Ujian matematika",
 "Ex.: Pôr do sol no Tejo": "Mis.: Matahari terbenam di Sungai Tagus",
 "Ex.: Reforma da cozinha": "Mis.: Renovasi dapur",
 "Ex.: TAP TP 108": "Mis.: TAP TP 108",
 "Ex.: Torre de Belém": "Contoh: Menara Belém",
 "Ex.: Troca da fiação da sala": "Mis.: Ganti kabel listrik ruang tamu",
 "Ex.: V10, antirrábica": "Mis.: V10, antirabies",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Mis.: Kunjungan ke Biara Jerónimos",
 "Ex.: cerâmica 30 cm": "Mis.: keramik 30 cm",
 "Ex.: kg, pacotes, latas": "Mis.: kg, bungkus, kaleng",
 "Ex.: seg e qua, 07:30": "Mis.: Sen dan Rab, 07:30",
 "Ex.: troquei o arroz por batata doce": "Mis.: nasi saya ganti ubi jalar",
 "Ex.: varanda, sala": "Mis.: balkon, ruang tamu",
 "Exame": "Pemeriksaan",
 "Exame da OAB": "Ujian OAB",
 "Exames": "Pemeriksaan",
 "Excel": "Excel",
 "Excluir": "Hapus",
 "Excluir \"{nome}\"?": "Hapus \"{nome}\"?",
 "Excluir \"{titulo}\"?": "Hapus \"{titulo}\"?",
 "Excluir a caixa?": "Hapus kotak?",
 "Excluir a compra": "Hapus pembelian",
 "Excluir a compra?": "Hapus pembelian?",
 "Excluir a meta \"{m}\"?": "Hapus target \"{m}\"?",
 "Excluir cartão": "Hapus kartu",
 "Excluir conta": "Hapus tagihan",
 "Excluir cuidado": "Hapus perawatan",
 "Excluir cômodo": "Hapus ruangan",
 "Excluir esta página?": "Hapus halaman ini?",
 "Excluir fichário": "Hapus map",
 "Excluir matéria": "Hapus mata pelajaran",
 "Excluir o cartão \"{c}\"?": "Hapus kartu \"{c}\"?",
 "Excluir o documento": "Hapus dokumen",
 "Excluir o fichário {nome}": "Hapus map {nome}",
 "Excluir página": "Hapus halaman",
 "Excluir refeição": "Hapus waktu makan",
 "Excluir suplemento": "Hapus suplemen",
 "Excluir tarefa": "Hapus tugas",
 "Excluir tarefa repetida": "Hapus tugas berulang",
 "Excluir tarefa?": "Hapus tugas?",
 "Excluir treino": "Hapus latihan",
 "Excluir {nome}?": "Hapus {nome}?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Dihapus permanen 30 hari setelah dibuang.",
 "Executivo e profissional": "Eksekutif dan profesional",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Pelaksanaan kontrak (art. 7º, V), untuk memberikan layanan; persetujuan (art. 7º, I), untuk kamera, galeri, mikrofon, dan lokasi; pemenuhan kewajiban hukum (art. 7º, II); dan kepentingan yang sah (art. 7º, IX), untuk keamanan dan pencegahan penipuan.",
 "Exemplos: 13:30, 1330, 9:05": "Contoh: 13:30, 1330, 9:05",
 "Exercício": "Olahraga",
 "Exercício físico": "Olahraga",
 "Experimente grátis por {n} dias": "Coba gratis selama {n} hari",
 "Explique o motivo (para cancelar)": "Jelaskan alasannya (untuk membatalkan)",
 "Exportar arquivo": "Ekspor file",
 "Exportar para o contador": "Ekspor untuk akuntan",
 "Extrair páginas": "Ekstrak halaman",
 "Extras (pet, check-in tardio...)": "Tambahan (hewan peliharaan, check-in larut...)",
 "Extrato": "Mutasi rekening",
 "Extrato bancário": "Rekening koran",
 "Extrato do banco (foto ou PDF)": "Mutasi rekening (foto atau PDF)",
 "Extrato importado": "Mutasi rekening diimpor",
 "Extrato por foto": "Mutasi lewat foto",
 "FRASE": "STATUS",
 "FRÁGIL": "MUDAH PECAH",
 "Fabricante ou estendida: {n} meses": "Pabrik atau tambahan: {n} bulan",
 "Facultativo": "Opsional",
 "Falar com a limpeza": "Hubungi petugas kebersihan",
 "Fale conosco": "Hubungi kami",
 "Falta": "Tidak hadir",
 "Falta XML": "XML belum ada",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Server faktur belum terhubung: di komputer, klik dua kali 13-LIGAR-NOTAS.bat lalu tempel di sini alamat yang ditampilkannya.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect belum ada, yaitu app Google yang mengumpulkan data dari jam tangan dan app kesehatan.",
 "Faltam": "Belum dikunjungi",
 "Faltam {ml} ({n} copo(s))": "Kurang {ml} ({n} gelas)",
 "Faltam {n} dia(s) do seu período grátis": "Sisa {n} hari masa gratis Anda",
 "Faltam {n} dias": "{n} hari lagi",
 "Faltou": "Tidak hadir",
 "Família": "Keluarga",
 "Fantasia": "Fantasi",
 "Fatura": "Tagihan",
 "Fatura com vencimento em {d}.": "Tagihan jatuh tempo pada {d}.",
 "Fatura de {mes}": "Tagihan {mes}",
 "Fatura de {mes}: vence {data}": "Tagihan {mes}: jatuh tempo {data}",
 "Fatura do cartão (foto ou PDF)": "Tagihan kartu (foto atau PDF)",
 "Fatura importada": "Tagihan diimpor",
 "Fatura paga (toque para desfazer)": "Tagihan lunas (ketuk untuk membatalkan)",
 "Fatura {c}": "Tagihan {c}",
 "Faturamento em {ano}: {v} de {lim}": "Omzet {ano}: {v} dari {lim}",
 "Faturas dos cartões": "Tagihan kartu",
 "Fazer agora, passo a passo": "Lakukan sekarang, langkah demi langkah",
 "Fazer com este PDF": "Lakukan dengan PDF ini",
 "Fazer cópia agora": "Cadangkan sekarang",
 "Fecha dia {f} · vence dia {v}": "Tutup tgl {f} · jatuh tempo tgl {v}",
 "Fecha {f} · vence {v}": "Tutup {f} · jatuh tempo {v}",
 "Fechar": "Tutup",
 "Fechar o cofre": "Tutup brankas",
 "Feche e abra o app de novo": "Tutup lalu buka lagi aplikasinya",
 "Federais": "Federal",
 "Feijão": "Kacang merah",
 "Feita em {data}": "Selesai pada {data}",
 "Feita hoje": "Selesai hari ini",
 "Feitas": "Selesai",
 "Feitas (não se repetem) · {n}": "Selesai (tidak berulang) · {n}",
 "Feito": "Selesai",
 "Feito!": "Beres!",
 "Feliz aniversário": "Selamat ulang tahun",
 "Feminino": "Feminin",
 "Feminino e suave": "Feminin dan lembut",
 "Feriado escolar": "Libur sekolah",
 "Feriado estadual": "Libur provinsi",
 "Feriado estadual: {nome}": "Libur negara bagian: {nome}",
 "Feriado municipal": "Libur kota",
 "Feriado municipal: {nome}": "Libur kota: {nome}",
 "Feriado nacional": "Libur nasional",
 "Feriado nacional: {nome}": "Libur nasional: {nome}",
 "Feriado regional": "Hari libur regional",
 "Feriado regional: {nome}": "Hari libur regional: {nome}",
 "Feriados": "Hari libur",
 "Feriados nacionais": "Libur nasional",
 "Feriados no planner": "Hari libur di planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Hari libur, kurs, saran kecerdasan buatan, serta pembacaan otomatis tagihan dan nota bisa saja keliru. Periksa sebelum digunakan.",
 "Ferramenta": "Perkakas",
 "Ferramentas": "Perkakas",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Data tiap tanaman, penggantian pot, dan kalender penyiraman dan pemupukan di jadwal.",
 "Ficha preenchida": "Formulir terisi",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Map, mata pelajaran dan halaman, pengatur waktu belajar, dan target mingguan.",
 "Ficção": "Fiksi",
 "Figurinha": "Stiker",
 "Figurinhas": "Stiker",
 "Filme": "Film",
 "Filme ou série": "Film atau serial",
 "Filmes e séries": "Film dan serial",
 "Filosofia": "Filsafat",
 "Filtros": "Filter",
 "Fim": "Selesai",
 "Fim (vazio = uso contínuo)": "Selesai (kosong = pemakaian rutin)",
 "Fim da garantia": "Akhir garansi",
 "Fim da garantia:": "Garansi berakhir:",
 "Fim da pausa. Continue: {tarefa}": "Jeda selesai. Lanjutkan: {tarefa}",
 "Fim de semana": "Akhir pekan",
 "Fim previsto": "Perkiraan selesai",
 "Fina": "Tipis",
 "Finados": "Hari Arwah",
 "Finalizador": "Produk penata rambut",
 "Financeiro": "Keuangan",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Keuangan: {gasto} dari {orcado} ({p}%)",
 "Financiamento": "Cicilan kredit",
 "Financiamento de veículo": "Kredit kendaraan",
 "Financiamento imobiliário": "KPR",
 "Financiamentos": "Pembiayaan",
 "Financiamentos e empréstimos": "Pembiayaan dan pinjaman",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Pembiayaan dan pinjaman dengan cicilan, bunga, sisa utang, dan bukti bayar; barang yang dipinjamkan dengan foto dan pengingat pengembalian.",
 "Finanças": "Keuangan",
 "Finanças {p}": "Keuangan {p}",
 "Finanças · {p}": "Keuangan · {p}",
 "Fins de semana": "Akhir pekan",
 "Fio dental": "Benang gigi",
 "Flex": "Flex",
 "Flexão de braço": "Push-up",
 "Flor": "Bunga",
 "Flutua": "Melayang",
 "Foguete": "Roket",
 "Fogão": "Kompor",
 "Foi no cartão de crédito? Lançar como compra no cartão": "Bayar dengan kartu kredit? Catat sebagai pembelian dengan kartu",
 "Foi para {destino}.": "Terkirim ke {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Terkirim ke {destino}. Hapus dari sini?",
 "Folha de pagamento": "Slip gaji",
 "Fone": "Earpiece",
 "Fone de ouvido": "Earphone",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Sumber: Brasil, dihitung di aplikasi berdasarkan peraturan federal tentang hari libur dan undang-undang tiap negara bagian. Negara lain: basis data publik Nager.Date (date.nager.at), diunduh dari internet dan disimpan di perangkat.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Sumber: Brasil, dihitung di aplikasi berdasarkan peraturan federal tentang hari libur, undang-undang tiap negara bagian, dan kalender resmi ibu kota. Negara lain: basis data publik Nager.Date (date.nager.at), diunduh dari internet dan disimpan di perangkat.",
 "Forma": "Metode",
 "Forma das parcelas": "Jenis cicilan",
 "Forma de pagamento": "Metode pembayaran",
 "Forma de pagamento: {f}.": "Metode pembayaran: {f}.",
 "Formas": "Bentuk",
 "Formato": "Format",
 "Formatos": "Bentuk",
 "Formatura": "Wisuda",
 "Fornecedor": "Vendor",
 "Fornecedores": "Vendor",
 "Forte": "Tebal",
 "Foto": "Foto",
 "Foto da galeria": "Foto dari galeri",
 "Foto do contato": "Foto kontak",
 "Foto inteira": "Seluruh foto",
 "Foto ou PDF (lido pela sua IA)": "Foto atau PDF (dibaca oleh AI Anda)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Foto setiap ruangan saat inspeksi keluar dan masuk. Foto ini melindungi Anda saat mengembalikan properti.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Foto setiap kuitansi dokter, dokter gigi, sekolah, dan dana pensiun begitu dibayar. Di akhir tahun semuanya sudah siap.",
 "Fotos": "Foto",
 "Fotos JPG, PNG e outras viram um PDF.": "Foto JPG, PNG, dan lainnya jadi PDF.",
 "Fotos de {d}": "Foto {d}",
 "Fotos do espaço pronto": "Foto properti yang sudah siap",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Foto dan file dari catatan ini juga masuk ke folder grup, agar peserta bisa membukanya.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Foto dan file hanya disimpan di perangkat ini. Data dokumen disimpan di akun Anda dengan aman.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Foto dan file tersimpan di perangkat ini (dan di Drive atau OneDrive Anda, jika diaktifkan di Pengaturan).",
 "Fotos e notas": "Foto dan catatan",
 "Fotos e vídeos": "Foto dan video",
 "Fotos, arquivos e links": "Foto, file, dan tautan",
 "Fraldas e lenços": "Popok dan tisu basah",
 "Francês": "Bahasa Prancis",
 "Frango com osso": "Ayam bertulang",
 "Frango sem osso": "Ayam tanpa tulang",
 "Frase (opcional, ex.: Bom dia!)": "Kalimat (opsional, mis.: Selamat pagi!)",
 "Freelancer & Projetos": "Freelancer & Proyek",
 "Freezer": "Freezer",
 "Freios": "Rem",
 "Frente": "Depan",
 "Frente do documento": "Bagian depan dokumen",
 "Frente e verso na mesma folha": "Depan dan belakang di satu halaman",
 "Frente pronta": "Bagian depan selesai",
 "Frequência": "Frekuensi",
 "Frio": "Dingin",
 "Fruta": "Buah",
 "Frágil": "Mudah pecah",
 "Fundação e estrutura": "Fondasi dan struktur",
 "Fundo": "Latar",
 "Fundos e renda fixa": "Reksa dana dan pendapatan tetap",
 "Fuso": "Zona",
 "Fuso horário": "Zona waktu",
 "Fuso horário do destino": "Zona waktu tujuan",
 "Futebol": "Sepak bola",
 "Física": "Fisika",
 "Físico (obra pronta): {p}%": "Fisik (proyek selesai): {p}%",
 "GASTOS POR CATEGORIA": "PENGELUARAN PER KATEGORI",
 "GIF guardado nos seus GIFs.": "GIF disimpan di GIF Anda.",
 "Garagem": "Garasi",
 "Garantia": "Garansi",
 "Garantia até {data}.": "Garansi sampai {data}.",
 "Garantia legal": "Garansi hukum",
 "Garantia vencendo": "Garansi segera berakhir",
 "Garantias": "Garansi",
 "Garrafa de água": "Botol minum",
 "Gasolina": "Bensin",
 "Gasto": "Pengeluaran",
 "Gasto até agora": "Terpakai sejauh ini",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Pengeluaran {v} dicatat. {n} harga disimpan untuk daftar belanja Anda.",
 "Gasto neste mês: {v}": "Pengeluaran bulan ini: {v}",
 "Gasto: {v}": "Terpakai: {v}",
 "Gastos": "Pengeluaran",
 "Gastos por categoria": "Pengeluaran per kategori",
 "Gato": "Kucing",
 "Geladeira": "Kulkas",
 "Geografia": "Geografi",
 "Gerado por": "Dihasilkan oleh",
 "Gerando QR Code...": "Membuat Kode QR...",
 "Gerar PDF": "Buat PDF",
 "Gerar as cobranças do mês": "Buat tagihan bulan ini",
 "Gerar as parcelas": "Buat cicilan",
 "Gerar lista da mala": "Buat daftar koper",
 "Gerar pelo cardápio e pela despensa": "Buat dari menu dan dapur",
 "Gesso e forro": "Gipsum dan plafon",
 "Gira todas as páginas ou só as escolhidas.": "Memutar semua halaman atau hanya yang dipilih.",
 "Girar": "Putar",
 "Google Drive e OneDrive": "Google Drive dan OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive, dan Google Kalender: hanya jika Anda menghubungkannya, dan hanya untuk menyimpan file dan acara Anda.",
 "Gorro, cachecol e luvas": "Kupluk, syal, dan sarung tangan",
 "Gota": "Tetes",
 "Graduação e Pós": "S1 dan Pascasarjana",
 "Grande": "Besar",
 "Gravando": "Merekam",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Merekam pengingat dan catatan suara saat Anda meminta. Mikrofon hanya menyala saat Anda mengetuknya.",
 "Gravar reunião": "Rekam rapat",
 "Gravação de áudio": "Perekaman audio",
 "Gravações das reuniões": "Rekaman rapat",
 "Grossa": "Tebal",
 "Grupo": "Grup",
 "Grupo com convite (turma, equipe, convidados)": "Grup dengan undangan (kelas, tim, tamu)",
 "Grupo criado": "Grup dibuat",
 "Grupo da família": "Grup keluarga",
 "Grupo da mudança (família e ajudantes)": "Grup pindahan (keluarga dan yang membantu)",
 "Grupo da obra (equipe)": "Grup proyek (tim)",
 "Grupo da turma (convidar alunos)": "Grup kelas (undang siswa)",
 "Grupo da viagem (convidar quem vai)": "Grup perjalanan (undang yang ikut)",
 "Grupo de cuidado (família ou profissional)": "Grup perawatan (keluarga atau profesional)",
 "Grupo de estudos (convidar colegas)": "Grup belajar (undang teman)",
 "Grupo de leitura (convidar)": "Grup membaca (undang)",
 "Grupo do cliente": "Grup klien",
 "Grupo do evento (convidar)": "Grup acara (undang)",
 "Grupos": "Grup",
 "Grupos de estudo": "Grup belajar",
 "Grupos de {aba}": "Grup {aba}",
 "Grupos desta aba: {n}": "Grup di tab ini: {n}",
 "Grupos e convites": "Grup & undangan",
 "Grátis no lançamento": "Gratis saat peluncuran",
 "Guarda-chuva": "Payung",
 "Guardada nas suas figurinhas.": "Disimpan di stiker Anda.",
 "Guardado": "Ditabung",
 "Guardado até agora: {v}": "Sudah ditabung: {v}",
 "Guardado em outro dispositivo": "Disimpan di perangkat lain",
 "Guardado na pasta \"{pasta}\" do celular.": "Tersimpan di folder \"{pasta}\" di ponsel.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Disimpan di brankas, dengan enkripsi end-to-end.",
 "Guardado no {nome}.": "Tersimpan di {nome}.",
 "Guardado {onde} em {quando}": "Tersimpan {onde} pada {quando}",
 "Guardando...": "Menyimpan...",
 "Guardar": "Tabung",
 "Guardar como recibo do IR": "Simpan sebagai kuitansi IR",
 "Guardar dinheiro": "Menabung",
 "Guardar e enviar": "Simpan dan kirim",
 "Guardar na meta": "Tabung ke target",
 "Guardar nas minhas figurinhas": "Simpan ke stiker saya",
 "Guardar nos meus GIFs": "Simpan ke GIF saya",
 "Guardar o PDF {onde}": "Simpan PDF {onde}",
 "Guardar os PDFs em": "Simpan PDF di",
 "Guardar os arquivos prontos em": "Simpan file yang selesai ke",
 "Guardar sozinho cada arquivo pronto": "Simpan otomatis setiap file yang selesai",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Simpan resep dan anjuran yang sering Anda gunakan. Di kunjungan, ketuk ⋮ › Gunakan templat.",
 "Guarde seus documentos num lugar só": "Simpan dokumen Anda di satu tempat",
 "Guarde {v} por mês até {d}": "Tabung {v} per bulan sampai {d}",
 "Guardou": "Ditabung",
 "Guia de imposto": "Slip pembayaran pajak",
 "Gás": "Gas",
 "Gênero ou categoria": "Genre atau kategori",
 "HISTÓRICO DOS DADOS": "RIWAYAT DATA",
 "HOJE": "HARI INI",
 "Hall de entrada": "Ruang depan",
 "Halteres": "Dumbel",
 "Hexágono": "Segi enam",
 "Hidratante": "Pelembap",
 "Hidratante labial": "Pelembap bibir",
 "Hidráulica": "Pipa air",
 "Higiene bucal": "Kebersihan mulut",
 "Higienizar": "Bersihkan",
 "História": "Sejarah",
 "Histórico": "Riwayat",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Riwayat keluarga, pemeriksaan terlindungi, vaksin, konsultasi, dan alarm obat di lini masa.",
 "Hmm...": "Hmm...",
 "Hoje": "Hari ini",
 "Hoje: {a} de {m} aulas ({p}%)": "Hari ini: {a} dari {m} pelajaran ({p}%)",
 "Hoje: {n} página(s)": "Hari ini: {n} halaman",
 "Hora": "Jam",
 "Hora da pausa": "Waktu jeda",
 "Hora de voltar": "Waktunya kembali",
 "Hora de voltar!": "Waktunya kembali!",
 "Hora do check-in": "Jam check-in",
 "Hora do check-out": "Jam check-out",
 "Horas": "Jam",
 "Horas de sono": "Jam tidur",
 "Horário": "Jam",
 "Horário de check-in": "Jam check-in",
 "Horário de check-out": "Jam check-out",
 "Horário do lembrete": "Jam pengingat",
 "Horário inválido": "Waktu tidak valid",
 "Horário ocupado": "Jam sudah terisi",
 "Horários": "Jam",
 "Horários (remédio diário)": "Jam (obat harian)",
 "Hospedados agora": "Sedang menginap",
 "Hospedagem": "Penginapan",
 "Hospital ou pronto-socorro de referência": "Rumah sakit atau UGD rujukan",
 "Hotel": "Hotel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Ada versi baru My Planner Web. Muat ulang untuk menggunakannya.",
 "Híbrido": "Hibrida",
 "Hóspede": "Tamu",
 "Hóspede ({c})": "Tamu ({c})",
 "Hóspedes (máximo)": "Tamu (maksimum)",
 "IA ligada": "AI aktif",
 "IA não ligada": "AI tidak aktif",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI tidak aktif. Aktifkan di Pengaturan › Kecerdasan buatan.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS dipotong oleh penerima jasa",
 "Ida": "Berangkat",
 "Identidade": "Kartu identitas",
 "Idioma": "Bahasa",
 "Idiomas": "Bahasa",
 "Ilimitados": "Tanpa batas",
 "Imagem": "Gambar",
 "Imagem escolhida (trocar)": "Gambar dipilih (ganti)",
 "Imagem guardada no {nome}. Toque para abrir.": "Gambar disimpan di {nome}. Ketuk untuk membuka.",
 "Imagens para PDF": "Gambar ke PDF",
 "Imagens {data}": "Gambar {data}",
 "Imperdíveis": "Wajib dikunjungi",
 "Imperdível": "Wajib",
 "Importar": "Impor",
 "Importar XML de nota": "Impor XML faktur",
 "Importar arquivo": "Impor file",
 "Importar backup?": "Impor cadangan?",
 "Importar extrato": "Impor mutasi",
 "Importar extrato do banco (OFX ou CSV)": "Impor mutasi rekening bank (OFX atau CSV)",
 "Importar fatura": "Impor tagihan",
 "Importar fotos": "Impor foto",
 "Importar reservas do Airbnb, Booking...": "Impor reservasi dari Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Impor {n} transaksi",
 "Imóveis e espaços": "Properti dan ruang",
 "Imóvel": "Properti",
 "Imóvel inteiro": "Seluruh properti",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Seluruh properti atau per kamar: reservasi dari Airbnb, Booking, atau langsung, bersih-bersih saat check-out, pengeluaran, okupansi, dan laba bulan ini.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Termasuk {v} dari faktur yang diterbitkan di tab Faktur Pajak.",
 "Independência do Brasil": "Hari Kemerdekaan Brasil",
 "Indicação": "Rekomendasi",
 "Indique e ganhe": "Ajak dan dapatkan",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Rekomendasikan My Planner ke teman dan keluarga. Siapa pun yang membuat akun dengan kode Anda mendapat 10 hari dengan semua tab terbuka.",
 "Infantil": "Anak-anak",
 "Informações do PDF": "Info PDF",
 "Informe a descrição e o valor.": "Masukkan deskripsi dan nominal.",
 "Informe de quantos em quantos dias regar ou adubar.": "Isi setiap berapa hari menyiram atau memupuk.",
 "Informe o nome do produto.": "Masukkan nama produk.",
 "Informe o rótulo e o nome.": "Masukkan label dan nama.",
 "Informe o total de aulas da matéria em Editar.": "Isi total pelajaran materi di Edit.",
 "Informe o valor.": "Masukkan nominal.",
 "Informe os horários": "Isi jamnya",
 "Informe quanto quer juntar.": "Masukkan berapa yang ingin dikumpulkan.",
 "Informe seu nome.": "Masukkan nama Anda.",
 "Informática": "Informatika",
 "Inglês": "Bahasa Inggris",
 "Ingredientes (um por linha)": "Bahan (satu per baris)",
 "Inscrição municipal (se tiver)": "Nomor pajak daerah (jika ada)",
 "Inspeção": "Inspeksi",
 "Instalar ou atualizar o Health Connect": "Instal atau perbarui Health Connect",
 "Instruções, receita, observações...": "Petunjuk, resep, catatan...",
 "Insumos (papel, sabonete, café)": "Perlengkapan (tisu, sabun, kopi)",
 "Inteligência artificial": "Kecerdasan buatan",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Kecerdasan buatan (Claude, ChatGPT, atau Gemini): hanya jika Anda mengaktifkannya, dengan kunci Anda sendiri yang hanya tersimpan di perangkat. Teks pertanyaan dikirim langsung ke layanan yang dipilih.",
 "Intensidade": "Intensitas",
 "Internação": "Rawat inap",
 "Internet": "Internet",
 "Intimação": "Pemberitahuan resmi",
 "Intimação com prazo": "Pemberitahuan resmi dengan tenggat",
 "Investimento": "Investasi",
 "Investimentos": "Investasi",
 "Início": "Mulai",
 "Início {ini} · Fim {fim} · Duração {dur}": "Mulai {ini} · Selesai {fim} · Durasi {dur}",
 "Iogurte": "Yogurt",
 "Ir para Ajustes (exportar meus dados)": "Ke Pengaturan (ekspor data saya)",
 "Ir para hoje": "Ke hari ini",
 "Ir para o My Planner Web": "Buka My Planner Web",
 "Italiano": "Bahasa Italia",
 "Item": "Item",
 "Item da despensa": "Barang dapur",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Item terlindungi: foto dan file dienkripsi di brankas, hanya di perangkat ini (tidak dikirim ke Drive atau OneDrive).",
 "Itens": "Barang",
 "Itens de higiene (xampu, sabonete)": "Perlengkapan mandi (sampo, sabun)",
 "Jantar": "Makan malam",
 "Japonês": "Bahasa Jepang",
 "Jaqueta impermeável": "Jaket tahan air",
 "Jogo": "Game",
 "Jovem e divertido": "Muda dan ceria",
 "Juntar PDFs": "Gabungkan PDF",
 "Juros": "Bunga",
 "Juros ainda por vir: {v}": "Bunga yang masih akan datang: {v}",
 "Juros ao mês": "Bunga per bulan",
 "JÁ RESPONDIDOS": "SUDAH DIJAWAB",
 "Já aberta na casa nova": "Sudah dibuka di rumah baru",
 "Já enviado para a turma": "Sudah dikirim ke kelas",
 "Já está compacto": "Sudah ringkas",
 "Já está no Planner": "Sudah ada di Planner",
 "Já está pago": "Sudah dibayar",
 "Já há horários deste item no My Planner": "Item ini sudah punya jadwal di My Planner",
 "Já pago: {v}": "Sudah dibayar: {v}",
 "Já tenho o app: abrir nele": "Sudah punya aplikasinya: buka di sana",
 "Já tenho o app: abrir o convite nele": "Saya sudah punya aplikasinya: buka undangan di sana",
 "Já visitei": "Sudah ke sini",
 "Kit de primeiros socorros": "Kotak P3K",
 "Kkkk": "Wkwk",
 "Kkkkk": "Wkwkwk",
 "Km de hoje no painel": "Km hari ini di odometer",
 "Km no dia": "Km pada hari itu",
 "Km no painel": "Km di odometer",
 "LANÇAMENTOS": "TRANSAKSI",
 "LINHA DO TEMPO": "LINI MASA",
 "Laboratório": "Laboratorium",
 "Lanche": "Camilan",
 "Lanche da manhã": "Camilan pagi",
 "Lanche da tarde": "Camilan sore",
 "Lanches e água": "Camilan dan air",
 "Lançamentos": "Transaksi",
 "Lavanderia": "Ruang cuci",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Laundry, perlengkapan, perawatan, tagihan, dan biaya. Masuk ke laba bulan ini.",
 "Lavar o rosto com sabonete facial": "Cuci muka dengan sabun wajah",
 "Lazer": "Rekreasi",
 "Leg press": "Leg press",
 "Legenda": "Keterangan",
 "Legislação Específica": "Peraturan Khusus",
 "Legumes": "Sayuran",
 "Leia hoje para começar uma sequência": "Baca hari ini untuk memulai rentetan",
 "Leite": "Susu",
 "Leitura": "Membaca",
 "Leitura automática do texto": "Pembacaan teks otomatis",
 "Leitura da IA": "Pembacaan AI",
 "Leitura, Cursos & Mídia": "Bacaan, Kursus & Media",
 "Lembrete": "Pengingat",
 "Lembrete de hoje": "Pengingat hari ini",
 "Lembrete de renovação no Planner": "Pengingat perpanjangan di Planner",
 "Lembrete no Planner": "Pengingat di Planner",
 "Lembrete no planner": "Pengingat di planner",
 "Lembrete pelo WhatsApp": "Pengingat lewat WhatsApp",
 "Lembrete: começa às {hora}": "Pengingat: mulai pukul {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Kami membaca semua pesan. Jika perlu, kami membalas lewat email Anda.",
 "Lendo": "Sedang dibaca",
 "Lendo a fatura...": "Membaca tagihan...",
 "Lendo a página": "Membaca halaman",
 "Lendo o boleto...": "Membaca boleto...",
 "Lendo o cupom...": "Membaca struk...",
 "Lendo o documento...": "Membaca dokumen...",
 "Lendo o extrato...": "Membaca mutasi...",
 "Lendo o relógio...": "Membaca jam tangan...",
 "Lendo o texto": "Membaca teks",
 "Ler a fatura": "Baca tagihan",
 "Ler a publicação inteira": "Baca publikasi lengkap",
 "Ler com a minha IA": "Baca dengan AI saya",
 "Ler de novo": "Baca ulang",
 "Ler de novo agora": "Baca ulang sekarang",
 "Ler o texto": "Baca teks",
 "Ler o texto completo": "Baca teks lengkap",
 "Ler publicação inteira": "Baca publikasi lengkap",
 "Ler sozinho as publicações novas": "Baca publikasi baru secara otomatis",
 "Leve": "Ringan",
 "Leve (sem perder qualidade)": "Ringan (tanpa kehilangan kualitas)",
 "Li e aceito os termos e a política de privacidade": "Saya telah membaca dan menyetujui ketentuan dan kebijakan privasi",
 "Li mais {n} páginas": "Membaca {n} halaman lagi",
 "Liberada pelo suporte": "Dibuka oleh dukungan",
 "Liberar para a equipe": "Bagikan ke tim",
 "Liberar para a turma em": "Buka untuk kelas pada",
 "Liberar para o grupo": "Buka untuk grup",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Akses dan kredit terkait dengan CPF Anda. Diperbarui saat sinkronisasi.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Izinkan kamera untuk My Planner di pengaturan ponsel untuk memindai Kode QR.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Izinkan akses kamera untuk My Planner di pengaturan ponsel.",
 "Libere outras abas em Ajustes › Compras.": "Buka tab lain di Pengaturan › Pembelian.",
 "Licenciamento": "Registrasi kendaraan",
 "Lidas hoje": "Dibaca hari ini",
 "Lido": "Sudah dibaca",
 "Ligando. Toque para atender.": "Memanggil. Ketuk untuk menjawab.",
 "Ligar": "Telepon",
 "Ligar certificado": "Hubungkan sertifikat",
 "Ligar para a assistência": "Telepon servis",
 "Ligar para {nome}": "Telepon {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Aktifkan AI Anda di Pengaturan › Kecerdasan buatan (Claude, ChatGPT atau Gemini) untuk memakai alat ini.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Aktifkan AI Anda di Pengaturan › Kecerdasan buatan untuk membaca teks, merangkum, dan bertanya tentang dokumen.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Aktifkan AI Anda di Pengaturan › Kecerdasan buatan.",
 "Ligue o certificado A1 da empresa primeiro.": "Hubungkan dulu sertifikat A1 perusahaan.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Hubungkan Google Drive atau OneDrive Anda untuk menyimpan foto dan file (yang bisa dibuka di perangkat mana pun) dan memiliki cadangan lengkap.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Aktifkan agar grup bekerja dengan data yang sama (proyek bangunan, perjalanan, kelas, properti, praktik), masing-masing dengan perannya.",
 "Ligue pelo menos 4 pontos.": "Hubungkan minimal 4 titik.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Batas tahunan dapat diubah di Pengaturan › Tab › Tab Keuangan. Selalu periksa dengan akuntan Anda.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Batas kueri tercapai. Coba lagi dalam 1 menit.",
 "Limite de energia por dia": "Batas energi per hari",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Batas omzet tahunan MEI (periksa nilai yang berlaku dengan akuntan Anda).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Batas pesan hari ini sudah tercapai. Coba lagi besok.",
 "Limite diário": "Batas harian",
 "Limite livre: {v} de {l}": "Sisa limit: {v} dari {l}",
 "Limite total (opcional)": "Limit total (opsional)",
 "Limpar": "Bersihkan",
 "Limpar a agenda": "Bersihkan agenda",
 "Limpar banheiro": "Bersihkan kamar mandi",
 "Limpar cozinha e louça": "Bersihkan dapur dan cuci piring",
 "Limpar feitos": "Hapus yang selesai",
 "Limpeza": "Bersih-bersih",
 "Limpeza após {h}": "Bersih-bersih setelah {h}",
 "Limpeza final": "Bersih-bersih akhir",
 "Limpeza · {e}": "Bersih-bersih · {e}",
 "Limpeza: {e}": "Bersih-bersih: {e}",
 "Limpezas": "Bersih-bersih",
 "Linha do tempo, tarefas, energia e alertas.": "Lini masa, tugas, energi, dan peringatan.",
 "Link": "Tautan",
 "Link (Drive, OneDrive, Dropbox)": "Tautan (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Tautan disalin. Tempel di tempat Anda ingin mengirimnya.",
 "Link da aula ou reunião online (opcional)": "Tautan kelas atau rapat online (opsional)",
 "Link da nota fiscal (Drive ou OneDrive)": "Tautan faktur (Drive atau OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Tautan folder di Drive atau OneDrive (opsional)",
 "Link da reserva": "Tautan reservasi",
 "Link da sala online (Meet, Zoom...)": "Tautan ruang online (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Tautan kalender lain (iCal)",
 "Link do calendário do Airbnb (iCal)": "Tautan kalender Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Tautan kalender Booking (iCal)",
 "Link inválido": "Tautan tidak valid",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Tautan materi (Drive, video, PDF), satu per baris",
 "Links: {n}": "Tautan: {n}",
 "Lista": "Daftar",
 "Lista da mala": "Daftar koper",
 "Lista de compras": "Daftar belanja",
 "Lista de exercícios": "Latihan soal",
 "Lista rápida": "Daftar cepat",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Daftar cepat dan kotak yang menjadi tugas atau dikirim ke tab lain.",
 "Literatura": "Sastra",
 "Litros": "Liter",
 "Livre": "Kosong",
 "Livro": "Buku",
 "Livros": "Buku",
 "Local": "Lokasi",
 "Local ou endereço": "Tempat atau alamat",
 "Local: {l}": "Tempat: {l}",
 "Localização (país e fuso horário)": "Lokasi (negara dan zona waktu)",
 "Logo, foto ou rubrica nas páginas.": "Logo, foto, atau paraf di halaman.",
 "Loja (opcional)": "Toko (opsional)",
 "Lote": "Batch",
 "Lua": "Bulan",
 "Lugar": "Tempat",
 "Lugar para visitar": "Tempat untuk dikunjungi",
 "Lugares": "Tempat",
 "Luz": "Listrik",
 "Luz indireta": "Cahaya tidak langsung",
 "Luz, água, gás e internet": "Listrik, air, gas, dan internet",
 "Lápis": "Pensil",
 "Língua Portuguesa": "Bahasa Portugis",
 "MAIS ADIANTE": "NANTI",
 "MAIS USADOS": "PALING SERING",
 "ME ou EPP do Simples": "ME atau EPP Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI: omzet {ano} sebesar {v} (batas {l}).",
 "MEMBROS ({n})": "ANGGOTA ({n})",
 "METAS": "TARGET",
 "MS": "MS",
 "Mais": "Lainnya",
 "Mais abas": "Tab lainnya",
 "Mais cidades entram nas próximas versões.": "Kota lainnya hadir di versi berikutnya.",
 "Mais emojis": "Emoji lainnya",
 "Mais ferramentas": "Alat lainnya",
 "Mais figurinhas animadas (KLIPY)": "Stiker animasi lainnya (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "Opsi lain untuk tab ini hadir di versi berikutnya.",
 "Mais uma": "Satu lagi",
 "Mala": "Koper",
 "Mala ({clima}, {n} dias)": "Koper ({clima}, {n} hari)",
 "Mamadeiras e leite": "Botol susu dan susu",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Kami mengirim kode 6 angka ke WhatsApp nomor {tel}.",
 "Mandar as orientações pelo WhatsApp": "Kirim anjuran lewat WhatsApp",
 "Mandar de novo": "Kirim ulang",
 "Mandar e-mail": "Kirim email",
 "Mandar lembrete": "Kirim pengingat",
 "Mandar meu código": "Kirim kode saya",
 "Mandar o acerto para o grupo": "Kirim penyelesaian ke grup",
 "Mandar para quem limpa (WhatsApp)": "Kirim ke petugas kebersihan (WhatsApp)",
 "Mandarim": "Bahasa Mandarin",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Kirim email meminta penghapusan, dengan nomor identitas akun. Kami membalas dalam 15 hari.",
 "Manter": "Simpan",
 "Manter ambas": "Simpan keduanya",
 "Manter ambos": "Simpan keduanya",
 "Manter aqui também": "Simpan di sini juga",
 "Manter tarefas": "Simpan tugas",
 "Manutenção": "Perawatan",
 "Manutenções": "Perawatan",
 "Mapas (Apple)": "Apple Maps",
 "Marca d'água": "Tanda air",
 "Marca-texto": "Stabilo",
 "Marcado": "Dicentang",
 "Marcado como feito hoje.": "Ditandai selesai hari ini.",
 "Marcar como concluída ({dia})": "Tandai selesai ({dia})",
 "Marcar como devolvido": "Tandai sudah dikembalikan",
 "Marcar como feita hoje": "Tandai selesai hari ini",
 "Marcar como lido": "Tandai sudah dibaca",
 "Marcar como paga": "Tandai sudah dibayar",
 "Marcar como pago": "Tandai sudah dibayar",
 "Marcar como quitado": "Tandai lunas",
 "Marcar como recebida": "Tandai sudah diterima",
 "Marcar como recebida?": "Tandai sudah diterima?",
 "Marcar como recebido": "Tandai sudah diterima",
 "Marcar como visto": "Tandai sudah dilihat",
 "Marcar e avisar a equipe": "Jadwalkan dan beri tahu tim",
 "Marcar esta conta como paga?": "Tandai tagihan ini sudah dibayar?",
 "Marcar fatura como paga": "Tandai tagihan lunas",
 "Marcar grupo": "Pilih grup",
 "Marcar reunião": "Jadwalkan rapat",
 "Marcenaria": "Pertukangan kayu",
 "Margem": "Margin",
 "Marketing": "Pemasaran",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Tandai foto catatan harian sebagai Sebelum atau Sesudah untuk membuat galeri.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Tandai hari-hari Anda belajar dan jam setiap harinya. Setiap hari menjadi tugas yang berulang setiap minggu, terhubung dengan item ini.",
 "Marque um ou mais estados.": "Pilih satu atau beberapa negara bagian.",
 "Martelo": "Palu",
 "Masculino": "Maskulin",
 "Masculino e minimalista": "Maskulin dan minimalis",
 "Matemática": "Matematika",
 "Materiais": "Materi",
 "Material": "Material",
 "Matrícula, placa, código ou CNPJ": "Nomor registrasi, pelat, kode, atau CNPJ",
 "Matéria ou material": "Mata pelajaran atau materi",
 "Matéria ou módulo": "Materi atau modul",
 "Matérias": "Materi",
 "Meia-sombra": "Teduh sebagian",
 "Melhorando a imagem...": "Memperbaiki gambar...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "Pembaruan baru sudah diunduh. Hanya butuh beberapa detik dan data Anda tetap aman.",
 "Membros": "Anggota",
 "Menos de 1 minuto": "Kurang dari 1 menit",
 "Mensagem": "Pesan",
 "Mensagem apagada": "Pesan dihapus",
 "Mensagem enviada. Obrigado!": "Pesan terkirim. Terima kasih!",
 "Mensagem ou observações": "Pesan atau catatan",
 "Mensagens": "Pesan",
 "Mensagens que você envia em Fale conosco.": "Pesan yang Anda kirim lewat Hubungi kami.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Pesan: daftar teman, obrolan, serta foto dan file yang dikirim disimpan di server agar sampai ke perangkat lain. Panggilan suara dan video tidak direkam.",
 "Mensalidade de {m}": "Iuran {m}",
 "Mensalidade ou valor por aluno": "Iuran bulanan atau nilai per siswa",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Iuran bulanan, kelas lepas, dan materi. Di ⋮ kelas, \"Buat tagihan bulan ini\" membuat satu tagihan untuk setiap siswa.",
 "Mercado": "Belanja dapur",
 "Mesa flexora": "Leg curl",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Mandor",
 "Meta": "Target",
 "Meta 100% batida": "Target 100% tercapai",
 "Meta atingida": "Target tercapai",
 "Meta atingida!": "Target tercapai!",
 "Meta da semana: {dur}": "Target minggu ini: {dur}",
 "Meta de aulas": "Target pelajaran",
 "Meta de aulas batida": "Target pelajaran tercapai",
 "Meta de copos por dia": "Target gelas per hari",
 "Meta de páginas por dia": "Target halaman per hari",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Target halaman, progres, dan ringkasan buku, film, dan serial yang ingin ditonton, serta pelajaran kursus.",
 "Meta diária": "Target harian",
 "Meta por dia": "Target per hari",
 "Meta por semana:": "Target per minggu:",
 "Meta {meta} · copo de {copo} · {n} copos": "Target {meta} · gelas {copo} · {n} gelas",
 "Metas": "Target",
 "Metodologia Científica": "Metodologi Penelitian",
 "Meu caderno": "Buku catatan saya",
 "Meu cartão de contato": "Kartu kontak saya",
 "Meu plano": "Paket saya",
 "Meus GIFs ({n})": "GIF saya ({n})",
 "Meus PDFs": "PDF saya",
 "Meus dados": "Data saya",
 "Meus dados profissionais": "Data profesional saya",
 "Microchip": "Mikrocip",
 "Microfone": "Mikrofon",
 "Microscópio": "Mikroskop",
 "Militares estaduais": "Militer negara bagian",
 "Minha Casa": "Rumahku",
 "Minha conta": "Akun saya",
 "Minhas anotações do livro": "Catatan bukuku",
 "Minhas figurinhas": "Stiker saya",
 "Minutos": "Menit",
 "Minutos de exercício": "Menit olahraga",
 "Mirante": "Tempat pemandangan",
 "Mirantes": "Tempat pemandangan",
 "Modelo": "Model",
 "Modelo de prescrição": "Templat resep",
 "Modelos": "Templat",
 "Modificado em": "Diubah pada",
 "Modo": "Mode",
 "Modo de preparo": "Cara membuat",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Mode aman: tugas otomatis mati sampai aplikasi dibuka lagi",
 "Moeda": "Mata uang",
 "Moeda: {m}": "Mata uang: {m}",
 "Moedas": "Koin",
 "Momento do evento": "Momen acara",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Monitor Diário de Justiça Eletrônico (DJEN) berdasarkan nama dan OAB.",
 "Monitor ou co-professor": "Asisten atau co-guru",
 "Montando o PDF: página {n} de {total}...": "Membuat PDF: halaman {n} dari {total}...",
 "Montar a mala pelo clima ({n} dias)": "Siapkan koper sesuai cuaca ({n} hari)",
 "Monte o cronograma alimentar para ver o relatório.": "Susun jadwal makan untuk melihat laporan.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Susun rencana per hari. Selama perjalanan, rencana ini muncul di lini masa My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Susun jadwal makan dan perawatan diri Anda di bawah. Yang untuk hari ini muncul di sini untuk ditandai.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Susun jadwal makan, perawatan, latihan, dan suplemen Anda di bawah. Yang dijadwalkan hari ini muncul di sini untuk ditandai.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Susun latihan dengan aktivitas siap pakai: alat gym, latihan di rumah, jalan kaki, lari, yoga, pilates...",
 "Mostrando as 120 mais recentes.": "Menampilkan 120 terbaru.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Hanya menampilkan rencana perjalanan. {n} tugas hari ini disembunyikan.",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Menampilkan tanggal, waktu, mata uang, dan hari libur yang tepat untuk lokasi Anda. Kami tidak menggunakan GPS.",
 "Mostrar menos": "Tampilkan lebih sedikit",
 "Mostrar só o roteiro durante a viagem": "Tampilkan hanya rencana selama perjalanan",
 "Motivo do cancelamento": "Alasan pembatalan",
 "Moto": "Motor",
 "Mover": "Pindahkan",
 "Mover para hoje": "Pindahkan ke hari ini",
 "Mudança": "Pindahan",
 "Mudança: {para}": "Pindahan: {para}",
 "Mudanças": "Pindahan",
 "Mudar e-mail": "Ubah email",
 "Mudar o nome": "Ganti nama",
 "Mudar senha": "Ubah kata sandi",
 "Mudo": "Bisukan",
 "Muitas tentativas": "Terlalu banyak percobaan",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Terlalu banyak percobaan salah. Coba lagi dalam {s} detik.",
 "Muitas tentativas. Aguarde alguns minutos.": "Terlalu banyak percobaan. Tunggu beberapa menit.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Bagus: bulan ini Anda sudah menabung {v}. Konsisten lebih penting daripada jumlah besar.",
 "Multa": "Tilang",
 "Multa e juros": "Denda dan bunga",
 "Multa e juros de {v}": "Denda dan bunga {v}",
 "Multa e juros estimados: {v}": "Perkiraan denda dan bunga: {v}",
 "Multas e juros pagos": "Denda dan bunga dibayar",
 "Mundo": "Dunia",
 "Municipal": "Kota",
 "Município da prestação (IBGE), se for outro": "Kota tempat layanan (IBGE), jika berbeda",
 "Município da prestação (código IBGE, 7 números)": "Kota tempat layanan (kode IBGE, 7 angka)",
 "Mural": "Papan pengumuman",
 "Museu": "Museum",
 "Museus": "Museum",
 "My Planner (vira tarefa)": "My Planner (jadi tugas)",
 "My Planner bloqueado": "My Planner terkunci",
 "Máxima": "Maksimal",
 "Média": "Sedang",
 "Média para aprovação": "Nilai minimum lulus",
 "Média · repouso {n}": "Rata-rata · istirahat {n}",
 "Médico": "Dokter",
 "Médico ou clínica": "Dokter atau klinik",
 "Médio": "Sedang",
 "Mês": "Bulan",
 "Mês a mês": "Per bulan",
 "Mês atual": "Bulan ini",
 "Mês passado": "Bulan lalu",
 "Móveis e enxoval": "Perabot dan linen",
 "Móvel": "Perabot",
 "Música": "Musik",
 "NAS ABAS": "DI TAB",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e: SEFAZ meminta jeda 1 jam antarpencarian. Berikutnya mulai pukul {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e: isi negara bagian (UF) perusahaan untuk mencari faktur barang.",
 "NFS-e emitida": "NFS-e diterbitkan",
 "NFS-e: {m}": "NFS-e: {m}",
 "Na (opcional):": "Pada hari (opsional):",
 "Na agenda": "Di jadwal",
 "Na agenda em {data}": "Di jadwal pada {data}",
 "Na barra": "Di bilah",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "Dalam demo tidak ada server faktur. Gunakan aplikasi dengan akun Anda.",
 "Na hora": "Langsung",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "Saat waktu jeda, muncul pemberitahuan besar di layar dengan hitung mundur.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "Di lini masa, mengetuk pengatur waktu juga membuka halaman ini.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "Di folder \"{pasta}\" di ponsel. Setiap file yang selesai masuk ke sana.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "Di folder \"{pasta}\" di ponsel. Setiap dokumen baru dikirim ke sana saat Anda keluar darinya.",
 "Na prévia de demonstração não há chamadas de verdade.": "Di pratinjau demo tidak ada panggilan sungguhan.",
 "Na prévia de demonstração não há gravação de verdade.": "Di pratinjau demo tidak ada rekaman sungguhan.",
 "Na prévia de demonstração os arquivos não abrem.": "Di pratinjau demo file tidak bisa dibuka.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "Di versi toko aplikasi, pembelian dilakukan lewat Google Play atau App Store. Untuk saat ini, tombol ini menyimulasikan langganan untuk pengujian.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "Di versi toko aplikasi, tombol ini membuka pembelian Google Play atau App Store.",
 "Nacional": "Nasional",
 "Nada a gerar": "Tidak ada yang perlu dibuat",
 "Nada encontrado.": "Tidak ditemukan apa pun.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Tidak ada yang masuk ke agenda siapa pun tanpa izin: setiap orang menerima, mengedit, atau menolak.",
 "Nada foi registrado.": "Tidak ada yang tercatat.",
 "Nada lançado neste mês.": "Belum ada transaksi bulan ini.",
 "Nada no mês": "Tidak ada di bulan ini",
 "Nada no roteiro deste dia.": "Tidak ada rencana untuk hari ini.",
 "Nada para apagar com esse filtro.": "Tidak ada yang bisa dihapus dengan filter ini.",
 "Nada para comprar": "Tidak ada yang perlu dibeli",
 "Nada para enviar.": "Tidak ada yang dikirim.",
 "Nada planejado para este dia": "Tidak ada rencana untuk hari ini",
 "Nada planejado para hoje. Bom dia!": "Tidak ada rencana untuk hari ini. Selamat pagi!",
 "Nada por aqui.": "Belum ada apa-apa di sini.",
 "Nada recebido ainda.": "Belum ada yang diterima.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "Di obrolan, setiap orang melihat nama Anda dan apa yang Anda kirim di sana. Anda bisa menghapus pesan untuk semua, keluar dari grup, atau memblokir seseorang.",
 "Nascimento": "Lahir",
 "Natal": "Natal",
 "Natação": "Renang",
 "Navegador conectado": "Peramban terhubung",
 "Negrito": "Tebal",
 "Negócios": "Bisnis",
 "Nenhum": "Tidak ada",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Tidak ada XML pada periode ini (atau tersimpan di perangkat lain).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Tidak ada teman untuk ditambahkan. Undang lewat WhatsApp atau tambahkan teman di Pesan (kode teman).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "Tidak ada file, gambar, atau tautan di halaman mata pelajaran ini.",
 "Nenhum arquivo.": "Tidak ada file.",
 "Nenhum atendimento pago neste mês.": "Tidak ada kunjungan yang dibayar bulan ini.",
 "Nenhum cartão": "Tidak ada kartu",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Belum ada bukti tersimpan. Saat membayar tagihan, ketuk tagihan itu dan lampirkan foto, PDF, atau tangkapan layar buktinya.",
 "Nenhum cômodo ainda": "Belum ada ruangan",
 "Nenhum dia": "Tidak ada hari",
 "Nenhum documento ainda.": "Belum ada dokumen.",
 "Nenhum documento neste filtro.": "Tidak ada dokumen di filter ini.",
 "Nenhum e-mail cadastrado": "Belum ada email terdaftar",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Tidak ada galat yang tercatat. Jika aplikasi tertutup sendiri atau layar bermasalah, galat muncul di sini untuk dikirim ke tim.",
 "Nenhum feriado neste ano.": "Tidak ada hari libur tahun ini.",
 "Nenhum fichário ainda": "Belum ada map",
 "Nenhum grupo ainda.": "Belum ada grup.",
 "Nenhum item em {nome}": "Tidak ada item di {nome}",
 "Nenhum lançamento encontrado": "Tidak ada transaksi ditemukan",
 "Nenhum país encontrado.": "Negara tidak ditemukan.",
 "Nenhum selecionado": "Tidak ada yang dipilih",
 "Nenhuma (plano gratuito)": "Tidak ada (paket gratis)",
 "Nenhuma aba encontrada.": "Tidak ada tab yang ditemukan.",
 "Nenhuma aba fixada além do My Planner.": "Belum ada tab yang disematkan selain My Planner.",
 "Nenhuma aba liberada para receber": "Tidak ada tab terbuka yang bisa menerima",
 "Nenhuma agenda encontrada": "Tidak ada kalender ditemukan",
 "Nenhuma agenda para trazer": "Tidak ada kalender untuk diimpor",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "Tidak ditemukan sidang atau tenggat dalam publikasi ini.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Tidak ada kotak yang diarsipkan. Geser kotak ke kiri untuk mengarsipkan.",
 "Nenhuma compra encontrada": "Tidak ada pembelian ditemukan",
 "Nenhuma compra nesta fatura.": "Tidak ada pembelian di tagihan ini.",
 "Nenhuma conta a pagar cadastrada.": "Belum ada tagihan yang didaftarkan.",
 "Nenhuma conta a receber cadastrada.": "Belum ada piutang yang didaftarkan.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Tidak ada tagihan bulan ini. Ketuk + untuk menambahkan (sewa, listrik, kartu...).",
 "Nenhuma cópia de segurança ainda.": "Belum ada cadangan.",
 "Nenhuma cópia encontrada.": "Tidak ada cadangan ditemukan.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Tidak ada garansi aktif. Tambahkan dengan +.",
 "Nenhuma garantia vencida.": "Tidak ada garansi yang berakhir.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Belum ada pesan. Sapa dulu! 👋",
 "Nenhuma nota neste período.": "Tidak ada faktur pada periode ini.",
 "Nenhuma opção ainda.": "Belum ada opsi.",
 "Nenhuma publicação nova.": "Tidak ada publikasi baru.",
 "Nenhuma refeição neste dia.": "Tidak ada waktu makan di hari ini.",
 "Nenhuma reunião marcada.": "Belum ada rapat terjadwal.",
 "Nesse ritmo, termina em {d}": "Dengan ritme ini, selesai pada {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "Selama masa peluncuran, semua tab terbuka dan gratis.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "Selama masa uji coba ini, kata sandi diatur ulang oleh tim dukungan. Kirim email ke {email} dengan menyebutkan CPF atau email Anda.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "Selama tahap uji coba, kata sandi diatur ulang oleh dukungan. Kirim email ke {email} dengan menyebutkan CPF Anda.",
 "Neve": "Salju",
 "Ninguém deve nada a ninguém.": "Tidak ada yang berutang.",
 "Ninguém entrou ainda. Envie o convite.": "Belum ada yang bergabung. Kirim undangannya.",
 "Ninguém usou o seu código ainda.": "Belum ada yang menggunakan kode Anda.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Di Android, aplikasi hanya menyimpan pintasan ke file yang dipilih: file tetap di tempatnya (Drive, OneDrive, Unduhan) dan terbuka di aplikasi ponsel. Tidak ada yang disalin. Opsi ini berlaku untuk foto yang diambil dengan kamera.",
 "No Google Drive ou OneDrive: {n}": "Di Google Drive atau OneDrive: {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "Di Google Drive, aplikasi hanya dapat melihat file yang dibuatnya sendiri di folder My Planner. Penggunaan informasi yang diterima dari Google API mematuhi Kebijakan Data Pengguna Layanan Google API, termasuk persyaratan Penggunaan Terbatas: tidak ada yang dijual, digunakan untuk iklan, atau dibaca oleh orang, kecuali dengan izin Anda atau karena diwajibkan oleh hukum.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "Di app jam tangan Anda (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), aktifkan opsi \"Health Connect\" atau \"Sinkronkan dengan Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "Di aplikasi baru (versi 0.49), ponsel menemukan tepi kertas sendiri. Di versi ini, sesuaikan 4 sudut dengan jari.",
 "No centro": "Tengah",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "Di komputer, buka {url}, ketuk tombol di atas, dan arahkan kamera ke Kode QR di layar.",
 "No dia (opcional):": "Pada tanggal (opsional):",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Di iPhone, aplikasi membuka \"Simpan ke File\" agar Anda bisa memilih folder (bisa juga iCloud Drive).",
 "No início": "Saat mulai",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "Dalam mode aman, aplikasi terbuka tanpa tugas otomatis (pengingat, Google Kalender, publikasi, pesan, dan jam). Datamu tidak berubah dan semuanya normal lagi saat dibuka berikutnya.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "Di browser, halaman hanya tersimpan selama halaman ini terbuka.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "Di browser, tempel tautan file dari Drive, OneDrive, atau Dropbox (di Studi atau Dokumen, opsi Tautan). Di ponsel, tombol file sudah menampilkan Drive dan OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "Di browser, PDF diunduh ke komputer.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "Di browser, hanya gambar kecil (hingga 200 KB) yang bisa disimpan. Untuk file lain, tambahkan tautan Drive, OneDrive, atau Dropbox, atau gunakan aplikasi di ponsel.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "Di aplikasi lain, salin tautan file (Bagikan › Salin tautan) lalu tempel di blok tautan yang ada di halaman ini.",
 "No ritmo atual, o ano fecha em {v}.": "Dengan laju saat ini, tahun ini ditutup di {v}.",
 "No seu fuso: {hora}{dia}": "Di zona waktu Anda: {hora}{dia}",
 "Nome": "Nama",
 "Nome (cliente ou fornecedor)": "Nama (klien atau pemasok)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Nama (mis.: Kelas 8B, Pasien klinik, Ulang tahun Ana)",
 "Nome (ex.: Almoço)": "Nama (mis.: Makan siang)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Nama (mis.: Sewa diterima, Klien X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Nama (mis.: Sewa, Listrik, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Nama (mis.: Doktoral UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Nama (mis.: Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Nama (mis.: Skincare malam)",
 "Nome (ex.: Treino A)": "Nama (mis.: Latihan A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Nama (mis.: Liburan, Dana darurat)",
 "Nome (ex.: Vitamina C)": "Nama (mis.: Vitamin C)",
 "Nome (opcional)": "Nama (opsional)",
 "Nome (opcional, ex.: CNH do Walter)": "Nama (opsional, mis.: CNH Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Nama (bisa diubah, mis.: \"Jus anggur\")",
 "Nome completo": "Nama lengkap",
 "Nome curto": "Nama singkat",
 "Nome da lista": "Nama daftar",
 "Nome da matéria": "Nama mata pelajaran",
 "Nome da obra": "Nama proyek",
 "Nome da pasta (ex.: Recibos, Contratos)": "Nama folder (mis.: Struk, Kontrak)",
 "Nome da tarefa": "Nama tugas",
 "Nome da tarefa (ex.: Academia)": "Nama tugas (mis.: Gym)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Nama tugas (mis.: Bersihkan kamar mandi)",
 "Nome do PDF (opcional)": "Nama PDF (opsional)",
 "Nome do conselho": "Nama dewan profesi",
 "Nome do cômodo": "Nama ruangan",
 "Nome do documento": "Nama dokumen",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Nama kantor (mis.: Ravasco Contabilidade)",
 "Nome do evento": "Nama acara",
 "Nome do grupo (ex.: Família)": "Nama grup (mis.: Keluarga)",
 "Nome do modelo": "Nama templat",
 "Nome ou modelo": "Nama atau model",
 "Nome ou razão social": "Nama atau nama perusahaan",
 "Nome, subtarefa ou anotação": "Nama, subtugas, atau catatan",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "Di grup, setiap orang bertanggung jawab atas apa yang ditambahkannya. Admin grup menentukan siapa yang ikut.",
 "Nossa Senhora Aparecida": "Nossa Senhora Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Nossa Senhora da Luz dos Pinhais",
 "Nota cancelada": "Faktur dibatalkan",
 "Nota fiscal": "Faktur",
 "Nota fiscal emitida": "Faktur diterbitkan",
 "Nota fiscal, certificado de garantia e fotos": "Nota, kartu garansi, dan foto",
 "Nota importada": "Faktur diimpor",
 "Notas": "Faktur",
 "Notas Fiscais": "Faktur Pajak",
 "Notebook e carregador": "Laptop dan pengisi daya",
 "Nova avaliação": "Penilaian baru",
 "Nova caixa (ex.: Compras, Ideias)": "Kotak baru (mis.: Belanja, Ide)",
 "Nova conversa": "Obrolan baru",
 "Nova garantia": "Garansi baru",
 "Nova matéria": "Mata pelajaran baru",
 "Nova meta": "Target baru",
 "Nova pasta": "Folder baru",
 "Nova página": "Halaman baru",
 "Nova página com esta caixa": "Halaman baru dengan kotak ini",
 "Nova refeição": "Waktu makan baru",
 "Nova tarefa": "Tugas baru",
 "Nova tarefa da casa": "Tugas rumah baru",
 "Nova tarefa neste cômodo": "Tugas baru di ruangan ini",
 "Novas": "Baru",
 "Novo": "Baru",
 "Novo alerta:": "Peringatan baru:",
 "Novo cartão": "Kartu baru",
 "Novo cartão de crédito": "Kartu kredit baru",
 "Novo cuidado": "Perawatan baru",
 "Novo documento": "Dokumen baru",
 "Novo e-mail": "Email baru",
 "Novo fichário": "Map baru",
 "Novo grupo": "Grup baru",
 "Novo item": "Item baru",
 "Novo perfil": "Profil baru",
 "Novo suplemento": "Suplemen baru",
 "Novo treino": "Latihan baru",
 "Novo: {nome}": "Baru: {nome}",
 "Novos": "Baru",
 "Num período": "Dalam periode",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Beri nomor setiap kardus dan tulis ruangan serta isinya. Gunakan pencarian untuk menemukan letak setiap barang.",
 "Nº": "No.",
 "Não": "Tidak",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Total di struk tidak ditemukan. Coba foto yang lebih jelas.",
 "Não consegue entrar?": "Tidak bisa masuk?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Tidak bisa membuka \"{nome}\". Coba alat Perbaiki PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Tidak dapat menyambungkan panggilan. Periksa internet Anda dan coba lagi.",
 "Não deu certo: {msg}": "Gagal: {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "PDF ini tidak bisa diperkecil lagi ({tam}).",
 "Não dá para tirar todas as páginas.": "Tidak bisa menghapus semua halaman.",
 "Não encontrei texto neste PDF.": "Tidak ada teks di PDF ini.",
 "Não encontrei texto neste documento.": "Tidak ada teks yang ditemukan di dokumen ini.",
 "Não foi possível": "Tidak dapat dilakukan",
 "Não foi possível abrir": "Tidak dapat dibuka",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Sertifikat yang tersimpan tidak dapat dibuka. Hubungkan sertifikat lagi.",
 "Não foi possível abrir.": "Tidak dapat dibuka.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Tidak dapat mengunduh hari libur negara ini. Periksa koneksi internet.",
 "Não foi possível conectar": "Tidak dapat terhubung",
 "Não foi possível conectar o {nome}": "Tidak dapat menghubungkan {nome}",
 "Não foi possível consultar o DJEN agora.": "Tidak dapat memeriksa DJEN saat ini.",
 "Não foi possível continuar": "Tidak dapat melanjutkan",
 "Não foi possível criar um evento na agenda: {msg}": "Tidak dapat membuat acara di kalender: {msg}",
 "Não foi possível entrar.": "Tidak dapat masuk.",
 "Não foi possível enviar": "Tidak dapat mengirim",
 "Não foi possível enviar.": "Tidak dapat mengirim.",
 "Não foi possível guardar: {erro}": "Gagal menyimpan: {erro}",
 "Não foi possível ler o arquivo.": "Tidak dapat membaca file.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Kalender tidak dapat dibaca. Periksa tautan di Edit.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Tidak dapat mencari sekarang. Akan dicoba lagi otomatis nanti.",
 "Não foi possível reiniciar sozinho.": "Tidak bisa memulai ulang otomatis.",
 "Não foi possível sincronizar com a agenda: {msg}": "Tidak dapat menyinkronkan dengan kalender: {msg}",
 "Não foi possível trocar a foto": "Tidak dapat mengganti foto",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Tidak ada jaminan notifikasi saat aplikasi ditutup. Pemeriksaan dilakukan saat aplikasi dibuka (setiap 6 jam) atau lewat \"Periksa sekarang\".",
 "Não identificado": "Tidak teridentifikasi",
 "Não marcada como feita": "Belum ditandai selesai",
 "Não optante pelo Simples": "Bukan peserta Simples",
 "Não se repete": "Tidak berulang",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "Jangan gunakan aplikasi untuk kegiatan ilegal, menyimpan konten pihak lain tanpa izin, atau mencoba mengakses data orang lain.",
 "Não vai": "Tidak datang",
 "Não vence": "Tidak kedaluwarsa",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Kami tidak menjual data Anda dan tidak menggunakan konten Anda untuk iklan.",
 "Não é possível adicionar esta pessoa.": "Tidak dapat menambahkan orang ini.",
 "Não é um XML de nota fiscal": "Bukan XML faktur",
 "Número": "Nomor",
 "Número (opcional)": "Nomor (opsional)",
 "Número da OAB": "Nomor OAB",
 "Número da caixa": "Nomor kardus",
 "Número da carteirinha": "Nomor kartu",
 "Número da guia do convênio": "Nomor surat jaminan asuransi",
 "Número da parcela": "Nomor cicilan",
 "Número de hóspedes": "Jumlah tamu",
 "Número de parcelas": "Jumlah cicilan",
 "Número do contrato": "Nomor kontrak",
 "Número do registro": "Nomor registrasi",
 "Número na chamada": "Nomor absen",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Nomor {n}. XML tersimpan di faktur. Ketuk faktur untuk melihat PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Nomor, instansi penerbit, dan catatan dienkripsi (AES-256) di perangkat sebelum dikirim ke cloud.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Nomor, instansi penerbit, catatan, foto, dan PDF dienkripsi (AES-256) di perangkat. File terlindungi hanya tersimpan di perangkat ini.",
 "Número: {n}": "Nomor: {n}",
 "Números de página": "Nomor halaman",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT tidak bisa membaca PDF di sini. Ambil foto atau tangkapan layar halamannya, atau gunakan Claude atau Gemini di Pengaturan › Kecerdasan buatan.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "DAS jatuh tempo tanggal {dia}. Tandai sudah dibayar di Keuangan.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "Kantor belum diaktifkan di server. Di komputer, jalankan 29-SERVIDOR-0.45.bat (cukup sekali).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado mengurus uang Anda: pembayaran, kartu dan tagihan, anggaran per kategori, target, mutasi dan struk lewat foto, laporan, dan MEI.",
 "O Mestre está pensando...": "Mestre sedang berpikir...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner membuat folder \"My Planner\" di Drive Anda dan hanya melihat apa yang disimpannya sendiri di sana.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner sudah terbuka di komputer dengan data Anda.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner membaca data jam tangan melalui {fonte}, tempat jam tangan serta app kesehatan dan olahraga menyimpan semuanya.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner mengatur agenda, tugas, keuangan, dokumen, dan bidang kehidupan Anda lainnya. Aplikasi ini disediakan oleh Walter Ravasco da Costa, yang merupakan pengendali data pribadi yang diproses di aplikasi.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner hanya menggunakan folder Aplikasi › My Planner di OneDrive Anda.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF dan gambar akan dihapus dari perangkat ini dan dari cloud.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF melebihi 15 MB. Jika WhatsApp atau email menolaknya, aktifkan \"File lebih kecil\".",
 "O QUE COMER": "MENU MAKAN",
 "O QUE OS MEMBROS PODEM": "YANG BISA DILAKUKAN ANGGOTA",
 "O QUE VOCÊ MANDA": "YANG ANDA KIRIM",
 "O QUE VOCÊ RECEBE": "YANG ANDA TERIMA",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "Akses tetap menggunakan CPF. Email digunakan agar tim dukungan dapat menghubungi Anda.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "Admin grup dapat mengirim janji temu, materi, dan pengumuman. Tidak ada yang masuk ke agenda Anda tanpa persetujuan Anda.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "Alarm berbunyi lagi setiap 2 menit (hingga 4 kali) selama obat belum ditandai sudah diminum.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "Aplikasi membantu Anda tetap teratur, tetapi tidak menggantikan saran dokter, pengacara, akuntan, atau profesional lainnya. Periksa tenggat, jumlah, dan tanggal penting.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "Aplikasi mengingatkan 3 hari sebelumnya dan pada hari jatuh tempo, pukul 09.00.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "Aplikasi memeriksa layanan publik CNJ (DJEN) dengan nama dan OAB yang Anda daftarkan. Data ini dikirim ke layanan tersebut setiap kali pemeriksaan.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "Aplikasi dan server My Planner mengakses layanan publik CNJ (DJEN) dengan nama dan nomor OAB yang Anda daftarkan dan, jika Anda centang, Querido Diário (lembaran resmi kota). Data ini dikirim ke layanan tersebut setiap kali pemeriksaan.",
 "O app fechou sozinho {n} vezes seguidas": "Aplikasi tertutup sendiri {n} kali berturut-turut",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "Aplikasi yang terpasang di perangkat ini adalah versi {v}. Untuk panggilan audio dan video, pasang aplikasi 0.35 atau yang lebih baru (APK baru). Pesan sudah berfungsi.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "Aplikasi tidak tertutup dan datamu tetap tersimpan. Coba lagi atau kirim laporan agar tim memperbaikinya.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "Aplikasi meminta buka kunci saat dibuka dan saat kembali dari latar belakang.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "Aplikasi meminta buka kunci saat dibuka. Berpindah aplikasi atau layar sebentar tidak memintanya lagi; jika ponsel terkunci atau aplikasi berada di luar layar lebih lama dari batas waktu di bawah, kunci akan diminta.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "App hanya membaca (langkah, jarak, kalori, olahraga, detak jantung, dan tidur) dan tidak pernah mengubah data kesehatan Anda. Total setiap hari disimpan di akun Anda agar juga tampil di situs web dan di ponsel lain.",
 "O app volta a pedir a senha para desbloquear.": "Aplikasi kembali meminta kata sandi untuk membuka kunci.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "Aplikasi ini ditujukan untuk usia di atas 18 tahun. Data anak-anak hanya boleh dicatat oleh orang tua atau wali.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "File hanya tersimpan di perangkat ini. Tidak dapat menyimpan ke {nome}: {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "File sudah tidak ada di tempat itu (dihapus atau dipindahkan).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "File sudah tidak ada di tempat itu (dihapus, dipindahkan, atau aplikasinya mencabut izin). Lampirkan lagi.",
 "O arquivo passa de 15 MB.": "File melebihi 15 MB.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "File melebihi 15 MB. Aktifkan \"File lebih kecil\" lalu coba lagi.",
 "O arquivo passa de 25 MB.": "File melebihi 25 MB.",
 "O arquivo passa de 50 MB.": "File lebih dari 50 MB.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "File akan keluar dari ponsel ini. Salinan yang kamu simpan di Drive, OneDrive atau kirim ke orang lain tetap ada.",
 "O arquivo sai do escritório para todos.": "File akan dihapus dari kantor untuk semua orang.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "Pengingat datang pukul 9.00, dan sekali lagi pada hari kedaluwarsa.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "Basis data belum disiapkan. Jalankan file supabase/schema.sql di Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "Kartu {c} sudah terpakai {p}% dari limitnya. Hindari cicilan baru di kartu ini untuk sementara.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "Ponsel tidak memberi tahu aplikasi saat layar dikunci, jadi aplikasi menghitung waktu di luar layar. Dengan 1 menit, mengunci ponsel lalu kembali nanti akan meminta biometrik; membalas pesan sebentar tidak.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Ponsel hanya digunakan untuk memastikan akun ini milik Anda (kode lewat WhatsApp saat mendaftar dan saat mengganti nomor). Satu nomor per akun.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "Berbagi belum diaktifkan di server. Di komputer, buka folder C:\\MyPlanner dan klik dua kali 12-LIGAR-COMPARTILHAMENTO.bat (cukup sekali).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "Komputer akan membuka My Planner dengan akun Anda. Lakukan ini hanya di komputer tepercaya.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "Undangan berisi tautan aplikasi dan APK terbaru. Siapa pun yang masuk lewat tautan langsung masuk ke kantor.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "Kode referral hanya berlaku dalam 30 hari pertama akun.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "Pola hanya disimpan di perangkat ini, dalam keadaan terlindungi. Kata sandi tetap berlaku jika Anda lupa pola.",
 "O dinheiro gasto está à frente do andamento da obra.": "Uang yang terpakai melampaui progres proyek.",
 "O documento não tem páginas.": "Dokumen tidak memiliki halaman.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "Mutasi rekening dibaca di perangkat ini. Tagihan dengan nominal sama dan tanggal berdekatan otomatis ditandai lunas.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "Mutasi dibaca di perangkat ini. Pembayaran tertunda dengan nilai sama dan tanggal berdekatan otomatis ditandai lunas. Pembayaran tagihan kartu tidak dihitung dua kali.",
 "O governo recusou a nota": "Pemerintah menolak faktur",
 "O governo recusou a nota.": "Pemerintah menolak faktur.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "Bahasa berlaku untuk perangkat ini. Data yang Anda ketik tidak diterjemahkan.",
 "O item vinculado foi apagado ou movido.": "Item yang ditautkan telah dihapus atau dipindahkan.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "Item yang ditautkan telah dihapus atau dipindahkan. Edit tugas untuk memilih yang lain.",
 "O link antigo deixa de funcionar.": "Tautan lama tidak akan berfungsi lagi.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "Tautan lama tidak berlaku lagi. Yang sudah di grup tetap bergabung.",
 "O link deve começar com https://": "Tautan harus diawali https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "Browser tidak bisa membaca kalender platform. Impor lewat aplikasi di ponsel.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "Paket dasar dan masa uji coba tab mengikuti aturan yang ditampilkan di Pengaturan > Pembelian. Manfaat referral berlaku satu kali per akun.",
 "O que acontece": "Apa yang terjadi",
 "O que apagar": "Yang dihapus",
 "O que comprou": "Apa yang dibeli",
 "O que fazer": "Yang harus dilakukan",
 "O que foi comido:": "Yang dimakan:",
 "O que foi feito": "Yang sudah dikerjakan",
 "O que foi visto": "Materi yang dibahas",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Apa yang berhasil, apa yang perlu diperbaiki, metode, ringkasan...",
 "O que já foi guardado continua nos lançamentos como investimento.": "Yang sudah ditabung tetap ada di transaksi sebagai investasi.",
 "O que levar ou estudar": "Yang perlu dibawa atau dipelajari",
 "O que o app pode usar": "Yang dapat digunakan aplikasi",
 "O que o médico disse": "Kata dokter",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Kiriman dari grup Anda. Janji temu yang diterima masuk ke My Planner; materi dan pengumuman masuk ke Catatan.",
 "O que precisa": "Yang dibutuhkan",
 "O que tem dentro": "Isinya",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Barang yang Anda pinjamkan atau pinjam: foto, siapa yang memegang, dan pengingat pengembalian.",
 "O que é apagado": "Apa yang dihapus",
 "O quê": "Apa",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "Pemilih menampilkan Google Drive, OneDrive dan Dropbox jika aplikasinya terpasang di ponsel. Aplikasi hanya menyimpan pintasan: file tetap di tempatnya dan terbuka di aplikasi ponsel.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "Pemilih menampilkan Google Drive, OneDrive, dan Dropbox jika aplikasi tersebut terpasang di ponsel. File yang dipilih disimpan di perangkat ini.",
 "O servidor ainda não buscou para os seus perfis.": "Server belum mencari untuk profil Anda.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "Server belum siap untuk pesan. Jalankan 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "Server belum siap untuk referral. Coba lagi nanti.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "Server belum siap untuk kartu kontak. Jalankan 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Server belum disiapkan untuk data bersama. Di komputer, buka folder C:\\MyPlanner lalu klik dua kali 15-LIGAR-GRUPOS-COLABORATIVOS.bat (cukup sekali).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "Server belum disiapkan untuk Drive dan OneDrive (lihat COMO RODAR, versi 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "Server belum disiapkan untuk akses web (jalankan supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "Server belum memiliki fungsi \"qr-login\". Lihat langkah versi 0.6 di COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "Server panggilan menolak kunci LiveKit. Di komputer admin, jalankan 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "Server faktur memberi respons tak terduga (HTTP {s}). Periksa alamatnya.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Server melakukan pengambilan otomatis setiap 2 jam, pukul 08.00 sampai 20.00 (waktu Brasília), meskipun aplikasi ditutup. Publikasi yang diambil muncul saat Anda membuka aplikasi. Anda juga bisa menggunakan \"Periksa sekarang\".",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Server melakukan pengambilan otomatis setiap hari pukul 08.00 dan 12.00 (waktu Brasília), meskipun aplikasi ditutup. Publikasi yang diambil muncul saat Anda membuka aplikasi. Anda juga bisa menggunakan \"Periksa sekarang\".",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Server menolak akses: di fungsi \"nuvem\" Supabase, matikan \"Verify JWT\" (32-LIGAR-DRIVE-ONEDRIVE.bat sudah melakukannya).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Server menolak akses: di fungsi \"nuvem\" Supabase, matikan \"Verify JWT\" (9-LIGAR-DRIVE-ONEDRIVE.bat sudah melakukannya).",
 "O seu papel no grupo não permite incluir aqui.": "Peran Anda di grup tidak mengizinkan menambah di sini.",
 "O site deve começar com https://": "Situs harus diawali dengan https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "Ukuran gelas standar ({copo}) diubah di Sesuaikan, pada kartu air.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "Tema mengubah warna tab (ikon tetap sama) dan berlaku di mode terang maupun gelap. Setelah itu Anda masih bisa mengganti warna satu tab di Pengaturan > Tab.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "Pengatur waktu terisi warna seiring berjalannya waktu tugas. Mengetuknya membuka tautan tugas.",
 "O teste grátis terminou": "Uji coba gratis telah berakhir",
 "O texto": "Teksnya",
 "O texto do PDF num arquivo .docx para editar.": "Teks PDF dalam file .docx untuk diedit.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "Teks juga disisipkan tersembunyi di dalam PDF: Anda bisa mencari dan menyalinnya di pembaca PDF.",
 "O tom escolhido fica para os próximos emojis.": "Warna kulit yang dipilih tetap dipakai untuk emoji berikutnya.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "Total muncul di bagian atas My Planner. Jika melebihi batas, ikon petir menjadi merah. Tugas \"Santai\" bernilai 0.",
 "OAB (opcional, para advogados)": "OAB (opsional, untuk pengacara)",
 "OBS": "CATATAN",
 "OCR: texto pesquisável": "OCR: teks bisa dicari",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "ATAU PILIH RUANGAN…",
 "Objetivos": "Tujuan",
 "Objeto": "Barang",
 "Objetos": "Objek",
 "Objetos e valores": "Barang dan uang",
 "Obra": "Proyek",
 "Obras": "Proyek",
 "Obras & Reformas": "Bangun & Renovasi",
 "Obrigado": "Terima kasih",
 "Obrigado!": "Makasih!",
 "Observações": "Catatan",
 "Observações (alergias, ração...)": "Catatan (alergi, pakan...)",
 "Observações (chave Pix, conta para depósito...)": "Catatan (kunci Pix, rekening untuk setoran...)",
 "Observações (código de barras, chave Pix...)": "Catatan (barcode, kunci Pix...)",
 "Observações (dados bancários, PIX...)": "Catatan (data bank, PIX...)",
 "Observações (estado do item...)": "Catatan (kondisi barang...)",
 "Observações (garantia, seguro, CET...)": "Catatan (jaminan, asuransi, biaya efektif...)",
 "Observações (nº de série, modelo...)": "Catatan (nomor seri, model...)",
 "Observações (onde está o original, categoria da CNH...)": "Catatan (lokasi dokumen asli, golongan SIM...)",
 "Observações (recibo de entrega, número...)": "Catatan (tanda terima, nomor...)",
 "Observações (restrição alimentar...)": "Catatan (pantangan makanan...)",
 "Ocultar texto (tarja)": "Sembunyikan teks (blok hitam)",
 "Ocupado": "Terisi",
 "Oficina": "Bengkel",
 "Ofício": "Legal",
 "Oi!": "Hai!",
 "Oi! Tudo certo para sábado?": "Hai! Semua beres untuk Sabtu?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Hai, {pessoa}! {coisa} yang kamu pinjamkan masih ada padaku. Kapan aku bisa mengembalikannya?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Hai, {pessoa}! Apa kabar? Mau mengingatkan soal {coisa} yang kupinjamkan padamu pada {data}. Bisa dikembalikan {quando}?",
 "Oi?!": "Hah?!",
 "Olá!": "Halo!",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Halo! Saya Mestre Achado. Tanyakan tentang pengeluaran, pembayaran, kartu, dan target Anda: saya menjawab dengan angka Anda.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Halo! Sekadar mengingatkan pembayaran {ref} ({v}), jatuh tempo pada {d}. Terima kasih!",
 "Olá! Preciso de assistência técnica para: {item}": "Halo! Saya butuh layanan servis untuk: {item}",
 "Olá, {nome}!": "Halo, {nome}!",
 "Olá, {nome}! Seja bem-vindo(a).": "Halo, {nome}! Selamat datang.",
 "Ombros: girar para trás": "Bahu: putar ke belakang",
 "Omelete": "Omelet",
 "Onde": "Di mana",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Di mana AI membantu: Publikasi (sidang dan tenggat), Dokumen (mengisi formulir dari foto), dan Catatan (mengubah kotak menjadi tugas).",
 "Onde assistir": "Tempat menonton",
 "Onde eu mais gastei este mês?": "Untuk apa pengeluaran terbesar saya bulan ini?",
 "Onde fica": "Lokasinya",
 "Onde guardar fotos e arquivos novos": "Tempat menyimpan foto dan file baru",
 "Onde na página": "Posisi di halaman",
 "Ontem": "Kemarin",
 "Organizar": "Atur",
 "Organizar barra": "Atur bilah",
 "Organizar com IA": "Atur dengan AI",
 "Organizar com IA (vira tarefas)": "Atur dengan AI (jadi tugas)",
 "Organizar páginas": "Atur halaman",
 "Orgulho e vibrante": "Bangga dan cerah",
 "Origem": "Sumber",
 "Origem da reserva": "Sumber reservasi",
 "Original": "Asli",
 "Orquídeas": "Anggrek",
 "Orçado": "Anggaran",
 "Orçamento": "Anggaran",
 "Orçamento do mês": "Anggaran bulan ini",
 "Orçamento por categoria": "Anggaran per kategori",
 "Orçamento total": "Total anggaran",
 "Orçamento: {v}": "Anggaran: {v}",
 "Os alertas precisam de um horário.": "Peringatan memerlukan jam.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Lampiran yang hanya ada di perangkat tidak muncul di perangkat lain dan hilang jika ponsel diganti. Hubungkan Google Drive atau OneDrive di Pengaturan untuk menyimpan salinan.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "File dan cadangan yang sudah ada di sana tetap ada. My Planner hanya berhenti menyimpan hal baru.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "File yang disimpan di perangkat ini juga akan dihapus.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "File di Google Drive, OneDrive, atau ponselmu tetap milikmu. Catatan yang wajib disimpan menurut hukum (seperti log akses) dapat disimpan selama jangka waktu hukum lalu dihapus.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Pemberitahuan grup belum diaktifkan di server. Di komputer, klik dua kali 15-LIGAR-GRUPOS-COLABORATIVOS.bat (cukup sekali).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Notifikasi dimatikan untuk My Planner. Ketuk Buka pengaturan dan nyalakan notifikasi.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Notifikasi di ponsel berfungsi di aplikasi yang terinstal (Android atau iPhone).",
 "Os campos do formulário viram parte da página.": "Kolom formulir jadi bagian dari halaman.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Data saat ini akan diganti dengan data dari file, di sini dan di cloud.",
 "Os dados continuam salvos na nuvem.": "Data tetap tersimpan di cloud.",
 "Os dados da aba ainda são só seus": "Data tab ini masih hanya milik Anda",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Data di tab {aba} akan terlihat oleh tim, masing-masing sesuai peran yang Anda pilih.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Data grup ini belum dibuka. Minta pembuat grup membuka My Planner versi terbaru: aplikasi akan membukanya otomatis.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Data grup ini belum dibuka. Minta pembuat grup memperbarui My Planner dan membuka grup: tombol untuk membukanya ada di sana.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Data brankas dienkripsi di perangkat ini (AES-256) sebelum dikirim ke cloud. Tim dukungan pun tidak bisa membacanya. Jika Anda lupa kata sandi brankas, data ini tidak dapat dipulihkan.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Data disimpan selama akun masih ada. Saat akun dihapus, data ikut dihapus, kecuali yang wajib disimpan menurut hukum.",
 "Os desenhos não conferem. Comece de novo.": "Pola tidak cocok. Mulai lagi.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Tanggalnya ada di aplikasi atau di tagihan bank. Pembelian setelah tanggal tutup masuk ke tagihan berikutnya.",
 "Os emojis que você usar aparecem aqui.": "Emoji yang Anda pakai muncul di sini.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Grup belum diaktifkan di server. Di komputer, buka folder C:\\MyPlanner dan klik dua kali 11-LIGAR-GRUPOS.bat (cukup sekali).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Grup belum diaktifkan di server. Jalankan supabase\\migracao-0.21.sql di Supabase (lihat COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Tempat dibuka di Google Maps, Waze, atau Peta, sesuai pilihan di Pengaturan.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Anggota selalu melihat admin dan hanya menerima yang dikirim kepada mereka.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Anggota lain tidak lagi melihat data (salinan hilang dari perangkat mereka). Semuanya tetap ada pada Anda.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Profil dan hasil disimpan di akun My Planner Anda.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Profil, OAB, dan pengadilan ada di dalam tab Publikasi. Pencarian otomatis berjalan di server pukul 08.00 dan 12.00 (waktu Brasília).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Harga disimpan dan muncul di daftar belanja tab Makanan & Dapur sebagai harga pembelian terakhir.",
 "Os resultados deste perfil também serão apagados.": "Hasil dari profil ini juga akan dihapus.",
 "Os termos foram atualizados": "Ketentuan telah diperbarui",
 "Ou digite (ex.: 2 ovos mexidos)": "Atau ketik (mis.: 2 telur orak-arik)",
 "Ou escreva o prato": "Atau tulis hidangannya",
 "Ou escreva o seu": "Atau tulis sendiri",
 "Outra": "Lainnya",
 "Outra aba…": "Tab lain…",
 "Outra atividade (digite e dê Enter)": "Aktivitas lain (ketik lalu tekan Enter)",
 "Outro": "Lainnya",
 "Outro (ml)": "Lainnya (ml)",
 "Outro valor": "Jumlah lain",
 "Outros": "Lainnya",
 "Outros países": "Negara lain",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Jam tangan lain (Garmin, Samsung, Xiaomi, Amazfit...): di app jam tangan, aktifkan opsi untuk mengirim data ke app Kesehatan (Apple Kesehatan).",
 "Ovo": "Telur",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "LUNAS, DITERIMA, RAHASIA, DISETUJUI atau teks Anda, dengan tanggal.",
 "PARA ACERTAR": "PERLU DISELESAIKAN",
 "PARA QUEM": "UNTUK SIAPA",
 "PARA {refeicao}": "UNTUK {refeicao}",
 "PASSO A PASSO": "LANGKAH DEMI LANGKAH",
 "PASSO {n}": "LANGKAH {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF dengan teks digital: langsung jadi di browser. PDF hasil pindai (foto): AI Anda membaca setiap halaman.",
 "PDF grande": "PDF besar",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF tersimpan di folder \"{pasta}\" di ponsel.",
 "PDF guardado no {nome}.": "PDF tersimpan di {nome}.",
 "PDF numa página só": "PDF dalam satu halaman",
 "PDF para Word": "PDF ke Word",
 "PDF para imagens": "PDF ke gambar",
 "PDF para texto": "PDF ke teks",
 "PDFs arquivados ({n})": "PDF diarsipkan ({n})",
 "PDFs juntados {data}": "PDF gabungan {data}",
 "PEDIDOS RECEBIDOS": "PERMINTAAN MASUK",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX SALIN-TEMPEL",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "TAGIHAN BERIKUTNYA (SUDAH TERPAKAI)",
 "Paciente": "Pasien",
 "Paciente ou aluno": "Pasien atau siswa",
 "Pacientes": "Pasien",
 "Padrão": "Default",
 "Padrão da aba": "Default tab",
 "Paga": "Dibayar",
 "Paga (toque para desfazer)": "Dibayar (ketuk untuk membatalkan)",
 "Pagador": "Pembayar",
 "Pagamento já contado": "Pembayaran sudah dihitung",
 "Pagar": "Bayar",
 "Pagar parcela {n}/{t} · {c}": "Bayar cicilan {n}/{t} · {c}",
 "Pagas": "Dibayar",
 "Pago": "Lunas",
 "Pago com": "Dibayar dengan",
 "Pago: {p} · Falta pagar: {f}": "Dibayar: {p} · Sisa: {f}",
 "Pagos": "Lunas",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Membayar {v}? Jika ada diskon, denda, atau bunga, masukkan jumlah yang dibayar. Simpan bukti sekarang?",
 "Paguei outro valor (desconto, multa ou juros)": "Saya membayar jumlah lain (diskon, denda, atau bunga)",
 "Paixão de Cristo": "Jumat Agung",
 "Palavras-chave (separe com vírgula)": "Kata kunci (pisahkan dengan koma)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Agar target \"{m}\" tercapai tepat waktu, perlu {v} per bulan. Sebaiknya perpanjang tenggat atau mulai dengan jumlah lebih kecil.",
 "Para clareza, firmo o presente.": "Demikian surat ini dibuat dengan sebenarnya.",
 "Para comprar": "Untuk dibeli",
 "Para continuar, digite a senha do app.": "Untuk melanjutkan, masukkan kata sandi aplikasi.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Untuk mengobrol, aktifkan AI Anda di Pengaturan › Kecerdasan buatan (Claude, ChatGPT, atau Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Untuk membagi pengeluaran, tulis nama-nama di \"Siapa yang ikut\" dipisahkan koma (edit perjalanan).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Untuk menerbitkan dan mencari faktur, hubungkan server faktur sekali saja: di komputer, klik dua kali 13-LIGAR-NOTAS.bat lalu tempel di sini alamat yang ditampilkannya (berakhiran .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Untuk menggunakan hak Anda, gunakan Hubungi kami di aplikasi atau kirim email ke alamat di bawah. Kami membalas dalam 15 hari.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Untuk panggilan suara dan video, instal versi baru aplikasi (0.35). Pesan sudah berfungsi.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Agar aplikasi berfungsi: menyimpan dan menyinkronkan data Anda antarperangkat, mengirim pengingat, berbagi dengan grup yang Anda pilih, dan memberi dukungan.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Untuk menyimpan PDF di {nome}, hubungkan akun Anda di Pengaturan › Google Drive dan OneDrive.",
 "Para hoje": "Ke hari ini",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Untuk membaca foto atau PDF, aktifkan AI Anda di Pengaturan › Kecerdasan buatan (Claude, ChatGPT, atau Gemini). Mutasi dalam OFX atau CSV bisa tanpa AI.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Untuk membaca jam tangan secara otomatis, instal versi baru app (0.33). Sementara itu, Anda dapat memasukkan secara manual.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Untuk membaca jam tangan, hubungkan melalui app di ponsel. Angkanya juga akan muncul di sini.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Untuk membaca jam tangan, izinkan My Planner mengakses data aktivitas.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Untuk membaca teks, merangkum, dan bertanya, aktifkan AI Anda di Pengaturan › Kecerdasan buatan (Claude, ChatGPT, atau Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Untuk mengaktifkan, gunakan aplikasi di ponsel (Pengaturan > Google Kalender). Setelah itu, semuanya juga muncul di sini.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Untuk mengaktifkan, gunakan aplikasi di ponsel (Pengaturan › Pengaturan umum › Google Kalender). Setelah itu, semuanya juga muncul di sini.",
 "Para monitorar a OAB, informe o número e a UF.": "Untuk memantau OAB, masukkan nomor dan UF (negara bagian).",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Agar tidak ditanya lagi, pilih aplikasi di Pengaturan › Pengaturan umum.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Untuk tenaga kesehatan: pasien, perkembangan di brankas, resep dengan templat, keuangan, kuitansi, dan surat keterangan klaim dalam PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Untuk tenaga kesehatan: pasien, perkembangan, resep dengan templat, keuangan dengan asuransi, kuitansi, dan surat keterangan klaim.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Untuk melindungi akun Anda, kami mengonfirmasi ponsel Anda sekali, dengan kode lewat WhatsApp. Kode hanya diminta lagi jika Anda mengganti nomor.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Untuk yang menyewakan properti atau kamar harian (Airbnb, Booking, atau langsung): reservasi, bersih-bersih, pengeluaran, dan laba setiap bulan.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Untuk menerima jadwal, lokasi, dan pemberitahuan acara di ponsel, bergabunglah ke grup: {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Untuk menyinkronkan, izinkan My Planner mengakses kalender di pengaturan ponsel.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Untuk mencabut izin yang sudah Anda berikan ke sistem (kamera, foto, mikrofon), gunakan juga pengaturan ponsel.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Untuk pembacaan yang lebih lengkap, aktifkan AI Anda di Pengaturan › Kecerdasan buatan.",
 "Parabéns": "Selamat",
 "Parabéns!": "Selamat!",
 "Parada": "Diam",
 "Parar": "Hentikan",
 "Parar de compartilhar?": "Berhenti berbagi?",
 "Parar e salvar": "Berhenti dan simpan",
 "Parar gravação": "Hentikan rekaman",
 "Parcela": "Cicilan",
 "Parcela de financiamento": "Cicilan pembiayaan",
 "Parcela {n}/{t}": "Cicilan {n}/{t}",
 "Parcela {n}/{t} · {c}": "Cicilan {n}/{t} · {c}",
 "Parcelas": "Cicilan",
 "Parcelas a pagar nos próximos meses": "Cicilan yang harus dibayar beberapa bulan ke depan",
 "Parcelas recalculadas": "Cicilan dihitung ulang",
 "Parece que foi impresso e escaneado.": "Terlihat seperti dicetak lalu dipindai.",
 "Parei": "Berhenti",
 "Parei na aula": "Berhenti di pelajaran",
 "Parei na aula...": "Berhenti di pelajaran...",
 "Pares de meia": "Pasang kaus kaki",
 "Parque ou natureza": "Taman atau alam",
 "Parques": "Taman",
 "Parte": "Pihak",
 "Partes": "Para pihak",
 "Participa": "Peserta",
 "Participantes": "Peserta",
 "Participação em empresa": "Kepemilikan saham perusahaan",
 "Passa do limite do MEI: fale com seu contador.": "Melebihi batas MEI: bicarakan dengan akuntan Anda.",
 "Passaporte": "Paspor",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Usap jari di atas gambar untuk menghapus bagian itu saja.",
 "Passeio": "Wisata",
 "Passeios": "Wisata",
 "Passo a passo": "Langkah demi langkah",
 "Passos": "Langkah",
 "Passos, exercício, calorias, batimentos e sono": "Langkah, olahraga, kalori, detak jantung, dan tidur",
 "Passou do orçamento": "Melebihi anggaran",
 "Passou do orçamento em {v}": "Melebihi anggaran sebesar {v}",
 "Pasta": "Folder",
 "Patrimônio": "Harta",
 "Patrimônio & Imposto de Renda": "Harta & Pajak Penghasilan",
 "Patrimônio pelo valor de compra: {v}": "Harta berdasarkan harga beli: {v}",
 "Pausa (s)": "Istirahat (dtk)",
 "Pausa de {m} min": "Jeda {m} mnt",
 "Pausado": "Dijeda",
 "Pausar": "Jeda",
 "Pausas": "Jeda",
 "Pausas de estudo": "Jeda belajar",
 "Pauta (opcional)": "Agenda (opsional)",
 "Paz": "Damai",
 "Pediatra": "Dokter anak",
 "Pedido": "Permintaan",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Permintaan dikirim ke {nome}. Setelah diterima, kalian sudah bisa mengobrol.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Permintaan dikirim. Setelah orang itu menerima, kalian sudah bisa mengobrol.",
 "Pedidos de documentos": "Permintaan dokumen",
 "Pedir de novo depois de": "Minta lagi setelah",
 "Peguei emprestado": "Saya pinjam",
 "Peito de frango": "Dada ayam",
 "Peixe": "Ikan",
 "Pela última compra: cerca de {v}": "Dari pembelian terakhir: sekitar {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Dengan pembayaran yang masih jatuh tempo bulan ini, akan kurang {v}. Lihat apa yang bisa ditunda atau dipangkas sebelum menambah pengeluaran baru.",
 "Pendente": "Menunggu",
 "Pensão alimentícia": "Tunjangan nafkah",
 "Pequena": "Kecil",
 "Pequeno": "Kecil",
 "Percentual de tributos do Simples (para sair na nota)": "Persentase pajak Simples (untuk dicantumkan di faktur)",
 "Perguntar ao Mestre": "Tanya Mestre",
 "Perguntar sempre": "Selalu tanya",
 "Pergunte ao Mestre...": "Tanya Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Tanyakan tentang dokumen (mis.: kapan tenggatnya?)",
 "Permissões": "Izin",
 "Personalizado": "Kustom",
 "Perto do limite do orçamento": "Mendekati batas anggaran",
 "Período": "Periode",
 "Período da meta": "Periode target",
 "Pescoço: inclinar para os lados": "Leher: miringkan ke samping",
 "Peso": "Berat",
 "Peso na média": "Bobot dalam rata-rata",
 "Pesquisar no mapa": "Cari di peta",
 "Pessoa": "Orang",
 "Pessoa de contato": "Narahubung",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Anggota grup Anda hanya melihat apa yang dibagikan di grup.",
 "Pet": "Hewan",
 "Pet & Família": "Hewan & Keluarga",
 "Pet shop": "Pet shop",
 "Pet shop ou clínica": "Pet shop atau klinik",
 "Pets": "Hewan peliharaan",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Minta dokumen ke klien dengan tenggat. Klien menerima, melampirkan, dan menandai sudah diserahkan.",
 "Pijamas": "Piyama",
 "Pilates": "Pilates",
 "Pintura": "Pengecatan",
 "Pix copia e cola": "Pix salin-tempel",
 "Placa": "Pelat nomor",
 "Planejado": "Rencana",
 "Planejado e comido": "Rencana dan yang dimakan",
 "Planilha": "Spreadsheet",
 "Planilha (Excel)": "Spreadsheet (Excel)",
 "Planilha do mês para o Receita Saúde": "Tabel bulanan untuk Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Paket dasar: My Planner + Catatan",
 "Plano de aula": "Rencana pelajaran",
 "Plano de saúde": "Asuransi kesehatan",
 "Planos de aula": "Rencana pelajaran",
 "Planta": "Tanaman",
 "Plantas": "Tanaman",
 "Plantas & Jardim": "Tanaman & Kebun",
 "Plataforma ou escola": "Platform atau sekolah",
 "Pneus novos": "Ban baru",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Bisa konfirmasi kehadiran dengan membalas pesan ini?",
 "Polichinelo": "Jumping jack",
 "Polo ativo": "Penggugat",
 "Polo passivo": "Tergugat",
 "Política de privacidade (LGPD)": "Kebijakan privasi (LGPD)",
 "Política de privacidade, LGPD e permissões": "Kebijakan privasi, LGPD, dan izin",
 "Política de privacidade, LGPD e termos": "Kebijakan privasi, LGPD, dan ketentuan",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Taruh foto dan video perjalanan di sini. Di dalam grup, semua orang dapat melihatnya dan menambahkan milik mereka.",
 "Ponte de glúteos": "Glute bridge",
 "Ponto facultativo": "Cuti bersama",
 "Ponto facultativo: {nome}": "Cuti bersama opsional: {nome}",
 "Ponto turístico": "Tempat wisata",
 "Pontos turísticos": "Tempat wisata",
 "Por dia": "Per hari",
 "Por faixas": "Per rentang",
 "Por mês": "Per bulan",
 "Por nome": "Berdasarkan nama",
 "Por semana": "Per minggu",
 "Portal": "Portal",
 "Portal do Cliente": "Portal Klien",
 "Portal do cliente (convidar o cliente)": "Portal klien (undang klien)",
 "Português": "Bahasa Portugis",
 "Porão": "Ruang bawah tanah",
 "Porções": "Porsi",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Ruang kosong sedikit: foto dan lampiran baru mungkin tidak tersimpan. Kosongkan ruang atau simpan lampiran di Google Drive atau OneDrive.",
 "Praia": "Pantai",
 "Prancha": "Plank",
 "Prato do cardápio": "Hidangan menu",
 "Prato principal": "Hidangan utama",
 "Prazo": "Tenggat",
 "Prazo (pagamento ou entrega)": "Tenggat (pembayaran atau pengumpulan)",
 "Prazo até {fim} · fazer em {dia}": "Tenggat sampai {fim} · kerjakan pada {dia}",
 "Prazo final: {fim}": "Batas akhir: {fim}",
 "Prazo: {d}": "Tenggat: {d}",
 "Prazo: {t}": "Tenggat: {t}",
 "Prazos criados": "Tenggat sudah dibuat",
 "Precisa da sua IA": "Perlu AI Anda",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Isi deskripsi, kode pajak nasional (6 angka), dan nilai.",
 "Preenche os campos do PDF e, se quiser, trava.": "Mengisi kolom PDF dan, jika mau, menguncinya.",
 "Preencher formulário": "Isi formulir",
 "Preencher pela foto com a minha IA": "Isi dari foto dengan AI saya",
 "Preencher pela nota fiscal com a minha IA": "Isi dari nota dengan AI saya",
 "Preparando a conversa da equipe...": "Menyiapkan obrolan tim...",
 "Preparando a página {n} de {total}...": "Menyiapkan halaman {n} dari {total}...",
 "Preparando o arquivo": "Menyiapkan file",
 "Prescrição, conduta e orientações": "Resep, tindakan, dan anjuran",
 "Presente": "Hadir",
 "Presença": "Kehadiran",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Tekan lama kode untuk menyalinnya, atau ketuk Kirim lalu pilih \"Salin\".",
 "Pressione e segure o código para copiar.": "Tekan dan tahan kode untuk menyalin.",
 "Pressione e segure um lançamento para apagar.": "Tekan dan tahan transaksi untuk menghapus.",
 "Pressione e segure um perfil para removê-lo.": "Tekan dan tahan profil untuk menghapusnya.",
 "Preto e branco": "Hitam putih",
 "Previdência privada": "Dana pensiun swasta",
 "Preço ou ingresso": "Harga atau tiket",
 "Price": "Anuitas (Price)",
 "Primeira": "Pertama",
 "Primeira cota ou cota única do IR": "Cicilan pertama atau pembayaran tunggal IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Cicilan pertama di tagihan {mes}, jatuh tempo {data}.",
 "Prioridade": "Prioritas",
 "Privacidade": "Privasi",
 "Privacidade e termos": "Privasi dan ketentuan",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Privasi: teks atau gambar yang dianalisis dikirim langsung dari perangkat ini ke perusahaan AI pilihan Anda, dengan kunci Anda. My Planner tidak menyimpan salinan.",
 "Problema": "Masalah",
 "Problemas, erros e sugestões": "Masalah, error, dan saran",
 "Procedimento": "Tindakan",
 "Procedimento: {c}": "Tindakan: {c}",
 "Processo": "Perkara",
 "Processo Civil": "Hukum Acara Perdata",
 "Processo Penal": "Hukum Acara Pidana",
 "Processo do Trabalho": "Hukum Acara Ketenagakerjaan",
 "Processo não informado": "Nomor perkara tidak ada",
 "Proclamação da República": "Hari Proklamasi Republik",
 "Procurando a folha...": "Mencari kertas...",
 "Procurando atualização...": "Mencari pembaruan...",
 "Procurar aba": "Cari tab",
 "Procurar atualização agora": "Cari pembaruan sekarang",
 "Procurar documento": "Cari dokumen",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Cari alat (mis.: gabung, tanda tangan, kompres)",
 "Produto": "Produk",
 "Produto (ex.: Geladeira)": "Produk (mis.: Kulkas)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Produk, faktur, servis, dan pengingat sebelum garansi berakhir.",
 "Produção (vale de verdade)": "Produksi (berlaku sungguhan)",
 "Produção restrita (teste)": "Produksi terbatas (uji)",
 "Produção restrita (teste, não vale)": "Produksi terbatas (uji, tidak berlaku)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Produksi terbatas: lingkungan uji pemerintah. Faktur tidak berlaku. Uji semuanya di sini sebelum beralih ke Produksi (di Edit).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Produksi: faktur yang diterbitkan berlaku sungguhan dan dikirim ke pemerintah kota dan Receita.",
 "Produção: vale de verdade": "Produksi: berlaku sungguhan",
 "Professor": "Guru",
 "Professor & Mentoria": "Guru & Mentoring",
 "Professor(a)": "Guru",
 "Profissionais": "Tukang",
 "Profissional": "Tukang",
 "Profissional assistente": "Tenaga asisten",
 "Profissional ou fornecedor": "Tukang atau vendor",
 "Profissional ou local": "Tenaga ahli atau tempat",
 "Profissão ou especialidade": "Profesi atau spesialisasi",
 "Profissões": "Profesi",
 "Programação": "Pemrograman",
 "Progresso geral": "Progres keseluruhan",
 "Projeto e licenças": "Desain dan izin",
 "Projetos": "Proyek",
 "Prontas": "Siap pakai",
 "Pronto": "Siap",
 "Pronto! Todas as abas estão liberadas até {data}.": "Selesai! Semua tab terbuka sampai {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "Selesai. Kunci layar dan tunggu 1 menit: peringatan seharusnya muncul dengan suara.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Rekam medis, perkembangan, dan resep, tanpa keuangan.",
 "Protegendo a chave...": "Melindungi kunci...",
 "Proteger no cofre": "Lindungi di brankas",
 "Protegido": "Dilindungi",
 "Protegido no cofre": "Terlindungi di brankas",
 "Protegidos pelo cofre: {n}": "Dilindungi brankas: {n}",
 "Protetor solar": "Tabir surya",
 "Protocolo": "Nomor protokol",
 "Prova": "Ujian",
 "Próxima": "Berikutnya",
 "Próxima até a data": "Berikutnya pada tanggal",
 "Próxima com quantos km": "Berikutnya pada km",
 "Próxima dose": "Dosis berikutnya",
 "Próxima: {data}": "Berikutnya: {data}",
 "Próxima: {d} · {v}": "Berikutnya: {d} · {v}",
 "Próximas": "Mendatang",
 "Próximo": "Berikutnya",
 "Próximo ano": "Tahun berikutnya",
 "Próximo número da DPS": "Nomor DPS berikutnya",
 "Próximos 7 dias": "7 hari ke depan",
 "Próximos vencimentos ({n})": "Jatuh tempo berikutnya ({n})",
 "Publicação": "Publikasi",
 "Publicações": "Publikasi",
 "Pula": "Melompat",
 "Pulsa": "Berdenyut",
 "Punho": "Kepalan tangan",
 "Puxada frontal": "Lat pulldown",
 "PÁGINAS": "HALAMAN",
 "PÔR NA BARRA": "PASANG DI BILAH",
 "Pág. {n}": "Hlm. {n}",
 "Página": "Halaman",
 "Página 1": "Halaman 1",
 "Página 1 de 10": "Halaman 1 dari 10",
 "Página em branco no fim": "Halaman kosong di akhir",
 "Página em que estou": "Halaman saat ini",
 "Página escaneada": "Halaman dipindai",
 "Página inteira": "Satu halaman penuh",
 "Página {a} de {n}": "Halaman {a} dari {n}",
 "Página {n}": "Halaman {n}",
 "Página {n} de {total}": "Halaman {n} dari {total}",
 "Página: {titulo}": "Halaman: {titulo}",
 "Páginas": "Halaman",
 "Páginas, tamanho, autor, datas e campos.": "Halaman, ukuran, penulis, tanggal, dan kolom.",
 "Pássaro": "Burung",
 "Pão francês": "Roti gulung",
 "Pão integral": "Roti gandum",
 "Pôr a data de hoje": "Tambahkan tanggal hari ini",
 "Pôr as parcelas no My Planner": "Masukkan cicilan ke My Planner",
 "Pôr na barra": "Pasang di bilah",
 "Pôr no roteiro da viagem": "Masukkan ke rencana perjalanan",
 "Pôr uma foto": "Pasang foto",
 "Quadro": "Papan",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Papan Kanban, pencatat jam per klien, dan tenggat di My Planner.",
 "Quais contas vencem nos próximos dias?": "Pembayaran apa yang jatuh tempo dalam beberapa hari ke depan?",
 "Quais páginas ficam no PDF novo": "Halaman yang masuk ke PDF baru",
 "Quais páginas sair": "Halaman yang dihapus",
 "Qual IA": "AI mana",
 "Qualidade alta": "Kualitas tinggi",
 "Qualidade boa (menor)": "Kualitas baik (lebih kecil)",
 "Quantidade": "Jumlah",
 "Quanto cortar de cada lado (% da página)": "Berapa yang dipotong di tiap sisi (% halaman)",
 "Quanto já tem guardado (opcional)": "Sudah ditabung (opsional)",
 "Quanto paga por limpeza": "Bayaran per bersih-bersih",
 "Quanto preciso guardar por mês para as minhas metas?": "Berapa yang perlu saya tabung per bulan untuk target saya?",
 "Quanto quer juntar": "Jumlah yang ingin dikumpulkan",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Berapa maksimal yang ingin Anda belanjakan di setiap kategori per bulan. Kosongkan jika tidak ingin dikontrol.",
 "Quarta": "Rabu",
 "Quarta-feira de Cinzas (até 14h)": "Rabu Abu (hingga 14.00)",
 "Quarto": "Kamar tidur",
 "Quarto das crianças": "Kamar anak",
 "Quarto de casal": "Kamar tidur utama",
 "Quarto de hóspedes": "Kamar tamu",
 "Quarto infantil": "Kamar anak",
 "Queijo": "Keju",
 "Queixa principal": "Keluhan utama",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Siapa pun yang membuka tautan akan mengunduh My Planner (atau memakainya di browser), masuk ke akun, dan menjadi anggota grup.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Siapa pun yang membuat akun dengan kode Anda langsung menjadi teman Anda di sini, tanpa perlu permintaan.",
 "Quem enviou": "Pengirim",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Orang yang satu grup dengan Anda di aplikasi (kelas, keluarga, perjalanan...) sudah bisa mengobrol tanpa berteman. Tahan seorang teman untuk menghapus pertemanan atau memblokir.",
 "Quem faz a limpeza": "Petugas kebersihan",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Siapa yang membayar, jika bukan pasien (ibu, ayah, wali)",
 "Quem pagou": "Siapa yang membayar",
 "Quem recebeu (médico, escola...)": "Penerima (dokter, sekolah...)",
 "Quem vai": "Siapa yang ikut",
 "Quem vai limpar": "Siapa yang membersihkan",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Siapa yang melihat: hanya orang yang mengobrol dengan Anda, teman Anda, dan orang yang satu grup aplikasi dengan Anda. Kosongkan yang tidak ingin Anda tampilkan.",
 "Quente": "Panas",
 "Quer escanear mais uma página?": "Pindai satu halaman lagi?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Simpan bukti sekarang? Foto, PDF, atau tangkapan layar Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Mau mengirim tangkapan layar? Kirim lewat email dan lampirkan gambarnya.",
 "Quer trocar pelos novos ou manter os dois?": "Ganti dengan yang baru atau simpan keduanya?",
 "Quero assistir": "Ingin ditonton",
 "Quero ir": "Ingin ke sana",
 "Quero ler": "Ingin dibaca",
 "Quero ver": "Ingin ditonton",
 "Quilometragem atual": "Km saat ini",
 "Quilometragem: {km}": "Jarak tempuh: {km}",
 "Quinta": "Kamis",
 "Quintal": "Halaman belakang",
 "Quitado": "Lunas",
 "Quitados": "Lunas",
 "Química": "Kimia",
 "RECIBO": "KUITANSI",
 "RG / Carteira de identidade": "KTP / Kartu identitas (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "KTP, SIM, paspor, kontrak, dan akta, dengan pengingat sebelum kedaluwarsa dan kirim dengan satu ketukan.",
 "Raciocínio Lógico": "Penalaran Logis",
 "Razão social ou nome": "Nama perusahaan atau nama",
 "Razão social ou nome do consultório": "Nama badan usaha atau tempat praktik",
 "Razão social ou nome fantasia": "Nama perusahaan atau nama dagang",
 "Raça": "Ras",
 "Realizado": "Terlaksana",
 "Recado": "Pesan",
 "Recalcular": "Hitung ulang",
 "Recalcular as parcelas em aberto": "Hitung ulang cicilan yang belum dibayar",
 "Recalcular as parcelas?": "Hitung ulang cicilan?",
 "Receber": "Terima",
 "Receber de volta: {i} ({p})": "Minta kembali: {i} ({p})",
 "Receber o código no WhatsApp": "Terima kode di WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Terima cicilan {n}/{t} · {c}",
 "Recebeu um convite?": "Menerima undangan?",
 "Recebeu um código?": "Dapat kode?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "Telah saya terima dari {pagador}{doc} uang sejumlah {valor}{extenso}, untuk {tipo} yang dilakukan pada {data}{paciente}.",
 "Recebi outro valor": "Saya menerima jumlah lain",
 "Recebida": "Diterima",
 "Recebida (toque para desfazer)": "Diterima (ketuk untuk membatalkan)",
 "Recebidas": "Diterima",
 "Recebido": "Diterima",
 "Recebido: {v}": "Diterima: {v}",
 "Recebidos": "Diterima",
 "Recebidos dos grupos": "Diterima dari grup",
 "Recebimento": "Penerimaan",
 "Receita": "Resep",
 "Receitas": "Resep",
 "Recibo": "Kuitansi",
 "Recibo em PDF": "Kuitansi PDF",
 "Recibo emitido": "Kuitansi diterbitkan",
 "Recibo guardado": "Kuitansi disimpan",
 "Recibos dedutíveis": "Kuitansi yang dapat dikurangkan",
 "Recomendada": "Disarankan",
 "Recomeçar": "Mulai ulang",
 "Recortar": "Potong",
 "Recortar margens": "Potong margin",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Potong, putar, dan filter hadir di aplikasi baru (versi 0.49).",
 "Recusada": "Ditolak",
 "Recusado": "Ditolak",
 "Recusar": "Tolak",
 "Redação": "Menulis Esai",
 "Refazer": "Ulangi",
 "Refeição": "Waktu makan",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Makan, olahraga, perawatan, dan suplemen yang dijadwalkan hari ini",
 "Referente a": "Untuk pembayaran",
 "Referência": "Referensi",
 "Reforço": "Booster",
 "Regar a cada quantos dias": "Siram setiap berapa hari",
 "Regar hoje": "Siram hari ini",
 "Regar: {p}": "Siram: {p}",
 "Regional": "Regional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Mengisi catatan harian, tahapan, dan pengiriman, tanpa melihat nominal.",
 "Registrar venda/serviço do MEI": "Catat penjualan/jasa MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Catat setiap kunjungan: perkembangan disimpan di brankas dengan enkripsi. Resep bisa diambil dari templat.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Catat pembelian dan penjualan properti, kendaraan, dan investasi beserta buktinya. Sangat membantu saat lapor pajak.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Catat apa yang berbeda dari jadwal (mengganti makanan, mengubah waktu makan). Masuk ke laporan mingguan.",
 "Registro": "Catatan",
 "Registro clínico": "Catatan klinis",
 "Registro de horas": "Catatan jam",
 "Registro do diário": "Catatan harian",
 "Regiões com feriado próprio (marque as suas):": "Wilayah dengan hari libur sendiri (pilih wilayah Anda):",
 "Regras da casa": "Aturan rumah",
 "Regras da casa:": "Aturan rumah:",
 "Reguei": "Sudah disiram",
 "Reguei hoje": "Sudah disiram hari ini",
 "Reiniciar": "Mulai ulang",
 "Reiniciar o app": "Mulai ulang aplikasi",
 "Relatório": "Laporan",
 "Relatório da semana": "Laporan mingguan",
 "Relatório em PDF ou Excel": "Laporan PDF atau Excel",
 "Relatório enviado. Obrigado!": "Laporan terkirim. Terima kasih!",
 "Relatórios": "Laporan",
 "Relatórios do Bem-Estar": "Laporan Kesehatan",
 "Relatórios gerados ({n})": "Laporan yang dibuat ({n})",
 "Relaxar": "Santai",
 "Religião": "Agama",
 "Relógio": "Jam",
 "Relógio e apps de saúde": "Jam tangan dan app kesehatan",
 "Remada baixa": "Seated row",
 "Remover": "Hapus",
 "Remover \"{nome}\"?": "Hapus \"{nome}\"?",
 "Remover anotações": "Hapus anotasi",
 "Remover este bloco?": "Hapus blok ini?",
 "Remover páginas": "Hapus halaman",
 "Remover vínculo": "Hapus tautan",
 "Remover {nome}?": "Keluarkan {nome}?",
 "Remédio": "Obat",
 "Remédio contínuo": "Obat rutin",
 "Remédio na linha do tempo": "Obat di lini masa",
 "Remédios": "Obat",
 "Remédios de uso contínuo": "Obat rutin",
 "Renavam ou chassi": "Renavam atau nomor rangka",
 "Renegociado": "Direstrukturisasi",
 "Renomear": "Ganti nama",
 "Renomear com IA": "Ganti nama dengan AI",
 "Renomear ou trocar ícone": "Ganti nama atau ikon",
 "Renomear pasta": "Ganti nama folder",
 "Renomear, ícone ou cor": "Ganti nama, ikon, atau warna",
 "Renovar: {nome}": "Perpanjang: {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Menata ulang isi file. Kurang membantu untuk PDF berisi foto.",
 "Reparar PDF": "Perbaiki PDF",
 "Repelente": "Losion antinyamuk",
 "Repete": "Ulangi",
 "Repetir a cada quantos dias": "Ulangi setiap berapa hari",
 "Repetições": "Repetisi",
 "Repita a senha": "Ulangi kata sandi",
 "Repita a senha do cofre": "Ulangi kata sandi brankas",
 "Repita a senha nova": "Ulangi kata sandi baru",
 "Replantio": "Ganti pot",
 "Replantios": "Ganti pot",
 "Repor papel higiênico, sabonete e café": "Isi ulang tisu toilet, sabun, dan kopi",
 "Representatividade": "Keberagaman",
 "Reserva": "Reservasi",
 "Reservas": "Reservasi",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Reservasi, bersih-bersih, pemasukan, dan pengeluaran di tab Sewa & Penginapan",
 "Respirar fundo 5 vezes": "Tarik napas dalam 5 kali",
 "Respondendo a {nome}": "Membalas {nome}",
 "Responder": "Balas",
 "Responsável": "Penanggung jawab",
 "Responsável (imobiliária, vistoriador)": "Penanggung jawab (agen properti, inspektur)",
 "Resposta da SEFAZ": "Respons SEFAZ",
 "Resta {tempo}": "Sisa {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Sisa {ml} = {n} gelas {copo}",
 "Restaurante": "Restoran",
 "Restaurantes": "Restoran",
 "Restaurar": "Pulihkan",
 "Restaurar esta cópia?": "Pulihkan cadangan ini?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "Memulihkan akan mengganti SEMUA data saat ini dengan data dari cadangan, di sini dan di akun Anda.",
 "Restaurar uma cópia": "Pulihkan cadangan",
 "Resultado": "Hasil",
 "Resultado nas vendas: {v}": "Hasil penjualan: {v}",
 "Resumir": "Rangkum",
 "Resumir e perguntar": "Ringkas dan tanya",
 "Resumo": "Ringkasan",
 "Resumo (falta o XML completo)": "Ringkasan (XML lengkap belum ada)",
 "Resumo da manhã": "Ringkasan pagi",
 "Resumo da pasta": "Ringkasan folder",
 "Resumo e opinião": "Ringkasan dan pendapat",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Ringkasan, pengeluaran per kategori, pembayaran, tagihan, target, dan semua transaksi. Cocok dikirim ke akuntan atau disimpan untuk IR.",
 "Retirar": "Tarik",
 "Retirar da meta": "Tarik dari target",
 "Retorno": "Kontrol ulang",
 "Reunião": "Rapat",
 "Reunião agora": "Rapat sekarang",
 "Reunião de equipe": "Rapat tim",
 "Reuniões": "Rapat",
 "Revestimento e pisos": "Pelapis dan lantai",
 "Revisão": "Servis berkala",
 "Revolução Constitucionalista": "Revolusi Konstitusionalis",
 "Rico em matéria orgânica": "Kaya bahan organik",
 "Rodízio de pneus": "Rotasi ban",
 "Roedor": "Hewan pengerat",
 "Romance": "Romansa",
 "Rosca direta": "Biceps curl",
 "Rota": "Rute",
 "Rota passando pelos {n} lugares que faltam": "Rute melewati {n} tempat tersisa",
 "Rotas e mapas": "Rute & peta",
 "Roteiro": "Rencana perjalanan",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Rencana harian yang masuk ke lini masa selama perjalanan, koper sesuai cuaca, reservasi, dan zona waktu.",
 "Rotina": "Rutinitas",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Rutinitas langkah demi langkah: skincare, peregangan, rambut... Ketuk \"+ Perawatan\" untuk memilih templat atau membuat sendiri.",
 "Roupa": "Pakaian",
 "Roupa social": "Pakaian formal",
 "Roupas de banho": "Pakaian renang",
 "Roupas extras das crianças": "Baju cadangan anak",
 "Roupas íntimas": "Pakaian dalam",
 "Rua": "Jalan",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Jalan, nomor, kelurahan, kota (atau nama tempat)",
 "Régua": "Penggaris",
 "Réptil": "Reptil",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Label (mis.: Nama saya, Perusahaan klien)",
 "SAC": "Pokok tetap (SAC)",
 "SEM HORÁRIO": "TANPA JAM",
 "SEU MÊS EM NÚMEROS": "BULAN ANDA DALAM ANGKA",
 "SEU TREINO": "LATIHAN ANDA",
 "SEUS GRUPOS DO APP": "GRUP ANDA DI APLIKASI",
 "SP": "SP",
 "SUBTAREFA": "SUBTUGAS",
 "SUBTAREFAS": "SUBTUGAS",
 "SUPLEMENTAÇÃO": "SUPLEMEN",
 "Sabonete facial": "Sabun wajah",
 "Sabão para lavar roupa": "Sabun cuci",
 "Sacada": "Balkon",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Hanya keluar dari daftar aplikasi ini. Salinan di Drive, OneDrive, atau folder ponsel tetap ada.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Hanya keluar dari daftar. File tetap di tempat disimpan.",
 "Sair": "Keluar",
 "Sair da conta?": "Keluar dari akun?",
 "Sair do escritório": "Keluar dari kantor",
 "Sair do escritório?": "Keluar dari kantor?",
 "Sair do grupo": "Keluar dari grup",
 "Sair do grupo?": "Keluar dari grup?",
 "Sair sem baixar": "Keluar tanpa mengunduh",
 "Saiu": "Keluar",
 "Sala": "Ruang tamu",
 "Sala de estar": "Ruang tamu",
 "Sala de jantar": "Ruang makan",
 "Sala virtual": "Ruang virtual",
 "Salada": "Salad",
 "Saldo": "Saldo",
 "Saldo depois desta parcela": "Sisa setelah cicilan ini",
 "Saldo devedor: {v}": "Sisa utang: {v}",
 "Saldo do mês": "Saldo bulan ini",
 "Salvar": "Simpan",
 "Salvar backup do My Planner": "Simpan cadangan My Planner",
 "Salvar cuidado": "Simpan perawatan",
 "Salvar cômodo": "Simpan ruangan",
 "Salvar e colocar no My Planner": "Simpan dan masukkan ke My Planner",
 "Salvar e sincronizar": "Simpan dan sinkronkan",
 "Salvar e testar": "Simpan dan uji",
 "Salvar endereço": "Simpan alamat",
 "Salvar no My Planner": "Simpan ke My Planner",
 "Salvar refeição": "Simpan waktu makan",
 "Salvar suplemento": "Simpan suplemen",
 "Salvar tarefa": "Simpan tugas",
 "Salvar treino": "Simpan latihan",
 "Sanduíche natural": "Sandwich sehat",
 "Santo Antônio": "Santo Antônio",
 "Sapato confortável": "Sepatu nyaman",
 "Saudade": "Kangen",
 "Saída (imóvel antigo)": "Keluar (rumah lama)",
 "Saída de praia": "Baju luaran pantai",
 "Saúde": "Kesehatan",
 "Saúde & Prontuário": "Kesehatan & Rekam Medis",
 "Saúde (médicos, dentistas, exames, plano)": "Kesehatan (dokter, dokter gigi, pemeriksaan, asuransi)",
 "Saúde e bem-estar": "Kesehatan dan kebugaran",
 "Scanner": "Pemindai",
 "Scanner PDF": "Pemindai PDF",
 "Sci-Fi": "Fiksi ilmiah",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Jika ada yang tidak merespons, mulai ulang aplikasi. Datamu tersimpan.",
 "Se der tempo": "Kalau sempat",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Jika kebijakan ini berubah secara penting, aplikasi akan memberi tahu dan meminta persetujuan Anda lagi.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Jika peringatan ini muncul, peringatan janji berfungsi dengan baik.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Jika ada akun dengan {email}, kami telah mengirim tautan untuk membuat kata sandi baru. Periksa juga folder spam.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Jika peringatan terlambat atau tidak muncul: di pengaturan aplikasi, biarkan notifikasi aktif, baterai \"Tidak dibatasi\", dan izinkan \"Alarm & pengingat\".",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Jika jam tangan terhubung, angkanya menggantikan angka yang dimasukkan manual saat datanya tersedia.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Jika Anda menghubungkan jam tangan: total harian langkah, jarak, kalori, olahraga, detak jantung, dan tidur, dibaca dari Health Connect (Android) atau app Kesehatan (iPhone). App hanya membaca dan tidak pernah mengubah data ini.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Jika Anda sudah pernah memakai tab ini, tidak ada yang dihapus: semuanya kembali seperti semula saat berlangganan.",
 "Secretária ou recepção": "Sekretaris atau resepsionis",
 "Seg a sex": "Sen–Jum",
 "Seguir": "Lanjut",
 "Segunda": "Senin",
 "Segurança": "Keamanan",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Tahan dan seret untuk mengubah urutan. ↻ memutar, ⧉ menggandakan, dan ✕ menghapus halaman.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Tekan lama GIF di obrolan lalu ketuk \"Simpan\" agar muncul di sini.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Tahan ruangan untuk memindahkan posisinya. Saat ruangan terbuka, tahan tugas lalu lepaskan di ruangan lain untuk memindahkannya.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Tahan map, mata pelajaran, atau halaman untuk mengubah urutan. Lepaskan mata pelajaran di map lain untuk memindahkannya ke sana.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Tahan sebuah chat untuk membisukan atau mengarsipkannya. Chat yang diarsipkan tetap menerima dan mengirim, tetapi tanpa notifikasi.",
 "Seguro": "Asuransi",
 "Seguro da casa": "Asuransi rumah",
 "Seguro viagem": "Asuransi perjalanan",
 "Selecionar": "Pilih",
 "Sem": "Tanpa",
 "Sem alerta": "Tanpa peringatan",
 "Sem categoria": "Tanpa kategori",
 "Sem comprovante": "Tanpa bukti bayar",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Tidak ada koneksi ke server faktur. Periksa internet dan alamat server.",
 "Sem conexão com o servidor. Confira a internet.": "Tidak ada koneksi ke server. Periksa internet Anda.",
 "Sem conexão com os GIFs agora.": "Tidak ada koneksi ke GIF saat ini.",
 "Sem cômodo": "Tanpa ruangan",
 "Sem data de fim": "Tanpa tanggal akhir",
 "Sem exercícios": "Tidak ada latihan",
 "Sem fatura em {mes}": "Tidak ada tagihan di {mes}",
 "Sem fim": "Tanpa akhir",
 "Sem horário": "Tanpa jam",
 "Sem internet ou servidor ainda não preparado.": "Tidak ada internet atau server belum siap.",
 "Sem internet. Envia quando voltar.": "Tidak ada internet. Akan dikirim saat tersambung kembali.",
 "Sem internet. Tente de novo.": "Tidak ada internet. Coba lagi.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Tanpa ini, blok hitam hanya menutupi: teks di bawahnya tetap ada di file dan bisa disalin.",
 "Sem itens": "Tanpa item",
 "Sem juros": "Tanpa bunga",
 "Sem limite": "Tanpa batas",
 "Sem link de calendário": "Tanpa tautan kalender",
 "Sem margem": "Tanpa margin",
 "Sem nome": "Tanpa nama",
 "Sem número na primeira página (capa)": "Tanpa nomor di halaman pertama (sampul)",
 "Sem pasta": "Tanpa folder",
 "Sem pausas": "Tanpa jeda",
 "Sem permissão": "Tanpa izin",
 "Sem prazo": "Tanpa tenggat",
 "Sem recibo": "Tanpa kuitansi",
 "Sem tarefas": "Tanpa tugas",
 "Sem texto.": "Tanpa teks.",
 "Sem tomador identificado": "Penerima jasa tidak teridentifikasi",
 "Sem título": "Tanpa judul",
 "Sem validade": "Tanpa masa berlaku",
 "Semana": "Minggu",
 "Semana completa": "Seminggu penuh",
 "Semana de {de} a {ate}": "Minggu {de} sampai {ate}",
 "Semanal": "Mingguan",
 "Semanal · dias úteis": "Mingguan · hari kerja",
 "Semanal · todos os dias": "Mingguan · setiap hari",
 "Semanal · {dias}": "Mingguan · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Selalu ditampilkan, bersama cuti bersama (Karnaval, Rabu Abu, dan Corpus Christi).",
 "Senha": "Kata sandi",
 "Senha (8 caracteres ou mais)": "Kata sandi (8 karakter atau lebih)",
 "Senha alterada.": "Kata sandi diubah.",
 "Senha atual": "Kata sandi saat ini",
 "Senha atual do cofre": "Kata sandi brankas saat ini",
 "Senha da conta": "Kata sandi akun",
 "Senha do certificado": "Kata sandi sertifikat",
 "Senha do cofre": "Kata sandi brankas",
 "Senha do cofre alterada.": "Kata sandi brankas diubah.",
 "Senha do cofre incorreta.": "Kata sandi brankas salah.",
 "Senha incorreta": "Kata sandi salah",
 "Senha incorreta.": "Kata sandi salah.",
 "Senha nova (8 caracteres ou mais)": "Kata sandi baru (minimal 8 karakter)",
 "Senha nova do cofre (6 caracteres ou mais)": "Kata sandi brankas baru (minimal 6 karakter)",
 "Senha, biometria, bloqueio e privacidade": "Kata sandi, biometrik, kunci, dan privasi",
 "Senha, e-mail e formas de desbloquear": "Kata sandi, email, dan cara membuka kunci",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Kumpulkan bukti potong penghasilan (bank, pemberi kerja, sekuritas)",
 "Servidor de notas": "Server faktur",
 "Servidor não configurado (lib/config.ts).": "Server belum dikonfigurasi (lib/config.ts).",
 "Servidor não configurado.": "Server belum dikonfigurasi.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Server belum dikonfigurasi: data Supabase di lib/config.ts belum ada.",
 "Serviço": "Layanan",
 "Serviço não prestado": "Layanan tidak diberikan",
 "Serviços": "Layanan",
 "Será excluída em 1 dia": "Akan dihapus dalam 1 hari",
 "Será excluída em {n} dias": "Akan dihapus dalam {n} hari",
 "Será excluída hoje": "Akan dihapus hari ini",
 "Sessão": "Sesi",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Akses Anda masih perlu disetujui. Coba masuk lagi sebentar lagi.",
 "Seu código": "Kode Anda",
 "Seu código de amigo": "Kode teman Anda",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Kode Anda agar teman mendapat 10 hari dengan semua tab",
 "Seu nome": "Nama Anda",
 "Seu papel: {p}": "Peran Anda: {p}",
 "Seu papel: {p}. {d}": "Peran Anda: {p}. {d}",
 "Seu scanner de bolso": "Pemindai saku Anda",
 "Seus dados continuam salvos na nuvem.": "Data Anda tetap tersimpan di cloud.",
 "Seus dados na nuvem do My Planner": "Data Anda di cloud My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Data Anda milik Anda: kami tidak menjualnya dan tidak menggunakannya untuk iklan. Anda bisa mengekspor atau menghapus semuanya kapan saja.",
 "Seus {n} meses grátis terminaram": "{n} bulan gratis Anda telah berakhir",
 "Sexta": "Jumat",
 "Sextou": "Jumat",
 "Sextou!": "Akhirnya Jumat!",
 "Shampoo": "Sampo",
 "Show ou passeio": "Pertunjukan atau tur",
 "Silenciar avisos": "Bisukan notifikasi",
 "Sim": "Ya",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Disinkronkan pada {data}",
 "Sincronizando pelo dispositivo {nome}": "Menyinkronkan melalui perangkat {nome}",
 "Sincronizando...": "Menyinkronkan...",
 "Sincronizar agora": "Sinkronkan sekarang",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Sinkronisasi berhenti: konfirmasi kata sandi Anda. Tidak ada yang hilang.",
 "Site da assistência": "Situs servis",
 "Site da assistência (https://...)": "Situs servis (https://...)",
 "Site ou ingresso online": "Situs atau tiket online",
 "Situação": "Status",
 "Situação agora": "Status saat ini",
 "Skincare da manhã": "Skincare pagi",
 "Skincare da noite": "Skincare malam",
 "Slides": "Slide",
 "Smileys e pessoas": "Smiley dan orang",
 "Sobremesa": "Hidangan penutup",
 "Sobrou no mês": "Sisa bulan ini",
 "Sociologia": "Sosiologi",
 "Sofá": "Sofa",
 "Sol": "Matahari",
 "Sol pleno": "Matahari penuh",
 "Solo ou substrato": "Tanah atau media tanam",
 "Solte numa matéria para mover a página para lá:": "Lepaskan di mata pelajaran untuk memindahkan halaman ke sana:",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Menjumlahkan garansi hukum dan garansi pabrik. Periksa di kartu garansi. Pengingat 15 dan 3 hari sebelumnya.",
 "Sombra": "Teduh",
 "Somente esta tarefa": "Hanya tugas ini",
 "Sono": "Tidur",
 "Sono da noite": "Tidur semalam",
 "Sopa": "Sup",
 "Sou MEI": "Saya MEI",
 "Status": "Status",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Koneksi Anda ke cloud telah kedaluwarsa (terjadi jika aplikasi lama tidak dibuka atau kata sandi diubah di perangkat lain). Tidak ada yang hilang: data di sini dikirim begitu Anda mengonfirmasi.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Tim Anda dalam satu tempat: obrolan, dokumen, rapat video dengan rekaman, dan undangan lewat tautan.",
 "Sua rotina em um só lugar": "Rutinitas Anda di satu tempat",
 "Sua senha": "Kata sandi Anda",
 "Suas abas": "Tab Anda",
 "Substituir": "Ganti",
 "Substrato usado": "Media tanam yang dipakai",
 "Subtarefa {n}": "Subtugas {n}",
 "Suco": "Jus",
 "Sugerir nome": "Sarankan nama",
 "Sugestão": "Saran",
 "Sugestões de {categoria}": "Saran untuk {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase: menyimpan akun dan data yang disinkronkan, sebagai pemroses. Server bisa berada di luar Brasil, dengan jaminan dari art. 33 LGPD.",
 "Superiores": "Tinggi",
 "Supino reto": "Bench press",
 "Suplemento": "Suplemen",
 "Suspense": "Thriller",
 "Suíte": "Kamar dengan kamar mandi",
 "Sábado": "Sabtu",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Lebih dari 60 file. Gunakan \"Setiap N halaman\".",
 "Série": "Serial",
 "Série da DPS": "Seri DPS",
 "Série e turma": "Tingkat dan kelas",
 "Séries": "Set",
 "Sérum": "Serum",
 "Símbolos": "Simbol",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Hanya tim kantor yang bisa melihat. Maks. 50 MB per file.",
 "Só acompanha": "Hanya memantau",
 "Só acompanha, sem valores": "Hanya memantau, tanpa nominal",
 "Só administradores": "Hanya admin",
 "Só em {data}": "Hanya {data}",
 "Só leitura": "Hanya baca",
 "Só mandar para a aba Estudos (sem escolher página)": "Kirim saja ke tab Studi (tanpa memilih halaman)",
 "Só neste dispositivo": "Hanya di perangkat ini",
 "Só neste dispositivo: {n}": "Hanya di perangkat ini: {n}",
 "Só o código": "Kode saja",
 "Só o dia {data}": "Hanya tanggal {data}",
 "Só os dados (texto)": "Hanya data (teks)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Hanya total Keuangan yang dikirim ke AI Anda. Ini bukan rekomendasi investasi.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Hanya untuk Anda: kajian, strategi mengajar, dan apa yang berhasil atau tidak di setiap kelas. Siswa tidak dapat melihatnya.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Hanya satu ponsel yang bisa sinkron dengan kalender. Untuk pindah ke ponsel ini, ketuk di bawah.",
 "Só uma vez": "Sekali saja",
 "Só uma vez (abrir a ficha da tarefa)": "Sekali saja (buka kartu tugas)",
 "Só áudio": "Hanya audio",
 "Sótão": "Loteng",
 "TAREFAS DA CASA": "TUGAS RUMAH",
 "TELEFONE (OPCIONAL)": "TELEPON (OPSIONAL)",
 "TRAZER PARA O MY PLANNER": "IMPOR KE MY PLANNER",
 "TV por assinatura": "TV berlangganan",
 "Tabela": "Tabel",
 "Talvez": "Mungkin",
 "Tamanho": "Ukuran",
 "Tamanho da foto": "Ukuran foto",
 "Tamanho da página": "Ukuran halaman",
 "Tamanho das páginas": "Ukuran halaman-halaman",
 "Tamanho do arquivo": "Ukuran file",
 "Tamanho do copo": "Ukuran gelas",
 "Também procurar nos Diários Oficiais dos municípios": "Cari juga di Lembaran Resmi kota",
 "Também serão excluídos {n} item(ns) dentro dele.": "{n} item di dalamnya juga akan dihapus.",
 "Tapioca": "Krep tapioka",
 "Tarefa": "Tugas",
 "Tarefa da casa": "Tugas rumah",
 "Tarefa de casa": "Pekerjaan rumah",
 "Tarefa duplicada": "Tugas diduplikat",
 "Tarefa ou entrega": "Tugas atau pengumpulan",
 "Tarefa para {nome}": "Tugas untuk {nome}",
 "Tarefas da casa": "Tugas rumah",
 "Tarefas e itens de todas as abas": "Tugas dan item dari semua tab",
 "Tarefas novas do My Planner vão para: {agenda}": "Tugas baru My Planner masuk ke: {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Tugas berulang yang melewati periode tetap ada di hari lain; hanya hari yang dipilih yang dihapus.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Blok hitam di atas CPF, nominal, dan nama. Benar-benar menghapus.",
 "Tartaruga": "Kura-kura",
 "Taxa de limpeza": "Biaya kebersihan",
 "Taxa de limpeza cobrada do hóspede": "Biaya kebersihan yang ditagihkan ke tamu",
 "Taxas e anúncios": "Biaya dan iklan",
 "Te amo": "Sayang kamu",
 "Tecnologia": "Teknologi",
 "Tela cheia": "Layar penuh",
 "Teleconsulta": "Telekonsultasi",
 "Telefone": "Telepon",
 "Telefone da assistência": "Telepon servis",
 "Telefone da empresa": "Telepon perusahaan",
 "Telefone da escola": "Telepon sekolah",
 "Telefone da limpeza": "Telepon petugas kebersihan",
 "Telefone de emergência": "Telepon darurat",
 "Telefone do veterinário": "Telepon dokter hewan",
 "Telhado": "Atap",
 "Tem anexos": "Ada lampiran",
 "Tem certeza?": "Anda yakin?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Ada {n} pembayaran terlambat dengan total {v}. Bayar dulu yang bunganya paling tinggi, seperti kartu kredit dan cerukan.",
 "Tema": "Topik",
 "Tempo de preparo": "Waktu memasak",
 "Temporada": "Musim",
 "Temporizador (direita)": "Pengatur waktu (kanan)",
 "Tenta consertar um PDF que não abre direito.": "Mencoba memperbaiki PDF yang tidak terbuka dengan benar.",
 "Tentar de novo": "Coba lagi",
 "Tente uma foto mais nítida, com a página inteira.": "Coba foto yang lebih jelas, dengan seluruh halaman.",
 "Termina às {hora}": "Berakhir pukul {hora}",
 "Terminar até": "Selesaikan paling lambat",
 "Terminei em": "Selesai tanggal",
 "Terminou": "Sudah selesai",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Berakhir pada {data}. Tidak ada yang dihapus: semuanya kembali seperti semula saat Anda berlangganan.",
 "Termos de uso": "Ketentuan penggunaan",
 "Termos de uso e privacidade": "Ketentuan penggunaan dan privasi",
 "Terror": "Horor",
 "Terça": "Selasa",
 "Testando...": "Menguji...",
 "Testar alerta (1 minuto)": "Uji peringatan (1 menit)",
 "Testar aviso": "Uji notifikasi",
 "Teste de alerta do Planner": "Uji peringatan Planner",
 "Teste grátis até {data} ({n} dia(s))": "Uji coba gratis sampai {data} ({n} hari)",
 "Teste grátis: {n} dia(s)": "Uji coba gratis: {n} hari",
 "Teste terminado": "Uji coba berakhir",
 "Teste terminou em {data}": "Uji coba berakhir pada {data}",
 "Teste: aviso feito pelo próprio celular.": "Uji: notifikasi dibuat oleh ponsel ini sendiri.",
 "Texto": "Teks",
 "Texto completo": "Teks lengkap",
 "Texto copiado. Cole onde quiser enviar.": "Teks disalin. Tempel di tempat Anda ingin mengirimnya.",
 "Texto do documento": "Teks dokumen",
 "Texto extra do convite (traje, presentes...)": "Teks tambahan undangan (dress code, hadiah...)",
 "Texto livre": "Teks bebas",
 "Texto ou recado": "Teks atau pengumuman",
 "Texto para PDF": "Teks ke PDF",
 "Texto {data}": "Teks {data}",
 "Tipo": "Jenis",
 "Tipo sanguíneo": "Golongan darah",
 "Tira as páginas que você não quer.": "Menghapus halaman yang tidak Anda inginkan.",
 "Tira autor, programas, comandos escondidos e anexos.": "Menghapus penulis, program, perintah tersembunyi, dan lampiran.",
 "Tira comentários, destaques e desenhos de outros programas.": "Menghapus komentar, sorotan, dan gambar dari program lain.",
 "Tira o texto do PDF (arquivo .txt).": "Mengambil teks dari PDF (file .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Hapus",
 "Tirar a assinatura": "Hapus tanda tangan",
 "Tirar a foto": "Hapus foto",
 "Tirar a foto agora": "Ambil foto sekarang",
 "Tirar admin": "Cabut admin",
 "Tirar alarmes do My Planner": "Hapus alarm dari My Planner",
 "Tirar arquivos anexados": "Hapus file lampiran",
 "Tirar comentários, destaques e links": "Hapus komentar, sorotan, dan tautan",
 "Tirar da agenda": "Hapus dari jadwal",
 "Tirar da barra": "Lepas dari bilah",
 "Tirar daqui": "Hapus dari sini",
 "Tirar das minhas figurinhas?": "Hapus dari stiker saya?",
 "Tirar de administrador": "Hapus dari admin",
 "Tirar do escritório": "Keluarkan dari kantor",
 "Tirar dos meus GIFs?": "Hapus dari GIF saya?",
 "Tirar este copo": "Hapus gelas ini",
 "Tirar foto": "Ambil foto",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Memotret tagihan, struk, dan dokumen, serta memilih foto dan video dari galeri.",
 "Tirar o desenho padrão?": "Hapus pola kunci?",
 "Tirar o lixo": "Buang sampah",
 "Tire a foto e a sua IA preenche a ficha": "Ambil foto dan AI Anda mengisi datanya",
 "Titular (de quem é o documento)": "Pemilik (milik siapa dokumen ini)",
 "Titular: {nome}": "Pemilik: {nome}",
 "Toalha de praia": "Handuk pantai",
 "Tocar os pés": "Sentuh ujung kaki",
 "Toda a agenda": "Seluruh agenda",
 "Toda semana": "Setiap minggu",
 "Todas": "Semua",
 "Todas (passadas, esta e futuras)": "Semua (sebelumnya, ini, dan yang akan datang)",
 "Todas ({n})": "Semua ({n})",
 "Todas as abas liberadas até {data}.": "Semua tab terbuka sampai {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Semua ibu kota. Tandai satu kota atau lebih.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Semua alat PDF: gabung, pisah, atur, tanda tangan, stempel, sensor, nomor halaman, formulir, kompres, konversi, OCR, dan AI. Simpan ke ponsel, Google Drive, atau OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Semua alat ada di layar tab.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Semua foto perjalanan ada di sini: yang Anda tambahkan ke album dan yang dari rencana perjalanan, tempat, dan reservasi.",
 "Todas as plantas estão regadas.": "Semua tanaman sudah disiram.",
 "Todas as páginas, uma embaixo da outra.": "Semua halaman, berurutan ke bawah.",
 "Todo ano": "Setiap tahun",
 "Todo dia": "Setiap hari",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Setiap hari pada jam yang dipilih: jumlah tugas hari itu, tugas pertama, dan total energi.",
 "Todo mês": "Setiap bulan",
 "Todo mês · dia {d}": "Setiap bulan · tanggal {d}",
 "Todo o histórico": "Seluruh riwayat",
 "Todos": "Semua",
 "Todos ({n})": "Semua ({n})",
 "Todos do grupo": "Semua anggota grup",
 "Todos do grupo veem": "Semua anggota grup dapat melihat",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Semua peserta rapat melihat pemberitahuan \"Merekam\". File masuk ke Dokumen kantor, hanya terlihat oleh Anda sampai Anda membagikannya ke tim.",
 "Todos os cuidados": "Semua perawatan",
 "Todos os dias": "Setiap hari",
 "Todos os suplementos": "Semua suplemen",
 "Todos os treinos": "Semua latihan",
 "Todos os tribunais": "Semua pengadilan",
 "Todos presentes": "Semua hadir",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Semua orang keluar dari grup. Yang sudah diterima setiap orang tetap ada di agendanya.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Semua bekerja dengan data yang sama, masing-masing sesuai perannya. Ketuk peran tiap orang di Anggota untuk mengubahnya.",
 "Tomador": "Penerima jasa",
 "Tomador (quem contratou)": "Penerima jasa (yang memesan)",
 "Tomadores": "Penerima jasa",
 "Tomei": "Saya meminjam",
 "Toque aqui ou no + para criar uma tarefa": "Ketuk di sini atau + untuk membuat tugas",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Ketuk \"Hapus akun saya dan semua data\" lalu konfirmasi.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Ketuk + › Kartu kredit baru lalu masukkan tanggal tutup dan jatuh tempo.",
 "Toque em Ajustes e depois em Segurança.": "Ketuk Pengaturan, lalu Keamanan.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Ketuk Hubungkan lalu, di layar Apple, aktifkan item yang boleh dibaca My Planner.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Ketuk Hubungkan lalu, di layar Health Connect, izinkan My Planner membaca data.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Ketuk orang yang TIDAK boleh melihat catatan ini (beserta isinya). Mis.: hadiah kejutan.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Ketuk tab untuk membuka. Tab yang terkunci menunjukkan cara berlangganan.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Ketuk tab untuk membuka. Setiap tab tambahan bisa dicoba gratis selama 10 hari.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Ketuk tab untuk membuka. Ketuk 📌 untuk memasang atau melepas tab dari bilah bawah. Setiap tab tambahan bisa dicoba gratis selama 10 hari.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Ketuk area untuk membuka. Yang terkunci menunjukkan cara berlangganan.",
 "Toque no desenho para continuar desenhando.": "Ketuk sketsa untuk melanjutkan menggambar.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Ketuk apa yang akan dibagikan grup ini. Semua isinya (rencana perjalanan, foto, reservasi...) ikut dan semua orang ikut serta.",
 "Toque nos PDFs na ordem em que devem ficar.": "Ketuk PDF sesuai urutan yang diinginkan.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Ketuk gelas untuk mengubah volume; tahan + untuk gelas ukuran lain.",
 "Toque num feriado para adicioná-lo ao Planner.": "Ketuk hari libur untuk menambahkannya ke Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Ketuk transaksi untuk mengganti kategori, menyimpan kuitansi IR, atau menghapus.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Ketuk transaksi untuk mengganti kategori. Tekan lama untuk menghapus.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Ketuk profil untuk mengedit. Tekan lama untuk menghapusnya.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Ketuk teks, gambar, atau checklist lalu seret ke mana saja di lembar.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Ketuk halaman untuk memotong, memutar, atau mengganti filter. Tahan dan seret untuk mengubah urutan.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Ketuk tugas untuk menyalin atau memindahkannya ke hari ini.",
 "Toque onde quer a checklist.": "Ketuk tempat Anda ingin daftar centang.",
 "Toque onde quer escrever.": "Ketuk tempat Anda ingin menulis.",
 "Toque para abrir": "Ketuk untuk membuka",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Ketuk untuk membuka di aplikasi ponsel. Geser ke kanan untuk menghapus dari daftar.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Ketuk untuk membuka, tekan lama untuk ganti nama. Geser ke kiri untuk mengarsipkan atau ke kanan untuk menghapus.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Ketuk untuk membuka. Geser ke kanan untuk menghapus dari daftar.",
 "Toque para aceitar ou recusar.": "Ketuk untuk menerima atau menolak.",
 "Toque para aceitar, editar ou recusar.": "Ketuk untuk menerima, mengedit, atau menolak.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Ketuk untuk menerapkan sekarang. Atau otomatis berlaku saat aplikasi dibuka ulang.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Ketuk untuk mengunduh dan memasang di atas versi lama. Data Anda tetap ada.",
 "Toque para conversar": "Ketuk untuk mengobrol",
 "Toque para enviar o emoji animado": "Ketuk untuk mengirim emoji animasi",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Ketuk untuk mengirim. Tekan lama untuk menyimpan atau menghapus dari milik Anda.",
 "Toque para escolher": "Ketuk untuk memilih",
 "Toque para fechar": "Ketuk untuk menutup",
 "Toque para gerar um novo QR Code": "Ketuk untuk membuat Kode QR baru",
 "Tornar admin": "Jadikan admin",
 "Tornar administrador": "Jadikan admin",
 "Tosa": "Grooming",
 "Totais por alimento": "Total per makanan",
 "Total": "Total",
 "Total bruto": "Total kotor",
 "Total das reservas: {v}": "Total reservasi: {v}",
 "Total de aulas": "Total pelajaran",
 "Total de capítulos": "Total bab",
 "Total de módulos": "Total modul",
 "Total de páginas": "Total halaman",
 "Total de recibos: {v}": "Total kuitansi: {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Total: {n}. Setiap tab bisa berisi hingga {lim} teks (foto dan file tidak dihitung: tersimpan di perangkat atau di Drive Anda).",
 "Total: {v}": "Total: {v}",
 "Trabalhando...": "Memproses...",
 "Trabalho": "Ketenagakerjaan",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Bawa acara dari Google Kalender Anda ke My Planner dan edit di sini: perubahan akan kembali ke kalender.",
 "Trans": "Trans",
 "Transferir: {s}": "Pindahkan: {s}",
 "Transferência": "Pemindahan",
 "Transferências": "Pemindahan",
 "Transporte": "Transportasi",
 "Tratamento": "Pengobatan",
 "Travar depois de preencher": "Kunci setelah diisi",
 "Trazer todas para hoje": "Bawa semua ke hari ini",
 "Trazer tudo para hoje?": "Bawa semuanya ke hari ini?",
 "Trecho ou ideia": "Kutipan atau ide",
 "Treino": "Latihan",
 "Trem ou ônibus": "Kereta atau bus",
 "Treme": "Bergetar",
 "Tribunais": "Pengadilan",
 "Trilha": "Hiking",
 "Triste": "Sedih",
 "Triângulo": "Segitiga",
 "Troca de óleo": "Ganti oli",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Ganti oli, rotasi ban, servis per km, IPVA, registrasi, dan asuransi.",
 "Trocador portátil": "Alas ganti popok portabel",
 "Trocar": "Ganti",
 "Trocar a categoria": "Ganti kategori",
 "Trocar a foto": "Ganti foto",
 "Trocar a pasta": "Ganti folder",
 "Trocar a senha do cofre": "Ganti kata sandi brankas",
 "Trocar número": "Ganti nomor",
 "Trocar o certificado": "Ganti sertifikat",
 "Trocar o código": "Ganti kode",
 "Trocar o código?": "Ganti kode?",
 "Trocar o desenho": "Ganti pola",
 "Trocar o emoji": "Ganti emoji",
 "Trocar o modelo": "Ganti model",
 "Trocar o número": "Ganti nomornya",
 "Trocar o número do celular": "Ganti nomor ponsel",
 "Trocar por:": "Ganti dengan:",
 "Trocar roupa de cama e toalhas": "Ganti sprei dan handuk",
 "Tríceps na polia": "Triceps pushdown",
 "Tubo de ensaio": "Tabung reaksi",
 "Tudo": "Semua",
 "Tudo certo": "Semua beres",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Semua beres di sini. Catat pengeluaran harian agar saya bisa melihat ke mana uang pergi.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Semuanya sudah tersimpan di akun Anda. File ini adalah salinan tambahan yang bisa Anda simpan di mana saja.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Semua yang ada di dalam \"{nome}\" akan terlihat oleh grup, masing-masing sesuai peran yang Anda pilih (yang baru bergabung mulai dengan peran paling terbatas).",
 "Tudo! Já comprei os ingressos.": "Beres! Tiketnya sudah saya beli.",
 "Turma": "Kelas",
 "Turma (opcional)": "Kelas (opsional)",
 "Turmas": "Kelas",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Kelas dan grup (pelajaran, mentoring, latihan): siswa, absensi, nilai, rencana, materi, tagihan, dan buku catatan Anda.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Kelas, siswa, absensi, nilai, dan rencana pelajaran.",
 "Turmas, pacientes, equipes e convidados": "Kelas, pasien, tim, dan tamu",
 "Técnico": "Teknis",
 "Título": "Judul",
 "Título (ex.: Capítulo 3)": "Judul (mis.: Bab 3)",
 "Título (opcional)": "Judul (opsional)",
 "Título da caixa": "Judul kotak",
 "Título de eleitor": "Kartu pemilih",
 "Título, autor, assunto e palavras-chave.": "Judul, penulis, subjek, dan kata kunci.",
 "Tô chegando": "OTW",
 "Tônico": "Toner",
 "UF": "UF",
 "Uau": "Wow",
 "Uhuul!": "Horee!",
 "Um PDF novo só com as páginas escolhidas.": "PDF baru hanya dengan halaman yang dipilih.",
 "Um texto clarinho na diagonal de todas as páginas.": "Teks samar diagonal di semua halaman.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Satu folder untuk setiap klien: Anda bertukar dokumen dua arah dan setiap klien hanya melihat foldernya sendiri.",
 "Uma página por arquivo": "Satu halaman per file",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Satu halaman per file, setiap N halaman, atau per rentang.",
 "Unicórnio": "Unicorn",
 "Unidade": "Satuan",
 "Universal": "Serbaguna",
 "União": "Persatuan",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Menggunakan akun Google yang sudah ada di ponsel. My Planner tidak pernah meminta kata sandi Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Terpakai: {u} · sisa: {v} · limit {l}",
 "Usar": "Pakai",
 "Usar \"{nome}\"": "Gunakan \"{nome}\"",
 "Usar biometria": "Gunakan biometrik",
 "Usar desenho padrão": "Gunakan pola kunci",
 "Usar este celular": "Gunakan ponsel ini",
 "Usar este nome": "Pakai nama ini",
 "Usar modelo: {m}": "Gunakan templat: {m}",
 "Usar no navegador (My Planner Web)": "Pakai di browser (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Gunakan file yang sudah dilampirkan ({nome})",
 "Usar o código": "Gunakan kode",
 "Usar senha": "Gunakan kata sandi",
 "Usar {ia}": "Gunakan {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Gunakan kata sandi baru saat masuk berikutnya, di sini dan di My Planner Web.",
 "Use a senha para desbloquear.": "Gunakan kata sandi untuk membuka kunci.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Gunakan AI Anda sendiri untuk membaca publikasi, dokumen, dan catatan serta menyarankan jadwal. Anda selalu mengonfirmasi sebelum apa pun masuk ke Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Gunakan kode ini saat membuat akun dan dapatkan 10 hari dengan semua tab terbuka.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Gunakan mutasi rekening dalam format OFX (paling disarankan) atau CSV, yang diunduh dari aplikasi atau situs bank Anda.",
 "Use o seu planner no computador, sincronizado com o celular.": "Gunakan planner Anda di komputer, tersinkron dengan ponsel.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Gunakan tautan https dari Google Drive, Google Docs, OneDrive, atau SharePoint.",
 "Uso": "Penggunaan",
 "Uso próprio": "Pemakaian pribadi",
 "VRBO": "VRBO",
 "Vacina": "Vaksin",
 "Vacina {nome}: {pet}": "Vaksin {nome}: {pet}",
 "Vacina: {nome}": "Vaksin: {nome}",
 "Vacinas": "Vaksin",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Vaksin dan obat hewan peliharaan, pet shop, serta rutinitas sekolah dan kesehatan anak.",
 "Vai na viagem": "Ikut perjalanan",
 "Vale até {d}": "Berlaku hingga {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "Berlaku untuk Studi dan Dokumen. Di cloud, file bisa dibuka di perangkat mana pun dan di My Planner Web (maks. 15 MB per file).",
 "Vale quantos pontos": "Nilai maksimum",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Hanya berlaku untuk Anda. Maksimal satu pemberitahuan setiap 3 menit per orang, meskipun ia menambahkan beberapa hal.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Berlaku sekali, dalam 30 hari pertama akun Anda.",
 "Validade": "Masa berlaku",
 "Validade do certificado A1": "Masa berlaku sertifikat A1",
 "Validade: {data}": "Berlaku s.d.: {data}",
 "Valor": "Nilai",
 "Valor ({m})": "Nominal ({m})",
 "Valor a pagar": "Jumlah yang harus dibayar",
 "Valor combinado": "Nilai yang disepakati",
 "Valor combinado por atendimento": "Nilai yang disepakati per kunjungan",
 "Valor da hora": "Tarif per jam",
 "Valor da parcela (1ª)": "Nilai cicilan (ke-1)",
 "Valor da venda": "Harga jual",
 "Valor de costume": "Nilai biasa",
 "Valor do atendimento: {v}{pago}.": "Nilai kunjungan: {v}{pago}.",
 "Valor emprestado ou financiado": "Nilai pinjaman atau pembiayaan",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Harga akhir ditetapkan oleh Google Play atau App Store, sudah dalam mata uang negara Anda.",
 "Valor maior que o guardado nesta meta.": "Jumlah lebih besar dari yang ditabung di target ini.",
 "Valor padrão da consulta ou sessão": "Tarif standar konsultasi atau sesi",
 "Valor pago": "Jumlah dibayar",
 "Valor pago (com multa ou desconto)": "Jumlah dibayar (dengan denda atau diskon)",
 "Valor pago (opcional)": "Jumlah dibayar (opsional)",
 "Valor pago: {v}": "Jumlah dibayar: {v}",
 "Valor que este aluno paga (se for diferente)": "Nilai yang dibayar siswa ini (jika berbeda)",
 "Valor recebido": "Jumlah diterima",
 "Valor recebido: {v}": "Jumlah diterima: {v}",
 "Valor total da compra": "Total nilai pembelian",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Nominal dan data klinis hanya muncul untuk yang perannya mengizinkan. Anda bisa menonaktifkannya kapan saja: data tetap ada pada Anda.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Angka untuk dicek bersama akuntan Anda. Aturan pengurangan berubah setiap tahun.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "Yuk ngobrol lewat My Planner? Tambahkan saya sebagai teman dengan kode {codigo} (tab Pesan > Teman).",
 "Vaso": "Pot",
 "Veja os planos em Ajustes › Compras.": "Lihat paket di Pengaturan › Pembelian.",
 "Vem da aba Empréstimos & Financiamentos": "Dari tab Pinjaman & Pembiayaan",
 "Vence em {data}.": "Kedaluwarsa pada {data}.",
 "Vence em {fim} (data informada na publicação).": "Jatuh tempo pada {fim} (tanggal yang tercantum di publikasi).",
 "Vence em {n} dia(s)": "Berakhir dalam {n} hari",
 "Vence hoje": "Berakhir hari ini",
 "Vence {data}": "Jatuh tempo {data}",
 "Vencendo": "Segera habis",
 "Venceu há {n} dia(s)": "Berakhir {n} hari lalu",
 "Vencidas": "Berakhir",
 "Vencidos": "Kedaluwarsa",
 "Vencimento": "Jatuh tempo",
 "Vencimento (guias e boletos)": "Jatuh tempo (slip dan boleto)",
 "Vencimento da 1ª parcela": "Jatuh tempo cicilan ke-1",
 "Vencimentos": "Jatuh tempo",
 "Venda": "Penjualan",
 "Venda/serviço do MEI": "Penjualan/jasa MEI",
 "Vendidos": "Terjual",
 "Ver": "Lihat",
 "Ver a lista de membros": "Lihat daftar anggota",
 "Ver a rota": "Lihat rute",
 "Ver arquivos": "Lihat file",
 "Ver detalhes do erro": "Lihat detail galat",
 "Ver e editar": "Lihat dan edit",
 "Ver em Compras": "Lihat di Pembelian",
 "Ver mais": "Lihat lainnya",
 "Ver mais páginas": "Lihat halaman lainnya",
 "Ver no My Planner": "Lihat di My Planner",
 "Ver o dia": "Lihat hari",
 "Ver os feriados do ano": "Lihat hari libur tahun ini",
 "Ver participantes": "Lihat peserta",
 "Ver páginas": "Lihat halaman",
 "Ver todos": "Lihat semua",
 "Ver todos ({n})": "Lihat semua ({n})",
 "Ver {nome}": "Lihat {nome}",
 "Verificar agora": "Periksa sekarang",
 "Vermífugo": "Obat cacing",
 "Vermífugo ou remédio": "Obat cacing atau obat",
 "Vermífugos e remédios": "Obat cacing dan obat",
 "Verso": "Belakang",
 "Verso do documento": "Bagian belakang dokumen",
 "Versão do PDF": "Versi PDF",
 "Versão instalada": "Versi terpasang",
 "Versão {versao} disponível": "Versi {versao} tersedia",
 "Versão {v}": "Versi {v}",
 "Veterinário": "Dokter hewan",
 "Veterinário ou clínica": "Dokter hewan atau klinik",
 "Veículo": "Kendaraan",
 "Veículo e acessórios": "Kendaraan dan aksesori",
 "Veículos": "Kendaraan",
 "Veículos & Manutenção": "Kendaraan & Perawatan",
 "Vi mais um episódio": "Sudah menonton satu episode lagi",
 "Viagem": "Perjalanan",
 "Viagens": "Perjalanan",
 "Viagens & Lazer": "Perjalanan & Hiburan",
 "Viagens e lugares": "Perjalanan dan tempat",
 "Vida noturna": "Hiburan malam",
 "Vidros e esquadrias": "Kaca dan kusen",
 "Vigente": "Berjalan",
 "Vigentes": "Berjalan",
 "Virar": "Balik",
 "Virar a câmera": "Balik kamera",
 "Virar tarefa (levar à assistência)": "Jadikan tugas (bawa ke servis)",
 "Visita domiciliar": "Kunjungan rumah",
 "Visitados": "Dikunjungi",
 "Visto": "Sudah ditonton",
 "Vistoria": "Inspeksi",
 "Vistoria: {i}": "Inspeksi: {i}",
 "Vistorias": "Inspeksi",
 "Visualizar feriados": "Lihat hari libur",
 "Vitamina": "Vitamin",
 "Vitamina D": "Vitamin D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitamin, whey, kreatin... dengan frekuensi masing-masing. Yang dijadwalkan hari ini muncul di \"Hari ini\" untuk ditandai.",
 "Você": "Anda",
 "Você aceitou os termos em {data}.": "Anda menyetujui ketentuan pada {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Anda belum punya teman di aplikasi. Tambahkan lewat kode.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Anda belum punya map. Buat satu di tab Studi.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Anda tidak akan lagi melihat obrolan, dokumen, dan rapat.",
 "Você deve: {v}": "Utang Anda: {v}",
 "Você entrou no grupo": "Anda telah bergabung dengan grup",
 "Você entrou no grupo \"{nome}\".": "Anda bergabung dengan grup \"{nome}\".",
 "Você está convidado(a) para: {evento}": "Anda diundang ke: {evento}",
 "Você foi convidado para o My Planner": "Anda diundang ke My Planner",
 "Você foi convidado para o grupo": "Anda diundang ke grup",
 "Você juntou {v} para \"{m}\".": "Anda berhasil mengumpulkan {v} untuk \"{m}\".",
 "Você já tem todas as abas.": "Anda sudah memiliki semua tab.",
 "Você já usou um código de indicação nesta conta.": "Anda sudah menggunakan kode referral di akun ini.",
 "Você ligou": "Anda menelepon",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Kamu bisa menghapus akun kapan saja, di aplikasi ponsel atau di situs:",
 "Você não tem permissão para isso neste grupo.": "Anda tidak punya izin untuk itu di grup ini.",
 "Você não vê os outros membros deste grupo.": "Anda tidak dapat melihat anggota lain grup ini.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Anda bisa menghapus akun kapan saja di Pengaturan > Keamanan. Ini menghapus data di cloud dan di perangkat secara permanen.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Anda dapat: memastikan apakah kami memproses data Anda, mengaksesnya, memperbaikinya, meminta portabilitas (ekspor file di Pengaturan > Pengaturan umum), meminta penghapusan, mengetahui dengan siapa kami berbagi, mencabut persetujuan, dan mengadu ke ANPD.",
 "Você recebe (líquido)": "Anda terima (bersih)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Anda bertanggung jawab atas kata sandi Anda dan apa yang dilakukan di akun Anda. Gunakan data yang benar saat mendaftar.",
 "Volta": "Pulang",
 "Volta ou check-out": "Pulang atau check-out",
 "Volta às {hora}": "Kembali pukul {hora}",
 "Voltar": "Kembali",
 "Voltar ao cardápio da semana neste dia": "Kembalikan menu mingguan di hari ini",
 "Voltar ao cálculo": "Kembali ke perhitungan",
 "Voltar ao foco": "Kembali fokus",
 "Voltar ao padrão": "Kembalikan ke bawaan",
 "Voltar ao planejado": "Kembali ke rencana",
 "Voltar para Anotações": "Kembali ke Catatan",
 "Voltar para as cores do My Planner": "Kembali ke warna My Planner",
 "Voltar para novas": "Kembali ke yang baru",
 "Voltar para o QR Code": "Kembali ke Kode QR",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Kembali ke aplikasi My Planner di ponsel. Layar Pengaturan akan diperbarui sendiri.",
 "Voo": "Penerbangan",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Penerbangan, hotel, mobil, dan wisata di satu tempat, dengan kode dan bukti pemesanan.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Buka Pengaturan dan ketuk \"Hubungkan peramban\".",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Buka Pengaturan › Pengaturan umum dan ketuk \"Hubungkan peramban\".",
 "Várias páginas por folha": "Beberapa halaman per lembar",
 "Vários PDFs num só, na ordem que você escolher.": "Beberapa PDF jadi satu, dengan urutan pilihan Anda.",
 "Vê as aulas e os materiais liberados.": "Melihat pelajaran dan materi yang dibuka.",
 "Vê as etapas e registra o diário.": "Melihat tahapan dan menulis di catatan harian.",
 "Vê e altera tudo, inclusive os valores.": "Melihat dan mengubah semuanya, termasuk nominal.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Melihat dan mengirim dokumen di foldernya sendiri dan menjawab permintaan.",
 "Vê o andamento, sem os valores e sem alterar.": "Melihat progres, tanpa nominal dan tanpa mengubah.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Melihat check-in dan check-out serta menandai kebersihan selesai, tanpa nominal.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Melihat semuanya dan mencatat pengeluaran, tempat, rencana perjalanan, dan barang bawaan.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Melihat semuanya, menambah, mengedit, berkomentar, dan mengunggah foto. Hanya tidak bisa menambah atau mengeluarkan orang dari grup.",
 "Vê tudo, inclusive os valores, sem alterar.": "Melihat semuanya, termasuk nominal, tanpa mengubah.",
 "Vídeo": "Video",
 "Vínculo": "Tautan",
 "Vínculo perdido": "Tautan hilang",
 "WhatsApp da assistência": "WhatsApp layanan servis",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (jaringan dan kata sandi)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Hari Zumbi dan Kesadaran Kulit Hitam",
 "Zzz": "Zzz",
 "a cada {n} dias": "setiap {n} hari",
 "a pagar": "harus dibayar",
 "a receber": "akan diterima",
 "a receber {v}": "belum diterima {v}",
 "a reserva": "reservasi",
 "a última execução falhou; avise o suporte": "eksekusi terakhir gagal; hubungi dukungan",
 "abr": "Apr",
 "abril": "April",
 "acabou": "habis",
 "achatado": "diratakan",
 "administra": "admin",
 "ago": "Agu",
 "agosto": "Agustus",
 "ajustado": "disesuaikan",
 "algo novo": "sesuatu yang baru",
 "alterou": "mengubah",
 "amanhã": "besok",
 "anual": "tahunan",
 "apagou": "menghapus",
 "aplicada em {d}": "diberikan {d}",
 "app {v} · atualização {p} de {data}": "aplikasi {v} · pembaruan {p} tanggal {data}",
 "assinado": "ditandatangani",
 "atrasada": "terlambat",
 "atrasada há {n} dia(s)": "terlambat {n} hari",
 "até": "sampai",
 "até {data}": "sampai {data}",
 "até {d}": "hingga {d}",
 "aula {a} de {n}": "pelajaran {a} dari {n}",
 "avisos silenciados": "notifikasi dibisukan",
 "caixa": "kotak",
 "colher(es)": "sendok",
 "coluna": "kolom",
 "com anexos": "dengan lampiran",
 "com imagem": "dengan gambar",
 "com tarjas": "disensor",
 "com texto": "dengan teks",
 "com {p}": "pada {p}",
 "como planejado": "sesuai rencana",
 "comprado em {data}": "dibeli pada {data}",
 "comprado em {d} por {v}": "dibeli {d} seharga {v}",
 "comprimido": "dikompres",
 "comprovante": "bukti bayar",
 "concha(s)": "centong",
 "confirmados": "hadir",
 "consulta recusada": "konsultasi ditolak",
 "contratado": "dikontrak",
 "contínuo": "rutin",
 "copo(s)": "gelas",
 "corridos": "kalender",
 "criou o grupo": "membuat grup",
 "de": "dari",
 "de Anotações": "dari Catatan",
 "de {meta} passos": "dari {meta} langkah",
 "de {n}": "dari {n}",
 "de {p}": "dari {p}",
 "dentro / fora do planejado": "sesuai / di luar rencana",
 "desconto {v}": "diskon {v}",
 "desfazer": "urungkan",
 "destino": "tujuan",
 "deve {v}": "berutang {v}",
 "devolvido em {d}": "dikembalikan {d}",
 "dez": "Des",
 "dezembro": "Desember",
 "dia": "hari",
 "dias": "hari",
 "dias com a meta batida": "hari target tercapai",
 "dias com a meta de passos": "hari target langkah tercapai",
 "digital": "sidik jari",
 "diária média": "tarif rata-rata per malam",
 "do cliente": "dari klien",
 "do escritório": "dari kantor",
 "dom": "Min",
 "domingo": "Minggu",
 "e mais {n}": "dan {n} lainnya",
 "em aberto": "belum dibayar",
 "em atraso": "terlambat",
 "em {n} dias": "dalam {n} hari",
 "emitida": "diterbitkan",
 "entregue": "diserahkan",
 "entrou no escritório": "bergabung dengan kantor",
 "enviado": "terkirim",
 "escaneado": "dipindai",
 "escolha": "pilih",
 "este": "ini",
 "este dispositivo": "perangkat ini",
 "este item": "item ini",
 "exercícios concluídos": "latihan selesai",
 "falta {v}": "kurang {v}",
 "faltam {km}": "{km} lagi",
 "fatia(s)": "iris",
 "faturamento": "pendapatan",
 "feita em {d}": "dibuat {d}",
 "feito {dur}": "selesai {dur}",
 "fev": "Feb",
 "fevereiro": "Februari",
 "frequência {p}%": "kehadiran {p}%",
 "gasto {v}": "terpakai {v}",
 "girado": "diputar",
 "guardado": "tersimpan",
 "higienizado": "dibersihkan",
 "hoje": "hari ini",
 "hora fixa no dia": "jam tetap pada hari itu",
 "há {n} dias": "{n} hari lalu",
 "iPhone ou computador: {link}": "iPhone atau komputer: {link}",
 "incluiu": "menambahkan",
 "jan": "Jan",
 "janeiro": "Januari",
 "jul": "Jul",
 "julho": "Juli",
 "jun": "Jun",
 "junho": "Juni",
 "já importado": "sudah diimpor",
 "liberar em {d}": "dibuka {d}",
 "ligou o compartilhamento": "mengaktifkan berbagi",
 "linha": "baris",
 "lucro líquido": "laba bersih",
 "mai": "Mei",
 "maio": "Mei",
 "mar": "Mar",
 "marca d'água": "tanda air",
 "marcada por {nome}": "dijadwalkan oleh {nome}",
 "março": "Maret",
 "menos de 1 ano": "kurang dari 1 tahun",
 "mensalidade": "iuran bulanan",
 "meta batida!": "target tercapai!",
 "metadados": "metadata",
 "min": "mnt",
 "min antes": "mnt sebelumnya",
 "min antes do início": "menit sebelum mulai",
 "min · {de} às {ate}": "mnt · {de} sampai {ate}",
 "multa e juros {v}": "denda dan bunga {v}",
 "média {m}": "rata-rata {m}",
 "mês(es)": "bulan",
 "na nuvem": "di cloud",
 "na pasta \"{pasta}\"": "di folder \"{pasta}\"",
 "na pasta escolhida": "di folder yang dipilih",
 "neste dispositivo": "di perangkat ini",
 "neste celular": "di ponsel ini",
 "no Planner": "di Planner",
 "no {nome}": "di {nome}",
 "nos próximos dias": "beberapa hari ke depan",
 "nov": "Nov",
 "novembro": "November",
 "numerado": "bernomor",
 "nunca verificado": "belum pernah diperiksa",
 "não vão": "tidak datang",
 "o documento mudou depois disso: guarde de novo": "dokumen berubah setelah itu: simpan lagi",
 "ocupação": "okupansi",
 "ontem": "kemarin",
 "organizado": "ditata",
 "orçando": "sedang ditawar",
 "out": "Okt",
 "outubro": "Oktober",
 "paga": "lunas",
 "paga em {d}": "dibayar {d}",
 "pago": "lunas",
 "pago em {d}": "dibayar pada {d}",
 "pago por {p}": "dibayar oleh {p}",
 "pagou {v}": "membayar {v}",
 "parcela {a} de {n}": "cicilan {a} dari {n}",
 "parece já lançado": "tampaknya sudah dicatat",
 "parte {n}": "bagian {n}",
 "passos por dia (média)": "langkah per hari (rata-rata)",
 "passou {km}": "lewat {km}",
 "pausa {p}": "istirahat {p}",
 "pausado": "dijeda",
 "peso {n}": "bobot {n}",
 "pesquisável": "bisa dicari",
 "por dia": "per hari",
 "por dia (média)": "per hari (rata-rata)",
 "por dia disponível": "per hari tersedia",
 "por semana": "per minggu",
 "por {p}": "oleh {p}",
 "porção(ões)": "porsi",
 "preenchido": "terisi",
 "primeira às {hora}: {tarefa}": "pertama pukul {hora}: {tarefa}",
 "produção": "produksi",
 "próxima em {data}": "berikutnya {data}",
 "próxima rega {d}": "siram berikutnya {d}",
 "publicação": "publikasi",
 "página de estudo": "halaman belajar",
 "página única": "satu halaman",
 "páginas": "halaman",
 "páginas {p}": "halaman {p}",
 "qua": "Rab",
 "quarta": "Rabu",
 "quarta-feira": "Rabu",
 "qui": "Kam",
 "quinta": "Kamis",
 "quinta-feira": "Kamis",
 "quitada": "lunas",
 "recebe {v}": "menerima {v}",
 "recebida": "diterima",
 "reconhecimento facial": "pengenalan wajah",
 "recortado": "dipotong",
 "refeições feitas": "waktu makan terlaksana",
 "rega a cada {n} dias": "siram setiap {n} hari",
 "regar hoje": "siram hari ini",
 "reparado": "diperbaiki",
 "retorno {d}": "kontrol {d}",
 "saldo {v}": "saldo {v}",
 "seg": "Sen",
 "segunda": "Senin",
 "segunda-feira": "Senin",
 "sem anotações": "tanpa anotasi",
 "sem as páginas {p}": "tanpa halaman {p}",
 "sem cliente": "tanpa klien",
 "sem dias previstos": "tidak ada hari terjadwal",
 "sem horário": "tanpa waktu",
 "sem meta": "tanpa target",
 "sem resposta": "belum menjawab",
 "sem tempo": "tanpa waktu",
 "semana(s)": "minggu",
 "set": "Sep",
 "setembro": "September",
 "seu@email.com": "anda@email.com",
 "sex": "Jum",
 "sexta": "Jumat",
 "sexta-feira": "Jumat",
 "sáb": "Sab",
 "sábado": "Sabtu",
 "talvez": "mungkin",
 "tarefa da casa": "tugas rumah",
 "tarefa: {t}": "PR: {t}",
 "taxas e despesas": "biaya dan pengeluaran",
 "ter": "Sel",
 "termina em {d}": "berakhir {d}",
 "terça": "Selasa",
 "terça-feira": "Selasa",
 "teste": "uji",
 "todas": "semua",
 "todo ano em {d}": "setiap tahun pada {d}",
 "todo dia {d}": "setiap bulan tgl {d}",
 "todos": "semua",
 "toque para abrir": "ketuk untuk membuka",
 "toque para pausar": "ketuk untuk menjeda",
 "toque para ver o contato": "ketuk untuk melihat kontak",
 "toque para voltar a hoje": "ketuk untuk kembali ke hari ini",
 "treinos concluídos": "sesi latihan selesai",
 "uma vez em {d}": "sekali pada {d}",
 "unidade(s)": "buah",
 "vale {n}": "nilai maks. {n}",
 "vence em {n} dias": "jatuh tempo dalam {n} hari",
 "vence {d}": "jatuh tempo {d}",
 "venceu em {data}": "berakhir pada {data}",
 "vencido": "lewat jatuh tempo",
 "vendido com ganho de {v}": "terjual dengan untung {v}",
 "vendido com perda de {v}": "terjual dengan rugi {v}",
 "verificado {quando}": "diperiksa {quando}",
 "você": "Anda",
 "você administra": "Anda admin",
 "xícara(s)": "cangkir",
 "{aba} bloqueada": "{aba} terkunci",
 "{aba} está bloqueada": "{aba} terkunci",
 "{aba}, em \"Anotações recebidas\"": "{aba}, di \"Catatan diterima\"",
 "{a} aula(s) feita(s)": "{a} pelajaran selesai",
 "{a} de {n} aulas": "{a} dari {n} pelajaran",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} mencapai {p}% dari anggaran ({g} dari {l}).",
 "{c} confirmados de {n} convidados": "{c} dari {n} tamu hadir",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} sudah {p}% dari anggaran bulan ini. Masih {dias} hari lagi sampai akhir bulan.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} sudah {v} di atas total bulan lalu. Periksa apakah ada yang tidak biasa.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} sudah melewati anggaran: {g} dari {l}. Tahan pengeluaran ini sampai bulan berganti.",
 "{c} passou do orçamento: {g} de {l}.": "{c} melewati anggaran: {g} dari {l}.",
 "{de} paga {v} para {para}": "{de} membayar {v} kepada {para}",
 "{de} às {ate}": "{de} sampai {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia}, {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia}, {d} {mes}",
 "{dia}, {d}/{m}": "{dia}, {d}/{m}",
 "{dur} na semana": "{dur} minggu ini",
 "{dur} registrados": "{dur} tercatat",
 "{d}/{n} notas": "{d}/{n} nilai",
 "{feito} de {meta}": "{feito} dari {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} dari {n} selesai",
 "{f}/{n} transferências feitas": "{f}/{n} pemindahan selesai",
 "{hora} em {fuso}": "{hora} di {fuso}",
 "{h} este mês": "{h} bulan ini",
 "{h} h": "{h} jam",
 "{h} h {m} min": "{h} jam {m} mnt",
 "{h} no seu relógio": "{h} di jam Anda",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} terhubung. {n} model tersedia di akun Anda.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}: kunci API tidak valid atau tanpa izin.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}: batas penggunaan tercapai. Periksa saldo atau batas akun API Anda.",
 "{item}: em {n} dias ({data}).": "{item}: dalam {n} hari ({data}).",
 "{item}: hoje ({data}).": "{item}: hari ini ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item}: berakhir dalam {n} hari ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item}: kedaluwarsa dalam {n} hari ({data}).",
 "{item}: vence hoje ({data}).": "{item}: kedaluwarsa hari ini ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}: jatuh tempo pada {data} dan belum ditandai selesai.",
 "{livre} livres de {total}": "{livre} kosong dari {total}",
 "{m} min": "{m} mnt",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} sekarang teman Anda. Kalian sudah bisa mengobrol.",
 "{nome} conectado!": "{nome} terhubung!",
 "{nome} ligou": "{nome} menelepon",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} baru, {atualizadas} diperbarui, {enviadas} dikirim, {removidas} dihapus",
 "{n} ITEM(NS)": "{n} ITEM",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} tab di paket Anda · warna dan opsi masing-masing",
 "{n} aba(s) para comprar": "{n} tab untuk dibeli",
 "{n} adicionada(s)": "{n} ditambahkan",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} peringatan dijadwalkan di ponsel ini untuk beberapa hari ke depan.",
 "{n} aluno(s)": "{n} siswa",
 "{n} anexo(s)": "{n} lampiran",
 "{n} ano(s)": "{n} tahun",
 "{n} arquivo(s)": "{n} file",
 "{n} atendimento(s)": "{n} kunjungan",
 "{n} atrasada(s)": "{n} terlambat",
 "{n} atrasado(s)": "{n} terlambat",
 "{n} caixa(s)": "{n} kardus",
 "{n} caixa(s) frágil(eis)": "{n} kardus mudah pecah",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} kardus · {a} sudah dibuka di rumah baru",
 "{n} cancelada(s).": "{n} dibatalkan.",
 "{n} cartão(ões) abertos": "{n} kartu terbuka",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} tagihan dibuat dengan jatuh tempo {d}.",
 "{n} com vencimento": "{n} dengan jatuh tempo",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} pembelian di kartu {c}. Cicilan berikutnya sudah muncul di tagihan selanjutnya.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} tagihan otomatis ditandai sudah dibayar.",
 "{n} copo(s), {ml} de {meta}": "{n} gelas, {ml} dari {meta}",
 "{n} de {meta} copos": "{n} dari {meta} gelas",
 "{n} de {total}": "{n} dari {total}",
 "{n} de {total} dias": "{n} dari {total} hari",
 "{n} de {total} hoje": "{n} dari {total} hari ini",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} dari {t} item dengan harga, dari struk yang dibaca di Keuangan.",
 "{n} dia(s)": "{n} hari",
 "{n} dia(s) seguido(s) lendo": "{n} hari berturut-turut membaca",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} hari dihapus dari tugas berulang",
 "{n} dias": "{n} hari",
 "{n} dias grátis": "Gratis {n} hari",
 "{n} dias grátis para testar": "Gratis {n} hari untuk mencoba",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} hari {tipo}: dipublikasikan {pub}, dihitung mulai {ini}, jatuh tempo {fim}.",
 "{n} documento(s)": "{n} dokumen",
 "{n} em atraso": "{n} terlambat",
 "{n} etapa(s) atrasada(s)": "{n} tahap terlambat",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} penghapusan menunggu ponsel disinkronkan.",
 "{n} falta(s)": "{n} absen",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} catatan di grup. Pilih peran tiap orang di Anggota.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} foto dan video perjalanan dari semua anggota grup. Foto dari rencana perjalanan, tempat, dan reservasi juga muncul di sini.",
 "{n} item(ns) adicionado(s).": "{n} item ditambahkan.",
 "{n} item(ns) com outras pessoas": "{n} barang dipinjam orang lain",
 "{n} item(ns) no Planner.": "{n} item di Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} transaksi ditemukan",
 "{n} lançamento(s) novo(s).": "{n} transaksi baru.",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} pengingat dimasukkan ke My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} buku dibaca tahun ini",
 "{n} marcado(s)": "{n} ditandai",
 "{n} matéria(s)": "{n} mata pelajaran",
 "{n} membro(s) · abrir a conversa do grupo": "{n} anggota · buka obrolan grup",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "Gratis {n} bulan sejak akun dibuat; setelah itu {preco} per tahun.",
 "{n} min": "{n} mnt",
 "{n} min antes": "{n} menit sebelumnya",
 "{n} módulo(s)": "{n} modul",
 "{n} noite(s)": "{n} malam",
 "{n} nota(s) nova(s).": "{n} faktur baru.",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} faktur tanpa XML di perangkat ini tidak disertakan.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} faktur · diterbitkan {e} · diterima {r}",
 "{n} nova(s)": "{n} baru",
 "{n} novo(s) do cliente": "{n} baru dari klien",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} baru untuk diterima, diedit, atau ditolak.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} cicilan dimasukkan ke My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} cicilan yang belum dibayar dihitung ulang. Yang sudah dibayar tetap seperti semula.",
 "{n} parcela(s) em atraso": "{n} cicilan terlambat",
 "{n} parcela(s) em atraso: {v}": "{n} cicilan terlambat: {v}",
 "{n} participantes · toque para ver": "{n} peserta · ketuk untuk melihat",
 "{n} passo(s)": "{n} langkah",
 "{n} pausa(s)": "{n} jeda",
 "{n} pedido(s) de amizade": "{n} permintaan pertemanan",
 "{n} pedido(s) em aberto": "{n} permintaan terbuka",
 "{n} pessoa(s)": "{n} orang",
 "{n} pessoa(s) já entraram com o seu código.": "{n} orang sudah bergabung dengan kode Anda.",
 "{n} pessoas": "{n} orang",
 "{n} por folha": "{n} per lembar",
 "{n} porções": "{n} porsi",
 "{n} publicação(ões) nova(s).": "{n} publikasi baru.",
 "{n} publicações novas": "{n} publikasi baru",
 "{n} página(s)": "{n} halaman",
 "{n} página(s) · {r} revisada(s)": "{n} halaman · {r} sudah diulas",
 "{n} páginas": "{n} halaman",
 "{n} recebido(s) dos seus grupos": "{n} diterima dari grup Anda",
 "{n} recebido(s) para responder": "{n} diterima untuk dijawab",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} waktu makan, dengan menu hari itu",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} reservasi baru atau berubah.",
 "{n} resultado(s) em todas as publicações": "{n} hasil di semua publikasi",
 "{n} selecionado(s): {lista}": "{n} dipilih: {lista}",
 "{n} tarefa(s)": "{n} tugas",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} tugas dihapus seluruhnya",
 "{n} tarefa(s) criada(s)": "{n} tugas dibuat",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} tugas rumah dikeluarkan dari My Planner dan kini hanya ada di Rumahku. Untuk membawa salah satunya ke Planner, buka tugas lalu ketuk \"Kirim ke My Planner\".",
 "{n} tarefa(s) de ontem sem concluir": "{n} tugas kemarin belum selesai",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} tugas beberapa hari terakhir belum selesai",
 "{n} tarefa(s) hoje": "{n} tugas hari ini",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} tugas tertunda akan masuk ke daftar hari ini.",
 "{n} tarjas no documento": "{n} blok hitam di dokumen",
 "{n} treino(s), cada um nos dias dele": "{n} latihan, masing-masing di harinya",
 "{n} tribunais": "{n} pengadilan",
 "{n}x de {v}": "{n}x {v}",
 "{n}º alerta": "Peringatan ke-{n}",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} terkirim, {falhas} gagal. Coba lagi nanti.",
 "{ok} enviado(s).": "{ok} terkirim.",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} dari {d} malam terisi. Reservasi yang melewati pergantian bulan dibagi per malam.",
 "{preco} por ano": "{preco} per tahun",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} dari {t} cicilan dibayar ({pct}%)",
 "{p} presentes · {f} faltas": "{p} hadir · {f} absen",
 "{p}% da meta de {m} páginas": "{p}% dari target {m} halaman",
 "{p}% feito": "{p}% selesai",
 "{p}% ocupado no mês": "{p}% terisi bulan ini",
 "{p}% pronta": "{p}% jadi",
 "{p}/{t} pagas": "{p}/{t} dibayar",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} mengundang Anda ke grup \"{grupo}\" di My Planner. Ketuk tautan untuk bergabung (aplikasinya gratis untuk memulai): {link}\nKode undangan: {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} dan lainnya menambahkan {n} item ke grup.",
 "{quem} incluiu {item} no grupo.": "{quem} menambahkan {item} ke grup.",
 "{servico} do veículo": "{servico} kendaraan",
 "{s} de {a}": "{s} dari {a}",
 "{tarefa}: volte às {hora}": "{tarefa}: kembali pukul {hora}",
 "{tipo}: {p}": "{tipo}: {p}",
 "{titulo} (cópia)": "{titulo} (salinan)",
 "{uso} usados de {total} reservados para o site": "{uso} terpakai dari {total} yang disediakan untuk situs",
 "{v} · atualização de {data}": "{v} · pembaruan {data}",
 "{v}/hora": "{v}/jam",
 "À direita": "Kanan",
 "À vista": "Sekali bayar",
 "Às": "Pukul",
 "Às {hora}": "Pukul {hora}",
 "ÁGUA": "AIR",
 "Ácido": "Asam",
 "Água": "Air",
 "Água hoje": "Air hari ini",
 "Área externa": "Area luar",
 "Áreas": "Area",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "Ini adalah alat bantu dan tidak menggantikan pemantauan pemberitahuan resmi melalui saluran resmi. Tenggat harus diperiksa di sistem resmi.",
 "Ética Profissional": "Etika Profesi",
 "Ícone e aba": "Ikon dan tab",
 "Óculos de sol": "Kacamata hitam",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Instansi penerbit (mis.: DETRAN-MS, Polisi Federal)",
 "Órgão emissor: {nome}": "Instansi penerbit: {nome}",
 "Ômega 3": "Omega 3",
 "Última": "Terakhir",
 "Última adubação": "Pemupukan terakhir",
 "Última aplicação": "Pemberian terakhir",
 "Última busca do servidor para você: {quando}": "Pencarian server terakhir untuk Anda: {quando}",
 "Última cópia de segurança: {data}": "Cadangan terakhir: {data}",
 "Última rega": "Penyiraman terakhir",
 "Última sincronização: {quando}": "Sinkronisasi terakhir: {quando}",
 "Última: {data}": "Terakhir: {data}",
 "Último dia para entregar a declaração do IR": "Batas akhir lapor SPT IR",
 "Último erro: {m}": "Galat terakhir: {m}",
 "Últimos 30 dias": "30 hari terakhir",
 "Últimos 7 dias": "7 hari terakhir",
 "íris": "iris",
 "última vez em {data}": "terakhir {data}",
 "último em {d}": "terakhir {d}",
 "úteis": "kerja",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ adalah warna My Planner. Pilihan ini berlaku untuk semua chat di perangkat ini dan di akun Anda.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} menelepon (video)",
 "📆 Conectar a agenda deste celular": "📆 Hubungkan kalender ponsel ini",
 "📞 {nome} está ligando (áudio)": "📞 {nome} menelepon (suara)",
 "Link bloqueado por segurança.": "Tautan diblokir demi keamanan.",
 "Este arquivo não é uma imagem válida.": "File ini bukan gambar yang valid.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "Pencarian otomatis server mengikuti 5 profil pertama. Sisanya diperiksa saat Anda mengetuk \"Periksa sekarang\".",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Layar ini menampilkan linimasa perjalanan, berisi aktivitas dan tempat yang sudah punya hari. Untuk menambah atau mengedit info lengkap sebuah tempat, gunakan tab Tempat.",
 "Para a viagem {d}": "Untuk perjalanan {d}",
 "sem nome": "tanpa nama",
 "Foi para a viagem {d}.": "Dipindahkan ke perjalanan {d}.",
 "Orçamento total (se não for detalhar)": "Total anggaran (jika tidak dirinci)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Susun rencana perjalanan hari demi hari. Tempat yang sudah punya hari otomatis masuk ke sini. Selama perjalanan, rencana perjalanan muncul di linimasa My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Atur hari dan jam pada tempat agar otomatis muncul di Rencana perjalanan.",
 "No roteiro": "Di rencana perjalanan",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "\"{nome}\" ada di rencana perjalanan tanggal {data}. Untuk mengubah hari atau jam, edit tempatnya.",
 "Para o roteiro desta viagem": "Untuk rencana perjalanan ini",
 "Orçamento e gastos": "Anggaran dan pengeluaran",
 "Parada (cidade)": "Persinggahan (kota)",
 "Item da categoria": "Item kategori",
 "Orçamento da viagem inteira": "Anggaran seluruh perjalanan",
 "Orçamento geral da viagem": "Anggaran umum perjalanan",
 "Previsto {p} · gasto {g}": "Rencana {p} · terpakai {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Di sini ada biaya perjalanan yang bukan milik persinggahan (mis.: tiket, asuransi). Tiap persinggahan punya anggarannya sendiri.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Isi berapa yang ingin dibelanjakan di tiap kategori. Saat mencatat pengeluaran, aplikasi menunjukkan berapa yang sudah terpakai.",
 "Orçamento por parada": "Anggaran per persinggahan",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Akan singgah di lebih dari satu kota? Tambahkan persinggahan (tab Persinggahan): masing-masing punya anggaran sendiri dan pengeluaran pada tanggal itu otomatis masuk ke sana.",
 "Coloque o valor do gasto.": "Isi jumlah pengeluaran.",
 "Orçamento de {c}": "Anggaran {c}",
 "Lançar um gasto nesta parada": "Catat pengeluaran di persinggahan ini",
 "Lançar gasto": "Catat pengeluaran",
 "Orçamento e gastos da parada": "Anggaran dan pengeluaran persinggahan",
 "Gastos lançados ({n})": "Pengeluaran tercatat ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Untuk memperbaiki atau menghapus pengeluaran, gunakan tab Anggaran dan pengeluaran pada perjalanan.",
 "Paradas": "Persinggahan",
 "Cidade ou lugar": "Kota atau tempat",
 "Ex.: Porto": "Mis.: Porto",
 "Chegada": "Tiba",
 "Saída": "Berangkat",
 "Onde vai ficar": "Tempat menginap",
 "gasto {g} de {p}": "terpakai {g} dari {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Akan singgah di lebih dari satu kota? Tambahkan tiap persinggahan beserta tanggalnya. Masing-masing punya anggaran sendiri (penginapan, makan, transportasi...) dan pengeluaran pada tanggal itu otomatis masuk ke sana.",
 "Café da tarde": "Ngopi sore",
 "Outros / Lanches": "Lainnya / Camilan",
 "Gasto {v}": "Terpakai {v}",
 "Gasto {g} de {p} · {a} acima": "Terpakai {g} dari {p} · lebih {a}",
 "Gasto {g} de {p}": "Terpakai {g} dari {p}",
 "Tirar \"{nome}\" do orçamento?": "Hapus \"{nome}\" dari anggaran?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Pengeluaran yang sudah dicatat di sana tetap ada di daftar pengeluaran.",
 "Previsto para {nome}": "Rencana untuk {nome}",
 "Tirar {nome}": "Hapus {nome}",
 "Nome do item (ex.: Jantar especial)": "Nama item (mis.: Makan malam spesial)",
 "Adicionar item": "Tambah item",
 "Detalhar em itens": "Rinci per item",
 "Nova categoria (ex.: Seguro, Presentes)": "Kategori baru (mis.: Asuransi, Hadiah)",
 "Voltar às categorias sugeridas?": "Kembali ke kategori yang disarankan?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Nilai rencana di daftar ini akan dihapus. Pengeluaran yang dicatat tetap ada.",
 "Voltar às categorias sugeridas": "Kembali ke kategori yang disarankan",
 "Previsto": "Rencana",
 "Ainda pode gastar": "Masih bisa dibelanjakan",
 "Passou do previsto": "Melebihi rencana",
 "Não foi possível buscar o câmbio": "Tidak bisa mengambil kurs",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Tidak ada internet atau {m} tidak ada di tabel. Edit perjalanan dan isi kurs secara manual.",
 "Câmbio de {m} ainda não definido": "Kurs {m} belum diatur",
 "Câmbio de hoje": "Kurs hari ini",
 "Atualizado em {d}": "Diperbarui pada {d}",
 "Valor em {m}": "Jumlah dalam {m}",
 "Moeda do destino": "Mata uang tujuan",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Kurs: berapa nilai 1 mata uang tujuan dalam mata uang Anda",
 "Sem dia marcado": "Belum ada hari",
 "Valor na moeda do destino": "Jumlah dalam mata uang tujuan",
 "Tirar só desta lista ou excluir de vez?": "Hapus hanya dari daftar ini atau hapus permanen?",
 "Excluir de vez": "Hapus permanen",
 "Relatório da viagem (PDF)": "Laporan perjalanan (PDF)",
 "Planilha da viagem (Excel)": "Spreadsheet perjalanan (Excel)",
 "Geral da viagem": "Seluruh perjalanan",
 "Viagem {d}": "Perjalanan {d}",
 "Quem vai: {p}": "Yang ikut: {p}",
 "Outros gastos": "Pengeluaran lain",
 "Orçamento · {n}": "Anggaran · {n}",
 "Código": "Kode",
 "Pagou": "Dibayar oleh",
 "Permissão internacional para dirigir": "Izin mengemudi internasional",
 "Vacina (certificado)": "Vaksin (sertifikat)",
 "Autorização de viagem de menor": "Izin perjalanan anak di bawah umur",
 "Vence antes da volta": "Kedaluwarsa sebelum pulang",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Kedaluwarsa kurang dari 6 bulan setelah pulang (banyak negara tidak menerima)",
 "A lista básica já está aqui.": "Daftar dasar sudah ada di sini.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} dokumen dengan masa berlaku yang bisa mengganggu perjalanan",
 "Lista básica: passaporte de cada um e seguro viagem": "Daftar dasar: paspor setiap orang dan asuransi perjalanan",
 "Lista básica: identidade de cada um": "Daftar dasar: kartu identitas setiap orang",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Isi masa berlaku setiap dokumen: aplikasi mengingatkan sebelum kedaluwarsa dan memeriksa apakah paspor berlaku 6 bulan setelah pulang. Foto dokumen tetap terlindungi di brankas.",
 "De quem": "Milik siapa",
 "Número (protegido no cofre)": "Nomor (terlindungi di brankas)",
 "Está em mãos": "Sudah di tangan",
 "Válido até {d}": "Berlaku hingga {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Paspor, visa, asuransi perjalanan, vaksin, izin anak... dengan masa berlaku dan foto. Tandai saat sudah di tangan.",
 "acerto entre os viajantes (não entra no orçamento)": "pelunasan antar pelancong (tidak masuk anggaran)",
 "Só gastos": "Hanya pengeluaran",
 "Acertos": "Pelunasan",
 "Marcar como pago?": "Tandai sudah dibayar?",
 "{de} já pagou {v} para {para}?": "{de} sudah membayar {v} ke {para}?",
 "Já pagou": "Sudah bayar",
 "Acerto: {de} pagou {para}": "Pelunasan: {de} membayar {para}",
 "Conferir minhas assinaturas": "Cek langganan saya",
 "Gerenciar ou cancelar assinaturas na loja": "Kelola atau batalkan langganan di toko",
 "Restaurar compras": "Pulihkan pembelian",
 "Procurando...": "Mencari...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} langganan ditemukan dan dibuka.",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Langganan tahunan, diperpanjang otomatis. Batalkan kapan saja di langganan toko, paling lambat 24 jam sebelum perpanjangan.",
 "Assinaturas da loja": "Langganan toko",
 "Gerenciar assinaturas (App Store)": "Kelola langganan (App Store)",
 "Gerenciar assinaturas (Google Play)": "Kelola langganan (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "Langganan dilakukan di aplikasi ponsel (Google Play atau App Store) dan juga berlaku di situs ini.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Langganan ini belum tersedia di toko. Coba lagi nanti.",
 "Assinatura feita": "Berhasil berlangganan",
 "Já assinei no celular: conferir": "Saya sudah berlangganan di ponsel: cek",
 "Nenhuma assinatura encontrada nesta conta da loja.": "Tidak ada langganan di akun toko ini.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Periksa internet dan coba lagi. Tidak ada biaya yang ditagih.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} terbuka. Juga berlaku di perangkat lain dan di situs.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Untuk berlangganan, perbarui My Planner dari Google Play atau App Store.",
 "Assinada, renova em {data}": "Berlangganan, diperpanjang pada {data}",
 "Não deu para assinar agora": "Tidak bisa berlangganan sekarang",
 "Assinar por {preco} por ano": "Berlangganan {preco} per tahun",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" dipindahkan ke Papan, di Pencapaian.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" sudah menjadi bagian dari rutinitas Anda. Dipindahkan ke Papan, di Pencapaian.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" kembali ke tempatnya.",
 "1 ano": "1 tahun",
 "1 mês": "1 bulan",
 "A IA não achou o valor no comprovante.": "AI tidak menemukan nominal di bukti pembayaran.",
 "A cada {n} dias": "Setiap {n} hari",
 "A carta está vazia": "Surat ini kosong",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "Surat ini terkunci sampai {d}. Sampai saat itu, surat tidak bisa dibaca ulang atau diedit. Untuk mengubah sesuatu, tulis surat lain.",
 "A lixeira está vazia.": "Tempat sampah kosong.",
 "A mesma do app e do celular": "Sama seperti aplikasi dan ponsel",
 "A mesma forma de desbloqueio do app e do celular": "Cara buka kunci yang sama dengan aplikasi dan ponsel",
 "A senha do diário precisa ter 6 caracteres ou mais.": "Kata sandi catatan harian harus 6 karakter atau lebih.",
 "A senha precisa ter 6 caracteres ou mais.": "Kata sandi harus 6 karakter atau lebih.",
 "A turma ainda não tem grupo": "Kelas ini belum punya grup",
 "AS 4 BOLINHAS DE COR": "4 BULATAN WARNA",
 "Aberta em {d}": "Dibuka pada {d}",
 "Abra a aba para poder restaurar": "Buka tab ini untuk memulihkan",
 "Abra o diário primeiro": "Buka catatan harian terlebih dahulu",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "Dibuka dengan biometrik, pengenalan wajah, atau kata sandi aplikasi. Kata sandi catatan harian hanya diminta pertama kali di setiap perangkat.",
 "Abre em {d}": "Dibuka pada {d}",
 "Abrir carta para o futuro": "Buka surat untuk masa depan",
 "Abrir em {aba}": "Buka di {aba}",
 "Abrir o Diário": "Buka Catatan Harian",
 "Abrir o diário": "Buka catatan harian",
 "Abrir {aba}": "Buka {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Memantau properti, reservasi, okupansi, pengeluaran, dan laba, tanpa mengubah apa pun.",
 "Adicionar foto": "Tambah foto",
 "Apaga tudo o que está no quadro desta página.": "Menghapus semua yang ada di papan halaman ini.",
 "Apagar o desenho?": "Hapus gambar?",
 "Apagar o diário": "Hapus catatan harian",
 "Apagar para todos?": "Hapus untuk semua?",
 "Aplicar a todas as páginas desta matéria": "Terapkan ke semua halaman mata pelajaran ini",
 "Aplicar a todas as páginas desta pasta": "Terapkan ke semua halaman folder ini",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Modul, daftar soal, slide, video, tautan, dan pesan. Lewat ⋮ › Kirim ke kelas, setiap siswa menerimanya di aplikasinya.",
 "Aquarela": "Cat air",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Di sini muncul, tanpa biaya, apa yang dibagikan grup kepada Anda. Untuk menggunakan tab ini dengan data Anda sendiri, berlanggananlah tab ini.",
 "Arquivados": "Diarsipkan",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Geser ke kanan untuk menghapus, atau ke kiri untuk mengarsipkan.",
 "As cobranças desta aula extra já existem.": "Tagihan untuk kelas tambahan ini sudah ada.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Nilai hanya dikirim ke masing-masing siswa. Untuk itu, nama orang di grup harus sama dengan nama siswa atau wali di data pendaftaran.",
 "Atestado": "Surat keterangan",
 "Atestados": "Surat keterangan",
 "Até quando (opcional)": "Sampai kapan (opsional)",
 "Até {d}": "Sampai {d}",
 "Aula extra": "Kelas tambahan",
 "Aula extra (fora dos dias de aula)": "Kelas tambahan (di luar hari kelas)",
 "Aula extra de {d}": "Kelas tambahan {d}",
 "Avaliação de {d}": "Penilaian {d}",
 "Avaliação salva": "Penilaian disimpan",
 "Avançar": "Lanjut",
 "Aviso da revisão do mês": "Pengingat ulasan bulanan",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Pengingat di hari terakhir bulan: \"Bagaimana kalau mengulas bulan Anda? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Pengingat tanpa isi catatan harian: \"Bagaimana hari Anda? ✍️\"",
 "Avulsa": "Satuan",
 "Avulsas": "Satuan",
 "Azul": "Biru",
 "Baixar na App Store": "Unduh di App Store",
 "Baixar na Google Play": "Unduh di Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Unduh My Planner di toko: Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biometrik, pengenalan wajah, atau kata sandi aplikasi. Kata sandi catatan harian disimpan untuk pertama kali di setiap perangkat.",
 "Branco": "Putih",
 "Buscando o clima…": "Mengambil cuaca…",
 "Básicas": "Dasar",
 "COMO ESTOU": "BAGAIMANA PERASAAN SAYA",
 "COMO O DIÁRIO ABRE": "CARA MEMBUKA CATATAN HARIAN",
 "COR DA FOLHA": "WARNA KERTAS",
 "Caixinha no My Planner": "Kotak di My Planner",
 "Caixinha {m}": "Kotak {m}",
 "Carta de {d}": "Surat {d}",
 "Carta guardada": "Surat disimpan",
 "Carta para o futuro": "Surat untuk masa depan",
 "Carta trancada": "Surat terkunci",
 "Cartas abertas podem ser lidas, mas não editadas.": "Surat yang sudah dibuka bisa dibaca, tetapi tidak bisa diedit.",
 "Cartas para o Futuro": "Surat untuk Masa Depan",
 "Cartões arquivados": "Kartu yang diarsipkan",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Ada surat dari {nome} {tempo} yang lalu 💌",
 "Chegou! Toque para abrir 💌": "Sudah tiba! Ketuk untuk membuka 💌",
 "Cinza-escuro": "Abu-abu tua",
 "Clara (segue o tema)": "Terang (mengikuti tema)",
 "Claras e pastel (boas para folha escura)": "Terang dan pastel (cocok untuk kertas gelap)",
 "Clima (toque para preencher)": "Cuaca (ketuk untuk mengisi)",
 "Clima automático": "Cuaca otomatis",
 "Clima do dia": "Cuaca hari ini",
 "Cobrar a aula extra": "Tagih kelas tambahan",
 "Cobrar a aula extra dos presentes": "Tagih kelas tambahan ke yang hadir",
 "Cobrar a turma toda": "Tagih seluruh kelas",
 "Cole um link que comece com https://": "Tempel tautan yang diawali https://",
 "Coloque o valor da aula extra na turma (Editar).": "Isi biaya kelas tambahan di kelas (Edit).",
 "Coloque o valor.": "Isi nominalnya.",
 "Colunas": "Kolom",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Dengan AI Anda aktif (Pengaturan › Kecerdasan buatan), aplikasi membaca nominal, tanggal, dan deskripsi dari foto.",
 "Como cuidei de mim hoje?": "Bagaimana saya merawat diri hari ini?",
 "Como foi o seu dia? ✍️": "Bagaimana hari Anda? ✍️",
 "Compartilhar este projeto (convidar)": "Bagikan proyek ini (undang)",
 "Compartilhar o texto": "Bagikan teks",
 "Completa": "Lengkap",
 "Comprovante (foto, PDF ou print)": "Bukti pembayaran (foto, PDF, atau tangkapan layar)",
 "Comprovante anexado": "Bukti pembayaran terlampir",
 "Comprovante de pagamento (foto ou PDF)": "Bukti pembayaran (foto atau PDF)",
 "Concluído: hábito formado": "Selesai: kebiasaan terbentuk",
 "Concluídos": "Selesai",
 "Configurar o Diário": "Atur Catatan Harian",
 "Confirmar pagamento": "Konfirmasi pembayaran",
 "Confirmar recebimento": "Konfirmasi penerimaan",
 "Conquistas": "Pencapaian",
 "Contas arquivadas": "Pembayaran yang diarsipkan",
 "Continuar escrevendo": "Lanjut menulis",
 "Copiado ✓": "Disalin ✓",
 "Copiar código": "Salin kode",
 "Copiar link": "Salin tautan",
 "Cor atual": "Warna saat ini",
 "Cor {n}": "Warna {n}",
 "Creme": "Krem",
 "Criada em {d}": "Dibuat pada {d}",
 "Criar as cobranças": "Buat tagihan",
 "Criar o grupo da turma": "Buat grup kelas",
 "Criar o meu diário": "Buat catatan harian saya",
 "Crie a senha do diário (6 ou mais)": "Buat kata sandi catatan harian (6 atau lebih)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Buat grup kelas dan kirim undangan ke siswa. Setelah itu, kiriman langsung sampai ke mereka.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Buat target, tujuan, atau impian pertama Anda dengan tombol + di bawah.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Buat proyek, undang yang ikut serta, dan bagi langkah-langkahnya. Setiap orang menandai yang sudah dikerjakan.",
 "Crie uma senha nova para começar.": "Buat kata sandi baru untuk memulai.",
 "Cuidados arquivados": "Perawatan yang diarsipkan",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Perawatan diri hari ini selesai (Kesehatan)",
 "Curto prazo": "Jangka pendek",
 "Custos": "Biaya",
 "Céu estrelado": "Langit berbintang",
 "Círculo": "Lingkaran",
 "Cômodos arquivados": "Ruangan yang diarsipkan",
 "DIAS CUMPRIDOS": "HARI TERPENUHI",
 "Data (opcional)": "Tanggal (opsional)",
 "De {d}": "Dari {d}",
 "Desafixar do topo": "Lepas sematan dari atas",
 "Desenho mais fraco ou mais forte": "Gambar lebih tipis atau lebih tebal",
 "Desfazer \"Concluído\" ({d})": "Batalkan \"Selesai\" ({d})",
 "Desligado": "Mati",
 "Desmarcar": "Hapus centang",
 "Desmarcar como paga?": "Hapus tanda lunas?",
 "Desmarcar como recebida?": "Hapus tanda diterima?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Hapus centang yang tidak Anda gunakan: bagian itu hilang dari layar dan tab jadi lebih sederhana. Bisa diubah nanti di Pengaturan › Tab › {aba} › Bagian tab ini.",
 "Dias da semana": "Hari dalam seminggu",
 "Dias de aula": "Hari kelas",
 "Dias de aula: {d}": "Hari kelas: {d}",
 "Dias escritos": "Hari yang ditulis",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Tips: gambar bentuknya dengan tangan dan tahan jari di akhir garis agar bentuknya jadi sempurna.",
 "Ditado": "Dikte",
 "Ditar (falar para escrever)": "Dikte (bicara untuk menulis)",
 "Diário apagado": "Catatan harian dihapus",
 "Diário protegido": "Catatan harian terlindungi",
 "Dom": "Min",
 "Dê um nome a ele na pasta Hábitos.": "Beri nama di folder Kebiasaan.",
 "EVOLUÇÃO": "PERKEMBANGAN",
 "Editada em {d}": "Diedit pada {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Surat ini dibuka pada {d} ({n} hari). Sampai saat itu, surat tidak bisa dibaca ulang atau diedit.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Surat ini dibuka pada {d}. Anda akan menerima pemberitahuan pada hari itu.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Disimpan dengan tanggal hari ini untuk dibandingkan nanti.",
 "Enorme": "Sangat besar",
 "Enviado ao paciente": "Dikirim ke pasien",
 "Enviado em": "Dikirim pada",
 "Enviar \"{t}\" para todos do grupo {g}?": "Kirim \"{t}\" ke semua anggota grup {g}?",
 "Enviar a nota para cada aluno": "Kirim nilai ke setiap siswa",
 "Enviar as notas": "Kirim nilai",
 "Enviar o arquivo: {nome}": "Kirim file: {nome}",
 "Enviar o recado para a turma": "Kirim pesan ke kelas",
 "Enviar o título para outra aba": "Kirim judul ke tab lain",
 "Enviar para a turma": "Kirim ke kelas",
 "Enviar para outra aba": "Kirim ke tab lain",
 "Escolha a cor desta bolinha": "Pilih warna bulatan ini",
 "Escolha uma data no futuro": "Pilih tanggal di masa depan",
 "Escolher qualquer cor": "Pilih warna apa saja",
 "Esconder a barra": "Sembunyikan bilah",
 "Escreva a frase": "Tulis kalimatnya",
 "Escreva a que se refere a cobrança.": "Tulis untuk apa tagihan ini.",
 "Escreva alguma coisa antes de guardar.": "Tulis sesuatu sebelum menyimpan.",
 "Escreva alguma coisa antes de salvar.": "Tulis sesuatu sebelum menyimpan.",
 "Escreva hoje, abra no futuro": "Tulis hari ini, buka di masa depan",
 "Escreva o que você quer mudar a partir de hoje": "Tulis apa yang ingin Anda ubah mulai hari ini",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Tulis untuk diri Anda di masa depan. Surat ini terkunci sampai hari dibuka.",
 "Escrever uma carta": "Tulis surat",
 "Escrita em {e} · abre em {a}": "Ditulis pada {e} · dibuka pada {a}",
 "Escuras (boas para folha clara)": "Gelap (cocok untuk kertas terang)",
 "Esperado": "Diharapkan",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Diharapkan: {e} · Selesai: {f} · Kurang: {fa}",
 "Esqueceu a senha do diário?": "Lupa kata sandi catatan harian?",
 "Esqueci a senha do diário": "Saya lupa kata sandi catatan harian",
 "Esta semana": "Minggu ini",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Transaksi ini berasal dari bagian lain aplikasi dan tidak bisa dihapus di sini.",
 "Estudo: {h}": "Belajar: {h}",
 "Esvaziar": "Kosongkan",
 "Esvaziar a lixeira": "Kosongkan tempat sampah",
 "Esvaziar a lixeira?": "Kosongkan tempat sampah?",
 "Ex.: Comer uma fruta por dia": "Mis.: Makan satu buah setiap hari",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Mis.: Latihan di rumah, Surat keterangan 2 hari",
 "Ex.: Reservar a pousada": "Mis.: Pesan penginapan",
 "Ex.: Viagem em família, juntar para a festa": "Mis.: Liburan keluarga, menabung untuk pesta",
 "Excluir de vez?": "Hapus permanen?",
 "Excluir esta avaliação?": "Hapus penilaian ini?",
 "Excluir este bloco?": "Hapus blok ini?",
 "Excluir este desenho?": "Hapus gambar ini?",
 "Excluir este item?": "Hapus item ini?",
 "Excluir {n} item(ns)?": "Hapus {n} item?",
 "Exportar como imagem": "Ekspor sebagai gambar",
 "Exportar em PDF": "Ekspor ke PDF",
 "FOTOS": "FOTO",
 "FRASE DO DIA": "KALIMAT HARI INI",
 "FREQUÊNCIA": "FREKUENSI",
 "Falta o valor": "Nominal belum diisi",
 "Feriado": "Hari libur",
 "Feriado: {f}": "Hari libur: {f}",
 "Fica 30 dias na lixeira.": "Disimpan 30 hari di tempat sampah.",
 "Ficam 30 dias na lixeira.": "Disimpan 30 hari di tempat sampah.",
 "Fichários arquivados": "Map yang diarsipkan",
 "Fixar no topo": "Sematkan di atas",
 "Floral": "Bunga",
 "Folha": "Kertas",
 "Folha, tema e cores das páginas com escrita": "Kertas, tema, dan warna halaman tulisan",
 "Folhas e plantas": "Daun dan tanaman",
 "Foto adicionada": "Foto ditambahkan",
 "Foto do sonho": "Foto impian",
 "Fotos do dia": "Foto hari ini",
 "Frase": "Kalimat",
 "Frase do dia (aparece no topo do Meu Dia)": "Kalimat hari ini (muncul di atas Hariku)",
 "Frases, textos, vídeos e fotos que motivam": "Kalimat, tulisan, video, dan foto yang memotivasi",
 "Geométrico": "Geometris",
 "Gerar": "Buat",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Merekam pengingat dan catatan dengan suara serta mendikte teks (🎤) saat Anda minta. Mikrofon hanya aktif saat Anda ketuk, dan audio dikte tidak disimpan.",
 "Guardar e trancar": "Simpan dan kunci",
 "Guardar e trancar?": "Simpan dan kunci?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Simpan di sini apa yang memotivasi Anda: kalimat, tulisan Anda, video, dan foto.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Simpan kata sandi ini baik-baik: tanpa kata sandi ini catatan harian tidak bisa dipulihkan.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Hari ini libur: {f}. Tetap catat?",
 "Humor do mês": "Suasana hati bulan ini",
 "Humor do período": "Suasana hati periode ini",
 "HÁBITOS LIGADOS": "KEBIASAAN TERKAIT",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "Ada item besar di pilihan. Item tersebut hanya bisa dihapus satu per satu, dengan konfirmasi dan kata sandi.",
 "Há um ano": "Setahun lalu",
 "Há um mês": "Sebulan lalu",
 "Hábito": "Kebiasaan",
 "Hábito criado": "Kebiasaan dibuat",
 "Hábitos": "Kebiasaan",
 "Hábitos cumpridos": "Kebiasaan terpenuhi",
 "Hábitos cumpridos: {f} de {n}": "Kebiasaan terpenuhi: {f} dari {n}",
 "Hábitos formados": "Kebiasaan terbentuk",
 "INSPIRAÇÃO": "INSPIRASI",
 "Imagem adicionada": "Gambar ditambahkan",
 "Imagem não encontrada": "Gambar tidak ditemukan",
 "Incrível": "Luar biasa",
 "Informação nutricional": "Informasi gizi",
 "Inserir": "Sisipkan",
 "Inspiração": "Inspirasi",
 "Item para o paciente": "Item untuk pasien",
 "Itens grandes só se excluem um por um.": "Item besar hanya bisa dihapus satu per satu.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Kumpulkan foto dari hal yang ingin Anda alami. Tahan dan seret untuk mengatur.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "TAUTKAN KE IMPIAN DI RENCANA HIDUP (OPSIONAL)",
 "LIGAR A UMA META (OPCIONAL)": "TAUTKAN KE TARGET (OPSIONAL)",
 "LINKS DE VÍDEO": "TAUTAN VIDEO",
 "Lance as notas antes de enviar.": "Isi nilai sebelum mengirim.",
 "Lançamentos arquivados": "Transaksi yang diarsipkan",
 "Legenda (opcional)": "Keterangan (opsional)",
 "Lembrete diário": "Pengingat harian",
 "Lendo o comprovante...": "Membaca bukti pembayaran...",
 "Ler o comprovante com a minha IA": "Baca bukti pembayaran dengan AI saya",
 "Ligado": "Aktif",
 "Ligar um texto de motivação (Inspiração)": "Tautkan teks motivasi (Inspirasi)",
 "Lilás": "Ungu muda",
 "Limpar a folha inteira?": "Bersihkan seluruh kertas?",
 "Linha reta": "Garis lurus",
 "Linhas": "Garis",
 "Link do vídeo (YouTube, Instagram...)": "Tautan video (YouTube, Instagram...)",
 "Lisa": "Polos",
 "Liste os passos do projeto e diga quem faz cada um.": "Tulis langkah-langkah proyek dan siapa yang mengerjakan masing-masing.",
 "Lixeira": "Tempat sampah",
 "Longo prazo": "Jangka panjang",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "TANDAI OTOMATIS DARI KESEHATAN (OPSIONAL)",
 "META OU SONHO LIGADO (OPCIONAL)": "TARGET ATAU IMPIAN TERKAIT (OPSIONAL)",
 "Mais opções": "Opsi lainnya",
 "Mal": "Buruk",
 "Mandar ao paciente pelo WhatsApp": "Kirim ke pasien lewat WhatsApp",
 "Marque o que fez em cada dia": "Tandai yang sudah dikerjakan setiap hari",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Tandai hari kelas di kelas (Edit) agar absensi hanya menampilkan hari-hari tersebut.",
 "Matérias arquivadas": "Mata pelajaran yang diarsipkan",
 "Mensalidade": "Iuran bulanan",
 "Meta de água do Bem-Estar": "Target minum air dari Kesehatan",
 "Metas arquivadas": "Target yang diarsipkan",
 "Metas e sonhos concluídos": "Target dan impian yang tercapai",
 "Metas em andamento": "Target yang sedang berjalan",
 "Metas que avançaram": "Target yang mengalami kemajuan",
 "Metas, objetivos e sonhos, com passos e prazos": "Target, tujuan, dan impian, dengan langkah dan tenggat",
 "Meu Dia": "Hariku",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "Hariku dengan halaman bebas, rencana hidup, kebiasaan, papan impian, roda kehidupan, surat untuk masa depan, dan pencapaian. Dilindungi kata sandi.",
 "Minimalista": "Minimalis",
 "Mostrar as contas antes do vencimento": "Tampilkan pembayaran sebelum jatuh tempo",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Menampilkan tanggal, jam, mata uang, dan hari libur yang sesuai dengan lokasi Anda. Lokasi perkiraan ponsel hanya digunakan saat Anda meminta cuaca hari ini di Catatan Harian, dan tidak disimpan.",
 "Muito bem": "Sangat baik",
 "Muito mal": "Sangat buruk",
 "Mural de fotos dos seus sonhos": "Papan foto impian Anda",
 "Mural, relatório e revisão do mês": "Papan, laporan, dan ulasan bulanan",
 "Médio prazo": "Jangka menengah",
 "N dias cumpridos no mês": "N hari terpenuhi dalam sebulan",
 "N dias seguidos": "N hari berturut-turut",
 "NESTE DIA": "PADA HARI INI",
 "Nada a enviar": "Tidak ada yang bisa dikirim",
 "Nenhum estudo registrado nesta semana.": "Belum ada belajar yang dicatat minggu ini.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Belum ada kebiasaan. Mis.: \"Makan satu buah setiap hari\", \"Minum 2 L air\", \"Tidak melewatkan sarapan\".",
 "Nenhum no período.": "Tidak ada di periode ini.",
 "Nenhuma": "Tidak ada",
 "Nenhuma carta ainda.": "Belum ada surat.",
 "Nenhuma foto ainda.": "Belum ada foto.",
 "Neutras e opacas": "Netral dan redup",
 "Ninguém encontrado no grupo": "Tidak ada yang ditemukan di grup",
 "No computador: {link}": "Di komputer: {link}",
 "No navegador, a senha do diário é pedida sempre.": "Di browser, kata sandi catatan harian selalu diminta.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Di hari terakhir bulan: \"Bagaimana kalau mengulas bulan Anda? ✨\"",
 "Nome da página (opcional)": "Nama halaman (opsional)",
 "Nome de quem faz este passo": "Nama orang yang mengerjakan langkah ini",
 "Nome do vídeo (opcional)": "Nama video (opsional)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Nilai 0 sampai 10 untuk setiap bidang kehidupan",
 "Nota: {a}": "Nilai: {a}",
 "Nova caixa": "Kotak baru",
 "Nova carta": "Surat baru",
 "Nova meta, objetivo ou sonho": "Target, tujuan, atau impian baru",
 "Nova senha (6 caracteres ou mais)": "Kata sandi baru (6 karakter atau lebih)",
 "Nova área (ex.: Espiritualidade)": "Bidang baru (mis.: Spiritualitas)",
 "Novo cômodo": "Ruangan baru",
 "Novo hábito": "Kebiasaan baru",
 "Não dá para excluir em grupo": "Tidak bisa dihapus sekaligus",
 "Não enviados": "Belum dikirim",
 "Não estão no grupo (ou com outro nome): {l}": "Tidak ada di grup (atau dengan nama lain): {l}",
 "Não foi possível exportar": "Tidak dapat mengekspor",
 "Não foi possível ouvir agora ({erro}).": "Tidak dapat mendengarkan sekarang ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Tidak meminta kata sandi catatan harian. Ini satu-satunya bagian yang bisa dibagikan.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "Hari ini bukan hari kelas untuk kelas ini. Absensi dicatat sebagai kelas pengganti atau kelas tambahan.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "Aplikasi mengingatkan {n} hari sebelumnya dan pada hari jatuh tempo, pukul 09.00. Bisa diubah di Pengaturan › Tab › Keuangan.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "Cuaca otomatis menggunakan lokasi ponsel. Tanpa izin, cuaca diisi manual di sini.",
 "O conteúdo desta carta não foi encontrado.": "Isi surat ini tidak ditemukan.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "Dikte tersedia di versi baru aplikasi. Perbarui My Planner lewat toko (atau instal APK baru) untuk menggunakan mikrofon.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "Catatan harian meminta kata sandi setiap kali Anda masuk, meskipun aplikasi sudah terbuka kuncinya.",
 "O diário só abre com essa senha, sempre.": "Catatan harian hanya bisa dibuka dengan kata sandi ini, selalu.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "Catatan harian dienkripsi: tanpa kata sandi, tidak ada yang bisa membukanya, termasuk tim dukungan. Jika mau, Anda bisa menghapus catatan harian dan memulai yang baru (Proyek Grup tetap ada).",
 "O que aprendi hoje?": "Apa yang saya pelajari hari ini?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "Apa yang diajarkan bulan ini kepada Anda? Apa yang ingin Anda bawa ke bulan berikutnya?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Yang tidak dicentang hilang dari layar. Datanya tetap tersimpan.",
 "O que foi bom hoje?": "Apa yang baik hari ini?",
 "O que foi excluído nos últimos 30 dias": "Yang dihapus dalam 30 hari terakhir",
 "O que quero melhorar amanhã?": "Apa yang ingin saya perbaiki besok?",
 "O que quero mudar agora": "Yang ingin saya ubah sekarang",
 "O que você escreveu nesta carta vai se perder.": "Yang Anda tulis di surat ini akan hilang.",
 "O que você quer fazer com o arquivo?": "Apa yang ingin Anda lakukan dengan file ini?",
 "Objetivo": "Tujuan",
 "Oculta": "Tersembunyi",
 "Orientação": "Arahan",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Arahan, resep, surat keterangan, dan materi untuk diberikan kepada pasien, dengan file. Hanya yang ada di sini yang dikirim: rekam medis tidak pernah keluar lewat folder ini.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Hari yang halamannya sudah ditulis akan ditandai. Ketuk hari untuk membukanya.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Item akan dihapus permanen dan tidak bisa dipulihkan lagi.",
 "Outra data": "Tanggal lain",
 "Outras moedas": "Mata uang lain",
 "Ouvindo…": "Mendengarkan…",
 "PASSOS": "LANGKAH",
 "PDF com seus dados e assinatura": "PDF dengan data dan tanda tangan Anda",
 "POR DIA": "PER HARI",
 "POR MATÉRIA": "PER MATA PELAJARAN",
 "PROGRESSO": "KEMAJUAN",
 "Paciente: {nome}": "Pasien: {nome}",
 "Para o paciente": "Untuk pasien",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Untuk mengganti cara membuka, masuk ke Catatan Harian dengan kata sandinya lalu kembali ke sini.",
 "Para {nome} de {tempo} depois": "Untuk {nome} {tempo} kemudian",
 "Parar o ditado": "Hentikan dikte",
 "Parcelado": "Cicilan",
 "Partes desta aba": "Bagian tab ini",
 "Passo": "Langkah",
 "Pastas arquivadas": "Folder yang diarsipkan",
 "Pastas arquivadas ({n})": "Folder yang diarsipkan ({n})",
 "Pautada": "Bergaris",
 "Pautada com margem": "Bergaris dengan margin",
 "Pedido de exame": "Permintaan pemeriksaan",
 "Pelo que sou grata hoje?": "Apa yang saya syukuri hari ini?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Izinkan mikrofon dan pengenalan suara untuk My Planner di pengaturan ponsel.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Sesuaikan: jenis, warna, dan tema kertas serta warna bulatan, hanya untuk tab ini",
 "Pontilhada": "Bertitik",
 "Posto": "SPBU",
 "Preenche o clima do Meu Dia pela localização do celular.": "Mengisi cuaca di Hariku berdasarkan lokasi ponsel.",
 "Preencher pela foto do comprovante": "Isi dari foto bukti pembayaran",
 "Primeira vez neste aparelho: digite a senha do diário.": "Pertama kali di perangkat ini: masukkan kata sandi catatan harian.",
 "Projeto": "Proyek",
 "Projeto de Vida": "Rencana Hidup",
 "Projetos com amigos e família (compartilhados)": "Proyek dengan teman dan keluarga (dibagikan)",
 "Projetos em Grupo": "Proyek Grup",
 "Proprietário / Locador": "Pemilik / Penyewa",
 "Páginas arquivadas": "Halaman yang diarsipkan",
 "Páginas desta aba": "Halaman di tab ini",
 "QUANDO ELA ABRE": "KAPAN SURAT DIBUKA",
 "Qua": "Rab",
 "Quadriculada": "Kotak-kotak",
 "Quadro dos Sonhos": "Papan Impian",
 "Quais partes você vai usar?": "Bagian mana yang akan Anda gunakan?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Saat Anda mencapai target atau membentuk kebiasaan, hal itu muncul di sini untuk dirayakan. 🎉",
 "Quanto você pagou?": "Berapa yang Anda bayar?",
 "Quanto você recebeu?": "Berapa yang Anda terima?",
 "Que tal revisar o seu mês? ✨": "Bagaimana kalau mengulas bulan Anda? ✨",
 "Quem faz": "Yang mengerjakan",
 "Quem fez o meu dia melhor?": "Siapa yang membuat hari saya lebih baik?",
 "Quer guardar o comprovante agora?": "Simpan bukti pembayaran sekarang?",
 "Qui": "Kam",
 "REFLEXÃO DO MÊS": "REFLEKSI BULAN INI",
 "Recebeu {v} a mais": "Menerima {v} lebih banyak",
 "Recebeu {v} a menos": "Menerima {v} lebih sedikit",
 "Receita médica": "Resep dokter",
 "Receitas médicas": "Resep dokter",
 "Recolher": "Ciutkan",
 "Refeições arquivadas": "Waktu makan yang diarsipkan",
 "Refeições do cronograma feitas (Bem-Estar)": "Waktu makan di jadwal selesai (Kesehatan)",
 "Referente a (ex.: material, passeio, inscrição)": "Untuk (mis.: materi, karyawisata, pendaftaran)",
 "Registrar": "Catat",
 "Relacionamentos": "Hubungan",
 "Relatório de estudos": "Laporan belajar",
 "Relatório de realizações": "Laporan pencapaian",
 "Relatório em PDF": "Laporan PDF",
 "Renomear, adicionar ou tirar áreas": "Ganti nama, tambah, atau hapus bidang",
 "Reposição": "Kelas pengganti",
 "Restaurado": "Dipulihkan",
 "Resumida": "Ringkas",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Ringkas: hanya satu baris dengan total. Lengkap: menampilkan item hari ini. Tersembunyi: tidak muncul. Tidak ada isi tab ini yang otomatis menjadi tugas.",
 "Resumo de {nome}": "Ringkasan {nome}",
 "Resumo do dia": "Ringkasan hari ini",
 "Retângulo": "Persegi panjang",
 "Revisar antes": "Tinjau dulu",
 "Revisão do mês": "Ulasan bulanan",
 "Roda da Vida": "Roda Kehidupan",
 "Rosa": "Merah muda",
 "Sair sem guardar?": "Keluar tanpa menyimpan?",
 "Salvar avaliação de hoje": "Simpan penilaian hari ini",
 "Salvar ou enviar": "Simpan atau kirim",
 "Seg": "Sen",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Tahan dan seret folder untuk mengubah urutan. Geser ke kiri untuk mengarsipkan.",
 "Sem chamada neste dia: cobra todos os alunos.": "Tidak ada absensi hari ini: semua siswa ditagih.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Bingung mau menulis apa? Ketuk salah satu pertanyaan:",
 "Sem registros de humor.": "Belum ada catatan suasana hati.",
 "Sem tema": "Tanpa tema",
 "Semana de {d}": "Minggu {d}",
 "Senha atual do diário": "Kata sandi catatan harian saat ini",
 "Senha do diário": "Kata sandi catatan harian",
 "Senha do diário incorreta.": "Kata sandi catatan harian salah.",
 "Senha do diário trocada": "Kata sandi catatan harian diganti",
 "Senha própria só do diário": "Kata sandi khusus catatan harian",
 "Sequência dos hábitos": "Rangkaian kebiasaan",
 "Seta": "Panah",
 "Seu diário, só seu": "Catatan harian Anda, hanya milik Anda",
 "Seu texto de motivação": "Teks motivasi Anda",
 "Sex": "Jum",
 "Sonho": "Impian",
 "Suplementos arquivados": "Suplemen yang diarsipkan",
 "Sáb": "Sab",
 "Só abre com a senha do diário.": "Hanya bisa dibuka dengan kata sandi catatan harian.",
 "TEMA DECORATIVO": "TEMA DEKORASI",
 "TIPO DE FOLHA": "JENIS KERTAS",
 "Tarefas arquivadas": "Tugas yang diarsipkan",
 "Ter": "Sel",
 "Texto para o paciente": "Teks untuk pasien",
 "Tipo, cor e tema da folha": "Jenis, warna, dan tema kertas",
 "Tirar a área \"{a}\"?": "Hapus bidang \"{a}\"?",
 "Tirar da frase do dia": "Hapus dari kalimat hari ini",
 "Tirar do arquivo": "Keluarkan dari arsip",
 "Tirar esta foto do quadro?": "Hapus foto ini dari papan?",
 "Tirar esta pergunta?": "Hapus pertanyaan ini?",
 "Tirar este vídeo?": "Hapus video ini?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Setiap hari pukul {h}: \"Bagaimana hari Anda? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Semua siswa sudah punya tagihan dengan keterangan ini.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Ketuk lagi untuk \"Lainnya\" (diizinkan, surat keterangan...): tidak dihitung sebagai absen maupun kelas.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Ketuk lingkaran untuk menandai yang sudah Anda lakukan hari ini. Kebiasaan tidak otomatis masuk ke My Planner: gunakan Kirim, di menu ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Ketuk hari untuk menandai atau menghapus tanda.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Ketuk bulatan untuk mengganti warna. Di halaman, menahan bulatan juga melakukan hal yang sama.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Ketuk untuk membuka. Geser ke kiri untuk mengarsipkan atau menduplikat, atau ke kanan untuk menghapus.",
 "Treino do dia feito (Bem-Estar)": "Latihan hari ini selesai (Kesehatan)",
 "Treinos arquivados": "Latihan yang diarsipkan",
 "Trocar a senha do diário": "Ganti kata sandi catatan harian",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Semua yang Anda tulis di catatan harian dienkripsi di perangkat ini sebelum masuk ke akun Anda. Tidak ada orang lain yang bisa membacanya, termasuk tim dukungan.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Semua yang Anda hapus disimpan di sini selama 30 hari. Setelah itu dihapus permanen.",
 "Título (ex.: Ter uma boa alimentação)": "Judul (mis.: Makan dengan sehat)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Satu tagihan satuan untuk setiap {n} siswa. Untuk menagih satu siswa saja, ketuk +.",
 "Uma senha própria, só do diário": "Kata sandi khusus, hanya untuk catatan harian",
 "Usar a senha do diário": "Gunakan kata sandi catatan harian",
 "Usar como frase do dia": "Gunakan sebagai kalimat hari ini",
 "Usar este valor": "Gunakan nominal ini",
 "Usar o padrão do app": "Gunakan bawaan aplikasi",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "Berlaku untuk nominal di semua tab (Keuangan, sewa, iuran bulanan...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "Berlaku untuk semua halaman tulisan (Studi, Catatan, Catatan Harian, Dokumen...). Setiap tab bisa punya bawaan sendiri di Pengaturan › Tab, dan setiap halaman bisa mengganti kertas di ⋮ › Kertas.",
 "Valor da aula extra (por aluno)": "Biaya kelas tambahan (per siswa)",
 "Valor por aluno": "Biaya per siswa",
 "Valor previsto: {v}": "Nominal perkiraan: {v}",
 "Vencimento: {d}": "Jatuh tempo: {d}",
 "Ver o comprovante": "Lihat bukti pembayaran",
 "Verde": "Hijau",
 "Visualizar": "Pratinjau",
 "Você está como convidado": "Anda sebagai tamu",
 "Voltar a acompanhar este hábito": "Pantau kebiasaan ini lagi",
 "Voltar ao início da folha": "Kembali ke awal kertas",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Kembali ke bawaan awal (kertas bergaris; hitam, biru, merah, dan hijau)",
 "Voltar para a nova avaliação": "Kembali ke penilaian baru",
 "Vídeos": "Video",
 "X vezes por semana": "X kali per minggu",
 "abre em {n} dias": "dibuka dalam {n} hari",
 "agradável": "nyaman",
 "arquivo": "arsip",
 "aula extra": "kelas tambahan",
 "calor": "panas",
 "chuva": "hujan",
 "concluído": "selesai",
 "céu limpo": "cerah",
 "de {n} planejados": "dari {n} yang direncanakan",
 "dentro de {p}": "dalam {p}",
 "enviado em {d}": "dikirim pada {d}",
 "estudados na semana": "dipelajari minggu ini",
 "excluído em {d}": "dihapus pada {d}",
 "falta 1 dia": "tinggal 1 hari",
 "faltam {n} dias": "tinggal {n} hari",
 "feito {dur} na semana": "selesai {dur} minggu ini",
 "fresco": "sejuk",
 "frio": "dingin",
 "garoa": "gerimis",
 "hoje não está planejado": "hari ini tidak direncanakan",
 "hábito formado ✨": "kebiasaan terbentuk ✨",
 "incorreta": "salah",
 "neblina": "berkabut",
 "neve": "salju",
 "nublado": "berawan",
 "não enviado": "belum dikirim",
 "parcela {k}/{n}": "cicilan {k}/{n}",
 "passou há {n} dias": "lewat {n} hari",
 "pelo Bem-Estar": "dari Kesehatan",
 "poucas nuvens": "sedikit berawan",
 "reposição": "kelas pengganti",
 "sai de vez em {n} dia(s)": "dihapus permanen dalam {n} hari",
 "sem registros": "belum ada catatan",
 "tempestade": "badai",
 "tracejado: {d}": "putus-putus: {d}",
 "ver mais": "lihat lebih banyak",
 "ver menos": "lihat lebih sedikit",
 "{aluno}: {n} de {max}": "{aluno}: {n} dari {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} adalah hari libur: {f}. Tetap catat?",
 "{f} de {n} passos feitos": "{f} dari {n} langkah selesai",
 "{f}/{n} passos": "{f}/{n} langkah",
 "{nome} daqui a 1 ano": "{nome} 1 tahun lagi",
 "{nome} daqui a 10 anos": "{nome} 10 tahun lagi",
 "{nome} daqui a 6 meses": "{nome} 6 bulan lagi",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} siswa hanya menerima nilai \"{a}\" miliknya sendiri.",
 "{n} aluno(s) receberam a nota.": "{n} siswa telah menerima nilai.",
 "{n} aluno(s) · {v} cada": "{n} siswa · {v} per orang",
 "{n} anos": "{n} tahun",
 "{n} dia(s) antes": "{n} hari sebelumnya",
 "{n} dia(s) cumprido(s) no mês": "{n} hari terpenuhi dalam sebulan",
 "{n} dia(s) registrado(s) · média {e}": "{n} hari dicatat · rata-rata {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} hari dicatat, rata-rata {m} dari 6",
 "{n} dia(s) seguido(s)": "{n} hari berturut-turut",
 "{n} dispensada(s) hoje": "{n} dilewati hari ini",
 "{n} meses": "{n} bulan",
 "{n} outro(s)": "{n} lainnya",
 "{n} selecionado(s)": "{n} dipilih",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} tugas selesai di My Planner",
 "{n} vez(es) por semana": "{n} kali per minggu",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Air: {a} dari {m} ml",
 "ÚLTIMAS 8 SEMANAS": "8 MINGGU TERAKHIR",
 "Última parcela em {d}": "Cicilan terakhir pada {d}",
 "é hoje!": "hari ini!",
 "A mesma do app": "Sama dengan aplikasi",
 "Abrir com o código": "Buka dengan kode",
 "Ainda não criado": "Belum dibuat",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "Saat dibuat, aplikasi menampilkan kode pemulihan untuk Anda simpan.",
 "Apagar o diário e começar de novo": "Hapus catatan harian dan mulai dari awal",
 "Biometria ou código do dispositivo": "Biometrik atau kode perangkat",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biometrik, PIN perangkat, atau kata sandi aplikasi. Tidak perlu membuat kata sandi lain.",
 "Bloquear o app": "Kunci aplikasi",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Daftarkan sidik jari, wajah, atau kode kunci layar di perangkat untuk menggunakannya.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Jika biometrik aktif, biometrik muncul lebih dulu. Jika gagal, jendela yang sama menawarkan kode/PIN/pola perangkat; kata sandi aplikasi tetap berlaku.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Dengan kode ini Anda bisa memulihkan catatan harian jika lupa kata sandi atau ganti perangkat.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Dengan kode ini Anda bisa memulihkan catatan harian jika lupa kata sandi atau ganti perangkat. Simpan di tempat aman dan jangan tunjukkan kepada siapa pun.",
 "Como funciona a Roda da Vida": "Cara kerja Roda Kehidupan",
 "Como o diário abre": "Cara membuka catatan harian",
 "Crie a senha que vai abrir o diário.": "Buat kata sandi untuk membuka catatan harian.",
 "Crie o PIN do diário (4 a 6 números)": "Buat PIN catatan harian (4 sampai 6 angka)",
 "Crie o diário de novo para começar.": "Buat catatan harian lagi untuk memulai.",
 "Código aceito. Crie uma senha nova para o diário.": "Kode diterima. Buat kata sandi baru untuk catatan harian.",
 "Código de recuperação": "Kode pemulihan",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Kode pemulihan (mis.: ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Kode pemulihan salah.",
 "Cômodos": "Ruangan",
 "Depois de 1 minuto": "Setelah 1 menit",
 "Depois de {n} minutos": "Setelah {n} menit",
 "Desenhe o padrão do diário": "Gambar pola catatan harian",
 "Dias no mês": "Hari dalam bulan",
 "Dias seguidos": "Hari berturut-turut",
 "Digite o seu PIN": "Masukkan PIN Anda",
 "Diário ainda não criado": "Catatan harian belum dibuat",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Beri nilai 0 sampai 10 untuk perasaan Anda hari ini di setiap bidang kehidupan. Gambar menunjukkan di mana hidup Anda seimbang dan di mana perlu perhatian. Simpan penilaian dan ulangi secara berkala (misalnya setiap bulan) untuk membandingkan dan melihat perkembangan Anda. Anda bisa mengganti nama, menambah, atau menghapus bidang.",
 "Entre na aba Diário para criar o seu diário.": "Buka tab Catatan Harian untuk membuat catatan harian Anda.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Masuk ke Catatan Harian (dengan kata sandinya atau buka kunci aplikasi) lalu kembali ke sini.",
 "Esconder a senha": "Sembunyikan kata sandi",
 "Gerar novo código": "Buat kode baru",
 "Gerar um código de recuperação novo?": "Buat kode pemulihan baru?",
 "Guarde este código": "Simpan kode ini",
 "Já guardei": "Sudah saya simpan",
 "Ligar um hábito que já existe": "Tautkan kebiasaan yang sudah ada",
 "Mostrar a senha": "Tampilkan kata sandi",
 "Mudar como o diário abre": "Ubah cara membuka catatan harian",
 "My Planner · Código de recuperação do Diário": "My Planner · Kode pemulihan Catatan Harian",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Tidak bisa dibuka dengan kunci perangkat ini. Gunakan kata sandi catatan harian atau kode pemulihan.",
 "O Caps Lock parece estar ligado.": "Caps Lock sepertinya aktif.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN hanya disimpan di perangkat ini, dalam keadaan terlindungi. Kata sandi tetap berlaku jika Anda lupa PIN.",
 "O PIN precisa ter de 4 a 6 números.": "PIN harus 4 sampai 6 angka.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "Kode sebelumnya tidak berlaku lagi. Demi keamanan, kode tidak disimpan di aplikasi: hanya bisa dilihat saat dibuat.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "Kode tidak disimpan di tempat mana pun yang bisa dilihat tim dukungan. Tanpa kata sandi dan kode, catatan harian tidak bisa dipulihkan.",
 "O diário agora abre só com a senha dele.": "Catatan harian sekarang hanya terbuka dengan kata sandinya sendiri.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "Pengenalan wajah di perangkat ini tidak bisa digunakan oleh aplikasi. Gunakan sidik jari atau kode/PIN perangkat.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "Waktu dihitung sejak aplikasi keluar dari layar (aplikasi lain, layar utama, atau layar mati). Menarik notifikasi, jendela biometrik, permintaan izin, atau memilih foto atau file tidak dihitung.",
 "Os PINs não conferem.": "PIN tidak cocok.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN (4 sampai 6 angka)",
 "PIN (só números, 4 a 6)": "PIN (hanya angka, 4 sampai 6)",
 "PIN do diário": "PIN catatan harian",
 "PIN incorreto": "PIN salah",
 "PIN salvo.": "PIN disimpan.",
 "Padrão do app": "Default aplikasi",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Untuk menghapus, konfirmasi dengan kata sandi aplikasi, biometrik, atau PIN perangkat. Ini menghapus Hariku, target, kebiasaan, surat, dan foto di catatan harian. Proyek Grup tetap ada.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Untuk melanjutkan, masukkan kata sandi aplikasi atau gunakan biometrik/kode perangkat.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Untuk memulihkan catatan harian jika lupa kata sandi atau ganti perangkat.",
 "Pastas": "Folder",
 "Pedir a senha de novo": "Minta kata sandi lagi",
 "Personalizada": "Kustom",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Pertama kali di perangkat ini: masukkan kata sandi catatan harian atau gunakan kode pemulihan.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Pertama kali di perangkat ini: masukkan kode pemulihan catatan harian.",
 "Reconhecimento de rosto": "Pengenalan wajah",
 "Repita o PIN": "Ulangi PIN",
 "Salvar a senha nova": "Simpan kata sandi baru",
 "Salvar em arquivo / no Drive": "Simpan ke file / Drive",
 "Salvar o código de recuperação": "Simpan kode pemulihan",
 "Senha (letras e números)": "Kata sandi (huruf dan angka)",
 "Senha do app": "Kata sandi aplikasi",
 "Senha nova do diário": "Kata sandi baru catatan harian",
 "Senha própria": "Kata sandi tersendiri",
 "Senha própria do diário": "Kata sandi tersendiri catatan harian",
 "Tarefas": "Tugas",
 "Trocar o PIN": "Ganti PIN",
 "Usar a senha": "Gunakan kata sandi",
 "Usar o PIN": "Gunakan PIN",
 "Usar o código de recuperação": "Gunakan kode pemulihan",
 "Usar o desbloqueio do app": "Gunakan buka kunci aplikasi",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Gunakan biometrik atau kode/PIN/pola perangkat.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Gunakan kode pemulihan yang muncul saat catatan harian dibuat. Tanpa kata sandi dan kode, tidak ada yang bisa membuka catatan harian, termasuk tim dukungan.",
 "Voltar a usar só a senha?": "Kembali hanya memakai kata sandi?",
 "incorreto": "salah",
 "1 h": "1 jam",
 "12 horas (2:30 PM)": "12 jam (2:30 PM)",
 "15 min": "15 mnt",
 "24 horas (14:30)": "24 jam (14:30)",
 "30 min": "30 mnt",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Tempat sampah berisi item besar. Konfirmasi dengan kata sandi aplikasi, biometrik, atau kode perangkat.",
 "A semana começa na": "Minggu dimulai pada",
 "Abra o Diário primeiro": "Buka Catatan harian dulu",
 "Abrir configurações do celular": "Buka pengaturan ponsel",
 "Agenda e mapas": "Kalender dan peta",
 "Agora: {m}": "Sekarang: {m}",
 "Ajuda e sobre": "Bantuan dan tentang",
 "Alarme (som)": "Alarm (suara)",
 "Alarme ou vibração das pausas": "Alarm atau getaran jeda",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Menghapus akun dan semua data di cloud dan di perangkat ini secara permanen. Meminta kata sandi Anda terlebih dahulu.",
 "Apagar todas ({n})": "Hapus semua ({n})",
 "Apagar {n} selecionada(s)": "Hapus {n} yang dipilih",
 "Aparência": "Tampilan",
 "App das rotas": "Aplikasi rute",
 "Ardósia": "Batu tulis",
 "Arrastar para a direita": "Geser ke kanan",
 "Arrastar para a esquerda": "Geser ke kiri",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Tagihan dari Keuangan muncul di My Planner sejauh ini sebelumnya.",
 "Atualizações e sobre": "Pembaruan dan tentang",
 "Avisar antes do vencimento": "Ingatkan sebelum jatuh tempo",
 "Aviso marcado": "Pengingat diatur",
 "Aviso no começo e no fim de cada pausa": "Pemberitahuan di awal dan akhir setiap jeda",
 "Avisos desta aba": "Pemberitahuan tab ini",
 "Avisos e alarmes": "Pemberitahuan dan alarm",
 "Avisos silenciosos": "Pemberitahuan senyap",
 "Avisos: som e vibração": "Pemberitahuan: suara dan getar",
 "Avisos: só som": "Pemberitahuan: hanya suara",
 "Avisos: só vibração": "Pemberitahuan: hanya getar",
 "Azul elétrico": "Biru elektrik",
 "Azul-aço": "Biru baja",
 "Azul-bebê": "Biru muda",
 "Azul-marinho": "Biru dongker",
 "Baixar meus dados": "Unduh data saya",
 "Baixar todos os meus dados": "Unduh semua data saya",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Unduh semua data saya dan hapus akun (LGPD)",
 "Biometria": "Biometrik",
 "Bissexual": "Biseksual",
 "Brilhante": "Cerah",
 "Buscar abas": "Cari tab",
 "Buscar nos ajustes": "Cari di pengaturan",
 "Cancelar aviso": "Batalkan pengingat",
 "Cinza-chumbo": "Abu-abu arang",
 "Cofre": "Brankas",
 "Coloque pelo menos uma matéria.": "Tambahkan setidaknya satu mata pelajaran.",
 "Como usar": "Cara menggunakan",
 "Conexões": "Koneksi",
 "Cor da aba": "Warna tab",
 "Cor de destaque": "Warna aksen",
 "Crie uma matéria primeiro": "Buat mata pelajaran dulu",
 "Cítrico": "Sitrus",
 "Cópia de segurança em arquivo": "Cadangan dalam file",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Data pasien dan rekam medis. Konfirmasi dengan kata sandi aplikasi, biometrik, atau kode perangkat.",
 "Desligadas": "Mati",
 "Digite a senha da sua conta para confirmar.": "Masukkan kata sandi akun Anda untuk mengonfirmasi.",
 "Duração padrão de uma tarefa nova": "Durasi default tugas baru",
 "Editar sessão": "Edit sesi",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Tugas ini berulang tanpa tanggal akhir: kemunculan ditampilkan hingga {data}. Jika semua dicentang, seluruh tugas akan dihapus.",
 "Em atividade": "Sedang berjalan",
 "Em pausa": "Sedang jeda",
 "Emoji da pausa": "Emoji jeda",
 "Encerrar": "Akhiri",
 "Encerrar a sessão?": "Akhiri sesi?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Masuk ke mode pilih, untuk memilih banyak item sekaligus.",
 "Escolha um horário no futuro.": "Pilih waktu di masa depan.",
 "Escolher a matéria": "Pilih mata pelajaran",
 "Esconde os valores em dinheiro (R$ •••)": "Menyembunyikan nilai uang (R$ •••)",
 "Esconder o CPF": "Sembunyikan CPF",
 "Esconder os valores": "Sembunyikan nilai",
 "Esta e as próximas": "Ini dan berikutnya",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Tugas ini berulang. Terapkan perubahan ke mana?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Item ini berisi banyak hal. Konfirmasi dengan kata sandi aplikasi, biometrik, atau kode perangkat.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Menghapus item (meminta konfirmasi). Setelah itu bisa dibatalkan atau dipulihkan dari Tempat sampah.",
 "Excluir minha conta": "Hapus akun saya",
 "Ficha protegida": "Data terlindungi",
 "Formato da hora": "Format waktu",
 "Foto do Quadro dos Sonhos": "Foto Papan Impian",
 "Geral": "Umum",
 "Gestos": "Gestur",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive, dan file cadangan",
 "Grafite": "Grafit",
 "Guardar em": "Simpan di",
 "Hábito do Diário": "Kebiasaan Catatan harian",
 "Idioma e moeda": "Bahasa dan mata uang",
 "Inspiração do Diário": "Inspirasi Catatan harian",
 "Intenso": "Intens",
 "Item arquivado": "Item diarsipkan",
 "Item excluído": "Item dihapus",
 "Lavanda": "Lavender",
 "Ligadas": "Nyala",
 "Limite de energia": "Batas energi",
 "Lésbica": "Lesbian",
 "Marque as vezes que vão ser apagadas.": "Centang kemunculan yang akan dihapus.",
 "Matéria": "Mata pelajaran",
 "Me avise em…": "Ingatkan saya dalam…",
 "Menta": "Mint",
 "Menu ⋮": "Menu ⋮",
 "Meta do Diário": "Target Catatan harian",
 "Modo discreto": "Mode rahasia",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Susun sesi sekali (mata pelajaran, waktu masing-masing, dan jeda) lalu ulangi di hari lain dengan mengetuk Mulai. Waktu belajar otomatis masuk ke target.",
 "Mostra Arquivar e Duplicar.": "Menampilkan Arsipkan dan Duplikat.",
 "Mostrar feriados no topo": "Tampilkan hari libur di atas",
 "Mostrar os valores": "Tampilkan nilai",
 "Muda a ordem dos itens.": "Mengubah urutan item.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Hanya mengubah warna My Planner. Warna aksen aplikasi ada di Pengaturan > Tampilan. Setiap tugas bisa punya warna sendiri di detailnya.",
 "Nada encontrado nos ajustes.": "Tidak ada yang ditemukan di pengaturan.",
 "Nenhuma sessão salva ainda.": "Belum ada sesi yang disimpan.",
 "Neon": "Neon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "Pada jam ini aplikasi tidak berbunyi atau bergetar. Pemberitahuan tetap masuk tanpa suara.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "Di menu ⋮ item apa pun: ponsel memberi tahu pada waktu yang dipilih, tanpa membuat tugas di My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Nama (mis.: Sesi S2)",
 "Nova sessão": "Sesi baru",
 "Nuvem e cópias de segurança": "Cloud dan cadangan",
 "Não perturbe": "Jangan ganggu",
 "Não perturbe {de}–{ate}": "Jangan ganggu {de}–{ate}",
 "Não-binário": "Non-biner",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "Tombol 🎉 Hari libur di bagian atas My Planner. Negara dan daftar hari libur ada di Pengaturan > Hari libur.",
 "O celular avisa às {h}.": "Ponsel akan memberi tahu pukul {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Yang dihapus dari Catatan harian tetap terenkripsi di tempat sampah. Masuk ke Catatan harian lalu kembali ke sini untuk memulihkan.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Yang dihapus tetap di Tempat sampah selama 30 hari. Masukkan kata sandi akun Anda untuk mengonfirmasi.",
 "O que saiu fica na Lixeira por 30 dias.": "Yang dihapus tetap di Tempat sampah selama 30 hari.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "Tema mengubah warna tab, warna aksen, dan sentuhan ringan pada latar, di mode terang dan gelap. Untuk mengganti warna satu tab saja, buka Pengaturan > Tab.",
 "O tempo estudado até agora entra na meta.": "Waktu belajar sejauh ini akan masuk ke target.",
 "Oliva": "Zaitun",
 "Orgulho": "Pride",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Pemberitahuan berfungsi di aplikasi yang terpasang, dengan notifikasi aktif.",
 "Os gestos do app": "Gestur aplikasi",
 "Outro (escolher a hora)": "Lainnya (pilih waktu)",
 "Pansexual": "Panseksual",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Untuk mengaktifkan, gunakan aplikasi di ponsel (Pengaturan › Kalender dan peta › Google Kalender). Setelah itu, semuanya juga muncul di sini.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Agar tidak ditanya lagi, pilih aplikasi di Pengaturan › Kalender dan peta.",
 "Pausa": "Jeda",
 "Petróleo": "Biru petrol",
 "Pink elétrico": "Pink elektrik",
 "Preto total": "Hitam pekat",
 "Progresso": "Progres",
 "Pêssego": "Persik",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Berapa hari sebelumnya tagihan muncul diatur di Pengaturan > Pemberitahuan dan alarm.",
 "Rosa-chá": "Merah muda pudar",
 "Roxo-profundo": "Ungu tua",
 "Segurança e dados": "Keamanan dan data",
 "Segurar e arrastar": "Tahan dan seret",
 "Segurar e soltar": "Tahan dan lepas",
 "Selecionar todas": "Pilih semua",
 "Semana começa na {dia}": "Minggu dimulai pada {dia}",
 "Sessão de estudo": "Sesi belajar",
 "Sessão encerrada": "Sesi berakhir",
 "Sessão pausada": "Sesi dijeda",
 "Som e vibração": "Suara dan getar",
 "Suave": "Lembut",
 "Só esta semana": "Hanya minggu ini",
 "Só hoje": "Hanya hari ini",
 "Só neste dia ({data})": "Hanya pada hari ini ({data})",
 "Tamanho das caixas": "Ukuran kotak",
 "Tamanho do texto": "Ukuran teks",
 "Tarefa nova": "Tugas baru",
 "Tela inicial": "Layar utama",
 "Tema e cor de destaque": "Tema dan warna aksen",
 "Testar alerta": "Uji peringatan",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Uji peringatan, \"Jangan ganggu\", dan pengaturan ponsel ada di Pengaturan > Pemberitahuan dan alarm.",
 "Testar e conferir": "Uji dan periksa",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Semua opsi item: edit, pindahkan, bagikan, arsipkan, hapus...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Ketuk salah satu warna tema {tema} untuk dipakai pada tombol, tombol +, dan item yang dipilih.",
 "Total: {dur}": "Total: {dur}",
 "Tropical": "Tropis",
 "Turquesa": "Pirus",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Satu file berisi semua data My Planner Anda, untuk disimpan atau dibawa ke tempat lain (portabilitas, LGPD).",
 "Usar no computador, pelo navegador": "Gunakan di komputer, lewat browser",
 "Usar o padrão": "Gunakan default",
 "Usar o padrão ({emoji})": "Gunakan default ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Gunakan aplikasi di ponsel untuk mengunduh file.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "Berlaku untuk semua tab. Setiap tab bisa punya pengaturannya sendiri di Pengaturan > Tab.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "Berlaku untuk tugas dengan jeda. Setiap tugas bisa mengubah alarm dan emoji di detailnya sendiri.",
 "Ver lista": "Lihat daftar",
 "Ver o CPF inteiro": "Lihat CPF lengkap",
 "Verde-floresta": "Hijau hutan",
 "Verde-água": "Hijau air",
 "Vibração": "Getar",
 "Vinho": "Merah anggur",
 "Você pediu para ser avisado agora.": "Anda meminta diberi tahu sekarang.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Anda dapat: memastikan apakah kami memproses data Anda, mengakses, memperbaiki, meminta portabilitas (unduh data Anda di Pengaturan > Data saya), meminta penghapusan, mengetahui dengan siapa kami berbagi, mencabut persetujuan, dan mengadu ke ANPD.",
 "Voltar ao filtro": "Kembali ke filter",
 "Voltar à lista": "Kembali ke daftar",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Buka Pengaturan › My Planner Web dan ketuk \"Hubungkan browser\".",
 "atividade {n} de {total}": "aktivitas {n} dari {total}",
 "matéria {n} de {t}": "mata pelajaran {n} dari {t}",
 "padrão": "default",
 "pausa em {n} min": "jeda dalam {n} mnt",
 "pausa {n} de {total}": "jeda {n} dari {total}",
 "termina em {n} min": "selesai dalam {n} mnt",
 "todas as vezes": "semua kemunculan",
 "troca em {n} min": "ganti dalam {n} mnt",
 "volta em {n} min": "kembali dalam {n} mnt",
 "{nome} · {n} dia(s)": "{nome} · {n} hari",
 "{n} de {total} vezes": "{n} dari {total} kali",
 "{n} itens arquivados": "{n} item diarsipkan",
 "{n} itens excluídos": "{n} item dihapus",
 "{n} marcada(s)": "{n} dicentang",
 "{n} vezes": "{n} kali",
 "{rotulo}: {feito} min / {total}": "{rotulo}: {feito} mnt / {total}",
 "📔 Diário": "📔 Catatan harian",
 "Agendados": "Terjadwal",
 "Atrasado": "Terlambat",
 "Atrasado: {v}": "Terlambat: {v}",
 "Atualizar o a receber": "Perbarui piutang",
 "Até (fim do contrato, se houver)": "Sampai (akhir kontrak, jika ada)",
 "Clínica": "Klinik",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Menghitung setiap hari dengan absensi yang sudah diisi atau rencana pelajaran yang ditandai \"Kelas selesai\".",
 "Data do recebimento": "Tanggal diterima",
 "Data prevista do pagamento": "Perkiraan tanggal pembayaran",
 "Desmarcar como recebido": "Batalkan tanda diterima",
 "Dia do pagamento": "Tanggal pembayaran",
 "Diferença: {v} (juros/multa)": "Selisih: {v} (bunga/denda)",
 "Diferença: {v} (taxas/descontos)": "Selisih: {v} (biaya/potongan)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Sekolah, universitas, dan kursus yang membayar Anda. Dengan gaji tetap, aplikasi membuat piutang setiap bulan; per jam pelajaran, aplikasi menjumlahkan kelas yang diajar di rombel yang terhubung ke institusi.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Pilih jenis pembayaran (Edit) agar aplikasi menghitung yang harus Anda terima.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Nilai ini berasal dari bagian \"Tempat kerja saya\" di tab {aba}. Tandai sebagai diterima di sini atau buka tab untuk melihat institusinya.",
 "Ex.: Colégio Estadual, Universidade Federal": "Contoh: SMA Negeri 1, Universitas Negeri",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Contoh: RS Umum Daerah, Klinik Sehat",
 "Ex.: Salário de outubro, 13º, férias": "Contoh: Gaji Oktober, THR, cuti",
 "Feitos": "Selesai",
 "Horas-aula de cada aula": "Jam pelajaran per kelas",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Rumah sakit dan klinik yang membayar Anda. Dengan gaji tetap, aplikasi membuat piutang setiap bulan; per shift atau layanan, tandai yang sudah selesai dan aplikasi menghitungnya.",
 "Hospital": "Rumah sakit",
 "Instituição": "Institusi",
 "Instituição (Onde trabalho)": "Institusi (Tempat kerja saya)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Hubungkan kelas ke institusi ini (di kelas, Edit › Institusi) agar aplikasi menjumlahkan kelas yang diajar.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Tandai setiap shift atau layanan sebagai selesai: aplikasi menjumlahkan dan menghitung nilai bulan ini.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Tandai setiap shift atau layanan yang selesai di institusi ini. Aplikasi menjumlahkan dan menghitung nilai yang akan diterima bulan ini.",
 "Nome da instituição": "Nama institusi",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Yang harus dibayar institusi kepada Anda, bulan demi bulan. Tandai sebagai diterima saat uang masuk: ikut tercatat di tab Keuangan.",
 "Onde trabalho": "Tempat kerja saya",
 "Plantão": "Shift",
 "Plantão ou atendimento": "Shift atau layanan",
 "Plantões e atendimentos": "Shift dan layanan",
 "Por atendimento ou procedimento": "Per layanan atau tindakan",
 "Por hora-aula": "Per jam pelajaran",
 "Por plantão": "Per shift",
 "Previsto: {v}": "Perkiraan: {v}",
 "Previsão do mês: {v}": "Perkiraan bulan ini: {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Jumlah (kelas, shift, atau layanan)",
 "Recebe no mês seguinte ao trabalhado": "Dibayar bulan berikutnya setelah bekerja",
 "Receber: {t}": "Terima: {t}",
 "Recebimentos": "Penerimaan",
 "Salário": "Gaji",
 "Salário (valor do mês)": "Gaji (nilai bulanan)",
 "Salário fixo": "Gaji tetap",
 "Telefone (RH ou financeiro)": "Telepon (HRD atau keuangan)",
 "Tipo de pagamento": "Jenis pembayaran",
 "Universidade": "Universitas",
 "Valor da hora-aula": "Nilai per jam pelajaran",
 "Valor de cada um (se for diferente)": "Nilai masing-masing (jika berbeda)",
 "Valor do plantão": "Nilai per shift",
 "Valor por atendimento ou procedimento": "Nilai per layanan atau tindakan",
 "Valor previsto": "Nilai perkiraan",
 "feito": "selesai",
 "recebido em {d}": "diterima pada {d}",
 "{n} aula(s) dada(s)": "{n} kelas diajar",
 "{n} hora(s)-aula": "{n} jam pelajaran",
 "{n} plantão(ões)": "{n} shift",
 "Abas do My Planner Anne": "Tab My Planner Anne",
 "Acesso ao Não perturbe": "Akses Jangan Ganggu",
 "Alarme dos remédios (mesmo no silencioso)": "Alarm obat (bahkan saat senyap)",
 "Algodão-doce": "Gulali",
 "Aplicar tema": "Terapkan tema",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Warna khas setiap tema: bunga merah muda, daun hijau, langit biru...",
 "Assim ficam as letras no app.": "Seperti inilah tampilan huruf di aplikasi.",
 "Automática": "Otomatis",
 "Baht tailandês": "Baht Thailand",
 "Boliviano": "Boliviano Bolivia",
 "Bolívar venezuelano": "Bolívar Venezuela",
 "Botão": "Tombol",
 "Buscar moeda": "Cari mata uang",
 "Cor do desenho": "Warna gambar",
 "Coroa dinamarquesa": "Krone Denmark",
 "Coroa norueguesa": "Krone Norwegia",
 "Coroa sueca": "Krona Swedia",
 "Coroa tcheca": "Koruna Ceko",
 "Crepúsculo": "Senja",
 "Crescente": "Meningkat",
 "Curta": "Pendek",
 "Despesas em outra moeda (fora do lucro): {v}": "Pengeluaran dalam mata uang lain (di luar laba): {v}",
 "Dirham dos Emirados Árabes Unidos": "Dirham Uni Emirat Arab",
 "Dirham marroquino": "Dirham Maroko",
 "Do seu país": "Dari negara Anda",
 "Dong vietnamita": "Dong Vietnam",
 "Dupla": "Ganda",
 "Dólar americano": "Dolar Amerika Serikat",
 "Dólar australiano": "Dolar Australia",
 "Dólar canadense": "Dolar Kanada",
 "Dólar de Hong Kong": "Dolar Hong Kong",
 "Dólar de Singapura": "Dolar Singapura",
 "Dólar neozelandês": "Dolar Selandia Baru",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Mengirim semua item dalam daftar ini, termasuk item baru yang dibuat nanti.",
 "Enviar todos para a equipe": "Kirim semua ke tim",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Pilih apakah alarm obat ini harus berbunyi meski ponsel dalam mode senyap.",
 "Euro": "Euro",
 "Exemplo": "Contoh",
 "Falta uma resposta": "Kurang satu jawaban",
 "Folha, tema e cores da caneta e das letras": "Kertas, tema, serta warna pena dan huruf",
 "Franco suíço": "Franc Swiss",
 "Guarani paraguaio": "Guarani Paraguay",
 "Hryvnia ucraniana": "Hryvnia Ukraina",
 "Iene japonês": "Yen Jepang",
 "Kwanza angolano": "Kwanza Angola",
 "Libra egípcia": "Pound Mesir",
 "Libra esterlina": "Pound sterling",
 "Lira turca": "Lira Turki",
 "Longa": "Panjang",
 "Mais usadas": "Paling sering dipakai",
 "Metical moçambicano": "Metical Mozambik",
 "Na página, segurar a bolinha faz o mesmo.": "Di halaman, menahan bulatan warna melakukan hal yang sama.",
 "Naira nigeriana": "Naira Nigeria",
 "Nenhuma moeda encontrada": "Mata uang tidak ditemukan",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Di Android, agar alarm obat berbunyi saat \"Jangan Ganggu\" aktif, ponsel harus mengizinkan akses \"Jangan Ganggu\" untuk My Planner. Ketuk \"Buka pengaturan\", cari My Planner di daftar, lalu aktifkan izinnya.",
 "No My Planner": "Di My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Di iPhone, mode senyap ponsel dapat menghalangi alarm. Biarkan ponsel dalam mode normal.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "Di iPhone, ▶ memberi gambaran setiap jenis. Notifikasi sebenarnya memakai getaran standar iPhone.",
 "Novo dólar taiwanês": "Dolar Taiwan Baru",
 "Novo shekel israelense": "Shekel Israel Baru",
 "Ouvir/Sentir": "Dengar/Rasakan",
 "Peso argentino": "Peso Argentina",
 "Peso chileno": "Peso Chili",
 "Peso colombiano": "Peso Kolombia",
 "Peso filipino": "Peso Filipina",
 "Peso mexicano": "Peso Meksiko",
 "Peso uruguaio": "Peso Uruguay",
 "Política de privacidade": "Kebijakan privasi",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "Selesai. Kunci layar dan tunggu 1 menit: notifikasi akan muncul tanpa suara.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "Selesai. Kunci layar dan tunggu 1 menit: notifikasi akan muncul dengan getaran, tanpa suara.",
 "Páginas e canetas": "Halaman dan pena",
 "Pôr do sol": "Matahari terbenam",
 "Rand sul-africano": "Rand Afrika Selatan",
 "Real brasileiro": "Real Brasil",
 "Ringgit malaio": "Ringgit Malaysia",
 "Riyal saudita": "Riyal Arab Saudi",
 "Rublo russo": "Rubel Rusia",
 "Rupia indiana": "Rupee India",
 "Rupia indonésia": "Rupiah Indonesia",
 "Rupia paquistanesa": "Rupee Pakistan",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Jika My Planner tidak muncul di daftar, izin ini akan tersedia di versi aplikasi berikutnya (perbarui melalui toko aplikasi).",
 "Sentir": "Rasakan",
 "Sol peruano": "Sol Peru",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Ini adalah warna cepat untuk pena dan huruf di halaman. Warna pertama adalah warna bawaan saat membuka halaman. Ketuk bulatan untuk mengganti warnanya.",
 "Taka bengali": "Taka Bangladesh",
 "Teste grátis por {n} dias": "Uji coba gratis {n} hari",
 "Tipo de vibração": "Jenis getaran",
 "Tirar do My Planner": "Hapus dari My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Bunyikan meski senyap dan dalam Jangan Ganggu",
 "Tocar só se o celular estiver no normal": "Bunyikan hanya jika ponsel dalam mode normal",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Semua item dalam daftar ini muncul di My Planner, termasuk yang baru.",
 "Vaga-lume": "Kunang-kunang",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "Berlaku untuk semua notifikasi yang bergetar (Getar, serta Suara dan getar).",
 "Won sul-coreano": "Won Korea Selatan",
 "Xelim queniano": "Shilling Kenya",
 "Yuan chinês": "Yuan Tiongkok",
 "Zloty polonês": "Zloty Polandia",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 Haruskah alarm obat ini berbunyi meski ponsel dalam mode senyap?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "Galeri foto hadir di versi aplikasi berikutnya. Untuk sementara, gunakan File atau Ambil foto.",
 "Abrir o fichário do grupo": "Buka map grup",
 "Arrastar a barra": "Seret bilah",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Begitu map dibagikan, map akan muncul di sini.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Cari ikon berdasarkan nama (mis.: buku, rumah, kopi)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Dengan tab Belajar Anda bisa membuat map sendiri, memakai stopwatch, memantau laporan, dan banyak lagi. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Dengan tab {aba} Anda bisa membuat konten sendiri dan memakai semua fitur. ✨",
 "Conhecer a aba": "Kenali tab ini",
 "Crie um fichário em Estudos e volte aqui.": "Buat map di Belajar lalu kembali ke sini.",
 "Em sessão": "Sedang sesi",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Hentikan dan simpan stopwatch lalu mulai sesi?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Hentikan dan simpan stopwatch lalu lanjutkan sesi?",
 "Enquadre e toque no botão": "Bidik lalu ketuk tombolnya",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Pilih map yang akan dilihat teman di layar (hanya baca).",
 "Esconder": "Sembunyikan",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "File ini hanya tersimpan di perangkat atau Drive milik orang yang membagikannya, jadi tidak muncul di sini.",
 "Fichário do grupo": "Map grup",
 "Guia passo a passo do app e de cada aba": "Panduan langkah demi langkah untuk aplikasi dan setiap tab",
 "Há um cronômetro em andamento.": "Ada stopwatch yang sedang berjalan.",
 "Há uma sessão em andamento.": "Ada sesi yang sedang berjalan.",
 "Inserir imagem": "Sisipkan gambar",
 "Mais ícones": "Ikon lainnya",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Tidak ada ikon dengan nama itu. Coba kata lain atau pilih dari kategori.",
 "Nenhuma matéria neste fichário ainda.": "Belum ada mata pelajaran di map ini.",
 "Nenhuma página nesta matéria ainda.": "Belum ada halaman di mata pelajaran ini.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "Di grup belajar, gambar dan PDF terbuka di layar ini. Jenis file ini tidak bisa dipratinjau di dalam aplikasi.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Tidak bisa ditampilkan sekarang. Periksa koneksi internet dan coba lagi.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "Fitur berbagi map masih disiapkan. Kembali lagi sebentar lagi.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "Map grup ini ada di perangkat Anda yang lain. Map tetap dibagikan dari sana.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Kenali tab ini · Batal = Nanti saja",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Teman tidak bisa melihat map ini lagi. Semuanya tetap ada pada Anda.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Teman melihat map ini di layar, hanya untuk dibaca: tidak bisa mengedit, mengunduh, mencetak, atau membagikan. Target, stopwatch, dan halaman yang sudah diulas tetap milik Anda sendiri.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Untuk melihat PDF di layar ini, instal versi terbaru aplikasi dari toko.",
 "Parar de compartilhar": "Berhenti berbagi",
 "Pausar a sessão": "Jeda sesi",
 "Pausar a sessão e estudar só esta?": "Jeda sesi dan pelajari ini saja?",
 "Página em branco.": "Halaman kosong.",
 "Quer estudar com tudo isso?": "Mau belajar dengan semua ini?",
 "Quer usar tudo isso?": "Mau memakai semua ini?",
 "Selecionar todos": "Pilih semua",
 "Trocar fichário": "Ganti map",
 "Você está participando do grupo de {nome}": "Anda bergabung di grup {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Anda melihat di layar apa yang dibagikan di grup ini, untuk dibaca dan diikuti.",
 "abacate, fruta": "alpukat, buah",
 "academia, musculação, treino, peso": "gym, angkat beban, latihan, beban",
 "acampamento, camping": "berkemah, kemah",
 "alfinete, fixar, importante": "pin, sematkan, penting",
 "almoço, arroz, prato": "makan siang, nasi, piring",
 "alvo, meta, objetivo, foco": "sasaran, target, tujuan, fokus",
 "aniversário, bolo": "ulang tahun, kue",
 "anotação, nota, lista, escrever": "catatan, memo, daftar, menulis",
 "arco-íris": "pelangi",
 "avião, viagem, voo": "pesawat, perjalanan, penerbangan",
 "balança, direito, justiça, lei, processo": "timbangan, hukum, keadilan, undang-undang, perkara",
 "balde, limpeza": "ember, bersih-bersih",
 "banana, fruta": "pisang, buah",
 "banheira, banho, banheiro": "bak mandi, mandi, kamar mandi",
 "barbear, barba, lâmina": "cukur, jenggot, pisau cukur",
 "bicicleta, pedalar, bike": "sepeda, bersepeda, gowes",
 "bolo, doce, sobremesa": "kue, manis, pencuci mulut",
 "brilho, mágica": "kilau, ajaib",
 "cabelo, cabeleireiro, corte": "rambut, penata rambut, potong rambut",
 "cachorro, cão, pet": "anjing, hewan peliharaan",
 "caderno": "buku tulis",
 "caderno, fichário, amarelo": "buku tulis, map, kuning",
 "café, xícara, pausa": "kopi, cangkir, istirahat",
 "caixa, pacote, mudança, entrega": "kotak, paket, pindahan, pengiriman",
 "calendário, agenda, data": "kalender, agenda, tanggal",
 "cama, quarto": "kasur, kamar tidur",
 "caminhada, caminhar, andar": "jalan kaki, berjalan, jalan",
 "camisa, gravata, roupa, trabalho": "kemeja, dasi, pakaian, kerja",
 "carne, churrasco": "daging, barbekyu",
 "carrinho, mercado, compras, supermercado": "troli, pasar, belanja, supermarket",
 "carro, dirigir, veículo": "mobil, menyetir, kendaraan",
 "certo, feito, visto": "centang, selesai, cek",
 "cesto, roupa, lavanderia, lavar roupa": "keranjang, pakaian, binatu, mencuci baju",
 "chave de fenda, ferramenta, conserto": "obeng, perkakas, perbaikan",
 "chave, senha": "kunci, kata sandi",
 "chocolate, doce": "cokelat, manis",
 "chuveiro, banho": "pancuran, mandi",
 "chá, xícara": "teh, cangkir",
 "compras, sacolas, shopping": "belanja, tas belanja, mal",
 "computador, monitor, tela": "komputer, monitor, layar",
 "computador, notebook, informática": "komputer, laptop, informatika",
 "coração amarelo": "hati kuning",
 "coração azul": "hati biru",
 "coração branco": "hati putih",
 "coração laranja": "hati oranye",
 "coração roxo": "hati ungu",
 "coração verde": "hati hijau",
 "coração, amor, saúde, vermelho": "hati, cinta, kesehatan, merah",
 "corrida, correr": "lari, berlari",
 "creme, hidratante, pele, skincare": "krim, pelembap, kulit, skincare",
 "croissant, pão, café da manhã": "croissant, roti, sarapan",
 "câmera, foto, fotografia": "kamera, foto, fotografi",
 "cérebro, mente, memória, pensar": "otak, pikiran, memori, berpikir",
 "dado, jogo de tabuleiro": "dadu, permainan papan",
 "dente, dentista": "gigi, dokter gigi",
 "despertador, relógio, alarme, acordar": "jam weker, jam, alarm, bangun",
 "diamante, joia": "berlian, perhiasan",
 "dinheiro, pagar, conta, pagamento": "uang, bayar, tagihan, pembayaran",
 "dormir, sono, descanso": "tidur, lelap, istirahat",
 "e-mail, mensagem, carta": "email, pesan, surat",
 "escada": "tangga",
 "escova de dentes, dentes": "sikat gigi, gigi",
 "escrever, redação, caneta": "menulis, karangan, pulpen",
 "esponja, lavar louça": "spons, cuci piring",
 "esquadro, régua, geometria, desenho técnico": "penggaris segitiga, penggaris, geometri, gambar teknik",
 "estrela brilhante, destaque": "bintang bersinar, sorotan",
 "estrela, favorito": "bintang, favorit",
 "etiqueta, marcador": "label, penanda",
 "extintor, segurança, incêndio": "pemadam api, keselamatan, kebakaran",
 "falar, idioma, inglês, conversa": "bicara, bahasa, bahasa Inggris, percakapan",
 "feito, concluído, certo": "selesai, tuntas, benar",
 "ferramenta, conserto, manutenção": "perkakas, perbaikan, perawatan",
 "festa, comemoração": "pesta, perayaan",
 "filme, cinema, série": "film, bioskop, serial",
 "fogo, urgente, sequência": "api, mendesak, beruntun",
 "folha, natureza, erva, chá": "daun, alam, herba, teh",
 "fone de ouvido, áudio, música, podcast": "headphone, audio, musik, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "wisuda, toga, kuliah, ijazah, universitas",
 "força, braço, músculo": "kekuatan, lengan, otot",
 "frango, coxa": "ayam, paha",
 "frigideira, cozinhar, ovo, cozinha": "wajan, memasak, telur, dapur",
 "futebol, bola, esporte": "sepak bola, bola, olahraga",
 "gato, pet": "kucing, hewan peliharaan",
 "gelo, geladeira, congelador": "es, kulkas, freezer",
 "gráfico, planilha, finanças, relatório": "grafik, spreadsheet, keuangan, laporan",
 "ingresso, show, evento": "tiket, konser, acara",
 "jogo, videogame, game": "game, video game, permainan",
 "lancha, barco": "speedboat, perahu",
 "leite, copo": "susu, gelas",
 "letras, alfabeto, português": "huruf, alfabet, bahasa Indonesia",
 "link, corrente": "tautan, rantai",
 "livro aberto, leitura, ler": "buku terbuka, bacaan, membaca",
 "livro azul, caderno": "buku biru, buku tulis",
 "livro laranja, caderno": "buku oranye, buku tulis",
 "livro verde, caderno": "buku hijau, buku tulis",
 "livro vermelho, caderno": "buku merah, buku tulis",
 "livros, estudo, estudar, biblioteca": "buku, belajar, studi, perpustakaan",
 "lixo, lixeira": "sampah, tempat sampah",
 "lua, noite": "bulan, malam",
 "lâmpada, ideia, luz": "lampu, ide, cahaya",
 "macarrão, massa": "mi, pasta",
 "maleta, trabalho, escritório, negócios": "tas kerja, kerja, kantor, bisnis",
 "massagem, relaxar": "pijat, santai",
 "maçã, fruta": "apel, buah",
 "microfone, cantar, karaokê, palestra": "mikrofon, menyanyi, karaoke, ceramah",
 "microscópio, ciência, biologia": "mikroskop, sains, biologi",
 "mochila, escola, filhos": "ransel, sekolah, anak",
 "montanha, trilha": "gunung, jalur pendakian",
 "mundo, planeta, geografia": "dunia, planet, geografi",
 "médico, consulta, exame, saúde": "dokter, konsultasi, pemeriksaan, kesehatan",
 "música, nota musical": "musik, not balok",
 "natação, nadar, piscina": "renang, berenang, kolam renang",
 "olho, visão, oftalmologista": "mata, penglihatan, dokter mata",
 "oração, orar, gratidão, igreja": "doa, berdoa, syukur, gereja",
 "ovo": "telur",
 "pastas, arquivo, fichário, divisórias": "folder, arsip, map, pembatas",
 "peixe": "ikan",
 "pescaria, pescar": "memancing, mancing",
 "pessoas, reunião, equipe, grupo": "orang, rapat, tim, grup",
 "piano, teclado musical": "piano, keyboard musik",
 "pintura, arte, desenho": "lukisan, seni, menggambar",
 "pipa": "layang-layang",
 "pipoca, cinema": "popcorn, bioskop",
 "pizza": "pizza",
 "planta, vaso, regar": "tanaman, pot, menyiram",
 "porta, entrada": "pintu, pintu masuk",
 "praia, férias": "pantai, liburan",
 "prato, refeição, louça, jantar": "piring, makanan, peralatan makan, makan malam",
 "prédio, história, governo, tribunal": "gedung, sejarah, pemerintah, pengadilan",
 "pão, padaria": "roti, toko roti",
 "pé, podólogo": "kaki, podiatris",
 "pôr do sol, amanhecer": "matahari terbenam, fajar",
 "quebra-cabeça, peça": "puzzle, teka-teki, kepingan",
 "queijo": "keju",
 "raio, energia, rápido": "petir, energi, cepat",
 "refrigerante, suco, bebida": "soda, jus, minuman",
 "remédio, medicamento, vitamina, farmácia": "obat, obat-obatan, vitamin, apotek",
 "sabão, sabonete, lavar": "sabun, mencuci",
 "salada, dieta, verdura": "salad, diet, sayuran",
 "sanduíche, lanche": "roti lapis, sandwich, camilan",
 "sino, aviso, lembrete": "lonceng, pemberitahuan, pengingat",
 "skate": "skateboard",
 "sofá, sala": "sofa, ruang tamu",
 "sol, manhã, dia": "matahari, pagi, siang",
 "spa, sauna, autocuidado": "spa, sauna, perawatan diri",
 "teatro, máscaras": "teater, topeng",
 "telefone, ligação, ligar": "telepon, panggilan, menelepon",
 "tigela, cereal, sopa, mingau": "mangkuk, sereal, sup, bubur",
 "trevo, sorte": "semanggi, keberuntungan",
 "troféu, conquista, prêmio": "piala, pencapaian, hadiah",
 "tubo de ensaio, química, laboratório": "tabung reaksi, kimia, laboratorium",
 "tênis, esporte": "tenis, olahraga",
 "unha, manicure": "kuku, manikur",
 "vassoura, limpeza, faxina, varrer": "sapu, bersih-bersih, kebersihan, menyapu",
 "violão, guitarra": "gitar, gitar akustik",
 "yoga, meditação, alongamento": "yoga, meditasi, peregangan",
 "{n} selecionada": "{n} dipilih",
 "{n} selecionadas": "{n} dipilih",
 "{n} selecionado": "{n} dipilih",
 "{n} selecionados": "{n} dipilih",
 "ábaco, matemática, contas, cálculo, contabilidade": "sempoa, matematika, hitungan, perhitungan, akuntansi",
 "água, gota, hidratar": "air, tetes, minum air",
 "árvore, jardim, quintal": "pohon, taman, halaman",
 "ônibus, transporte": "bus, transportasi",
 "1 dia antes": "1 hari sebelumnya",
 "1 dia depois": "1 hari sesudahnya",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "Langganan dilakukan di aplikasi ponsel melalui toko aplikasi, dan juga berlaku di situs ini.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "Kunci tidak lengkap (terlalu pendek). Salin lagi dengan tombol salin di halaman kunci.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "Kunci berisi karakter yang bukan bagian dari kunci. Salin lagi kuncinya saja, tanpa teks di sekitarnya.",
 "A galeria chega na próxima atualização do app.": "Galeri hadir di pembaruan aplikasi berikutnya.",
 "ALERTAS": "PERINGATAN",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Buka tab berbayar dan mulai uji coba gratis. Lalu kembali ke sini.",
 "Abrir a barra do editor": "Buka bilah editor",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "Saat ini jam Jangan ganggu aplikasi: pemberitahuan tiba dalam 5 detik, tanpa suara dan getar.",
 "Aguardando confirmação": "Menunggu konfirmasi",
 "Aguardando envio ao My Planner": "Menunggu dikirim ke My Planner",
 "Alertas de cada fatura": "Peringatan setiap tagihan",
 "Alertas do fim da garantia": "Peringatan akhir garansi",
 "Alertas do vencimento": "Peringatan jatuh tempo",
 "Alertas: {campo}": "Peringatan: {campo}",
 "Alvorada": "Fajar",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "Saat membuka tab ini, aplikasi meminta buka kunci yang sama dengan aplikasi (kata sandi, biometrik, atau PIN). Bisa diubah di Pengaturan > Tab.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Saat mengetuk file lampiran, file terbuka di aplikasi ponsel yang Anda pilih (jika ponsel bertanya, \"Hanya sekali\" atau \"Selalu\"). Apa yang Anda edit di sana tersimpan di file itu sendiri.",
 "App instalado": "Aplikasi terpasang",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch: sudah mencatat semuanya ke aplikasi Kesehatan di ponsel. Tidak perlu melakukan apa pun.",
 "Arquivados e fixados": "Diarsipkan dan disematkan",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "File untuk dibaca dan disimpan, disusun per tab. Dibuat pada {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Notifikasi My Planner dimatikan di ponsel.",
 "Atualização automática disponível no app instalado.": "Pembaruan otomatis tersedia di aplikasi terpasang.",
 "Aurora": "Aurora",
 "Avisos: alarme (som)": "Pemberitahuan: alarm (suara)",
 "Baixar o app": "Unduh aplikasi",
 "Baixar o arquivo técnico": "Unduh file teknis",
 "Baixar para ler (PDF)": "Unduh untuk dibaca (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Bilah editor (pena, stabilo, teks)",
 "Brisa": "Semilir",
 "Campainha": "Bel",
 "Canal": "Saluran",
 "Cole a chave antes de testar.": "Tempel kunci sebelum menguji.",
 "Começa em": "Mulai pada",
 "Como avisar": "Cara memberi tahu",
 "Confira a chave": "Periksa kunci",
 "Conta de teste de compras": "Akun uji pembelian",
 "Conta vencida": "Tagihan jatuh tempo",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Salin kunci saat itu juga (hanya muncul sekali). Diawali dengan \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Salin kunci saat itu juga (hanya muncul sekali). Diawali dengan \"sk-ant-\".",
 "Cristal": "Kristal",
 "Daqui a 1 hora": "1 jam lagi",
 "Daqui a 1 semana": "1 minggu lagi",
 "Daqui a 3 dias": "3 hari lagi",
 "Depois de 5 min fora": "Setelah 5 mnt di luar",
 "Depois de 5 minutos fora": "Setelah 5 menit di luar",
 "Desligar a senha desta aba": "Matikan kata sandi tab ini",
 "Detalhes técnicos": "Detail teknis",
 "Dia {n} de {t}": "Hari {n} dari {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Tips: kunci itu seperti kata sandi. Jangan kirim lewat pesan atau publikasikan. Jika bocor, hapus di situs dan buat yang baru.",
 "Documento vencido": "Dokumen kedaluwarsa",
 "Ela abre em {d}.": "Terbuka pada {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Terbuka pada {d}. Anda akan menerima pemberitahuan: {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Terbuka pada {d}. Anda akan menerima satu pemberitahuan: {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "Di \"API keys\", ketuk \"Create key\" (Buat kunci) dan beri nama, misalnya \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "Di \"Billing\" (Tagihan), tambahkan kartu dan beberapa dolar kredit. Langganan ChatGPT Plus tidak berlaku di sini.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "Di \"Billing\" (Tagihan), beli kredit. Langganan Claude Pro tidak berlaku di sini.",
 "Em breve": "Segera hadir",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Masuk dengan akun ChatGPT yang sama atau buat akun baru.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Masuk dengan akun Google Anda (akun Gmail juga bisa).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Masuk atau buat akun (boleh pakai email yang sama dengan Claude).",
 "Enviados para o My Planner": "Terkirim ke My Planner",
 "Enviar agora": "Kirim sekarang",
 "Escolha hoje ou uma data futura.": "Pilih hari ini atau tanggal mendatang.",
 "Escolhas lembradas": "Pilihan yang diingat",
 "Escolher a data": "Pilih tanggal",
 "Escolher células": "Pilih sel",
 "Escolher quando": "Pilih waktu",
 "Espessura": "Ketebalan",
 "Esquecer": "Lupakan",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Kunci ini dari layanan lain ({servico}). Di sini hanya kunci Claude, ChatGPT, atau Gemini yang berfungsi.",
 "Esta chave é do {ia}, não do {escolhida}.": "Kunci ini milik {ia}, bukan {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Akun ini melihat aplikasi seperti akun baru, tanpa tab yang terbuka, untuk memeriksa gembok, uji coba gratis, dan pembelian. Akun lain tidak berubah.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Alat ini perlu melihat halaman PDF, yang hadir di aplikasi baru (versi 0.50). Gunakan browser atau perbarui My Planner melalui toko.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Ini tidak terlihat seperti kunci {ia}. Kunci {ia} diawali dengan {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Pemberitahuan ini diatur ke \"Mati\": tidak akan ada bunyi.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Ponsel ini belum menerima pemberitahuan saat aplikasi ditutup. Perbarui My Planner melalui toko (versi {v} atau lebih baru). Saat aplikasi terbuka, pemberitahuan sudah berfungsi.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Jenis pemberitahuan ini dimatikan di pengaturan notifikasi ponsel.",
 "Estudado": "Dipelajari",
 "Estudado: {dur}": "Dipelajari: {dur}",
 "Faltou: {dur}": "Kurang: {dur}",
 "Fazer os testes terminarem agora": "Akhiri uji coba sekarang",
 "Fechar a barra do editor": "Tutup bilah editor",
 "Fichário": "Map",
 "Figurinhas e emojis": "Stiker dan emoji",
 "Garantia terminou": "Garansi berakhir",
 "Gerando…": "Membuat…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Menyimpan dokumen, hasil pemeriksaan, dan riwayat kesehatan dengan kata sandinya sendiri. Bahkan tim dukungan tidak bisa membacanya. Jika Anda lupa kata sandinya, tidak ada cara untuk memulihkannya.",
 "Harpa": "Harpa",
 "Horas por dia": "Jam per hari",
 "Identificação": "Identitas",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Ini tampak seperti tautan atau email, bukan kunci. Salin seluruh kunci dari halaman kunci API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Ini hanya muncul di My Planner jika Anda mengirimnya. Kirim sekarang?",
 "Já dá para confirmar {titulo}?": "Sudah bisa mengonfirmasi {titulo}?",
 "Lembrar minha escolha nesta aba": "Ingat pilihan saya di tab ini",
 "Lembrete para confirmar: {data}": "Pengingat untuk mengonfirmasi: {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Tandai setidaknya satu hari dalam seminggu di rencana.",
 "Me lembre de confirmar": "Ingatkan saya untuk mengonfirmasi",
 "Me lembre depois": "Ingatkan saya nanti",
 "Menos": "Lebih sedikit",
 "Meta somada": "Target gabungan",
 "Meta somada: {dur}": "Target gabungan: {dur}",
 "Meus dados - My Planner {data}": "Data saya - My Planner {data}",
 "Meus dados do My Planner": "Data My Planner saya",
 "Mostrar a barra": "Tampilkan bilah",
 "Mudar senha do diário": "Ubah kata sandi catatan harian",
 "Na primeira vez, aceite os termos de uso.": "Pertama kali, setujui ketentuan penggunaan.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "Di versi toko, pembelian dilakukan melalui toko aplikasi ponsel. Untuk sementara, kunci ini menyimulasikan langganan untuk pengujian.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Tidak ada yang dari tab lain masuk sendiri ke My Planner. Item ini punya tanggal dan belum dikirim.",
 "Nenhum estudo registrado neste mês.": "Tidak ada belajar yang tercatat bulan ini.",
 "Nenhum item aguardando envio.": "Tidak ada item yang menunggu dikirim.",
 "Nenhum teste começado": "Belum ada uji coba yang dimulai",
 "Nesta tela não há nada para adicionar.": "Tidak ada yang bisa ditambahkan di layar ini.",
 "No dia": "Pada hari itu",
 "Nova nota rápida": "Catatan cepat baru",
 "Nova página do dia": "Halaman hari baru",
 "Não deu certo": "Tidak berhasil",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Tidak termasuk: isi Catatan Harian dan kolom brankas (dilindungi kata sandi), foto, dan file lampiran. Untuk memulihkan data di aplikasi, gunakan file teknis.",
 "Não foi possível gerar o PDF.": "Tidak dapat membuat PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Tidak dapat menguji sekarang. Coba lagi dalam beberapa detik.",
 "Não lembrar": "Jangan ingat",
 "Não, obrigada": "Tidak, terima kasih",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "Catatan Harian dilindungi kata sandinya sendiri dan tidak termasuk dalam file ini.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Aplikasi membuka \"Simpan ke File\" agar Anda memilih folder (bisa iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Aplikasi hanya menyimpan pintasan ke file yang dipilih: file tetap di tempatnya (Drive, OneDrive, Unduhan) dan terbuka di aplikasi ponsel. Tidak ada yang disalin. Opsi ini berlaku untuk foto yang diambil dengan kamera.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "Aplikasi yang terpasang di perangkat ini adalah versi {v}. Untuk panggilan audio dan video, perbarui My Planner melalui toko (versi 0.35 atau lebih baru). Pesan sudah berfungsi.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "Pemberitahuan akan tiba tanpa suara, langsung ke daftar notifikasi: aktifkan peringatan My Planner di pengaturan ponsel.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "Pemberitahuan akan tiba tanpa suara: suara untuk jenis pemberitahuan ini dimatikan di pengaturan ponsel.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "Pemberitahuan akan tiba, tetapi suara notifikasi My Planner dimatikan di ponsel.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "Undangan berisi tautan untuk mengunduh aplikasi. Siapa pun yang masuk lewat tautan langsung masuk ke kantor.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "Dikte hadir di versi baru aplikasi. Perbarui My Planner melalui toko untuk menggunakan mikrofon.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "Buka kunci yang sama dengan aplikasi: kata sandi, biometrik, atau PIN. Diminta sekali saat masuk; di dalam tab tidak diminta lagi. Membuka galeri, kamera, atau file tidak dihitung sebagai keluar. Item besar tetap meminta kata sandi untuk dihapus.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Mode senyap ponsel dapat menghalangi alarm. Biarkan ponsel dalam mode normal.",
 "O plano fica só em Estudos (não vai para o My Planner).": "Rencana hanya ada di Belajar (tidak masuk ke My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Opsional: tenggat, jam per hari, dan hari dalam seminggu.",
 "Os avisos do celular funcionam no app instalado.": "Pemberitahuan ponsel berfungsi di aplikasi terpasang.",
 "Os avisos no celular funcionam no app instalado.": "Pemberitahuan di ponsel berfungsi di aplikasi terpasang.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Uji coba yang dimulai telah berakhir. Buka tab untuk melihat \"Uji coba gratis telah berakhir\".",
 "Outros dados": "Data lainnya",
 "Ouvir": "Dengarkan",
 "Pacote em uso": "Paket yang digunakan",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Untuk berlangganan, perbarui My Planner melalui toko aplikasi ponsel.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "Untuk dibaca (PDF): disusun per tab, dengan judul dan tanggal. Bisa dibuka di perangkat atau komputer apa pun.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Agar alarm obat berbunyi saat \"Jangan ganggu\" aktif, ponsel harus mengizinkan akses \"Jangan ganggu\" untuk My Planner. Ketuk \"Buka pengaturan\", cari My Planner di daftar, dan aktifkan izinnya.",
 "Passo a passo para criar a chave": "Langkah demi langkah membuat kunci",
 "Pedir de novo": "Minta lagi",
 "Pedir senha ao abrir esta aba": "Minta kata sandi saat membuka tab ini",
 "Plano com período": "Rencana dengan periode",
 "Plano começa em {d}": "Rencana dimulai pada {d}",
 "Por matéria": "Per mata pelajaran",
 "Prolongar": "Perpanjang",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "Selesai: pemberitahuan tiba dalam 5 detik, dengan suara. Jika tidak berbunyi, periksa apakah ponsel dalam mode senyap.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "Selesai: pemberitahuan tiba dalam 5 detik, hanya bergetar.",
 "Publicado em": "Diterbitkan pada",
 "Pulso": "Denyut",
 "Quando o app bloquear": "Saat aplikasi terkunci",
 "Quer proteger esta aba com senha?": "Lindungi tab ini dengan kata sandi?",
 "Recolher ou arrastar a barra": "Ciutkan atau seret bilah",
 "Recomeçar os testes grátis": "Mulai ulang uji coba gratis",
 "Recomeçar os testes grátis?": "Mulai ulang uji coba gratis?",
 "Rolar a folha para os lados": "Gulir lembar ke samping",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Jika Anda menghubungkan jam tangan: total harian langkah, jarak, kalori, olahraga, detak jantung, dan tidur, dibaca dari Health Connect atau aplikasi Kesehatan di ponsel. Aplikasi hanya membaca dan tidak pernah mengubah data ini.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Tidak ada internet atau koneksi terputus. Periksa Wi-Fi atau data seluler lalu coba lagi.",
 "Senha desta aba": "Kata sandi tab ini",
 "Seu plano terminou": "Rencana Anda telah berakhir",
 "Sino": "Lonceng",
 "Som do alarme": "Suara alarm",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Menjumlahkan garansi hukum dan garansi pabrik. Periksa di kartu garansi.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Ada dua file berisi data My Planner Anda (portabilitas, LGPD):",
 "Só quando o app bloquear": "Hanya saat aplikasi terkunci",
 "Tamanho da borracha": "Ukuran penghapus",
 "Tamanho da letra": "Ukuran huruf",
 "Tempo": "Waktu",
 "Termina em": "Berakhir pada",
 "Testar": "Uji",
 "Texto de exemplo": "Contoh teks",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Berbunyi untuk pemberitahuan dengan \"Alarm (suara)\". \"Suara dan getar\" memakai suara notifikasi ponsel.",
 "Toda vez que sair": "Setiap kali keluar",
 "Toda vez que sair da aba": "Setiap kali keluar dari tab",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Semua tab kembali ke \"{n} hari gratis untuk mencoba\", seperti akun baru. Langganan simulasi dimatikan.",
 "Todos os fichários": "Semua map",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Ketuk \"Create API key\" (Buat kunci API). Jika diminta proyek, pilih yang muncul atau buat yang baru.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Ketuk \"Buat kunci API saya\" di atas. Ini membuka platform OpenAI (bukan situs ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Ketuk \"Buat kunci API saya\" di atas. Ini membuka Console Anthropic (bukan situs Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Ketuk \"Buat kunci API saya\" di atas. Ini membuka Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Ketuk Hubungkan, lalu di layar aplikasi Kesehatan, aktifkan item yang boleh dibaca My Planner.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Ketuk ikon salin di samping kunci. Kunci diawali dengan \"AIza\" atau \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Ketuk sel tabel (atau \"Pilih sel\") untuk mengubah ukuran hurufnya.",
 "Transparência": "Transparansi",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Teknis (untuk memulihkan): salinan lengkap yang hanya dibaca My Planner. Untuk menggunakannya, buka Pengaturan › Cloud dan cadangan › Impor file.",
 "Uma carta da {nome} abre em {n} dias 💌": "Surat dari {nome} terbuka dalam {n} hari 💌",
 "Usa a senha do app": "Memakai kata sandi aplikasi",
 "Usar no {ia}": "Gunakan di {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Gunakan aplikasi di ponsel untuk mengunduh file teknis.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Harga akhir ditentukan toko aplikasi, langsung dalam mata uang negara Anda.",
 "Você ainda não enviou {titulo} para o My Planner.": "Anda belum mengirim {titulo} ke My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Kembali ke sini, tempel di kolom di bawah, dan ketuk \"Simpan dan uji\".",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Kembali ke \"API keys\" dan ketuk \"Create new secret key\" (Buat kunci).",
 "atualização automática": "pembaruan otomatis",
 "erro desconhecido": "kesalahan tidak diketahui",
 "estudados no mês": "dipelajari bulan ini",
 "faltou {dur}": "kurang {dur}",
 "hoje {feito} de {meta}": "hari ini {feito} dari {meta}",
 "hoje é folga": "hari ini libur",
 "login do Google (não é chave de API)": "login Google (bukan kunci API)",
 "meta cumprida": "target tercapai",
 "o que veio com a instalação": "bawaan instalasi",
 "outro": "lainnya",
 "provisório": "sementara",
 "superou {dur}": "melebihi {dur}",
 "token de login (não é chave de API)": "token login (bukan kunci API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} terlalu lama merespons. Coba lagi sebentar lagi.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} sedang tidak aktif atau kelebihan beban. Ini bukan masalah kunci Anda: coba lagi nanti.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} menjawab uji dengan model {modelo}. Sekarang bisa dipakai di tab.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} menolak membaca konten ini (filter keamanan perusahaan).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}: kunci ada, tetapi tidak punya izin untuk memakai AI. Buat kunci baru di halaman yang disebutkan dalam langkah demi langkah.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}: kunci tidak valid. Periksa apakah Anda menyalin seluruh kunci atau buat kunci baru.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}: kunci ini diblokir oleh perusahaan karena terpublikasi di internet. Hapus dan buat yang baru.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}: batas penggunaan tercapai. Tunggu beberapa menit (atau sampai besok, pada paket gratis) lalu coba lagi.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}: model yang dipilih tidak tersedia untuk akun Anda. Pilih model lain di \"Model\".",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}: layanan tidak tersedia di wilayah Anda atau untuk jenis akun ini.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}: akun API Anda tidak punya saldo atau metode pembayaran. Tambahkan kredit di situs perusahaan.",
 "{item}: a garantia termina hoje ({data}).": "{item}: garansi berakhir hari ini ({data}).",
 "{item}: a garantia terminou em {data}.": "{item}: garansi berakhir pada {data}.",
 "{item}: venceu em {data}.": "{item}: jatuh tempo pada {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} dilindungi kata sandi",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}: akhiri rencana atau perpanjang dengan tanggal akhir baru? Tidak ada yang dihapus.",
 "{n} dias antes": "{n} hari sebelumnya",
 "{n} dias de estudo no plano · {dur} por dia": "{n} hari belajar dalam rencana · {dur} per hari",
 "{n} dias de plano": "{n} hari rencana",
 "{n} dias depois": "{n} hari sesudahnya",
 "{n} item(ns) aguardando envio ao My Planner": "{n} item menunggu dikirim ke My Planner",
 "{n} itens aguardando envio": "{n} item menunggu dikirim",
 "{quando} às {hora}": "{quando} pukul {hora}",
 "ÚLTIMOS 6 MESES": "6 BULAN TERAKHIR",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Buka My Planner Anne dan masuk dengan CPF atau email serta kata sandi Anda.",
 "Anexo": "Lampiran",
 "Assédio ou ameaça": "Pelecehan atau ancaman",
 "Bloquear {nome}": "Blokir {nome}",
 "Conte mais (opcional)": "Ceritakan lebih lanjut (opsional)",
 "Conteúdo impróprio": "Konten tidak pantas",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Konten yang menyinggung dan pengguna yang kasar tidak ditoleransi. Laporan ditinjau oleh tim kami dalam 24 jam.",
 "Denunciar": "Laporkan",
 "Denunciar contato": "Laporkan kontak",
 "Denunciar grupo": "Laporkan grup",
 "Denunciar mensagem": "Laporkan pesan",
 "Denúncia enviada": "Laporan terkirim",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Laporan yang Anda buat di Pesan: alasannya, siapa yang dilaporkan, dan cuplikan pesan yang dilaporkan. Hanya tim My Planner yang membacanya, untuk meninjau kasusnya.",
 "Enviar denúncia": "Kirim laporan",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Kirim email untuk meminta penghapusan, dengan CPF atau email akun. Kami membalas dalam 15 hari.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Kami tidak menoleransi konten yang menyinggung, ilegal, atau tidak pantas maupun pengguna yang kasar di Pesan dan grup. Siapa pun dapat melaporkan pesan, kontak, atau grup (tekan lama pesan atau ketuk ⋮ > Laporkan) dan memblokir siapa saja. Laporan ditinjau oleh tim kami dalam 24 jam: konten dapat dihapus dan akun pengirimnya dapat ditangguhkan atau ditutup.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Terima kasih. Tim kami akan meninjaunya dalam 24 jam.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Untuk akun yang masuk dengan CPF, kata sandi baru dibuat oleh tim dukungan kami setelah memastikan akun itu milik Anda. Tulis ke {email} dengan menyebutkan CPF atau email terdaftar Anda.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Mengapa Anda melaporkan? Orang yang dilaporkan tidak akan tahu siapa yang melaporkannya.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} tidak bisa lagi mengobrol dengan Anda.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nBerlaku hingga {d}. Sertifikat disimpan terenkripsi di brankas Anda, hanya di perangkat ini dan di salinan cloud Anda.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. Di komputer, buka {url} lalu pilih Masuk dengan kode QR.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Di sini, ketuk Hubungkan browser dan arahkan kamera ke kode QR di komputer.",
 "Abandonados": "Ditinggalkan",
 "Bloquear o computador": "Kunci komputer",
 "Cheguei na página...": "Saya sampai di halaman...",
 "Computador conectado": "Komputer terhubung",
 "Computador desconectado": "Komputer terputus",
 "Conectado em {d}": "Terhubung pada {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: yang bergabung melihat materi buku dan mengikuti bacaan. Admin menambah, mengedit, dan memasang foto, dan bisa mengizinkannya untuk yang juga memakai tab ini. Hanya admin yang menambah atau mengeluarkan orang.",
 "Depois de {n} minutos parado": "Setelah {n} menit tidak aktif",
 "Desconectar o computador?": "Putuskan komputer?",
 "Difícil demais": "Terlalu sulit",
 "Editar livro": "Edit buku",
 "Entrar com o QR Code": "Masuk dengan kode QR",
 "Escreva (ex.: filosofia)": "Tulis (mis.: filsafat)",
 "Este computador": "Komputer ini",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Komputer ini terputus (dari ponsel atau karena komputer lain masuk). Untuk memakainya lagi, masuk dengan kode QR.",
 "Já existe um computador conectado": "Sudah ada komputer terhubung",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Sudah ada komputer terhubung. Ganti ke yang ini? Yang lain akan terputus.",
 "Navegador": "Browser",
 "Nenhum computador conectado": "Tidak ada komputer terhubung",
 "Novo livro": "Buku baru",
 "Não gostei": "Tidak suka",
 "Não, abandonei": "Tidak, saya tinggalkan",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner akan tertutup di komputer. Untuk memakainya lagi, cukup hubungkan dengan kode QR.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "Kode QR berganti setiap 3 menit dan hanya berlaku sekali. Di komputer bersama, gunakan Pengaturan › Keluar dari komputer ini setelah selesai.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Data Anda tetap tersimpan di cloud dan di ponsel. Untuk masuk lagi, gunakan kode QR.",
 "Parei em": "Berhenti pada",
 "Perdi o interesse": "Kehilangan minat",
 "Por que parei": "Mengapa saya berhenti",
 "Páginas e meta": "Halaman dan target",
 "Quero voltar a ler?": "Mau membaca lagi?",
 "Sair deste computador": "Keluar dari komputer ini",
 "Sair deste computador?": "Keluar dari komputer ini?",
 "Se quiser, escreva com as suas palavras": "Kalau mau, tulis dengan kata-kata Anda sendiri",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Jika mouse dan keyboard tidak dipakai selama itu, My Planner terkunci. Untuk kembali, ketik kata sandi akun (atau masuk lagi dengan kode QR).",
 "Sem tempo": "Tidak ada waktu",
 "Sim, depois": "Ya, nanti",
 "Só um computador pode ficar conectado por vez.": "Hanya satu komputer yang bisa terhubung sekaligus.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "Foto atau PDF sertifikat masuk ke \"Foto, file, dan tautan\": tandai sebagai Sertifikat.",
 "ABNT copiada": "ABNT disalin",
 "APA copiada": "APA disalin",
 "Ano inválido": "Tahun tidak valid",
 "Ano ou data de publicação": "Tahun atau tanggal terbit",
 "Assisti em": "Ditonton pada",
 "Buscando os dados...": "Mencari data...",
 "Calculado pelos módulos": "Dihitung dari modul",
 "Carga horária (horas)": "Beban jam (jam)",
 "Certificado": "Sertifikat",
 "Certificado emitido em": "Sertifikat terbit pada",
 "Cheguei na aula": "Saya sampai di pelajaran",
 "Cheguei na aula...": "Saya sampai di pelajaran...",
 "Cheguei na temporada": "Saya di musim",
 "Cheguei no episódio": "Saya di episode",
 "Citação copiada": "Kutipan disalin",
 "Colocar em pasta": "Masukkan ke folder",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Masukkan buku, film, atau kursus ke folder ini untuk menyusun daftar.",
 "Comentário": "Komentar",
 "Copiar ABNT": "Salin ABNT",
 "Copiar APA": "Salin APA",
 "Copiar citação (ABNT)": "Salin kutipan (ABNT)",
 "Copiar citação (APA)": "Salin kutipan (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Buat kartu dengan daftar centang, daftar, teks bebas, atau gambar untuk materi ini. Geser ke kanan untuk menghapus dan ke kiri untuk Arsipkan atau Duplikat.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: yang bergabung melihat daftar dan mengikutinya. Admin menambah, mengedit, dan memasang foto, dan bisa mengizinkannya untuk yang juga memakai tab ini. Hanya admin yang menambah atau mengeluarkan orang.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: yang bergabung melihat materi kursus dan mengikutinya. Admin menambah, mengedit, dan memasang foto, dan bisa mengizinkannya untuk yang juga memakai tab ini. Hanya admin yang menambah atau mengeluarkan orang.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Buat folder dulu, di bagian 📁 Folder pada tab ini.",
 "DOI (artigos)": "DOI (artikel)",
 "Data de acesso": "Tanggal akses",
 "Deixar avulsas": "Biarkan terpisah",
 "Descrição (objetivo)": "Deskripsi (tujuan)",
 "Digite o ano com 4 números (ex.: {a}).": "Ketik tahun dengan 4 angka (mis.: {a}).",
 "Direção": "Sutradara",
 "Editar pasta": "Edit folder",
 "Editora": "Penerbit",
 "Edição": "Edisi",
 "Em 1 mês": "Dalam 1 bulan",
 "Em {n} meses": "Dalam {n} bulan",
 "Episódios por temporada (opcional)": "Episode per musim (opsional)",
 "Escreva o trecho na anotação para copiar a citação.": "Tulis kutipan di catatan untuk menyalinnya.",
 "Este item já está em todas as pastas.": "Item ini sudah ada di semua folder.",
 "Ex.: 10.1590/...": "Mis.: 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Mis.: Skripsi — Etika dan Hukum",
 "Ex.: {a}": "Mis.: {a}",
 "Fazendo": "Sedang",
 "Grupo de filmes e séries": "Grup film dan serial",
 "Grupo de leitura": "Grup baca",
 "Grupo do curso": "Grup kursus",
 "ISBN": "ISBN",
 "Ideia minha": "Ide saya",
 "Instrutor": "Instruktur",
 "Itens da pasta": "Isi folder",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Kumpulkan buku, film, dan kursus dalam folder (mis.: \"Skripsi\", \"Hanya novel\"). Item yang sama bisa ada di beberapa folder.",
 "Link (material online)": "Tautan (materi online)",
 "Lista copiada": "Daftar disalin",
 "Lista de referências": "Daftar pustaka",
 "Mais de um autor: separe com ponto e vírgula (;).": "Lebih dari satu penulis: pisahkan dengan titik koma (;).",
 "Módulo": "Modul",
 "Nada novo": "Tidak ada yang baru",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "Di ⋮ buku, film, atau kursus, ketuk \"Masukkan ke folder\".",
 "Nome da pasta": "Nama folder",
 "Não achei dados novos para completar a ficha.": "Tidak ada data baru untuk melengkapi.",
 "Não foi possível preencher": "Tidak bisa mengisi",
 "O módulo não tem cards de anotações.": "Modul ini tidak punya kartu catatan.",
 "Organizador": "Penyunting",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Data berasal dari catatan buku (Edit › Referensi).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Buku, film, dan kursus di folder TIDAK dihapus: tetap ada di tab.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "{n} kartu catatan modul ini juga masuk ke tempat sampah.",
 "Pasta vazia": "Folder kosong",
 "Preencha o título (e o que mais tiver) na ficha.": "Isi judul (dan data lain yang ada) di catatan.",
 "Preencher pelo DOI": "Isi dari DOI",
 "Preencher pelo link": "Isi dari tautan",
 "Produtora ou país": "Rumah produksi atau negara",
 "Quero fazer": "Ingin ikut",
 "Quero voltar?": "Mau kembali?",
 "Referência vazia": "Referensi kosong",
 "Referências": "Daftar pustaka",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Jika dibiarkan terpisah, tetap dihitung dalam total kursus.",
 "Subtítulo": "Subjudul",
 "Tirar da pasta": "Keluarkan dari folder",
 "Total de episódios (opcional)": "Total episode (opsional)",
 "Total de temporadas (opcional)": "Total musim (opsional)",
 "Tradutor": "Penerjemah",
 "Trecho (citação)": "Kutipan",
 "Trecho vazio": "Kutipan kosong",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Anda sudah menonton {n} pelajaran. Masukkan ke modul mana?",
 "Volume": "Jilid",
 "{n} item(ns)": "{n} item",
 "{n} referência(s) em ordem alfabética.": "{n} referensi urut abjad.",
 "Ícone": "Ikon",
 "ASSISTIDOS POR DIA": "DITONTON PER HARI",
 "ASSISTIDOS POR MÊS": "DITONTON PER BULAN",
 "AULAS POR DIA": "PELAJARAN PER HARI",
 "AULAS POR MÊS": "PELAJARAN PER BULAN",
 "Apagar a meta": "Hapus target",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Ditonton {a} · Sedang {b} · Berhenti {c} · Ingin {d}",
 "Aulas": "Pelajaran",
 "CURSOS": "KURSUS",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Selesai {a} · Sedang {b} · Berhenti {c}",
 "Datas": "Tanggal",
 "Datas escolhidas": "Tanggal pilihan",
 "Datas à escolha": "Tanggal pilihan",
 "Definir meta de {ano}": "Tetapkan target {ano}",
 "Definir meta do ano": "Tetapkan target tahun ini",
 "FILMES E SÉRIES": "FILM DAN SERIAL",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Kurang {f} kursus: sekitar {m} per bulan",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Kurang {f} buku: sekitar {m} per bulan",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Kurang {f} judul: sekitar {m} per bulan",
 "Gênero": "Genre",
 "Incluir lista de referências no PDF": "Sertakan daftar pustaka di PDF",
 "LIVROS": "BUKU",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Selesai {a} buku · Berhenti {b} · Sedang {c}",
 "Meta de {ano}": "Target {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Target {ano}: pakai target {antes} ({n})?",
 "Meta do ano cumprida": "Target tahun tercapai",
 "Mudar": "Ubah",
 "Nada neste período.": "Tidak ada di periode ini.",
 "Nota": "Nilai",
 "O PDF não leva as suas anotações, resumos e comentários.": "PDF tidak memuat catatan, ringkasan, dan komentar Anda.",
 "POR ITEM": "PER ITEM",
 "Plataforma": "Platform",
 "PÁGINAS POR DIA": "HALAMAN PER HARI",
 "PÁGINAS POR MÊS": "HALAMAN PER BULAN",
 "Quantos no ano?": "Berapa dalam setahun?",
 "Quero ler {a} · Abandonei {b}": "Ingin dibaca {a} · Ditinggalkan {b}",
 "Relatório de leitura e mídia": "Laporan bacaan dan media",
 "concluídos no período": "selesai dalam periode",
 "cursos concluídos no período": "kursus selesai dalam periode",
 "livros lidos no período": "buku selesai dibaca dalam periode",
 "pág. {a} de {n}": "hlm. {a} dari {n}",
 "títulos assistidos no período": "judul ditonton dalam periode",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} pelajaran dalam periode · {h} jam kursus selesai",
 "{a} de {n} aulas ({p}%)": "{a} dari {n} pelajaran ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} dari {n} kursus selesai di {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} dari {n} buku di {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} dari {n} judul ditonton di {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} item tanpa tanggal perubahan status: dipakai tanggal dibuat.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} halaman dalam {d} hari · rekor beruntun: {s} hari",
 "{p}% lido · falta {f}%": "{p}% dibaca · sisa {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Tab ini meminta kata sandi. Buka dulu, lalu panduan berlanjut dari sini.",
 "Abrir esta aba": "Buka tab ini",
 "Mostrar na tela": "Tunjukkan di layar",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Titik ini tidak ditemukan di layar. Pastikan layar yang benar terbuka dan coba lagi.",
 "Primeiros passos": "Langkah awal",
 "Buscar no guia": "Cari di panduan",
 "Entendi": "Mengerti",
 "{n} de {total} passos feitos": "{n} dari {total} langkah selesai",
 "Já fiz": "Sudah",
 "Guia em construção": "Panduan sedang disusun",
 "Limpar marcações": "Hapus tanda",
 "Este ponto ainda não está marcado no app.": "Titik ini belum ditandai di aplikasi.",
 "Dicas e atalhos": "Tips dan pintasan",
 "Gestos do app": "Gerakan aplikasi",
 "Procurando na tela…": "Mencari di layar…",
 "Guia das abas": "Panduan tab",
 "Voltar ao guia": "Kembali ke panduan",
 "Para que serve": "Untuk apa",
 "Disponível no app do celular.": "Tersedia di aplikasi ponsel.",
 "Nada encontrado no guia.": "Tidak ditemukan di panduan.",
 "Recursos que valem para todas as abas": "Fitur untuk semua tab",
 "Perguntas comuns": "Pertanyaan umum",
 "Ligar e desligar partes": "Nyalakan dan matikan bagian",
 "Entrada cancelada. Este computador não foi conectado.": "Masuk dibatalkan. Komputer ini tidak terhubung.",
 "Alterações ainda não enviadas": "Perubahan belum terkirim",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Beberapa perubahan belum terkirim ke server (tidak ada internet?). Jika keluar sekarang, perubahan itu akan hilang. Tetap keluar?",
 "Sair mesmo assim": "Tetap keluar",
 "O seu papel no grupo não permite mudar aqui.": "Peran Anda di grup tidak mengizinkan perubahan di sini.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "DOI tidak dapat dicari sekarang (tidak ada internet?). Coba lagi.",
 "DOI inválido.": "DOI tidak valid.",
 "DOI não encontrado.": "DOI tidak ditemukan.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "Situs tidak mengizinkan data dibaca dari sini (umum di browser komputer). Coba lewat aplikasi di ponsel, gunakan DOI, atau isi kolomnya.",
 "Atualizando...": "Memperbarui...",
 "Banco de dados (Supabase, plano grátis)": "Basis data (Supabase, paket gratis)",
 "Cadeado (HTTPS) até": "Gembok HTTPS hingga",
 "Dados das abas: {d}": "Data tab: {d}",
 "Disco": "Disk",
 "Esta conta não tem acesso a estas informações.": "Akun ini tidak punya akses ke informasi ini.",
 "Ligado há": "Menyala selama",
 "Livre: {l} · site: {s}": "Kosong: {l} · situs: {s}",
 "Maiores tabelas": "Tabel terbesar",
 "Memória em uso": "Memori terpakai",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "Server belum mengirim laporan. Server mengirimnya setiap 10 menit setelah 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "Server belum punya fungsi ini. Jalankan 53-SERVIDOR-0.78.bat di komputer.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "Sistem server meminta mulai ulang (pembaruan keamanan terpasang).",
 "Processador": "Prosesor",
 "Relatório do servidor: {q}": "Laporan server: {q}",
 "Servidor": "Server",
 "Servidor do site (Locaweb)": "Server situs (Locaweb)",
 "Sistema": "Sistem",
 "Só você vê este quadro.": "Hanya Anda yang melihat panel ini.",
 "Versão do site no ar": "Versi situs yang aktif",
 "atrasado: confira se o servidor está ligado": "terlambat: periksa apakah server menyala",
 "sem cadeado": "tanpa gembok",
 "{a} ({n} guardadas)": "{a} ({n} disimpan)",
 "{d} dia(s) e {h} h": "{d} hari dan {h} jam",
 "{n} núcleo(s) · carga {c}": "{n} inti · beban {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} baru dan {ativas} aktif dalam 7 hari",
 "{u} de {t} ({p}%)": "{u} dari {t} ({p}%)",
 "Fechar teclado": "Tutup keyboard",
 "Mostrar as ferramentas": "Tampilkan alat",
 "Últimas cores usadas": "Warna terakhir dipakai",
 "Voltar ao topo": "Kembali ke atas",
 "Topo": "Atas",
 "1 atividade do roteiro por fazer": "1 aktivitas rencana perjalanan belum dilakukan",
 "1 dia": "1 hari",
 "1 item por pôr na mala": "1 barang belum dikemas",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 daftar Perjalanan dulu dikirim utuh ke My Planner dan sudah dihapus dari sana. Sekarang pengiriman per item, lewat ⋮ di setiap item.",
 "1 lugar não visitado": "1 tempat belum dikunjungi",
 "1 reserva por confirmar": "1 pemesanan belum dikonfirmasi",
 "Abrir o bloco": "Buka bagian",
 "Adicionar pessoa": "Tambah orang",
 "Ainda pode gastar {v}": "Masih bisa dibelanjakan {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Jika aktif, jumlahnya masuk ke Pengeluaran sebagai lunas.",
 "Até (dd/mm/aaaa)": "Sampai (hh/bb/tttt)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Masukkan orang di \"Siapa ikut\" (edit perjalanan).",
 "Como foi?": "Bagaimana?",
 "Concluído em {d}": "Selesai pada {d}",
 "Confirmada em {d}": "Dikonfirmasi pada {d}",
 "Confirmadas": "Dikonfirmasi",
 "Dia anterior": "Hari sebelumnya",
 "Dias": "Hari",
 "Dias × valor por dia": "Hari × nilai per hari",
 "Documentos (só o tipo e a validade)": "Dokumen (hanya jenis dan masa berlaku)",
 "EXIGÊNCIAS DO DESTINO": "PERSYARATAN TUJUAN",
 "Em mãos": "Sudah di tangan",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Tulis apa yang diminta tujuan (mis.: 2 halaman kosong di paspor, sertifikat vaksin). Cek di situs resmi negara tersebut.",
 "Ex.: Lisboa (LIS)": "Mis.: Lisbon (LIS)",
 "Ex.: São Paulo (GRU)": "Mis.: São Paulo (GRU)",
 "Falta confirmar": "Belum dikonfirmasi",
 "Falta pôr": "Belum dikemas",
 "Faltou ({n}): {l}": "Tertinggal ({n}): {l}",
 "Foi ({n}): {l}": "Dibawa ({n}): {l}",
 "Fotos (lista das legendas)": "Foto (daftar keterangan)",
 "Gasto de {nome} em {d}": "Pengeluaran {nome} pada {d}",
 "Gastos do dia": "Pengeluaran hari ini",
 "Gastos em outras moedas (não convertidos): {v}": "Pengeluaran dalam mata uang lain (tidak dikonversi): {v}",
 "Gastos por dia": "Pengeluaran per hari",
 "Horário de chegada": "Waktu tiba",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Tempat (dikunjungi, belum, wajib dikunjungi, dan nilai)",
 "Mala (o que foi e o que faltou)": "Koper (yang dibawa dan yang tertinggal)",
 "Marcar como acertado": "Tandai sudah lunas",
 "Marcar como acertado?": "Tandai sudah lunas?",
 "Na mala": "Sudah dikemas",
 "Nenhuma parada ainda": "Belum ada perhentian",
 "Nova exigência": "Persyaratan baru",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Nomor dokumen dan isi brankas tidak pernah masuk ke laporan. Jumlah dalam mata uang berbeda ditampilkan terpisah.",
 "O QUE AINDA FALTA": "YANG MASIH KURANG",
 "O QUE INCLUIR": "YANG DISERTAKAN",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Opsional. Aplikasi memberi tahu jika paspor habis berlaku sebelum itu, dihitung dari tanggal pulang. Cek persyaratan negara tersebut.",
 "Orçamento previsto × gasto por categoria": "Anggaran rencana × pengeluaran per kategori",
 "Passou do previsto em {v}": "Melebihi anggaran {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Isi masa berlaku setiap dokumen: aplikasi memberi tahu sebelum habis. Foto dokumen tetap terlindungi di brankas.",
 "Próximo dia": "Hari berikutnya",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Anggota grup perjalanan otomatis masuk. Gunakan \"+ Tambah orang\" untuk yang tidak punya aplikasinya.",
 "Recolher o bloco": "Ciutkan bagian",
 "Relatório da viagem": "Laporan perjalanan",
 "Reserva confirmada": "Pemesanan dikonfirmasi",
 "Resumo da viagem": "Ringkasan perjalanan",
 "Resumo da viagem (datas, destino, pessoas)": "Ringkasan perjalanan (tanggal, tujuan, orang)",
 "Roteiro por dia (feito e falta)": "Rencana per hari (selesai dan belum)",
 "Sem data": "Tanpa tanggal",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Paspor Anda mungkin tidak diterima. Cek persyaratan negara tersebut",
 "Subir": "Naikkan",
 "Total do dia: {v}": "Total hari ini: {v}",
 "Uma frase (opcional)": "Satu kalimat (opsional)",
 "Validade mínima exigida (meses)": "Masa berlaku paspor minimum (bulan)",
 "Validade: {d}": "Berlaku hingga: {d}",
 "Valor por dia": "Nilai per hari",
 "Viagens no My Planner": "Perjalanan di My Planner",
 "Visitado": "Dikunjungi",
 "Visitado em {d}": "Dikunjungi pada {d}",
 "Voltaria: {r}": "Akan kembali: {r}",
 "Voltaria?": "Mau kembali lagi?",
 "confirmada": "dikonfirmasi",
 "em mãos": "sudah di tangan",
 "gasto na viagem {d}": "pengeluaran perjalanan {d}",
 "meses": "bulan",
 "outro gasto": "pengeluaran lain",
 "vence em {d}": "berakhir {d}",
 "{a} de {b} confirmadas": "{a} dari {b} dikonfirmasi",
 "{a} de {b} em mãos": "{a} dari {b} sudah di tangan",
 "{a} de {b} feitos": "{a} dari {b} selesai",
 "{a} de {b} na mala": "{a} dari {b} sudah dikemas",
 "{a} de {b} pagos": "{a} dari {b} lunas",
 "{a} de {b} visitados": "{a} dari {b} dikunjungi",
 "{de} deve {v} a {para}": "{de} berutang {v} kepada {para}",
 "{g} de {p}": "{g} dari {p}",
 "{n} atividades do roteiro por fazer": "{n} aktivitas rencana perjalanan belum dilakukan",
 "{n} item(ns) enviado(s).": "{n} item terkirim.",
 "{n} itens por pôr na mala": "{n} barang belum dikemas",
 "{n} já estava(m) no My Planner.": "{n} sudah ada di My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} daftar Perjalanan dulu dikirim utuh ke My Planner dan sudah dihapus dari sana. Sekarang pengiriman per item, lewat ⋮ di setiap item.",
 "{n} lugares não visitados": "{n} tempat belum dikunjungi",
 "{n} reservas por confirmar": "{n} pemesanan belum dikonfirmasi",
 "{n} sem data (não foi).": "{n} tanpa tanggal (tidak terkirim).",
 "ARTIGOS E SITES": "ARTIKEL DAN SITUS",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "Sekarang pengiriman per item (lewat ⋮ item atau dengan memilih beberapa). Daftar ini dulu dikirim utuh dan sudah dikeluarkan dari My Planner ({n} item, tidak ada yang dihapus):",
 "Artigo científico": "Artikel ilmiah",
 "Artigo de site ou blog": "Artikel situs atau blog",
 "Artigo ou site": "Artikel atau situs",
 "Artigos e sites": "Artikel dan situs",
 "Autor(es)": "Penulis",
 "Cadastrar pela foto ou PDF": "Tambah dari foto atau PDF",
 "Capítulo de livro": "Bab buku",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Buat grup dan kirim tautannya: yang bergabung melihat artikel dan mengikuti bacaan. Admin menambah, mengedit, dan memasang foto, dan dapat mengizinkannya bagi yang juga memakai tab ini. Hanya admin yang menambah atau mengeluarkan orang.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Tanggal atau tahun terbit",
 "Editar artigo ou site": "Edit artikel atau situs",
 "Enviar para o My Planner (lembrete de renovação)": "Kirim ke My Planner (pengingat perpanjangan)",
 "Envio para o My Planner": "Pengiriman ke My Planner",
 "Ex.: 2024 ou 12/03/2024": "Mis.: 2024 atau 12/03/2024",
 "Ex.: 45-60": "Mis.: 45-60",
 "Grupo de artigos": "Grup artikel",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Simpan artikel, berita, dan halaman web dengan referensi siap (ABNT dan APA). Isi lewat DOI atau tautan.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Dibaca {a} · Sedang dibaca {b} · Berhenti {c} · Ingin dibaca {d}",
 "Minhas anotações do artigo": "Catatan saya tentang artikel",
 "Notícia": "Berita",
 "Novo artigo ou site": "Artikel atau situs baru",
 "Os dados vêm da ficha do artigo (Editar).": "Data diambil dari kartu artikel (Edit).",
 "Páginas (opcional)": "Halaman (opsional)",
 "Revista, site ou veículo": "Jurnal, situs, atau media",
 "artigos e sites lidos no período": "artikel dan situs yang dibaca dalam periode",
 "1 confirmado": "1 terkonfirmasi",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 tamu yang berstatus \"Tertunda\" pindah ke \"Akan diundang\". Saat undangan dikirim lewat aplikasi, ia otomatis pindah ke \"Diundang, belum menjawab\".",
 "1 extra": "1 tambahan",
 "1 talvez": "1 mungkin",
 "A convidar": "Akan diundang",
 "Agendar na igreja": "Jadwalkan di gereja",
 "Agora": "Sekarang",
 "Agradeci": "Sudah berterima kasih",
 "Agradeci em {d}": "Berterima kasih pada {d}",
 "Agradecidos": "Sudah diberi terima kasih",
 "Alianças": "Cincin",
 "Aluguéis (mesas, cadeiras, louças)": "Sewa (meja, kursi, peralatan makan)",
 "Avisar a data (save the date)": "Umumkan tanggal (save the date)",
 "Bebidas": "Minuman",
 "Beca e cerimônia": "Toga dan upacara",
 "Bolo": "Kue",
 "Brincadeiras": "Permainan",
 "Brincadeiras e amigo secreto": "Permainan dan tukar kado",
 "Brindes": "Suvenir",
 "Buffet": "Katering",
 "Calculado sozinho: valor menos o sinal.": "Dihitung otomatis: jumlah dikurangi uang muka.",
 "Calcular quantidades": "Hitung jumlah",
 "Categoria do orçamento": "Kategori anggaran",
 "Celebrante": "Pemimpin upacara",
 "Cerimônia": "Upacara",
 "Cerveja (adultos)": "Bir (dewasa)",
 "Checklist de preparação": "Daftar persiapan",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Isi tanggal acara (edit acara) untuk melihat batas waktu tiap item.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Tambahkan orang di \"Orang di acara\" (edit acara).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Isi berapa yang ingin dibelanjakan di tiap kategori. Gunakan ⊕ untuk menghitung per tamu. Vendor yang dikontrak otomatis masuk ke kategori yang dipilih.",
 "Combinado: {v}": "Disepakati: {v}",
 "Comprado": "Sudah dibeli",
 "Comprados": "Sudah dibeli",
 "Comprar a decoração e as lembrancinhas": "Beli dekorasi dan suvenir",
 "Comprar as alianças": "Beli cincin",
 "Comprar as lembrancinhas": "Beli suvenir",
 "Comprar bebidas e gelo": "Beli minuman dan es",
 "Comprar comida e bebidas": "Beli makanan dan minuman",
 "Comprar o que falta": "Beli yang masih kurang",
 "Comprar ou alugar a roupa": "Beli atau sewa pakaian",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Terkonfirmasi beserta pendamping. Berubah otomatis saat ada yang konfirmasi atau membatalkan.",
 "Confirmar a presença dos convidados": "Konfirmasi kehadiran tamu",
 "Confirmar os fornecedores": "Konfirmasi vendor",
 "Confirmar os fornecedores e os convidados": "Konfirmasi vendor dan tamu",
 "Contratar a comida": "Pesan makanan",
 "Contratar a comida e o bolo": "Pesan makanan dan kue",
 "Contratar a decoração": "Pesan dekorasi",
 "Contratar comida e bebidas": "Pesan makanan dan minuman",
 "Contratar foto e vídeo": "Pesan foto dan video",
 "Contratar o buffet": "Pesan katering",
 "Convidado, sem resposta": "Diundang, belum menjawab",
 "Convidados (por situação, com acompanhantes)": "Tamu (per status, dengan pendamping)",
 "Convidados que contam no ⊕": "Tamu yang dihitung di ⊕",
 "Convites": "Undangan",
 "Cronograma do dia (com responsáveis e situação)": "Jadwal hari H (dengan penanggung jawab dan status)",
 "Data do restante": "Tanggal pelunasan",
 "Data do sinal": "Tanggal uang muka",
 "Decoração": "Dekorasi",
 "Definir a data e o orçamento": "Tentukan tanggal dan anggaran",
 "Definir a lista de convidados": "Tentukan daftar tamu",
 "Doces": "Kue manis",
 "Dá para mudar, tirar e incluir itens depois.": "Item bisa diubah, dihapus, dan ditambah nanti.",
 "Enviar os convites": "Kirim undangan",
 "Equipamentos (projetor, som)": "Peralatan (proyektor, sound)",
 "Equipe (garçons, limpeza)": "Staf (pelayan, kebersihan)",
 "Escolha \"Outro\" para escrever o nome.": "Pilih \"Lainnya\" untuk menulis nama.",
 "Escolher a roupa": "Pilih pakaian",
 "Escolher a roupa dos noivos": "Pilih pakaian pengantin",
 "Escolher os padrinhos": "Pilih pendamping/wali baptis",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Perkiraan untuk {n} tamu. Ubah sesuai keinginan sebelum dipakai.",
 "Eu faço": "Saya yang kerjakan",
 "Ex.: 200 un.": "Contoh: 200 buah",
 "Ex.: Copos descartáveis": "Contoh: Gelas sekali pakai",
 "Ex.: Jogo de panelas": "Contoh: Set panci",
 "Ex.: Reservar o local": "Contoh: Pesan tempat",
 "Ex.: em negociação": "Contoh: sedang negosiasi",
 "Extras de margem (quem aparece sem avisar)": "Cadangan tambahan (yang datang tanpa kabar)",
 "Falta 1 dia": "Tinggal 1 hari",
 "Falta agradecer": "Belum berterima kasih",
 "Falta comprar": "Belum dibeli",
 "Falta pagar": "Belum dibayar",
 "Fazer a lista de presentes": "Buat daftar hadiah",
 "Fazer o curso de batismo": "Ikuti kursus baptis",
 "Fornecedores (contratado, pago, falta)": "Vendor (dikontrak, dibayar, sisa)",
 "Foto e vídeo": "Foto dan video",
 "Fraldas": "Popok",
 "Frase curta (opcional)": "Kalimat singkat (opsional)",
 "Hoje é o dia do evento!": "Hari ini hari acaranya!",
 "Igreja e celebrante": "Gereja dan pemimpin upacara",
 "Incluir os Talvez": "Sertakan yang Mungkin",
 "Incluir telefones": "Sertakan nomor telepon",
 "Item da lista de compras": "Item daftar belanja",
 "Item da preparação": "Item persiapan",
 "Já deram: {d} · Falta: {f}": "Sudah diberikan: {d} · Kurang: {f}",
 "Já deu": "Sudah memberi",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Catat pengeluaran di sini. Pembayaran ke vendor dan belanja yang dicentang otomatis masuk.",
 "Lançar o gasto": "Catat pengeluaran",
 "Lembrancinhas": "Suvenir",
 "Levar para os itens": "Masukkan ke item",
 "Local / espaço": "Tempat / lokasi",
 "Mais um extra": "Tambah satu",
 "Menos um extra": "Kurangi satu",
 "Música / som / DJ": "Musik / sound / DJ",
 "No dia do evento": "Pada hari acara",
 "O que comprar": "Yang perlu dibeli",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "Total berubah otomatis saat ada yang konfirmasi atau membatalkan.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "Nilai kontrak otomatis masuk sebagai rencana di kategori ini, dan yang dibayar masuk ke pengeluaran.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "Nilainya masuk ke pengeluaran acara, di kategori item. Bisa dilewati jika mau.",
 "Onde comprar": "Tempat beli",
 "Orçamento do evento": "Anggaran acara",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Item yang dicentang masuk ke kategori dengan ⊕ per tamu. Lalu cukup ketuk ⊕ dan isi harga satuan.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Nomor telepon tamu hanya muncul di PDF jika Anda mencentang \"Sertakan nomor telepon\". Nilai dalam mata uang berbeda ditampilkan terpisah.",
 "Pago em {d}": "Dibayar pada {d}",
 "Parte da vaquinha": "Bagian patungan",
 "Pessoas do evento": "Orang di acara",
 "Pessoas do evento: {p}": "Orang di acara: {p}",
 "Preparar as brincadeiras": "Siapkan permainan",
 "Preparação": "Persiapan",
 "Presente recebido": "Hadiah diterima",
 "Presentes": "Hadiah",
 "Prova final da roupa": "Fitting terakhir",
 "Pular": "Lewati",
 "Quantidade por convidado": "Jumlah per tamu",
 "Quantidade por convidado × valor unitário": "Jumlah per tamu × harga satuan",
 "Quanto custou?": "Berapa harganya?",
 "Quanto já deu": "Yang sudah diberikan",
 "Quanto vai contribuir": "Jumlah kontribusi",
 "Quantos dias antes do evento": "Berapa hari sebelum acara",
 "Quem deu": "Dari siapa",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Anggota grup acara otomatis masuk. Gunakan \"+ Tambah orang\" untuk yang tidak punya aplikasi. Daftar ini dipakai di jadwal, pengeluaran, dan patungan.",
 "Recreação e brinquedos": "Hiburan dan wahana bermain",
 "Refrigerante": "Minuman ringan",
 "Relatório do evento": "Laporan acara",
 "Relatório do evento (PDF)": "Laporan acara (PDF)",
 "Reservar o local": "Pesan tempat",
 "Reservar o local da cerimônia e da festa": "Pesan tempat upacara dan pesta",
 "Reservar o local ou a mesa da festa": "Pesan tempat atau meja pesta",
 "Restante": "Sisa",
 "Restante pago": "Sisa sudah dibayar",
 "Resumo do evento": "Ringkasan acara",
 "Roupa e beleza": "Pakaian dan kecantikan",
 "Salgados": "Camilan gurih",
 "Separar a roupa e o que levar": "Siapkan pakaian dan barang bawaan",
 "Separar os documentos e as alianças": "Siapkan dokumen dan cincin",
 "Separar os documentos e os ingressos": "Siapkan dokumen dan tiket",
 "Sinal": "Uang muka",
 "Sinal pago": "Uang muka sudah dibayar",
 "Sinal {v} pago": "Uang muka {v} sudah dibayar",
 "Usar a lista pronta para {tipo}": "Gunakan daftar siap pakai untuk {tipo}",
 "Vai contribuir": "Akan berkontribusi",
 "Valor unitário": "Harga satuan",
 "Vaquinha": "Patungan",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Anda bisa memantau semua yang dibagikan, selalu terbaru. Untuk menambah, mengedit, dan mengambil tugas, berlangganan tab ini.",
 "agradeci": "sudah berterima kasih",
 "atrasado": "terlambat",
 "completo": "lengkap",
 "deu {d} de {v}": "memberi {d} dari {v}",
 "em {l}": "di {l}",
 "falta o valor": "nilai belum diisi",
 "falta {v} até {d}": "kurang {v} sampai {d}",
 "gasto em {e}": "dibelanjakan untuk {e}",
 "kg": "kg",
 "o evento": "acara",
 "restante": "sisa",
 "sinal": "uang muka",
 "total": "total",
 "un.": "buah",
 "{n} confirmados": "{n} terkonfirmasi",
 "{n} convidados contam no ⊕ por convidado.": "{n} tamu dihitung di ⊕ per tamu.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} tamu yang berstatus \"Tertunda\" pindah ke \"Akan diundang\". Saat undangan dikirim lewat aplikasi, mereka otomatis pindah ke \"Diundang, belum menjawab\".",
 "{n} extras": "{n} tambahan",
 "{n} talvez": "{n} mungkin",
 "{q} por convidado": "{q} per tamu",
 "{v} por convidado": "{v} per tamu",
 "Item completo": "Item lengkap",
 "Nota rápida": "Catatan cepat",
 "📝 Nota rápida": "📝 Catatan cepat",
 "Conteúdo da nota": "Isi catatan",
 "{c} confirmado(s) de {n} convidado(s)": "{c} terkonfirmasi dari {n} tamu",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Akan dihapus untuk semua: dokumen, rapat terjadwal, dan rekaman kantor \"{nome}\". Obrolan tetap ada di Pesan.",
 "Confirme para apagar o escritório": "Konfirmasi untuk menghapus kantor",
 "Escreva o assunto da reunião para poder marcar.": "Tulis topik rapat untuk menjadwalkannya.",
 "{n} min (marcada para {m} min)": "{n} mnt (dijadwalkan {m} mnt)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Tidak dapat mengunduh file sekarang. Periksa internet dan coba lagi.",
 "Meus clientes": "Klien saya",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Satu daftar klien, dipakai oleh semua tab kerja: kontak, alamat, label, catatan, dan file.",
 "Copiar para Meus clientes": "Salin ke Klien saya",
 "Ver ou mudar": "Lihat atau ubah",
 "Ver o documento completo": "Lihat dokumen lengkap",
 "CEP incompleto": "CEP tidak lengkap",
 "O CEP tem 8 números.": "CEP terdiri dari 8 angka.",
 "CEP não encontrado": "CEP tidak ditemukan",
 "Confira os números ou preencha o endereço à mão.": "Periksa angkanya atau isi alamat secara manual.",
 "Não foi possível buscar o CEP": "Tidak dapat mencari CEP",
 "Confira a internet ou preencha o endereço à mão.": "Periksa koneksi internet atau isi alamat secara manual.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Sepertinya ada yang kurang di email ini (mis.: nama@situs.com).",
 "opcional": "opsional",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Klien Anda kini ada dalam satu daftar, dipakai oleh semua tab kerja.",
 "Portal do Cliente: {n} cliente(s).": "Portal Klien: {n} klien.",
 "Freelancer & Projetos: {n} cliente(s).": "Freelancer & Proyek: {n} klien.",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} adalah klien yang sama di lebih dari satu tab dan kini jadi satu data.",
 "Nenhum cliente repetido.": "Tidak ada klien ganda.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Tidak ada yang dihapus: dokumen, pesanan, kartu, dan jam tetap di tempatnya.",
 "Já está em Meus clientes": "Sudah ada di Klien saya",
 "{nome} já está na lista.": "{nome} sudah ada di daftar.",
 "Copiado para Meus clientes": "Disalin ke Klien saya",
 "Só o nome e o contato foram copiados.": "Hanya nama dan kontak yang disalin.",
 "Aniversário hoje!": "Ulang tahun hari ini!",
 "Fechar tudo": "Tutup semua",
 "Abrir tudo": "Buka semua",
 "Quem é": "Siapa",
 "Razão social": "Nama badan usaha",
 "Nome fantasia": "Nama dagang",
 "Data de abertura": "Tanggal pendirian",
 "Inscrição estadual / municipal": "Registrasi negara bagian / kota",
 "Outras pessoas de contato": "Kontak lainnya",
 "Como chamar": "Nama panggilan",
 "Cliente desde": "Klien sejak",
 "Outro telefone": "Telepon lain",
 "Site": "Situs web",
 "Melhor jeito de falar": "Cara terbaik menghubungi",
 "Autorizou receber mensagens": "Setuju menerima pesan",
 "Outros endereços": "Alamat lain",
 "Relacionamento": "Hubungan",
 "Como me conheceu": "Tahu dari mana",
 "Etiquetas": "Label",
 "Nada anotado ainda.": "Belum ada catatan.",
 "Bloco da aba {aba}": "Bagian tab {aba}",
 "Abrir na aba {aba}": "Buka di tab {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Satu daftar, dipakai oleh semua tab kerja.",
 "Escreva o nome do cliente.": "Tulis nama klien.",
 "Telefone / WhatsApp": "Telepon / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Hanya nama yang wajib. Buka bagian yang ingin diisi.",
 "Como chamar (apelido)": "Nama panggilan (julukan)",
 "Inscrição estadual / municipal (opcional)": "Registrasi negara bagian / kota (opsional)",
 "Cargo": "Jabatan",
 "Telefone da pessoa de contato": "Telepon narahubung",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Kontak lainnya (satu per baris: nama, jabatan, telepon)",
 "O telefone principal é WhatsApp": "Telepon utama adalah WhatsApp",
 "O outro telefone é WhatsApp": "Telepon lain adalah WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Mis.: @nama",
 "Ex.: WhatsApp, à tarde": "Mis.: WhatsApp, sore hari",
 "Estado (UF)": "Negara bagian (UF)",
 "Endereço (como estava escrito)": "Alamat (seperti yang tertulis)",
 "Outros endereços (trabalho, entrega...)": "Alamat lain (kantor, pengiriman...)",
 "Google": "Google",
 "Passou na frente": "Lewat di depan",
 "Indicado por": "Direkomendasikan oleh",
 "Criar etiqueta": "Buat label",
 "Ex.: VIP, Mensal, Atacado": "Mis.: VIP, Bulanan, Grosir",
 "Ativo": "Aktif",
 "Inativo": "Tidak aktif",
 "Em negociação": "Dalam negosiasi",
 "O cliente autorizou receber mensagens?": "Apakah klien setuju menerima pesan?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Tanpa izin, tidak ada pesan ulang tahun, penagihan otomatis, atau promo untuk klien ini.",
 "aniversário hoje": "ulang tahun hari ini",
 "contato: {n}": "kontak: {n}",
 "com esse telefone": "dengan telepon ini",
 "com esse e-mail": "dengan email ini",
 "com esse documento": "dengan dokumen ini",
 "com esse nome": "dengan nama ini",
 "Cliente parecido": "Klien serupa",
 "Já existe {nome} {por}. Abrir?": "{nome} sudah ada {por}. Buka?",
 "Cadastrar mesmo assim": "Tetap tambahkan",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Akan dihapus: data, catatan, dan file klien ini.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Juga di tab: {abas} (beserta dokumen, pesanan, kartu, dan jam di sana).",
 "Juntar com outra ficha": "Gabungkan dengan data lain",
 "Juntar fichas": "Gabungkan data",
 "Não há outra ficha para juntar.": "Tidak ada data lain untuk digabungkan.",
 "Juntar \"{nome}\" com:": "Gabungkan \"{nome}\" dengan:",
 "Juntar as duas fichas?": "Gabungkan kedua data?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "\"{a}\" mendapat semua dari \"{b}\" (data, catatan, file, dan tautan ke tab). Data \"{b}\" tidak akan ada lagi.",
 "Juntar": "Gabungkan",
 "Confirme para juntar as fichas": "Konfirmasi untuk menggabungkan data",
 "Aniversariantes do mês": "Ulang tahun bulan ini",
 "Ativos": "Aktif",
 "Inativos": "Tidak aktif",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Tambahkan setiap klien sekali: klien akan muncul di semua tab kerja yang Anda pakai.",
 "Novo cliente": "Klien baru",
 "Editar cliente": "Edit klien",
 "Linha do tempo": "Linimasa",
 "{n} registro(s)": "{n} catatan",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Belum ada apa-apa. Penjualan, pembayaran, dokumen, dan jam kerja muncul di sini.",
 "Me deve": "Utang ke saya",
 "Total pago": "Total dibayar",
 "Última compra ou atendimento": "Pembelian atau layanan terakhir",
 "Próximo compromisso": "Janji berikutnya",
 "na entrega": "saat diserahkan",
 "Passou do limite de fiado ({v}).": "Melewati batas utang ({v}).",
 "Recebeu {v} ({p})": "Diterima {v} ({p})",
 "Hoje é aniversário de {n}.": "Hari ini ulang tahun {n}.",
 "Mandar parabéns": "Kirim ucapan",
 "{n}: parcela de {v} atrasada.": "{n}: cicilan {v} terlambat.",
 "Cobrar": "Tagih",
 "{n} não compra há {d} dias.": "{n} tidak membeli selama {d} hari.",
 "Chamar de volta": "Hubungi lagi",
 "🟢 em dia · 🟡 sumido": "🟢 lancar · 🟡 lama tak muncul",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 lancar · 🟡 ada yang jatuh tempo atau klien lama tak muncul · 🔴 terlambat",
 "Limite de fiado (opcional)": "Batas utang (opsional)",
 "Avisa quando o que ele deve passar deste valor.": "Memberi tahu saat utangnya melebihi jumlah ini.",
 "A prazo": "Cicilan",
 "parcela atrasada": "cicilan terlambat",
 "falta na entrega": "sisa saat diserahkan",
 "Sumidos": "Lama tak muncul",
 "Sinal pago, falta o resto": "DP lunas, sisa belum",
 "Pagou {a} de {b}": "Dibayar {a} dari {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Cicilan ini berasal dari Klien saya. Tandai di sini sebagai diterima atau buka klien untuk menagih dan membuat kuitansi.",
 "Sinal + restante": "DP + sisa",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Kartu kredit, sekali bayar",
 "Cartão de crédito parcelado": "Kartu kredit, cicilan",
 "Fiado / a prazo": "Utang / cicilan",
 "Parcela única": "Sekali bayar",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Hai, {nome}! Selamat ulang tahun! 🎉 Semoga harimu indah. Salam hangat!",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Hai, {nome}! Sudah lama kita tidak ngobrol. Ada yang bisa saya bantu? Senang sekali bisa melayani kamu lagi!",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Hai, {nome}! Sekadar mengingatkan cicilan {v} yang jatuh tempo pada {d}. Kalau ada apa-apa, kabari saya ya. Terima kasih!",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Hai, {nome}! Sekadar mengingatkan cicilan {v}{d}. Kalau ada apa-apa, kabari saya ya. Terima kasih!",
 "que vence dia {d}": "yang jatuh tempo pada {d}",
 "Quanto recebeu?": "Berapa yang diterima?",
 "Falta {v}. Pode ser só uma parte.": "Sisa {v}. Boleh sebagian saja.",
 "(seu nome ou sua marca, em Como você recebe?)": "(nama atau merek Anda, di Bagaimana Anda dibayar?)",
 "Recibo {c}": "Kuitansi {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "Telah diterima dari {c} sejumlah {v} untuk {o}.",
 "{v} no {f} → recebe {l}": "{v} lewat {f} → Anda terima {l}",
 "Pagou {a} de {b}, faltam {c}": "Dibayar {a} dari {b}, sisa {c}",
 "Recebido em {d}": "Diterima pada {d}",
 "Cobrar pelo WhatsApp": "Tagih lewat WhatsApp",
 "Sem autorização": "Tanpa izin",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Klien ini belum mengizinkan menerima pesan (profil klien › Hubungan).",
 "Sem telefone": "Tanpa nomor telepon",
 "Coloque o telefone na ficha do cliente.": "Tambahkan nomor telepon di profil klien.",
 "Gerar recibo": "Buat kuitansi",
 "Como você recebe?": "Bagaimana Anda dibayar?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Hanya \"Tunai\": layar bersih, tanpa cicilan maupun warna merah.",
 "Taxa da maquininha (%)": "Biaya mesin EDC (%)",
 "Taxa {k}": "Biaya {k}",
 "Cliente sumido depois de (dias sem comprar)": "Klien dianggap hilang setelah (hari tanpa pembelian)",
 "Dias para considerar sumido": "Hari hingga dianggap hilang",
 "Lembretes de cobrança por parcela atrasada": "Pengingat tagihan untuk cicilan terlambat",
 "Nome ou marca no recibo": "Nama atau merek di kuitansi",
 "Ex.: Ana Beatriz Doces": "Mis.: Ana Beatriz Kue",
 "Venda ou serviço": "Penjualan atau layanan",
 "O que foi vendido ou feito": "Apa yang dijual atau dikerjakan",
 "Ex.: Bolo de aniversário": "Mis.: Kue ulang tahun",
 "Como paga": "Cara bayar",
 "Sinal (%)": "DP (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Atau tulis jumlah DP di bawah ini.",
 "Sinal (valor)": "DP (jumlah)",
 "Restante na entrega": "Sisa saat diserahkan",
 "Próximo vencimento": "Jatuh tempo berikutnya",
 "Sinal a receber": "DP belum diterima",
 "falta {v}{q}": "sisa {v}{q}",
 "quitado": "lunas",
 "Parcelas mantidas": "Cicilan dipertahankan",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Sudah ada pembayaran tercatat: cicilan tidak dibuat ulang. Untuk mengubahnya, batalkan pembayaran terlebih dahulu.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Catat apa yang dibeli klien atau layanan yang Anda berikan, dan cara bayarnya.",
 "Débito": "Debit",
 "Crédito à vista": "Kredit, sekali bayar",
 "Crédito 2x": "Kredit, 2x cicilan",
 "Crédito 3x": "Kredit, 3x cicilan",
 "Crédito 4x": "Kredit, 4x cicilan",
 "Crédito 5x": "Kredit, 5x cicilan",
 "Crédito 6x": "Kredit, 6x cicilan",
 "Crédito 7x": "Kredit, 7x cicilan",
 "Crédito 8x": "Kredit, 8x cicilan",
 "Crédito 9x": "Kredit, 9x cicilan",
 "Crédito 10x": "Kredit, 10x cicilan",
 "Crédito 11x": "Kredit, 11x cicilan",
 "Crédito 12x": "Kredit, 12x cicilan",
 "ATRASADOS": "TERLAMBAT",
 "Atrasado (hoje): {v}": "Terlambat (hari ini): {v}",
 "Buscar um cliente": "Cari klien",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ lengkap, alamat lengkap, dan tanggal lahir. Meminta kata sandi aplikasi.",
 "Cliente cadastrado": "Klien ditambahkan",
 "Com documentos: guarde o arquivo em lugar seguro.": "Dengan dokumen: simpan file di tempat yang aman.",
 "Como pagou": "Cara bayar",
 "Esse contato não tem nome.": "Kontak ini tidak punya nama.",
 "Exportar planilha": "Ekspor spreadsheet",
 "Falta receber": "Belum diterima",
 "Falta receber (hoje): {v}": "Belum diterima (hari ini): {v}",
 "Importar dos contatos": "Impor dari kontak",
 "Importar dos contatos do celular": "Impor dari kontak ponsel",
 "Incluir documentos": "Sertakan dokumen",
 "Incluir documentos no relatório": "Sertakan dokumen dalam laporan",
 "MELHORES CLIENTES": "KLIEN TERBAIK",
 "Melhores clientes": "Klien terbaik",
 "Não foi possível gerar a planilha.": "Spreadsheet tidak dapat dibuat.",
 "O que foi": "Apa",
 "Pago em": "Dibayar pada",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Untuk mengambil klien dari kontak ponsel, perbarui My Planner lewat toko aplikasi.",
 "RECEBIDO POR DIA": "DITERIMA PER HARI",
 "RECEBIDO POR MÊS": "DITERIMA PER BULAN",
 "Recebeu": "Diterima",
 "Recebeu no período": "Diterima dalam periode",
 "Recebeu no período: {v}": "Diterima dalam periode: {v}",
 "Recebido no período": "Diterima dalam periode",
 "Relatório de clientes": "Laporan klien",
 "Relatório deste cliente": "Laporan klien ini",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Tanpa izin kontak, kamu tidak bisa memilih kontak. Kamu bisa mengizinkannya di pengaturan ponsel.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Tanpa dokumen: CPF/CNPJ hanya menampilkan 2 angka terakhir. Catatan tidak pernah disertakan.",
 "Todos os clientes": "Semua klien",
 "Trabalha em: {e}": "Bekerja di: {e}",
 "Trazer outro": "Tambah lagi",
 "VENDAS E ATENDIMENTOS": "PENJUALAN DAN LAYANAN",
 "Vence": "Jatuh tempo",
 "Venceu": "Sudah jatuh tempo",
 "Vendas e atendimentos": "Penjualan dan layanan",
 "Vendeu": "Terjual",
 "Vendeu no período": "Terjual dalam periode",
 "Vendeu no período: {v}": "Terjual dalam periode: {v}",
 "venceu {d}": "jatuh tempo {d}",
 "vendido no período": "terjual dalam periode",
 "{nome} comprou no período": "{nome} membeli dalam periode",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} masuk ke Klien saya. Periksa datanya dan tandai apakah ia mengizinkan menerima pesan.",
 "{n} compra(s)": "{n} pembelian",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Geser kotak ke kiri untuk mengarsipkan atau ke kanan untuk menghapus. Tahan bagian kosong kotak lalu seret untuk mengubah urutan.",
 "Bloco": "Blok",
 "Confirme para apagar o grupo": "Konfirmasi untuk menghapus grup",
 "Descer": "Turunkan",
 "Opções do bloco": "Opsi blok",
 "Exigências do destino": "Persyaratan tujuan",
 "{n} para acertar": "{n} perlu diselesaikan",
 "{n} parada(s)": "{n} persinggahan",
 "Cor do item selecionado": "Warna item yang dipilih",
 "Abrir o grupo": "Buka grup",
 "Recolher o grupo": "Ciutkan grup",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Geser kotak ke kanan untuk menghapus atau ke kiri untuk mengarsipkan. Tahan dan seret untuk mengubah urutan.",
 "Editar subtítulo": "Edit subjudul",
 "Início da caixa": "Awal kotak",
 "Mover para…": "Pindahkan ke…",
 "Mover {n} item(ns) para": "Pindahkan {n} item ke",
 "Opções do item": "Opsi item",
 "Transformar em subtítulo": "Ubah jadi subjudul",
 "Transformar em texto": "Ubah jadi teks",
 "esta caixa": "kotak ini",
 "{a} de {n} feitos": "{a} dari {n} selesai",
 "1 documento pedido atrasado": "1 dokumen yang diminta terlambat",
 "1 pedido vence logo": "1 permintaan segera jatuh tempo",
 "A lista vem de \"Meus clientes\".": "Daftar diambil dari \"Klien saya\".",
 "Abrir Meus clientes": "Buka Klien saya",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Tab Kantor dan Portal Klien kini jadi satu.",
 "Clientes com pendência": "Klien dengan hal tertunda",
 "Com pendência ({n})": "Tertunda ({n})",
 "Conversa da equipe": "Obrolan tim",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Buat kantor dan undang tim (teman di aplikasi atau undangan lewat tautan): obrolan, rapat video, dan dokumen internal. Kerja sendiri? Pakai Klien saja.",
 "Documentos internos": "Dokumen internal",
 "Entrar com um código de convite": "Gabung dengan kode undangan",
 "Escritório & Clientes": "Kantor & Klien",
 "Escritórios: {n}": "Kantor: {n}",
 "Esta parte é para quem trabalha com equipe": "Bagian ini untuk yang bekerja dengan tim",
 "Guias vencendo": "Slip pajak jatuh tempo",
 "Minhas tarefas": "Tugas saya",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Tidak ada yang dihapus: tim, obrolan, rapat, dokumen, dan klien yang diundang tetap seperti semula.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Belum ada klien. Tambahkan di \"Klien saya\", langsung muncul di sini.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Untuk yang bekerja dengan klien, sendiri atau bersama tim: folder tiap klien (dokumen, permintaan, slip pajak), tim, obrolan, rapat, dan dokumen internal.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Folder klien Portal: {c} (dengan {d} dokumen dan {p} permintaan)",
 "Pessoa física": "Perorangan",
 "Procurar por nome, CNPJ ou CPF": "Cari berdasarkan nama, CNPJ, atau CPF",
 "Reuniões hoje": "Rapat hari ini",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Belum ada kantor (tim). Ketuk untuk membuat atau gabung dengan kode.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Hanya tim yang melihat. Klien tidak pernah melihat bagian ini.",
 "Tudo em dia": "Semua beres",
 "Vencendo ({n})": "Segera jatuh tempo ({n})",
 "chega na próxima versão": "hadir di versi berikutnya",
 "nos próximos 7 dias": "dalam 7 hari ke depan",
 "vence amanhã": "jatuh tempo besok",
 "vence hoje": "jatuh tempo hari ini",
 "{doc} venceu em {d}": "{doc} jatuh tempo pada {d}",
 "{n} documentos pedidos atrasados": "{n} dokumen yang diminta terlambat",
 "{n} pedidos vencem logo": "{n} permintaan segera jatuh tempo",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 beres · 🟡 ada yang segera jatuh tempo · 🔴 permintaan terlambat atau slip pajak lewat tempo",
 "Acesso ao gov.br": "Akses gov.br",
 "Alvará": "Izin usaha",
 "Até o dia (do mês)": "Paling lambat tanggal (bulan)",
 "CCMEI (certificado do MEI)": "CCMEI (sertifikat MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Daftarkan nomor telepon klien untuk mengingatkan lewat WhatsApp.",
 "Cartão CNPJ": "Kartu CNPJ",
 "Checklist criado": "Checklist dibuat",
 "Checklist de cliente novo": "Checklist klien baru",
 "Cliente viu {doc}": "Klien melihat {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Tempel di aplikasi bank, pada Pix salin-tempel.",
 "Cole no app do banco.": "Tempel di aplikasi bank.",
 "Comprovante de endereço": "Bukti alamat",
 "Contrato social e alterações": "Akta pendirian dan perubahannya",
 "Copiado": "Disalin",
 "Copiar Pix": "Salin Pix",
 "Copiar código de barras": "Salin kode batang",
 "Código de barras (linha digitável)": "Kode batang (baris angka)",
 "Dados bancários": "Data bank",
 "Escreva o recado.": "Tulis pesannya.",
 "Escritório enviou {doc}": "Kantor mengirim {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Klien ini belum mengizinkan menerima pesan (lihat profil di Klien saya).",
 "Extratos bancários": "Rekening koran",
 "Ficha completa": "Profil lengkap",
 "Guia": "Slip pajak",
 "Guias a pagar": "Slip pajak yang harus dibayar",
 "Honorário": "Honorarium",
 "Honorário por": "Honorarium per",
 "Informes de rendimentos": "Bukti penghasilan",
 "Lembrar pelo WhatsApp": "Ingatkan lewat WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Baca slip pajak atau boleto dengan AI saya",
 "Lucro presumido": "Laba presumtif",
 "Lucro real": "Laba riil",
 "Nada ainda.": "Belum ada.",
 "Nenhum pedido em aberto.": "Tidak ada permintaan terbuka.",
 "Notas fiscais emitidas": "Faktur yang diterbitkan",
 "O cliente": "Klien",
 "O pedido entrou em Pedidos de documentos.": "Permintaan masuk ke Permintaan dokumen.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Halo, {nome}! Masih kurang: {itens}. Bisa dikirim lewat sini?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Halo, {nome}! Masih kurang: {itens}. Bisa dikirim lewat sini?",
 "Oi, {nome}! Tudo certo por aí?": "Halo, {nome}! Semua lancar di sana?",
 "Pedido criado": "Permintaan dibuat",
 "Pedido feito: {o}": "Permintaan dikirim: {o}",
 "Pedido recebido: {o}": "Permintaan diterima: {o}",
 "Pedidos pendentes": "Permintaan tertunda",
 "Pedir de novo todo mês": "Minta lagi setiap bulan",
 "Pedir nova ({c})": "Minta yang baru ({c})",
 "Pendentes": "Tertunda",
 "Que tipo de cliente?": "Jenis klien apa?",
 "RG e CPF": "RG dan CPF",
 "RG e CPF do titular": "RG dan CPF pemilik",
 "RG e CPF dos sócios": "RG dan CPF para mitra",
 "Recados": "Pesan",
 "Recados entre você e o cliente, presos à pasta dele.": "Pesan antara Anda dan klien, tersimpan di foldernya.",
 "Responde ao pedido": "Menjawab permintaan",
 "Tipo / regime": "Jenis / rezim pajak",
 "Visto pelo cliente em {d}": "Dilihat klien pada {d}",
 "Válido até": "Berlaku hingga",
 "ano": "tahun",
 "código Pix copia e cola, se houver": "kode Pix salin-tempel, jika ada",
 "data de vencimento": "tanggal jatuh tempo",
 "documento": "dokumen",
 "linha digitável do boleto ou da guia, só números": "baris angka boleto atau slip pajak, hanya angka",
 "mês": "bulan",
 "novo": "baru",
 "todo mês, até o dia {n}": "setiap bulan, paling lambat tanggal {n}",
 "valor a pagar": "jumlah yang harus dibayar",
 "válido até {d}": "berlaku hingga {d}",
 "{c} nova": "{c} baru",
 "{doc} pago": "{doc} sudah dibayar",
 "{n} a pagar": "{n} harus dibayar",
 "{n} enviou {doc}": "{n} mengirim {doc}",
 "{n} novo(s)": "{n} baru",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} permintaan dokumen dibuat, tenggat 7 hari.",
 "{n} vencida(s)": "{n} lewat jatuh tempo",
 "Última declaração do Imposto de Renda": "SPT pajak penghasilan terakhir",
 "Últimas guias pagas": "Slip pajak terakhir yang dibayar",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Bagian Kantor ini belum terhubung ke server. Di komputer, jalankan 56-SERVIDOR-0.96.bat (cukup sekali).",
 "Só vê": "Hanya melihat",
 "Nova versão": "Versi baru",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Sudah ada berkas dengan nama ini: yang sebelumnya disimpan sebagai versi {n}.",
 "Visto por e comentários": "Dilihat oleh & komentar",
 "Arquivar (só neste aparelho)": "Arsipkan (hanya di perangkat ini)",
 "Tirar do topo": "Lepas dari atas",
 "Fixar no topo (para todos)": "Sematkan di atas (untuk semua)",
 "Mover para a pasta…": "Pindahkan ke folder…",
 "versão {n}": "versi {n}",
 "visto por {n}": "dilihat oleh {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Maksimal 50 MB per berkas. Mengunggah berkas dengan nama yang sama akan menyimpan yang sebelumnya sebagai versi.",
 "Procurar documento ou pasta": "Cari dokumen atau folder",
 "Fixados": "Disematkan",
 "Abrir o documento": "Buka dokumen",
 "enviado por {nome}": "diunggah oleh {nome}",
 "Versões ({n})": "Versi ({n})",
 "Versão {n} (atual)": "Versi {n} (saat ini)",
 "Versão {n}": "Versi {n}",
 "Visto por ({n})": "Dilihat oleh ({n})",
 "Ninguém da equipe abriu ainda.": "Belum ada anggota tim yang membukanya.",
 "{nome} em {d}": "{nome} pada {d}",
 "Comentários ({n})": "Komentar ({n})",
 "Escreva um comentário": "Tulis komentar",
 "Contratos": "Kontrak",
 "Financeiro do escritório": "Keuangan kantor",
 "RH": "SDM",
 "Mover para a pasta": "Pindahkan ke folder",
 "Ou escreva o nome de uma pasta nova": "Atau ketik nama folder baru",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Rapat ini berulang setiap minggu: jika dibatalkan, akan hilang dari semua minggu, daftar, dan Kotak Masuk tim.",
 "a equipe toda": "seluruh tim",
 "Com {quem}": "Dengan {quem}",
 "toda semana": "setiap minggu",
 "Vão: {n}": "Hadir: {n}",
 "Não vão: {n}": "Tidak hadir: {n}",
 "Vou": "Saya hadir",
 "Não vou": "Saya tidak hadir",
 "Pauta": "Agenda",
 "Ata": "Notulen",
 "Escrever a ata": "Tulis notulen",
 "Abrir o link": "Buka tautan",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Setiap orang yang diundang menerima rapat di Kotak Masuk dan menambahkannya ke Planner dengan satu ketukan, lengkap dengan pengingat.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Tulis dulu catatan rapat (apa yang dibahas dan diputuskan); AI akan menyusunnya menjadi notulen.",
 "Ata: {nome}": "Notulen: {nome}",
 "Gerando...": "Membuat...",
 "Gerar ata com a minha IA": "Buat notulen dengan AI saya",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "AI menyusun agenda dan catatan Anda menjadi notulen. Periksa sebelum menyimpan.",
 "Ainda sem ata.": "Belum ada notulen.",
 "Tarefas da reunião ({n})": "Tugas rapat ({n})",
 "Tarefa da reunião": "Tugas rapat",
 "Salvar a ata": "Simpan notulen",
 "Repetir toda semana ({dia})": "Ulangi setiap minggu ({dia})",
 "Quem participa": "Siapa yang ikut",
 "A equipe toda": "Seluruh tim",
 "Link externo (opcional: Meet, Zoom, Teams)": "Tautan eksternal (opsional: Meet, Zoom, Teams)",
 "O link precisa começar com https://": "Tautan harus diawali dengan https://",
 "Marcar e avisar quem participa": "Jadwalkan dan beri tahu peserta",
 "Cargo e papel": "Jabatan dan peran",
 "Passar o Admin": "Alihkan Admin",
 "Passar o Admin para {nome}?": "Alihkan Admin ke {nome}?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} menjadi penanggung jawab kantor (dapat menghapusnya). Anda tetap di tim sebagai administrator (penerima dapat mengubahnya nanti).",
 "Passar": "Alihkan",
 "{nome} agora cuida do escritório.": "{nome} sekarang menjadi penanggung jawab kantor.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Peran Anda di sini adalah \"Hanya melihat\": Anda mengikuti pengumuman, tugas, rapat, dan dokumen.",
 "Edita": "Dapat mengedit",
 "Incluir": "Tambah",
 "Novo aviso no mural": "Pengumuman baru di papan",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Anda hanya dapat melihat kantor ini: administrator memilih peran \"Hanya melihat\" untuk Anda. Minta administrator mengubahnya jika perlu.",
 "Quem viu": "Siapa yang melihat",
 "Apagar aviso": "Hapus pengumuman",
 "Mural de avisos": "Papan pengumuman",
 "Novo aviso": "Pengumuman baru",
 "Ex.: Feriado na sexta: escritório fechado": "Contoh: Libur hari Jumat: kantor tutup",
 "Fixar no mural": "Sematkan di papan",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Belum ada pengumuman. Pengumuman disematkan di sini untuk seluruh tim.",
 "visto por {n} de {m}": "dilihat oleh {n} dari {m}",
 "sem responsável": "tanpa penanggung jawab",
 "atrasada desde {d}": "terlambat sejak {d}",
 "prazo {d}": "tenggat {d}",
 "Comecei": "Mulai",
 "Terminei": "Selesai",
 "Reabrir": "Buka kembali",
 "Tarefas da equipe": "Tugas tim",
 "1 aberta": "1 terbuka",
 "{n} abertas": "{n} terbuka",
 "Minhas tarefas ({n})": "Tugas saya ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Tidak ada tugas Anda yang terbuka. Ketuk \"Saya kerjakan\" pada tugas tim.",
 "Nenhuma tarefa aberta.": "Tidak ada tugas yang terbuka.",
 "Feitas ({n})": "Selesai ({n})",
 "Apagar a tarefa?": "Hapus tugas?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "Apa yang perlu dilakukan? (contoh: Hitung DAS bulan Maret)",
 "Cliente (opcional)": "Klien (opsional)",
 "Prazo (opcional)": "Tenggat (opsional)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Penanggung jawab (opsional; jika tidak, seseorang mengetuk \"Saya kerjakan\")",
 "Escreva a tarefa para poder salvar.": "Tulis tugasnya agar dapat disimpan.",
 "Membro": "Anggota",
 "Cargo (livre)": "Jabatan (bebas)",
 "Ex.: Advogada, Assistente, Estagiário": "Contoh: Pengacara, Asisten, Magang",
 "Papel": "Peran",
 "Admin: pode tudo no escritório.": "Admin: dapat melakukan semuanya di kantor.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Dapat mengedit: menambah tugas, pengumuman, dokumen, dan rapat",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Hanya melihat: mengikuti semuanya, tanpa menambah atau mengubah",
 "Proposta": "Proposal",
 "Documento sensível (pede a senha do app para abrir)": "Dokumen sensitif (perlu kata sandi aplikasi untuk membuka)",
 "Li e concordo: {d}": "Sudah dibaca dan setuju: {d}",
 "Li e concordo": "Saya sudah membaca dan setuju",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "Saat Anda mengetuk Setuju, aplikasi menyimpan tanggal dan jam Anda membaca dan menyetujui \"{doc}\". Ini persetujuan sederhana: tidak menggantikan tanda tangan digital resmi.",
 "Concordo": "Setuju",
 "Fotos (escolha quais entram)": "Foto (pilih yang dimasukkan)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 foto tidak bisa dibaca di perangkat ini dan tidak dimasukkan.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} foto tidak bisa dibaca di perangkat ini dan tidak dimasukkan.",
 "Nenhuma foto no álbum desta viagem.": "Belum ada foto di album perjalanan ini.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Ketuk foto untuk memilih atau membatalkan. Foto dikecilkan agar PDF tetap ringan.",
 "Sugerir até 12": "Sarankan hingga 12",
 "1 foto marcada": "1 foto dipilih",
 "{n} fotos marcadas": "{n} foto dipilih",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Lebih dari 12 foto membuat PDF lebih berat.",
 "Confirme para abrir este documento": "Konfirmasi untuk membuka dokumen ini",
 "Como usar esta aba": "Cara memakai tab ini",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 klien ada di lebih dari satu tab dan kini menjadi satu data.",
 "Juntar {n} fotos num PDF?": "Gabungkan {n} foto menjadi satu PDF?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Foto-foto menjadi halaman dalam satu PDF, sesuai urutan daftar. Foto lepasan akan dihapus dari kartu ini.",
 "Não foi possível ler as fotos neste dispositivo.": "Tidak dapat membaca foto di perangkat ini.",
 "PDF criado": "PDF dibuat",
 "Montando o PDF...": "Menyusun PDF...",
 "Juntar as {n} fotos num PDF": "Gabungkan {n} foto menjadi satu PDF",
 "Baixar o mês": "Unduh bulan ini",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "File bulan ini ada di perangkat lain dan tidak dapat dibaca di sini.",
 "Os documentos deste mês não têm arquivos.": "Dokumen bulan ini tidak memiliki file.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 file ada di perangkat lain dan tidak disertakan.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} file ada di perangkat lain dan tidak disertakan.",
 "Conversa sobre este documento": "Percakapan tentang dokumen ini",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Ajukan pertanyaan atau balas tentang dokumen ini. Kantor dan klien dapat melihatnya.",
 "Escreva a mensagem": "Tulis pesan",
 "Usar um modelo de pedido ({n})": "Gunakan templat permintaan ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Ingatkan {nome} lewat WhatsApp: {o}",
 "Sem honorário": "Tanpa honorarium",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Isi nilai honorarium di blok \"Kantor\" pada kartu klien, di Klien Saya.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "Telah diterima dari {c} sejumlah {v}, untuk honorarium periode {m}.",
 "Recibo honorário {m} {c}": "Kuitansi honorarium {m} {c}",
 "Recibo do honorário {m}": "Kuitansi honorarium {m}",
 "Recibo criado": "Kuitansi dibuat",
 "O recibo entrou em Documentos, na competência {m}.": "Kuitansi masuk ke Dokumen, pada periode {m}.",
 "Vendo como o cliente": "Melihat sebagai klien",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "Begini klien melihat foldernya: tanpa catatan internal dan tanpa hal yang hanya untuk tim. Tidak ada yang bisa diubah dalam mode ini.",
 "Voltar a ver como escritório": "Kembali melihat sebagai kantor",
 "Ver como o cliente": "Lihat sebagai klien",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Catatan internal (klien tidak pernah melihatnya)",
 "Recibo do honorário…": "Kuitansi honorarium…",
 "Competência do recibo": "Periode kuitansi",
 "⬇️ Baixar o mês": "⬇️ Unduh bulan ini",
 "Me avisar para lembrar o cliente": "Ingatkan saya untuk mengingatkan klien",
 "Guardar como modelo": "Simpan sebagai templat",
 "Modelo guardado": "Templat disimpan",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Saat membuat permintaan untuk klien mana pun, ketuk \"Gunakan templat permintaan\".",
 "Relatório do mês": "Laporan bulanan",
 "Notas rápidas": "Catatan cepat",
 "Item completo: {o}": "Item lengkap: {o}",
 "Reuniões do mês": "Rapat bulan ini",
 "Tarefas feitas e pendentes": "Tugas selesai dan tertunda",
 "Documentos internos enviados": "Dokumen internal terkirim",
 "Documentos enviados e recebidos dos clientes": "Dokumen terkirim dan diterima dari klien",
 "Documentos da competência": "Dokumen periode",
 "Guias pagas e vencidas": "Slip pajak lunas dan jatuh tempo",
 "Honorários": "Honorarium",
 "Relatório do mês · {m}": "Laporan bulanan · {m}",
 "Reuniões ({n})": "Rapat ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Tugas: {f} selesai bulan ini · {p} tertunda",
 "Quem fez": "Dikerjakan oleh",
 "Feita em": "Selesai pada",
 "Documentos internos enviados ({n})": "Dokumen internal terkirim ({n})",
 "Documentos trocados com os clientes": "Dokumen yang dipertukarkan dengan klien",
 "Enviados pelo escritório": "Dikirim oleh kantor",
 "Recebidos do cliente": "Diterima dari klien",
 "Nenhum documento trocado neste mês.": "Tidak ada dokumen yang dipertukarkan bulan ini.",
 "Clientes com pendência ({n})": "Klien dengan hal tertunda ({n})",
 "Pendência": "Hal tertunda",
 "Nenhum cliente com pendência.": "Tidak ada klien dengan hal tertunda.",
 "Documentos da competência {m} ({n})": "Dokumen periode {m} ({n})",
 "Pedidos de documentos ({n})": "Permintaan dokumen ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Slip pajak bulan ini: {p} lunas · {v} jatuh tempo",
 "Vencida": "Jatuh tempo",
 "Recebido no mês": "Diterima bulan ini",
 "Relatório {m} {q}": "Laporan {m} {q}",
 "MÊS": "BULAN",
 "DE QUEM": "MILIK SIAPA",
 "O escritório": "Kantor",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Rapat, tugas, dan dokumen internal disertakan jika ada kantor (tim).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF, CNPJ, catatan internal, dan percakapan tidak pernah masuk ke laporan.",
 "Anotações recebidas": "Catatan diterima",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Jumlah yang akan diterima dari daftar ini muncul di My Planner, termasuk yang baru.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "Hanya mengirim jumlah yang akan diterima dari daftar ini (janji temu sudah masuk sendiri), termasuk yang baru.",
 "Acrescentar": "Tambah",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "{n} kotak ada di {aba}, di \"Catatan diterima\".",
 "Enviadas": "Terkirim",
 "Enviar para": "Kirim ke",
 "Excluir 1 item?": "Hapus 1 item?",
 "Excluir {n} itens?": "Hapus {n} item?",
 "Inserir abaixo": "Sisipkan di bawah",
 "Mover para": "Pindahkan ke",
 "Mover {n} selecionados para": "Pindahkan {n} yang dipilih ke",
 "adicionar aqui": "tambah di sini",
 "continue segurando para selecionar": "terus tahan untuk memilih"
}
